window["Telescope"] = window["Telescope"] || {}; window["Telescope"]["Widget"] = window["Telescope"]["Widget"] || {}; window["Telescope"]["Widget"]["VoteWidget"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lo-Dash 2.4.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash underscore exports="amd,commonjs,global,node" -o ./dist/lodash.underscore.js`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre ES5 environments */
  var undefined;

  /** Used to generate unique IDs */
  var idCounter = 0;

  /** Used internally to indicate various things */
  var indicatorObject = {};

  /** Used to prefix keys to avoid issues with `__proto__` and properties on `Object.prototype` */
  var keyPrefix = +new Date + '';

  /** Used to match "interpolate" template delimiters */
  var reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to ensure capturing order of template delimiters */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals */
  var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
      arrayClass = '[object Array]',
      boolClass = '[object Boolean]',
      dateClass = '[object Date]',
      funcClass = '[object Function]',
      numberClass = '[object Number]',
      objectClass = '[object Object]',
      regexpClass = '[object RegExp]',
      stringClass = '[object String]';

  /** Used to determine if values are of the language type Object */
  var objectTypes = {
    'boolean': false,
    'function': true,
    'object': true,
    'number': false,
    'string': false,
    'undefined': false
  };

  /** Used to escape characters for inclusion in compiled string literals */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\t': 't',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Used as a reference to the global object */
  var root = (objectTypes[typeof window] && window) || this;

  /** Detect free variable `exports` */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module` */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports` */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root` */
  var freeGlobal = objectTypes[typeof global] && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) {
    root = freeGlobal;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `_.indexOf` without support for binary searches
   * or `fromIndex` constraints.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    var index = (fromIndex || 0) - 1,
        length = array ? array.length : 0;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Used by `sortBy` to compare transformed `collection` elements, stable sorting
   * them in ascending order.
   *
   * @private
   * @param {Object} a The object to compare to `b`.
   * @param {Object} b The object to compare to `a`.
   * @returns {number} Returns the sort order indicator of `1` or `-1`.
   */
  function compareAscending(a, b) {
    var ac = a.criteria,
        bc = b.criteria,
        index = -1,
        length = ac.length;

    while (++index < length) {
      var value = ac[index],
          other = bc[index];

      if (value !== other) {
        if (value > other || typeof value == 'undefined') {
          return 1;
        }
        if (value < other || typeof other == 'undefined') {
          return -1;
        }
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to return the same value for
    // `a` and `b`. See https://github.com/jashkenas/underscore/pull/1247
    //
    // This also ensures a stable sort in V8 and other engines.
    // See http://code.google.com/p/v8/issues/detail?id=90
    return a.index - b.index;
  }

  /**
   * Used by `template` to escape characters for inclusion in compiled
   * string literals.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(match) {
    return '\\' + stringEscapes[match];
  }

  /**
   * Slices the `collection` from the `start` index up to, but not including,
   * the `end` index.
   *
   * Note: This function is used instead of `Array#slice` to support node lists
   * in IE < 9 and to ensure dense arrays are returned.
   *
   * @private
   * @param {Array|Object|string} collection The collection to slice.
   * @param {number} start The start index.
   * @param {number} end The end index.
   * @returns {Array} Returns the new array.
   */
  function slice(array, start, end) {
    start || (start = 0);
    if (typeof end == 'undefined') {
      end = array ? array.length : 0;
    }
    var index = -1,
        length = end - start || 0,
        result = Array(length < 0 ? 0 : length);

    while (++index < length) {
      result[index] = array[start + index];
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Used for `Array` method references.
   *
   * Normally `Array.prototype` would suffice, however, using an array literal
   * avoids issues in Narwhal.
   */
  var arrayRef = [];

  /** Used for native method references */
  var objectProto = Object.prototype;

  /** Used to restore the original `_` reference in `noConflict` */
  var oldDash = root._;

  /** Used to resolve the internal [[Class]] of values */
  var toString = objectProto.toString;

  /** Used to detect if a method is native */
  var reNative = RegExp('^' +
    String(toString)
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .replace(/toString| for [^\]]+/g, '.*?') + '$'
  );

  /** Native method shortcuts */
  var ceil = Math.ceil,
      floor = Math.floor,
      hasOwnProperty = objectProto.hasOwnProperty,
      push = arrayRef.push,
      propertyIsEnumerable = objectProto.propertyIsEnumerable;

  /* Native method shortcuts for methods with the same name as other `lodash` methods */
  var nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate,
      nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray,
      nativeIsFinite = root.isFinite,
      nativeIsNaN = root.isNaN,
      nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys,
      nativeMax = Math.max,
      nativeMin = Math.min,
      nativeRandom = Math.random;

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` object which wraps the given value to enable intuitive
   * method chaining.
   *
   * In addition to Lo-Dash methods, wrappers also have the following `Array` methods:
   * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`, `splice`,
   * and `unshift`
   *
   * Chaining is supported in custom builds as long as the `value` method is
   * implicitly or explicitly included in the build.
   *
   * The chainable wrapper functions are:
   * `after`, `assign`, `bind`, `bindAll`, `bindKey`, `chain`, `compact`,
   * `compose`, `concat`, `countBy`, `create`, `createCallback`, `curry`,
   * `debounce`, `defaults`, `defer`, `delay`, `difference`, `filter`, `flatten`,
   * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
   * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
   * `invoke`, `keys`, `map`, `max`, `memoize`, `merge`, `min`, `object`, `omit`,
   * `once`, `pairs`, `partial`, `partialRight`, `pick`, `pluck`, `pull`, `push`,
   * `range`, `reject`, `remove`, `rest`, `reverse`, `shuffle`, `slice`, `sort`,
   * `sortBy`, `splice`, `tap`, `throttle`, `times`, `toArray`, `transform`,
   * `union`, `uniq`, `unshift`, `unzip`, `values`, `where`, `without`, `wrap`,
   * and `zip`
   *
   * The non-chainable wrapper functions are:
   * `clone`, `cloneDeep`, `contains`, `escape`, `every`, `find`, `findIndex`,
   * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `has`, `identity`,
   * `indexOf`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
   * `isEmpty`, `isEqual`, `isFinite`, `isFunction`, `isNaN`, `isNull`, `isNumber`,
   * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `join`,
   * `lastIndexOf`, `mixin`, `noConflict`, `parseInt`, `pop`, `random`, `reduce`,
   * `reduceRight`, `result`, `shift`, `size`, `some`, `sortedIndex`, `runInContext`,
   * `template`, `unescape`, `uniqueId`, and `value`
   *
   * The wrapper functions `first` and `last` return wrapped values when `n` is
   * provided, otherwise they return unwrapped values.
   *
   * Explicit chaining can be enabled by using the `_.chain` method.
   *
   * @name _
   * @constructor
   * @category Chaining
   * @param {*} value The value to wrap in a `lodash` instance.
   * @returns {Object} Returns a `lodash` instance.
   * @example
   *
   * var wrapped = _([1, 2, 3]);
   *
   * // returns an unwrapped value
   * wrapped.reduce(function(sum, num) {
   *   return sum + num;
   * });
   * // => 6
   *
   * // returns a wrapped value
   * var squares = wrapped.map(function(num) {
   *   return num * num;
   * });
   *
   * _.isArray(squares);
   * // => false
   *
   * _.isArray(squares.value());
   * // => true
   */
  function lodash(value) {
    return (value instanceof lodash)
      ? value
      : new lodashWrapper(value);
  }

  /**
   * A fast path for creating `lodash` wrapper objects.
   *
   * @private
   * @param {*} value The value to wrap in a `lodash` instance.
   * @param {boolean} chainAll A flag to enable chaining for all methods
   * @returns {Object} Returns a `lodash` instance.
   */
  function lodashWrapper(value, chainAll) {
    this.__chain__ = !!chainAll;
    this.__wrapped__ = value;
  }
  // ensure `new lodashWrapper` is an instance of `lodash`
  lodashWrapper.prototype = lodash.prototype;

  /**
   * An object used to flag environments features.
   *
   * @static
   * @memberOf _
   * @type Object
   */
  var support = {};

  (function() {
    var object = { '0': 1, 'length': 1 };

    /**
     * Detect if `Array#shift` and `Array#splice` augment array-like objects correctly.
     *
     * Firefox < 10, IE compatibility mode, and IE < 9 have buggy Array `shift()`
     * and `splice()` functions that fail to remove the last element, `value[0]`,
     * of array-like objects even though the `length` property is set to `0`.
     * The `shift()` method is buggy in IE 8 compatibility mode, while `splice()`
     * is buggy regardless of mode in IE < 9 and buggy in compatibility mode in IE 9.
     *
     * @memberOf _.support
     * @type boolean
     */
    support.spliceObjects = (arrayRef.splice.call(object, 0, 1), !object[0]);
  }(1));

  /**
   * By default, the template delimiters used by Lo-Dash are similar to those in
   * embedded Ruby (ERB). Change the following template settings to use alternative
   * delimiters.
   *
   * @static
   * @memberOf _
   * @type Object
   */
  lodash.templateSettings = {

    /**
     * Used to detect `data` property values to be HTML-escaped.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'escape': /<%-([\s\S]+?)%>/g,

    /**
     * Used to detect code to be evaluated.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'evaluate': /<%([\s\S]+?)%>/g,

    /**
     * Used to detect `data` property values to inject.
     *
     * @memberOf _.templateSettings
     * @type RegExp
     */
    'interpolate': reInterpolate,

    /**
     * Used to reference the data object in the template text.
     *
     * @memberOf _.templateSettings
     * @type string
     */
    'variable': ''
  };

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `_.bind` that creates the bound function and
   * sets its meta data.
   *
   * @private
   * @param {Array} bindData The bind data array.
   * @returns {Function} Returns the new bound function.
   */
  function baseBind(bindData) {
    var func = bindData[0],
        partialArgs = bindData[2],
        thisArg = bindData[4];

    function bound() {
      // `Function#bind` spec
      // http://es5.github.io/#x15.3.4.5
      if (partialArgs) {
        // avoid `arguments` object deoptimizations by using `slice` instead
        // of `Array.prototype.slice.call` and not assigning `arguments` to a
        // variable as a ternary expression
        var args = slice(partialArgs);
        push.apply(args, arguments);
      }
      // mimic the constructor's `return` behavior
      // http://es5.github.io/#x13.2.2
      if (this instanceof bound) {
        // ensure `new bound` is an instance of `func`
        var thisBinding = baseCreate(func.prototype),
            result = func.apply(thisBinding, args || arguments);
        return isObject(result) ? result : thisBinding;
      }
      return func.apply(thisArg, args || arguments);
    }
    return bound;
  }

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} prototype The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  function baseCreate(prototype, properties) {
    return isObject(prototype) ? nativeCreate(prototype) : {};
  }
  // fallback for browsers without `Object.create`
  if (!nativeCreate) {
    baseCreate = (function() {
      function Object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          Object.prototype = prototype;
          var result = new Object;
          Object.prototype = null;
        }
        return result || root.Object();
      };
    }());
  }

  /**
   * The base implementation of `_.createCallback` without support for creating
   * "_.pluck" or "_.where" style callbacks.
   *
   * @private
   * @param {*} [func=identity] The value to convert to a callback.
   * @param {*} [thisArg] The `this` binding of the created callback.
   * @param {number} [argCount] The number of arguments the callback accepts.
   * @returns {Function} Returns a callback function.
   */
  function baseCreateCallback(func, thisArg, argCount) {
    if (typeof func != 'function') {
      return identity;
    }
    // exit early for no `thisArg` or already bound by `Function#bind`
    if (typeof thisArg == 'undefined' || !('prototype' in func)) {
      return func;
    }
    switch (argCount) {
      case 1: return function(value) {
        return func.call(thisArg, value);
      };
      case 2: return function(a, b) {
        return func.call(thisArg, a, b);
      };
      case 3: return function(value, index, collection) {
        return func.call(thisArg, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(thisArg, accumulator, value, index, collection);
      };
    }
    return bind(func, thisArg);
  }

  /**
   * The base implementation of `createWrapper` that creates the wrapper and
   * sets its meta data.
   *
   * @private
   * @param {Array} bindData The bind data array.
   * @returns {Function} Returns the new function.
   */
  function baseCreateWrapper(bindData) {
    var func = bindData[0],
        bitmask = bindData[1],
        partialArgs = bindData[2],
        partialRightArgs = bindData[3],
        thisArg = bindData[4],
        arity = bindData[5];

    var isBind = bitmask & 1,
        isBindKey = bitmask & 2,
        isCurry = bitmask & 4,
        isCurryBound = bitmask & 8,
        key = func;

    function bound() {
      var thisBinding = isBind ? thisArg : this;
      if (partialArgs) {
        var args = slice(partialArgs);
        push.apply(args, arguments);
      }
      if (partialRightArgs || isCurry) {
        args || (args = slice(arguments));
        if (partialRightArgs) {
          push.apply(args, partialRightArgs);
        }
        if (isCurry && args.length < arity) {
          bitmask |= 16 & ~32;
          return baseCreateWrapper([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
        }
      }
      args || (args = arguments);
      if (isBindKey) {
        func = thisBinding[key];
      }
      if (this instanceof bound) {
        thisBinding = baseCreate(func.prototype);
        var result = func.apply(thisBinding, args);
        return isObject(result) ? result : thisBinding;
      }
      return func.apply(thisBinding, args);
    }
    return bound;
  }

  /**
   * The base implementation of `_.difference` that accepts a single array
   * of values to exclude.
   *
   * @private
   * @param {Array} array The array to process.
   * @param {Array} [values] The array of values to exclude.
   * @returns {Array} Returns a new array of filtered values.
   */
  function baseDifference(array, values) {
    var index = -1,
        indexOf = getIndexOf(),
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (indexOf(values, value) < 0) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.flatten` without support for callback
   * shorthands or `thisArg` binding.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
   * @param {boolean} [isStrict=false] A flag to restrict flattening to arrays and `arguments` objects.
   * @param {number} [fromIndex=0] The index to start from.
   * @returns {Array} Returns a new flattened array.
   */
  function baseFlatten(array, isShallow, isStrict, fromIndex) {
    var index = (fromIndex || 0) - 1,
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];

      if (value && typeof value == 'object' && typeof value.length == 'number'
          && (isArray(value) || isArguments(value))) {
        // recursively flatten arrays (susceptible to call stack limits)
        if (!isShallow) {
          value = baseFlatten(value, isShallow, isStrict);
        }
        var valIndex = -1,
            valLength = value.length,
            resIndex = result.length;

        result.length += valLength;
        while (++valIndex < valLength) {
          result[resIndex++] = value[valIndex];
        }
      } else if (!isStrict) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.isEqual`, without support for `thisArg` binding,
   * that allows partial "_.where" style comparisons.
   *
   * @private
   * @param {*} a The value to compare.
   * @param {*} b The other value to compare.
   * @param {Function} [callback] The function to customize comparing values.
   * @param {Function} [isWhere=false] A flag to indicate performing partial comparisons.
   * @param {Array} [stackA=[]] Tracks traversed `a` objects.
   * @param {Array} [stackB=[]] Tracks traversed `b` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(a, b, stackA, stackB) {
    if (a === b) {
      return a !== 0 || (1 / a == 1 / b);
    }
    var type = typeof a,
        otherType = typeof b;

    if (a === a &&
        !(a && objectTypes[type]) &&
        !(b && objectTypes[otherType])) {
      return false;
    }
    if (a == null || b == null) {
      return a === b;
    }
    var className = toString.call(a),
        otherClass = toString.call(b);

    if (className != otherClass) {
      return false;
    }
    switch (className) {
      case boolClass:
      case dateClass:
        return +a == +b;

      case numberClass:
        return a != +a
          ? b != +b
          : (a == 0 ? (1 / a == 1 / b) : a == +b);

      case regexpClass:
      case stringClass:
        return a == String(b);
    }
    var isArr = className == arrayClass;
    if (!isArr) {
      var aWrapped = a instanceof lodash,
          bWrapped = b instanceof lodash;

      if (aWrapped || bWrapped) {
        return baseIsEqual(aWrapped ? a.__wrapped__ : a, bWrapped ? b.__wrapped__ : b, stackA, stackB);
      }
      if (className != objectClass) {
        return false;
      }
      var ctorA = a.constructor,
          ctorB = b.constructor;

      if (ctorA != ctorB &&
            !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) &&
            ('constructor' in a && 'constructor' in b)
          ) {
        return false;
      }
    }
    stackA || (stackA = []);
    stackB || (stackB = []);

    var length = stackA.length;
    while (length--) {
      if (stackA[length] == a) {
        return stackB[length] == b;
      }
    }
    var result = true,
        size = 0;

    stackA.push(a);
    stackB.push(b);

    if (isArr) {
      size = b.length;
      result = size == a.length;

      if (result) {
        while (size--) {
          if (!(result = baseIsEqual(a[size], b[size], stackA, stackB))) {
            break;
          }
        }
      }
    }
    else {
      forIn(b, function(value, key, b) {
        if (hasOwnProperty.call(b, key)) {
          size++;
          return !(result = hasOwnProperty.call(a, key) && baseIsEqual(a[key], value, stackA, stackB)) && indicatorObject;
        }
      });

      if (result) {
        forIn(a, function(value, key, a) {
          if (hasOwnProperty.call(a, key)) {
            return !(result = --size > -1) && indicatorObject;
          }
        });
      }
    }
    stackA.pop();
    stackB.pop();
    return result;
  }

  /**
   * The base implementation of `_.random` without argument juggling or support
   * for returning floating-point numbers.
   *
   * @private
   * @param {number} min The minimum possible value.
   * @param {number} max The maximum possible value.
   * @returns {number} Returns a random number.
   */
  function baseRandom(min, max) {
    return min + floor(nativeRandom() * (max - min + 1));
  }

  /**
   * The base implementation of `_.uniq` without support for callback shorthands
   * or `thisArg` binding.
   *
   * @private
   * @param {Array} array The array to process.
   * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
   * @param {Function} [callback] The function called per iteration.
   * @returns {Array} Returns a duplicate-value-free array.
   */
  function baseUniq(array, isSorted, callback) {
    var index = -1,
        indexOf = getIndexOf(),
        length = array ? array.length : 0,
        result = [],
        seen = callback ? [] : result;

    while (++index < length) {
      var value = array[index],
          computed = callback ? callback(value, index, array) : value;

      if (isSorted
            ? !index || seen[seen.length - 1] !== computed
            : indexOf(seen, computed) < 0
          ) {
        if (callback) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Creates a function that aggregates a collection, creating an object composed
   * of keys generated from the results of running each element of the collection
   * through a callback. The given `setter` function sets the keys and values
   * of the composed object.
   *
   * @private
   * @param {Function} setter The setter function.
   * @returns {Function} Returns the new aggregator function.
   */
  function createAggregator(setter) {
    return function(collection, callback, thisArg) {
      var result = {};
      callback = createCallback(callback, thisArg, 3);

      var index = -1,
          length = collection ? collection.length : 0;

      if (typeof length == 'number') {
        while (++index < length) {
          var value = collection[index];
          setter(result, value, callback(value, index, collection), collection);
        }
      } else {
        forOwn(collection, function(value, key, collection) {
          setter(result, value, callback(value, key, collection), collection);
        });
      }
      return result;
    };
  }

  /**
   * Creates a function that, when called, either curries or invokes `func`
   * with an optional `this` binding and partially applied arguments.
   *
   * @private
   * @param {Function|string} func The function or method name to reference.
   * @param {number} bitmask The bitmask of method flags to compose.
   *  The bitmask may be composed of the following flags:
   *  1 - `_.bind`
   *  2 - `_.bindKey`
   *  4 - `_.curry`
   *  8 - `_.curry` (bound)
   *  16 - `_.partial`
   *  32 - `_.partialRight`
   * @param {Array} [partialArgs] An array of arguments to prepend to those
   *  provided to the new function.
   * @param {Array} [partialRightArgs] An array of arguments to append to those
   *  provided to the new function.
   * @param {*} [thisArg] The `this` binding of `func`.
   * @param {number} [arity] The arity of `func`.
   * @returns {Function} Returns the new function.
   */
  function createWrapper(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
    var isBind = bitmask & 1,
        isBindKey = bitmask & 2,
        isCurry = bitmask & 4,
        isCurryBound = bitmask & 8,
        isPartial = bitmask & 16,
        isPartialRight = bitmask & 32;

    if (!isBindKey && !isFunction(func)) {
      throw new TypeError;
    }
    if (isPartial && !partialArgs.length) {
      bitmask &= ~16;
      isPartial = partialArgs = false;
    }
    if (isPartialRight && !partialRightArgs.length) {
      bitmask &= ~32;
      isPartialRight = partialRightArgs = false;
    }
    // fast path for `_.bind`
    var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
    return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
  }

  /**
   * Used by `escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} match The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(match) {
    return htmlEscapes[match];
  }

  /**
   * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
   * customized, this method returns the custom method, otherwise it returns
   * the `baseIndexOf` function.
   *
   * @private
   * @returns {Function} Returns the "indexOf" function.
   */
  function getIndexOf() {
    var result = (result = lodash.indexOf) === indexOf ? baseIndexOf : result;
    return result;
  }

  /**
   * Checks if `value` is a native function.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a native function, else `false`.
   */
  function isNative(value) {
    return typeof value == 'function' && reNative.test(value);
  }

  /**
   * Used by `unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} match The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(match) {
    return htmlUnescapes[match];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Checks if `value` is an `arguments` object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an `arguments` object, else `false`.
   * @example
   *
   * (function() { return _.isArguments(arguments); })(1, 2, 3);
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  function isArguments(value) {
    return value && typeof value == 'object' && typeof value.length == 'number' &&
      toString.call(value) == argsClass || false;
  }
  // fallback for browsers that can't detect `arguments` objects by [[Class]]
  if (!isArguments(arguments)) {
    isArguments = function(value) {
      return value && typeof value == 'object' && typeof value.length == 'number' &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee') || false;
    };
  }

  /**
   * Checks if `value` is an array.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an array, else `false`.
   * @example
   *
   * (function() { return _.isArray(arguments); })();
   * // => false
   *
   * _.isArray([1, 2, 3]);
   * // => true
   */
  var isArray = nativeIsArray || function(value) {
    return value && typeof value == 'object' && typeof value.length == 'number' &&
      toString.call(value) == arrayClass || false;
  };

  /**
   * A fallback implementation of `Object.keys` which produces an array of the
   * given object's own enumerable property names.
   *
   * @private
   * @type Function
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names.
   */
  var shimKeys = function(object) {
    var index, iterable = object, result = [];
    if (!iterable) return result;
    if (!(objectTypes[typeof object])) return result;
      for (index in iterable) {
        if (hasOwnProperty.call(iterable, index)) {
          result.push(index);
        }
      }
    return result
  };

  /**
   * Creates an array composed of the own enumerable property names of an object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names.
   * @example
   *
   * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
   * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
   */
  var keys = !nativeKeys ? shimKeys : function(object) {
    if (!isObject(object)) {
      return [];
    }
    return nativeKeys(object);
  };

  /**
   * Used to convert characters to HTML entities:
   *
   * Though the `>` character is escaped for symmetry, characters like `>` and `/`
   * don't require escaping in HTML and have no special meaning unless they're part
   * of a tag or an unquoted attribute value.
   * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
   */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;'
  };

  /** Used to convert HTML entities to characters */
  var htmlUnescapes = invert(htmlEscapes);

  /** Used to match HTML entities and HTML characters */
  var reEscapedHtml = RegExp('(' + keys(htmlUnescapes).join('|') + ')', 'g'),
      reUnescapedHtml = RegExp('[' + keys(htmlEscapes).join('') + ']', 'g');

  /*--------------------------------------------------------------------------*/

  /**
   * Assigns own enumerable properties of source object(s) to the destination
   * object. Subsequent sources will overwrite property assignments of previous
   * sources. If a callback is provided it will be executed to produce the
   * assigned values. The callback is bound to `thisArg` and invoked with two
   * arguments; (objectValue, sourceValue).
   *
   * @static
   * @memberOf _
   * @type Function
   * @alias extend
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param {Function} [callback] The function to customize assigning values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * _.assign({ 'name': 'fred' }, { 'employer': 'slate' });
   * // => { 'name': 'fred', 'employer': 'slate' }
   *
   * var defaults = _.partialRight(_.assign, function(a, b) {
   *   return typeof a == 'undefined' ? b : a;
   * });
   *
   * var object = { 'name': 'barney' };
   * defaults(object, { 'name': 'fred', 'employer': 'slate' });
   * // => { 'name': 'barney', 'employer': 'slate' }
   */
  function assign(object) {
    if (!object) {
      return object;
    }
    for (var argsIndex = 1, argsLength = arguments.length; argsIndex < argsLength; argsIndex++) {
      var iterable = arguments[argsIndex];
      if (iterable) {
        for (var key in iterable) {
          object[key] = iterable[key];
        }
      }
    }
    return object;
  }

  /**
   * Creates a clone of `value`. If `isDeep` is `true` nested objects will also
   * be cloned, otherwise they will be assigned by reference. If a callback
   * is provided it will be executed to produce the cloned values. If the
   * callback returns `undefined` cloning will be handled by the method instead.
   * The callback is bound to `thisArg` and invoked with one argument; (value).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to clone.
   * @param {boolean} [isDeep=false] Specify a deep clone.
   * @param {Function} [callback] The function to customize cloning values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the cloned value.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * var shallow = _.clone(characters);
   * shallow[0] === characters[0];
   * // => true
   *
   * var deep = _.clone(characters, true);
   * deep[0] === characters[0];
   * // => false
   *
   * _.mixin({
   *   'clone': _.partialRight(_.clone, function(value) {
   *     return _.isElement(value) ? value.cloneNode(false) : undefined;
   *   })
   * });
   *
   * var clone = _.clone(document.body);
   * clone.childNodes.length;
   * // => 0
   */
  function clone(value) {
    return isObject(value)
      ? (isArray(value) ? slice(value) : assign({}, value))
      : value;
  }

  /**
   * Assigns own enumerable properties of source object(s) to the destination
   * object for all destination properties that resolve to `undefined`. Once a
   * property is set, additional defaults of the same property will be ignored.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The destination object.
   * @param {...Object} [source] The source objects.
   * @param- {Object} [guard] Allows working with `_.reduce` without using its
   *  `key` and `object` arguments as sources.
   * @returns {Object} Returns the destination object.
   * @example
   *
   * var object = { 'name': 'barney' };
   * _.defaults(object, { 'name': 'fred', 'employer': 'slate' });
   * // => { 'name': 'barney', 'employer': 'slate' }
   */
  function defaults(object) {
    if (!object) {
      return object;
    }
    for (var argsIndex = 1, argsLength = arguments.length; argsIndex < argsLength; argsIndex++) {
      var iterable = arguments[argsIndex];
      if (iterable) {
        for (var key in iterable) {
          if (typeof object[key] == 'undefined') {
            object[key] = iterable[key];
          }
        }
      }
    }
    return object;
  }

  /**
   * Iterates over own and inherited enumerable properties of an object,
   * executing the callback for each property. The callback is bound to `thisArg`
   * and invoked with three arguments; (value, key, object). Callbacks may exit
   * iteration early by explicitly returning `false`.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns `object`.
   * @example
   *
   * function Shape() {
   *   this.x = 0;
   *   this.y = 0;
   * }
   *
   * Shape.prototype.move = function(x, y) {
   *   this.x += x;
   *   this.y += y;
   * };
   *
   * _.forIn(new Shape, function(value, key) {
   *   console.log(key);
   * });
   * // => logs 'x', 'y', and 'move' (property order is not guaranteed across environments)
   */
  var forIn = function(collection, callback) {
    var index, iterable = collection, result = iterable;
    if (!iterable) return result;
    if (!objectTypes[typeof iterable]) return result;
      for (index in iterable) {
        if (callback(iterable[index], index, collection) === indicatorObject) return result;
      }
    return result
  };

  /**
   * Iterates over own enumerable properties of an object, executing the callback
   * for each property. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, key, object). Callbacks may exit iteration early by
   * explicitly returning `false`.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Objects
   * @param {Object} object The object to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns `object`.
   * @example
   *
   * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
   *   console.log(key);
   * });
   * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
   */
  var forOwn = function(collection, callback) {
    var index, iterable = collection, result = iterable;
    if (!iterable) return result;
    if (!objectTypes[typeof iterable]) return result;
      for (index in iterable) {
        if (hasOwnProperty.call(iterable, index)) {
          if (callback(iterable[index], index, collection) === indicatorObject) return result;
        }
      }
    return result
  };

  /**
   * Creates a sorted array of property names of all enumerable properties,
   * own and inherited, of `object` that have function values.
   *
   * @static
   * @memberOf _
   * @alias methods
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property names that have function values.
   * @example
   *
   * _.functions(_);
   * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
   */
  function functions(object) {
    var result = [];
    forIn(object, function(value, key) {
      if (isFunction(value)) {
        result.push(key);
      }
    });
    return result.sort();
  }

  /**
   * Checks if the specified property name exists as a direct property of `object`,
   * instead of an inherited property.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @param {string} key The name of the property to check.
   * @returns {boolean} Returns `true` if key is a direct property, else `false`.
   * @example
   *
   * _.has({ 'a': 1, 'b': 2, 'c': 3 }, 'b');
   * // => true
   */
  function has(object, key) {
    return object ? hasOwnProperty.call(object, key) : false;
  }

  /**
   * Creates an object composed of the inverted keys and values of the given object.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to invert.
   * @returns {Object} Returns the created inverted object.
   * @example
   *
   * _.invert({ 'first': 'fred', 'second': 'barney' });
   * // => { 'fred': 'first', 'barney': 'second' }
   */
  function invert(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index];
      result[object[key]] = key;
    }
    return result;
  }

  /**
   * Checks if `value` is a boolean value.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a boolean value, else `false`.
   * @example
   *
   * _.isBoolean(null);
   * // => false
   */
  function isBoolean(value) {
    return value === true || value === false ||
      value && typeof value == 'object' && toString.call(value) == boolClass || false;
  }

  /**
   * Checks if `value` is a date.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a date, else `false`.
   * @example
   *
   * _.isDate(new Date);
   * // => true
   */
  function isDate(value) {
    return value && typeof value == 'object' && toString.call(value) == dateClass || false;
  }

  /**
   * Checks if `value` is a DOM element.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a DOM element, else `false`.
   * @example
   *
   * _.isElement(document.body);
   * // => true
   */
  function isElement(value) {
    return value && value.nodeType === 1 || false;
  }

  /**
   * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
   * length of `0` and objects with no own enumerable properties are considered
   * "empty".
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Array|Object|string} value The value to inspect.
   * @returns {boolean} Returns `true` if the `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({});
   * // => true
   *
   * _.isEmpty('');
   * // => true
   */
  function isEmpty(value) {
    if (!value) {
      return true;
    }
    if (isArray(value) || isString(value)) {
      return !value.length;
    }
    for (var key in value) {
      if (hasOwnProperty.call(value, key)) {
        return false;
      }
    }
    return true;
  }

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent to each other. If a callback is provided it will be executed
   * to compare values. If the callback returns `undefined` comparisons will
   * be handled by the method instead. The callback is bound to `thisArg` and
   * invoked with two arguments; (a, b).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} a The value to compare.
   * @param {*} b The other value to compare.
   * @param {Function} [callback] The function to customize comparing values.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'name': 'fred' };
   * var copy = { 'name': 'fred' };
   *
   * object == copy;
   * // => false
   *
   * _.isEqual(object, copy);
   * // => true
   *
   * var words = ['hello', 'goodbye'];
   * var otherWords = ['hi', 'goodbye'];
   *
   * _.isEqual(words, otherWords, function(a, b) {
   *   var reGreet = /^(?:hello|hi)$/i,
   *       aGreet = _.isString(a) && reGreet.test(a),
   *       bGreet = _.isString(b) && reGreet.test(b);
   *
   *   return (aGreet || bGreet) ? (aGreet == bGreet) : undefined;
   * });
   * // => true
   */
  function isEqual(a, b) {
    return baseIsEqual(a, b);
  }

  /**
   * Checks if `value` is, or can be coerced to, a finite number.
   *
   * Note: This is not the same as native `isFinite` which will return true for
   * booleans and empty strings. See http://es5.github.io/#x15.1.2.5.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is finite, else `false`.
   * @example
   *
   * _.isFinite(-101);
   * // => true
   *
   * _.isFinite('10');
   * // => true
   *
   * _.isFinite(true);
   * // => false
   *
   * _.isFinite('');
   * // => false
   *
   * _.isFinite(Infinity);
   * // => false
   */
  function isFinite(value) {
    return nativeIsFinite(value) && !nativeIsNaN(parseFloat(value));
  }

  /**
   * Checks if `value` is a function.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   */
  function isFunction(value) {
    return typeof value == 'function';
  }
  // fallback for older versions of Chrome and Safari
  if (isFunction(/x/)) {
    isFunction = function(value) {
      return typeof value == 'function' && toString.call(value) == funcClass;
    };
  }

  /**
   * Checks if `value` is the language type of Object.
   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(1);
   * // => false
   */
  function isObject(value) {
    // check if the value is the ECMAScript language type of Object
    // http://es5.github.io/#x8
    // and avoid a V8 bug
    // http://code.google.com/p/v8/issues/detail?id=2291
    return !!(value && objectTypes[typeof value]);
  }

  /**
   * Checks if `value` is `NaN`.
   *
   * Note: This is not the same as native `isNaN` which will return `true` for
   * `undefined` and other non-numeric values. See http://es5.github.io/#x15.1.2.4.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `NaN`, else `false`.
   * @example
   *
   * _.isNaN(NaN);
   * // => true
   *
   * _.isNaN(new Number(NaN));
   * // => true
   *
   * isNaN(undefined);
   * // => true
   *
   * _.isNaN(undefined);
   * // => false
   */
  function isNaN(value) {
    // `NaN` as a primitive is the only value that is not equal to itself
    // (perform the [[Class]] check first to avoid errors with some host objects in IE)
    return isNumber(value) && value != +value;
  }

  /**
   * Checks if `value` is `null`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
   * @example
   *
   * _.isNull(null);
   * // => true
   *
   * _.isNull(undefined);
   * // => false
   */
  function isNull(value) {
    return value === null;
  }

  /**
   * Checks if `value` is a number.
   *
   * Note: `NaN` is considered a number. See http://es5.github.io/#x8.5.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(8.4 * 5);
   * // => true
   */
  function isNumber(value) {
    return typeof value == 'number' ||
      value && typeof value == 'object' && toString.call(value) == numberClass || false;
  }

  /**
   * Checks if `value` is a regular expression.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a regular expression, else `false`.
   * @example
   *
   * _.isRegExp(/fred/);
   * // => true
   */
  function isRegExp(value) {
    return value && objectTypes[typeof value] && toString.call(value) == regexpClass || false;
  }

  /**
   * Checks if `value` is a string.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is a string, else `false`.
   * @example
   *
   * _.isString('fred');
   * // => true
   */
  function isString(value) {
    return typeof value == 'string' ||
      value && typeof value == 'object' && toString.call(value) == stringClass || false;
  }

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
   * @example
   *
   * _.isUndefined(void 0);
   * // => true
   */
  function isUndefined(value) {
    return typeof value == 'undefined';
  }

  /**
   * Creates a shallow clone of `object` excluding the specified properties.
   * Property names may be specified as individual arguments or as arrays of
   * property names. If a callback is provided it will be executed for each
   * property of `object` omitting the properties the callback returns truey
   * for. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The source object.
   * @param {Function|...string|string[]} [callback] The properties to omit or the
   *  function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns an object without the omitted properties.
   * @example
   *
   * _.omit({ 'name': 'fred', 'age': 40 }, 'age');
   * // => { 'name': 'fred' }
   *
   * _.omit({ 'name': 'fred', 'age': 40 }, function(value) {
   *   return typeof value == 'number';
   * });
   * // => { 'name': 'fred' }
   */
  function omit(object) {
    var props = [];
    forIn(object, function(value, key) {
      props.push(key);
    });
    props = baseDifference(props, baseFlatten(arguments, true, false, 1));

    var index = -1,
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index];
      result[key] = object[key];
    }
    return result;
  }

  /**
   * Creates a two dimensional array of an object's key-value pairs,
   * i.e. `[[key1, value1], [key2, value2]]`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns new array of key-value pairs.
   * @example
   *
   * _.pairs({ 'barney': 36, 'fred': 40 });
   * // => [['barney', 36], ['fred', 40]] (property order is not guaranteed across environments)
   */
  function pairs(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = Array(length);

    while (++index < length) {
      var key = props[index];
      result[index] = [key, object[key]];
    }
    return result;
  }

  /**
   * Creates a shallow clone of `object` composed of the specified properties.
   * Property names may be specified as individual arguments or as arrays of
   * property names. If a callback is provided it will be executed for each
   * property of `object` picking the properties the callback returns truey
   * for. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, key, object).
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The source object.
   * @param {Function|...string|string[]} [callback] The function called per
   *  iteration or property names to pick, specified as individual property
   *  names or arrays of property names.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns an object composed of the picked properties.
   * @example
   *
   * _.pick({ 'name': 'fred', '_userid': 'fred1' }, 'name');
   * // => { 'name': 'fred' }
   *
   * _.pick({ 'name': 'fred', '_userid': 'fred1' }, function(value, key) {
   *   return key.charAt(0) != '_';
   * });
   * // => { 'name': 'fred' }
   */
  function pick(object) {
    var index = -1,
        props = baseFlatten(arguments, true, false, 1),
        length = props.length,
        result = {};

    while (++index < length) {
      var key = props[index];
      if (key in object) {
        result[key] = object[key];
      }
    }
    return result;
  }

  /**
   * Creates an array composed of the own enumerable property values of `object`.
   *
   * @static
   * @memberOf _
   * @category Objects
   * @param {Object} object The object to inspect.
   * @returns {Array} Returns an array of property values.
   * @example
   *
   * _.values({ 'one': 1, 'two': 2, 'three': 3 });
   * // => [1, 2, 3] (property order is not guaranteed across environments)
   */
  function values(object) {
    var index = -1,
        props = keys(object),
        length = props.length,
        result = Array(length);

    while (++index < length) {
      result[index] = object[props[index]];
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Checks if a given value is present in a collection using strict equality
   * for comparisons, i.e. `===`. If `fromIndex` is negative, it is used as the
   * offset from the end of the collection.
   *
   * @static
   * @memberOf _
   * @alias include
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {*} target The value to check for.
   * @param {number} [fromIndex=0] The index to search from.
   * @returns {boolean} Returns `true` if the `target` element is found, else `false`.
   * @example
   *
   * _.contains([1, 2, 3], 1);
   * // => true
   *
   * _.contains([1, 2, 3], 1, 2);
   * // => false
   *
   * _.contains({ 'name': 'fred', 'age': 40 }, 'fred');
   * // => true
   *
   * _.contains('pebbles', 'eb');
   * // => true
   */
  function contains(collection, target) {
    var indexOf = getIndexOf(),
        length = collection ? collection.length : 0,
        result = false;
    if (length && typeof length == 'number') {
      result = indexOf(collection, target) > -1;
    } else {
      forOwn(collection, function(value) {
        return (result = value === target) && indicatorObject;
      });
    }
    return result;
  }

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of `collection` through the callback. The corresponding value
   * of each key is the number of times the key was returned by the callback.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * _.countBy([4.3, 6.1, 6.4], function(num) { return Math.floor(num); });
   * // => { '4': 1, '6': 2 }
   *
   * _.countBy([4.3, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
   * // => { '4': 1, '6': 2 }
   *
   * _.countBy(['one', 'two', 'three'], 'length');
   * // => { '3': 2, '5': 1 }
   */
  var countBy = createAggregator(function(result, value, key) {
    (hasOwnProperty.call(result, key) ? result[key]++ : result[key] = 1);
  });

  /**
   * Checks if the given callback returns truey value for **all** elements of
   * a collection. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias all
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if all elements passed the callback check,
   *  else `false`.
   * @example
   *
   * _.every([true, 1, null, 'yes']);
   * // => false
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.every(characters, 'age');
   * // => true
   *
   * // using "_.where" callback shorthand
   * _.every(characters, { 'age': 36 });
   * // => false
   */
  function every(collection, callback, thisArg) {
    var result = true;
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        if (!(result = !!callback(collection[index], index, collection))) {
          break;
        }
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        return !(result = !!callback(value, index, collection)) && indicatorObject;
      });
    }
    return result;
  }

  /**
   * Iterates over elements of a collection, returning an array of all elements
   * the callback returns truey for. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias select
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of elements that passed the callback check.
   * @example
   *
   * var evens = _.filter([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
   * // => [2, 4, 6]
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.filter(characters, 'blocked');
   * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
   *
   * // using "_.where" callback shorthand
   * _.filter(characters, { 'age': 36 });
   * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
   */
  function filter(collection, callback, thisArg) {
    var result = [];
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (callback(value, index, collection)) {
          result.push(value);
        }
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        if (callback(value, index, collection)) {
          result.push(value);
        }
      });
    }
    return result;
  }

  /**
   * Iterates over elements of a collection, returning the first element that
   * the callback returns truey for. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias detect, findWhere
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the found element, else `undefined`.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36, 'blocked': false },
   *   { 'name': 'fred',    'age': 40, 'blocked': true },
   *   { 'name': 'pebbles', 'age': 1,  'blocked': false }
   * ];
   *
   * _.find(characters, function(chr) {
   *   return chr.age < 40;
   * });
   * // => { 'name': 'barney', 'age': 36, 'blocked': false }
   *
   * // using "_.where" callback shorthand
   * _.find(characters, { 'age': 1 });
   * // =>  { 'name': 'pebbles', 'age': 1, 'blocked': false }
   *
   * // using "_.pluck" callback shorthand
   * _.find(characters, 'blocked');
   * // => { 'name': 'fred', 'age': 40, 'blocked': true }
   */
  function find(collection, callback, thisArg) {
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (callback(value, index, collection)) {
          return value;
        }
      }
    } else {
      var result;
      forOwn(collection, function(value, index, collection) {
        if (callback(value, index, collection)) {
          result = value;
          return indicatorObject;
        }
      });
      return result;
    }
  }

  /**
   * Examines each element in a `collection`, returning the first that
   * has the given properties. When checking `properties`, this method
   * performs a deep comparison between values to determine if they are
   * equivalent to each other.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Object} properties The object of property values to filter by.
   * @returns {*} Returns the found element, else `undefined`.
   * @example
   *
   * var food = [
   *   { 'name': 'apple',  'organic': false, 'type': 'fruit' },
   *   { 'name': 'banana', 'organic': true,  'type': 'fruit' },
   *   { 'name': 'beet',   'organic': false, 'type': 'vegetable' }
   * ];
   *
   * _.findWhere(food, { 'type': 'vegetable' });
   * // => { 'name': 'beet', 'organic': false, 'type': 'vegetable' }
   */
  function findWhere(object, properties) {
    return where(object, properties, true);
  }

  /**
   * Iterates over elements of a collection, executing the callback for each
   * element. The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection). Callbacks may exit iteration early by
   * explicitly returning `false`.
   *
   * Note: As with other "Collections" methods, objects with a `length` property
   * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
   * may be used for object iteration.
   *
   * @static
   * @memberOf _
   * @alias each
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array|Object|string} Returns `collection`.
   * @example
   *
   * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
   * // => logs each number and returns '1,2,3'
   *
   * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
   * // => logs each number and returns the object (property order is not guaranteed across environments)
   */
  function forEach(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0;

    callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
    if (typeof length == 'number') {
      while (++index < length) {
        if (callback(collection[index], index, collection) === indicatorObject) {
          break;
        }
      }
    } else {
      forOwn(collection, callback);
    }
  }

  /**
   * This method is like `_.forEach` except that it iterates over elements
   * of a `collection` from right to left.
   *
   * @static
   * @memberOf _
   * @alias eachRight
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array|Object|string} Returns `collection`.
   * @example
   *
   * _([1, 2, 3]).forEachRight(function(num) { console.log(num); }).join(',');
   * // => logs each number from right to left and returns '3,2,1'
   */
  function forEachRight(collection, callback) {
    var length = collection ? collection.length : 0;
    if (typeof length == 'number') {
      while (length--) {
        if (callback(collection[length], length, collection) === false) {
          break;
        }
      }
    } else {
      var props = keys(collection);
      length = props.length;
      forOwn(collection, function(value, key, collection) {
        key = props ? props[--length] : --length;
        return callback(collection[key], key, collection) === false && indicatorObject;
      });
    }
  }

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of a collection through the callback. The corresponding value
   * of each key is an array of the elements responsible for generating the key.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * _.groupBy([4.2, 6.1, 6.4], function(num) { return Math.floor(num); });
   * // => { '4': [4.2], '6': [6.1, 6.4] }
   *
   * _.groupBy([4.2, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
   * // => { '4': [4.2], '6': [6.1, 6.4] }
   *
   * // using "_.pluck" callback shorthand
   * _.groupBy(['one', 'two', 'three'], 'length');
   * // => { '3': ['one', 'two'], '5': ['three'] }
   */
  var groupBy = createAggregator(function(result, value, key) {
    (hasOwnProperty.call(result, key) ? result[key] : result[key] = []).push(value);
  });

  /**
   * Creates an object composed of keys generated from the results of running
   * each element of the collection through the given callback. The corresponding
   * value of each key is the last element responsible for generating the key.
   * The callback is bound to `thisArg` and invoked with three arguments;
   * (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Object} Returns the composed aggregate object.
   * @example
   *
   * var keys = [
   *   { 'dir': 'left', 'code': 97 },
   *   { 'dir': 'right', 'code': 100 }
   * ];
   *
   * _.indexBy(keys, 'dir');
   * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
   *
   * _.indexBy(keys, function(key) { return String.fromCharCode(key.code); });
   * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
   *
   * _.indexBy(characters, function(key) { this.fromCharCode(key.code); }, String);
   * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
   */
  var indexBy = createAggregator(function(result, value, key) {
    result[key] = value;
  });

  /**
   * Invokes the method named by `methodName` on each element in the `collection`
   * returning an array of the results of each invoked method. Additional arguments
   * will be provided to each invoked method. If `methodName` is a function it
   * will be invoked for, and `this` bound to, each element in the `collection`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|string} methodName The name of the method to invoke or
   *  the function invoked per iteration.
   * @param {...*} [arg] Arguments to invoke the method with.
   * @returns {Array} Returns a new array of the results of each invoked method.
   * @example
   *
   * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
   * // => [[1, 5, 7], [1, 2, 3]]
   *
   * _.invoke([123, 456], String.prototype.split, '');
   * // => [['1', '2', '3'], ['4', '5', '6']]
   */
  function invoke(collection, methodName) {
    var args = slice(arguments, 2),
        index = -1,
        isFunc = typeof methodName == 'function',
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    forEach(collection, function(value) {
      result[++index] = (isFunc ? methodName : value[methodName]).apply(value, args);
    });
    return result;
  }

  /**
   * Creates an array of values by running each element in the collection
   * through the callback. The callback is bound to `thisArg` and invoked with
   * three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias collect
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of the results of each `callback` execution.
   * @example
   *
   * _.map([1, 2, 3], function(num) { return num * 3; });
   * // => [3, 6, 9]
   *
   * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
   * // => [3, 6, 9] (property order is not guaranteed across environments)
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.map(characters, 'name');
   * // => ['barney', 'fred']
   */
  function map(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0;

    callback = createCallback(callback, thisArg, 3);
    if (typeof length == 'number') {
      var result = Array(length);
      while (++index < length) {
        result[index] = callback(collection[index], index, collection);
      }
    } else {
      result = [];
      forOwn(collection, function(value, key, collection) {
        result[++index] = callback(value, key, collection);
      });
    }
    return result;
  }

  /**
   * Retrieves the maximum value of a collection. If the collection is empty or
   * falsey `-Infinity` is returned. If a callback is provided it will be executed
   * for each value in the collection to generate the criterion by which the value
   * is ranked. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the maximum value.
   * @example
   *
   * _.max([4, 2, 8, 6]);
   * // => 8
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * _.max(characters, function(chr) { return chr.age; });
   * // => { 'name': 'fred', 'age': 40 };
   *
   * // using "_.pluck" callback shorthand
   * _.max(characters, 'age');
   * // => { 'name': 'fred', 'age': 40 };
   */
  function max(collection, callback, thisArg) {
    var computed = -Infinity,
        result = computed;

    // allows working with functions like `_.map` without using
    // their `index` argument as a callback
    if (typeof callback != 'function' && thisArg && thisArg[callback] === collection) {
      callback = null;
    }
    var index = -1,
        length = collection ? collection.length : 0;

    if (callback == null && typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (value > result) {
          result = value;
        }
      }
    } else {
      callback = createCallback(callback, thisArg, 3);

      forEach(collection, function(value, index, collection) {
        var current = callback(value, index, collection);
        if (current > computed) {
          computed = current;
          result = value;
        }
      });
    }
    return result;
  }

  /**
   * Retrieves the minimum value of a collection. If the collection is empty or
   * falsey `Infinity` is returned. If a callback is provided it will be executed
   * for each value in the collection to generate the criterion by which the value
   * is ranked. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the minimum value.
   * @example
   *
   * _.min([4, 2, 8, 6]);
   * // => 2
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * _.min(characters, function(chr) { return chr.age; });
   * // => { 'name': 'barney', 'age': 36 };
   *
   * // using "_.pluck" callback shorthand
   * _.min(characters, 'age');
   * // => { 'name': 'barney', 'age': 36 };
   */
  function min(collection, callback, thisArg) {
    var computed = Infinity,
        result = computed;

    // allows working with functions like `_.map` without using
    // their `index` argument as a callback
    if (typeof callback != 'function' && thisArg && thisArg[callback] === collection) {
      callback = null;
    }
    var index = -1,
        length = collection ? collection.length : 0;

    if (callback == null && typeof length == 'number') {
      while (++index < length) {
        var value = collection[index];
        if (value < result) {
          result = value;
        }
      }
    } else {
      callback = createCallback(callback, thisArg, 3);

      forEach(collection, function(value, index, collection) {
        var current = callback(value, index, collection);
        if (current < computed) {
          computed = current;
          result = value;
        }
      });
    }
    return result;
  }

  /**
   * Retrieves the value of a specified property from all elements in the collection.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {string} property The name of the property to pluck.
   * @returns {Array} Returns a new array of property values.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * _.pluck(characters, 'name');
   * // => ['barney', 'fred']
   */
  var pluck = map;

  /**
   * Reduces a collection to a value which is the accumulated result of running
   * each element in the collection through the callback, where each successive
   * callback execution consumes the return value of the previous execution. If
   * `accumulator` is not provided the first element of the collection will be
   * used as the initial `accumulator` value. The callback is bound to `thisArg`
   * and invoked with four arguments; (accumulator, value, index|key, collection).
   *
   * @static
   * @memberOf _
   * @alias foldl, inject
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [accumulator] Initial value of the accumulator.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the accumulated value.
   * @example
   *
   * var sum = _.reduce([1, 2, 3], function(sum, num) {
   *   return sum + num;
   * });
   * // => 6
   *
   * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
   *   result[key] = num * 3;
   *   return result;
   * }, {});
   * // => { 'a': 3, 'b': 6, 'c': 9 }
   */
  function reduce(collection, callback, accumulator, thisArg) {
    if (!collection) return accumulator;
    var noaccum = arguments.length < 3;
    callback = createCallback(callback, thisArg, 4);

    var index = -1,
        length = collection.length;

    if (typeof length == 'number') {
      if (noaccum) {
        accumulator = collection[++index];
      }
      while (++index < length) {
        accumulator = callback(accumulator, collection[index], index, collection);
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        accumulator = noaccum
          ? (noaccum = false, value)
          : callback(accumulator, value, index, collection)
      });
    }
    return accumulator;
  }

  /**
   * This method is like `_.reduce` except that it iterates over elements
   * of a `collection` from right to left.
   *
   * @static
   * @memberOf _
   * @alias foldr
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function} [callback=identity] The function called per iteration.
   * @param {*} [accumulator] Initial value of the accumulator.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the accumulated value.
   * @example
   *
   * var list = [[0, 1], [2, 3], [4, 5]];
   * var flat = _.reduceRight(list, function(a, b) { return a.concat(b); }, []);
   * // => [4, 5, 2, 3, 0, 1]
   */
  function reduceRight(collection, callback, accumulator, thisArg) {
    var noaccum = arguments.length < 3;
    callback = createCallback(callback, thisArg, 4);
    forEachRight(collection, function(value, index, collection) {
      accumulator = noaccum
        ? (noaccum = false, value)
        : callback(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The opposite of `_.filter` this method returns the elements of a
   * collection that the callback does **not** return truey for.
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of elements that failed the callback check.
   * @example
   *
   * var odds = _.reject([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
   * // => [1, 3, 5]
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.reject(characters, 'blocked');
   * // => [{ 'name': 'barney', 'age': 36, 'blocked': false }]
   *
   * // using "_.where" callback shorthand
   * _.reject(characters, { 'age': 36 });
   * // => [{ 'name': 'fred', 'age': 40, 'blocked': true }]
   */
  function reject(collection, callback, thisArg) {
    callback = createCallback(callback, thisArg, 3);
    return filter(collection, function(value, index, collection) {
      return !callback(value, index, collection);
    });
  }

  /**
   * Retrieves a random element or `n` random elements from a collection.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to sample.
   * @param {number} [n] The number of elements to sample.
   * @param- {Object} [guard] Allows working with functions like `_.map`
   *  without using their `index` arguments as `n`.
   * @returns {Array} Returns the random sample(s) of `collection`.
   * @example
   *
   * _.sample([1, 2, 3, 4]);
   * // => 2
   *
   * _.sample([1, 2, 3, 4], 2);
   * // => [3, 1]
   */
  function sample(collection, n, guard) {
    if (collection && typeof collection.length != 'number') {
      collection = values(collection);
    }
    if (n == null || guard) {
      return collection ? collection[baseRandom(0, collection.length - 1)] : undefined;
    }
    var result = shuffle(collection);
    result.length = nativeMin(nativeMax(0, n), result.length);
    return result;
  }

  /**
   * Creates an array of shuffled values, using a version of the Fisher-Yates
   * shuffle. See http://en.wikipedia.org/wiki/Fisher-Yates_shuffle.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to shuffle.
   * @returns {Array} Returns a new shuffled collection.
   * @example
   *
   * _.shuffle([1, 2, 3, 4, 5, 6]);
   * // => [4, 1, 6, 3, 5, 2]
   */
  function shuffle(collection) {
    var index = -1,
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    forEach(collection, function(value) {
      var rand = baseRandom(0, ++index);
      result[index] = result[rand];
      result[rand] = value;
    });
    return result;
  }

  /**
   * Gets the size of the `collection` by returning `collection.length` for arrays
   * and array-like objects or the number of own enumerable properties for objects.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to inspect.
   * @returns {number} Returns `collection.length` or number of own enumerable properties.
   * @example
   *
   * _.size([1, 2]);
   * // => 2
   *
   * _.size({ 'one': 1, 'two': 2, 'three': 3 });
   * // => 3
   *
   * _.size('pebbles');
   * // => 7
   */
  function size(collection) {
    var length = collection ? collection.length : 0;
    return typeof length == 'number' ? length : keys(collection).length;
  }

  /**
   * Checks if the callback returns a truey value for **any** element of a
   * collection. The function returns as soon as it finds a passing value and
   * does not iterate over the entire collection. The callback is bound to
   * `thisArg` and invoked with three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias any
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {boolean} Returns `true` if any element passed the callback check,
   *  else `false`.
   * @example
   *
   * _.some([null, 0, 'yes', false], Boolean);
   * // => true
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'blocked': false },
   *   { 'name': 'fred',   'age': 40, 'blocked': true }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.some(characters, 'blocked');
   * // => true
   *
   * // using "_.where" callback shorthand
   * _.some(characters, { 'age': 1 });
   * // => false
   */
  function some(collection, callback, thisArg) {
    var result;
    callback = createCallback(callback, thisArg, 3);

    var index = -1,
        length = collection ? collection.length : 0;

    if (typeof length == 'number') {
      while (++index < length) {
        if ((result = callback(collection[index], index, collection))) {
          break;
        }
      }
    } else {
      forOwn(collection, function(value, index, collection) {
        return (result = callback(value, index, collection)) && indicatorObject;
      });
    }
    return !!result;
  }

  /**
   * Creates an array of elements, sorted in ascending order by the results of
   * running each element in a collection through the callback. This method
   * performs a stable sort, that is, it will preserve the original sort order
   * of equal elements. The callback is bound to `thisArg` and invoked with
   * three arguments; (value, index|key, collection).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an array of property names is provided for `callback` the collection
   * will be sorted by each property value.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Array|Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new array of sorted elements.
   * @example
   *
   * _.sortBy([1, 2, 3], function(num) { return Math.sin(num); });
   * // => [3, 1, 2]
   *
   * _.sortBy([1, 2, 3], function(num) { return this.sin(num); }, Math);
   * // => [3, 1, 2]
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36 },
   *   { 'name': 'fred',    'age': 40 },
   *   { 'name': 'barney',  'age': 26 },
   *   { 'name': 'fred',    'age': 30 }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.map(_.sortBy(characters, 'age'), _.values);
   * // => [['barney', 26], ['fred', 30], ['barney', 36], ['fred', 40]]
   *
   * // sorting by multiple properties
   * _.map(_.sortBy(characters, ['name', 'age']), _.values);
   * // = > [['barney', 26], ['barney', 36], ['fred', 30], ['fred', 40]]
   */
  function sortBy(collection, callback, thisArg) {
    var index = -1,
        length = collection ? collection.length : 0,
        result = Array(typeof length == 'number' ? length : 0);

    callback = createCallback(callback, thisArg, 3);
    forEach(collection, function(value, key, collection) {
      result[++index] = {
        'criteria': [callback(value, key, collection)],
        'index': index,
        'value': value
      };
    });

    length = result.length;
    result.sort(compareAscending);
    while (length--) {
      result[length] = result[length].value;
    }
    return result;
  }

  /**
   * Converts the `collection` to an array.
   *
   * @static
   * @memberOf _
   * @category Collections
   * @param {Array|Object|string} collection The collection to convert.
   * @returns {Array} Returns the new converted array.
   * @example
   *
   * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
   * // => [2, 3, 4]
   */
  function toArray(collection) {
    if (isArray(collection)) {
      return slice(collection);
    }
    if (collection && typeof collection.length == 'number') {
      return map(collection);
    }
    return values(collection);
  }

  /**
   * Performs a deep comparison of each element in a `collection` to the given
   * `properties` object, returning an array of all elements that have equivalent
   * property values.
   *
   * @static
   * @memberOf _
   * @type Function
   * @category Collections
   * @param {Array|Object|string} collection The collection to iterate over.
   * @param {Object} props The object of property values to filter by.
   * @returns {Array} Returns a new array of elements that have the given properties.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36, 'pets': ['hoppy'] },
   *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
   * ];
   *
   * _.where(characters, { 'age': 36 });
   * // => [{ 'name': 'barney', 'age': 36, 'pets': ['hoppy'] }]
   *
   * _.where(characters, { 'pets': ['dino'] });
   * // => [{ 'name': 'fred', 'age': 40, 'pets': ['baby puss', 'dino'] }]
   */
  function where(collection, properties, first) {
    return (first && isEmpty(properties))
      ? undefined
      : (first ? find : filter)(collection, properties);
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates an array with all falsey values removed. The values `false`, `null`,
   * `0`, `""`, `undefined`, and `NaN` are all falsey.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to compact.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.compact([0, 1, false, 2, '', 3]);
   * // => [1, 2, 3]
   */
  function compact(array) {
    var index = -1,
        length = array ? array.length : 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Creates an array excluding all values of the provided arrays using strict
   * equality for comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to process.
   * @param {...Array} [values] The arrays of values to exclude.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.difference([1, 2, 3, 4, 5], [5, 2, 10]);
   * // => [1, 3, 4]
   */
  function difference(array) {
    return baseDifference(array, baseFlatten(arguments, true, true, 1));
  }

  /**
   * Gets the first element or first `n` elements of an array. If a callback
   * is provided elements at the beginning of the array are returned as long
   * as the callback returns truey. The callback is bound to `thisArg` and
   * invoked with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias head, take
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback] The function called
   *  per element or the number of elements to return. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the first element(s) of `array`.
   * @example
   *
   * _.first([1, 2, 3]);
   * // => 1
   *
   * _.first([1, 2, 3], 2);
   * // => [1, 2]
   *
   * _.first([1, 2, 3], function(num) {
   *   return num < 3;
   * });
   * // => [1, 2]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': false, 'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.first(characters, 'blocked');
   * // => [{ 'name': 'barney', 'blocked': true, 'employer': 'slate' }]
   *
   * // using "_.where" callback shorthand
   * _.pluck(_.first(characters, { 'employer': 'slate' }), 'name');
   * // => ['barney', 'fred']
   */
  function first(array, callback, thisArg) {
    var n = 0,
        length = array ? array.length : 0;

    if (typeof callback != 'number' && callback != null) {
      var index = -1;
      callback = createCallback(callback, thisArg, 3);
      while (++index < length && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = callback;
      if (n == null || thisArg) {
        return array ? array[0] : undefined;
      }
    }
    return slice(array, 0, nativeMin(nativeMax(0, n), length));
  }

  /**
   * Flattens a nested array (the nesting can be to any depth). If `isShallow`
   * is truey, the array will only be flattened a single level. If a callback
   * is provided each element of the array is passed through the callback before
   * flattening. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to flatten.
   * @param {boolean} [isShallow=false] A flag to restrict flattening to a single level.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a new flattened array.
   * @example
   *
   * _.flatten([1, [2], [3, [[4]]]]);
   * // => [1, 2, 3, 4];
   *
   * _.flatten([1, [2], [3, [[4]]]], true);
   * // => [1, 2, 3, [[4]]];
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 30, 'pets': ['hoppy'] },
   *   { 'name': 'fred',   'age': 40, 'pets': ['baby puss', 'dino'] }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.flatten(characters, 'pets');
   * // => ['hoppy', 'baby puss', 'dino']
   */
  function flatten(array, isShallow) {
    return baseFlatten(array, isShallow);
  }

  /**
   * Gets the index at which the first occurrence of `value` is found using
   * strict equality for comparisons, i.e. `===`. If the array is already sorted
   * providing `true` for `fromIndex` will run a faster binary search.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {boolean|number} [fromIndex=0] The index to search from or `true`
   *  to perform a binary search on a sorted array.
   * @returns {number} Returns the index of the matched value or `-1`.
   * @example
   *
   * _.indexOf([1, 2, 3, 1, 2, 3], 2);
   * // => 1
   *
   * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
   * // => 4
   *
   * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
   * // => 2
   */
  function indexOf(array, value, fromIndex) {
    if (typeof fromIndex == 'number') {
      var length = array ? array.length : 0;
      fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0);
    } else if (fromIndex) {
      var index = sortedIndex(array, value);
      return array[index] === value ? index : -1;
    }
    return baseIndexOf(array, value, fromIndex);
  }

  /**
   * Gets all but the last element or last `n` elements of an array. If a
   * callback is provided elements at the end of the array are excluded from
   * the result as long as the callback returns truey. The callback is bound
   * to `thisArg` and invoked with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback=1] The function called
   *  per element or the number of elements to exclude. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a slice of `array`.
   * @example
   *
   * _.initial([1, 2, 3]);
   * // => [1, 2]
   *
   * _.initial([1, 2, 3], 2);
   * // => [1]
   *
   * _.initial([1, 2, 3], function(num) {
   *   return num > 1;
   * });
   * // => [1]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.initial(characters, 'blocked');
   * // => [{ 'name': 'barney',  'blocked': false, 'employer': 'slate' }]
   *
   * // using "_.where" callback shorthand
   * _.pluck(_.initial(characters, { 'employer': 'na' }), 'name');
   * // => ['barney', 'fred']
   */
  function initial(array, callback, thisArg) {
    var n = 0,
        length = array ? array.length : 0;

    if (typeof callback != 'number' && callback != null) {
      var index = length;
      callback = createCallback(callback, thisArg, 3);
      while (index-- && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = (callback == null || thisArg) ? 1 : callback || n;
    }
    return slice(array, 0, nativeMin(nativeMax(0, length - n), length));
  }

  /**
   * Creates an array of unique values present in all provided arrays using
   * strict equality for comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {...Array} [array] The arrays to inspect.
   * @returns {Array} Returns an array of shared values.
   * @example
   *
   * _.intersection([1, 2, 3], [5, 2, 1, 4], [2, 1]);
   * // => [1, 2]
   */
  function intersection() {
    var args = [],
        argsIndex = -1,
        argsLength = arguments.length;

    while (++argsIndex < argsLength) {
      var value = arguments[argsIndex];
       if (isArray(value) || isArguments(value)) {
         args.push(value);
       }
    }
    var array = args[0],
        index = -1,
        indexOf = getIndexOf(),
        length = array ? array.length : 0,
        result = [];

    outer:
    while (++index < length) {
      value = array[index];
      if (indexOf(result, value) < 0) {
        var argsIndex = argsLength;
        while (--argsIndex) {
          if (indexOf(args[argsIndex], value) < 0) {
            continue outer;
          }
        }
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Gets the last element or last `n` elements of an array. If a callback is
   * provided elements at the end of the array are returned as long as the
   * callback returns truey. The callback is bound to `thisArg` and invoked
   * with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback] The function called
   *  per element or the number of elements to return. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {*} Returns the last element(s) of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   *
   * _.last([1, 2, 3], 2);
   * // => [2, 3]
   *
   * _.last([1, 2, 3], function(num) {
   *   return num > 1;
   * });
   * // => [2, 3]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': false, 'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': true,  'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true,  'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.pluck(_.last(characters, 'blocked'), 'name');
   * // => ['fred', 'pebbles']
   *
   * // using "_.where" callback shorthand
   * _.last(characters, { 'employer': 'na' });
   * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
   */
  function last(array, callback, thisArg) {
    var n = 0,
        length = array ? array.length : 0;

    if (typeof callback != 'number' && callback != null) {
      var index = length;
      callback = createCallback(callback, thisArg, 3);
      while (index-- && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = callback;
      if (n == null || thisArg) {
        return array ? array[length - 1] : undefined;
      }
    }
    return slice(array, nativeMax(0, length - n));
  }

  /**
   * Gets the index at which the last occurrence of `value` is found using strict
   * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
   * as the offset from the end of the collection.
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} [fromIndex=array.length-1] The index to search from.
   * @returns {number} Returns the index of the matched value or `-1`.
   * @example
   *
   * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2);
   * // => 4
   *
   * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2, 3);
   * // => 1
   */
  function lastIndexOf(array, value, fromIndex) {
    var index = array ? array.length : 0;
    if (typeof fromIndex == 'number') {
      index = (fromIndex < 0 ? nativeMax(0, index + fromIndex) : nativeMin(fromIndex, index - 1)) + 1;
    }
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Creates an array of numbers (positive and/or negative) progressing from
   * `start` up to but not including `end`. If `start` is less than `stop` a
   * zero-length range is created unless a negative `step` is specified.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {number} [start=0] The start of the range.
   * @param {number} end The end of the range.
   * @param {number} [step=1] The value to increment or decrement by.
   * @returns {Array} Returns a new range array.
   * @example
   *
   * _.range(4);
   * // => [0, 1, 2, 3]
   *
   * _.range(1, 5);
   * // => [1, 2, 3, 4]
   *
   * _.range(0, 20, 5);
   * // => [0, 5, 10, 15]
   *
   * _.range(0, -4, -1);
   * // => [0, -1, -2, -3]
   *
   * _.range(1, 4, 0);
   * // => [1, 1, 1]
   *
   * _.range(0);
   * // => []
   */
  function range(start, end, step) {
    start = +start || 0;
    step =  (+step || 1);

    if (end == null) {
      end = start;
      start = 0;
    }
    // use `Array(length)` so engines like Chakra and V8 avoid slower modes
    // http://youtu.be/XAqIpGU8ZZk#t=17m25s
    var index = -1,
        length = nativeMax(0, ceil((end - start) / step)),
        result = Array(length);

    while (++index < length) {
      result[index] = start;
      start += step;
    }
    return result;
  }

  /**
   * The opposite of `_.initial` this method gets all but the first element or
   * first `n` elements of an array. If a callback function is provided elements
   * at the beginning of the array are excluded from the result as long as the
   * callback returns truey. The callback is bound to `thisArg` and invoked
   * with three arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias drop, tail
   * @category Arrays
   * @param {Array} array The array to query.
   * @param {Function|Object|number|string} [callback=1] The function called
   *  per element or the number of elements to exclude. If a property name or
   *  object is provided it will be used to create a "_.pluck" or "_.where"
   *  style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a slice of `array`.
   * @example
   *
   * _.rest([1, 2, 3]);
   * // => [2, 3]
   *
   * _.rest([1, 2, 3], 2);
   * // => [3]
   *
   * _.rest([1, 2, 3], function(num) {
   *   return num < 3;
   * });
   * // => [3]
   *
   * var characters = [
   *   { 'name': 'barney',  'blocked': true,  'employer': 'slate' },
   *   { 'name': 'fred',    'blocked': false,  'employer': 'slate' },
   *   { 'name': 'pebbles', 'blocked': true, 'employer': 'na' }
   * ];
   *
   * // using "_.pluck" callback shorthand
   * _.pluck(_.rest(characters, 'blocked'), 'name');
   * // => ['fred', 'pebbles']
   *
   * // using "_.where" callback shorthand
   * _.rest(characters, { 'employer': 'slate' });
   * // => [{ 'name': 'pebbles', 'blocked': true, 'employer': 'na' }]
   */
  function rest(array, callback, thisArg) {
    if (typeof callback != 'number' && callback != null) {
      var n = 0,
          index = -1,
          length = array ? array.length : 0;

      callback = createCallback(callback, thisArg, 3);
      while (++index < length && callback(array[index], index, array)) {
        n++;
      }
    } else {
      n = (callback == null || thisArg) ? 1 : nativeMax(0, callback);
    }
    return slice(array, n);
  }

  /**
   * Uses a binary search to determine the smallest index at which a value
   * should be inserted into a given sorted array in order to maintain the sort
   * order of the array. If a callback is provided it will be executed for
   * `value` and each element of `array` to compute their sort ranking. The
   * callback is bound to `thisArg` and invoked with one argument; (value).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to inspect.
   * @param {*} value The value to evaluate.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {number} Returns the index at which `value` should be inserted
   *  into `array`.
   * @example
   *
   * _.sortedIndex([20, 30, 50], 40);
   * // => 2
   *
   * // using "_.pluck" callback shorthand
   * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
   * // => 2
   *
   * var dict = {
   *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
   * };
   *
   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
   *   return dict.wordToNumber[word];
   * });
   * // => 2
   *
   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
   *   return this.wordToNumber[word];
   * }, dict);
   * // => 2
   */
  function sortedIndex(array, value, callback, thisArg) {
    var low = 0,
        high = array ? array.length : low;

    // explicitly reference `identity` for better inlining in Firefox
    callback = callback ? createCallback(callback, thisArg, 1) : identity;
    value = callback(value);

    while (low < high) {
      var mid = (low + high) >>> 1;
      (callback(array[mid]) < value)
        ? low = mid + 1
        : high = mid;
    }
    return low;
  }

  /**
   * Creates an array of unique values, in order, of the provided arrays using
   * strict equality for comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {...Array} [array] The arrays to inspect.
   * @returns {Array} Returns an array of combined values.
   * @example
   *
   * _.union([1, 2, 3], [5, 2, 1, 4], [2, 1]);
   * // => [1, 2, 3, 5, 4]
   */
  function union() {
    return baseUniq(baseFlatten(arguments, true, true));
  }

  /**
   * Creates a duplicate-value-free version of an array using strict equality
   * for comparisons, i.e. `===`. If the array is sorted, providing
   * `true` for `isSorted` will use a faster algorithm. If a callback is provided
   * each element of `array` is passed through the callback before uniqueness
   * is computed. The callback is bound to `thisArg` and invoked with three
   * arguments; (value, index, array).
   *
   * If a property name is provided for `callback` the created "_.pluck" style
   * callback will return the property value of the given element.
   *
   * If an object is provided for `callback` the created "_.where" style callback
   * will return `true` for elements that have the properties of the given object,
   * else `false`.
   *
   * @static
   * @memberOf _
   * @alias unique
   * @category Arrays
   * @param {Array} array The array to process.
   * @param {boolean} [isSorted=false] A flag to indicate that `array` is sorted.
   * @param {Function|Object|string} [callback=identity] The function called
   *  per iteration. If a property name or object is provided it will be used
   *  to create a "_.pluck" or "_.where" style callback, respectively.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns a duplicate-value-free array.
   * @example
   *
   * _.uniq([1, 2, 1, 3, 1]);
   * // => [1, 2, 3]
   *
   * _.uniq([1, 1, 2, 2, 3], true);
   * // => [1, 2, 3]
   *
   * _.uniq(['A', 'b', 'C', 'a', 'B', 'c'], function(letter) { return letter.toLowerCase(); });
   * // => ['A', 'b', 'C']
   *
   * _.uniq([1, 2.5, 3, 1.5, 2, 3.5], function(num) { return this.floor(num); }, Math);
   * // => [1, 2.5, 3]
   *
   * // using "_.pluck" callback shorthand
   * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
   * // => [{ 'x': 1 }, { 'x': 2 }]
   */
  function uniq(array, isSorted, callback, thisArg) {
    // juggle arguments
    if (typeof isSorted != 'boolean' && isSorted != null) {
      thisArg = callback;
      callback = (typeof isSorted != 'function' && thisArg && thisArg[isSorted] === array) ? null : isSorted;
      isSorted = false;
    }
    if (callback != null) {
      callback = createCallback(callback, thisArg, 3);
    }
    return baseUniq(array, isSorted, callback);
  }

  /**
   * Creates an array excluding all provided values using strict equality for
   * comparisons, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @category Arrays
   * @param {Array} array The array to filter.
   * @param {...*} [value] The values to exclude.
   * @returns {Array} Returns a new array of filtered values.
   * @example
   *
   * _.without([1, 2, 1, 0, 3, 1, 4], 0, 1);
   * // => [2, 3, 4]
   */
  function without(array) {
    return baseDifference(array, slice(arguments, 1));
  }

  /**
   * Creates an array of grouped elements, the first of which contains the first
   * elements of the given arrays, the second of which contains the second
   * elements of the given arrays, and so on.
   *
   * @static
   * @memberOf _
   * @alias unzip
   * @category Arrays
   * @param {...Array} [array] Arrays to process.
   * @returns {Array} Returns a new array of grouped elements.
   * @example
   *
   * _.zip(['fred', 'barney'], [30, 40], [true, false]);
   * // => [['fred', 30, true], ['barney', 40, false]]
   */
  function zip() {
    var index = -1,
        length = max(pluck(arguments, 'length')),
        result = Array(length < 0 ? 0 : length);

    while (++index < length) {
      result[index] = pluck(arguments, index);
    }
    return result;
  }

  /**
   * Creates an object composed from arrays of `keys` and `values`. Provide
   * either a single two dimensional array, i.e. `[[key1, value1], [key2, value2]]`
   * or two arrays, one of `keys` and one of corresponding `values`.
   *
   * @static
   * @memberOf _
   * @alias object
   * @category Arrays
   * @param {Array} keys The array of keys.
   * @param {Array} [values=[]] The array of values.
   * @returns {Object} Returns an object composed of the given keys and
   *  corresponding values.
   * @example
   *
   * _.zipObject(['fred', 'barney'], [30, 40]);
   * // => { 'fred': 30, 'barney': 40 }
   */
  function zipObject(keys, values) {
    var index = -1,
        length = keys ? keys.length : 0,
        result = {};

    if (!values && length && !isArray(keys[0])) {
      values = [];
    }
    while (++index < length) {
      var key = keys[index];
      if (values) {
        result[key] = values[index];
      } else if (key) {
        result[key[0]] = key[1];
      }
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a function that executes `func`, with  the `this` binding and
   * arguments of the created function, only after being called `n` times.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {number} n The number of times the function must be called before
   *  `func` is executed.
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var saves = ['profile', 'settings'];
   *
   * var done = _.after(saves.length, function() {
   *   console.log('Done saving!');
   * });
   *
   * _.forEach(saves, function(type) {
   *   asyncSave({ 'type': type, 'complete': done });
   * });
   * // => logs 'Done saving!', after all saves have completed
   */
  function after(n, func) {
    if (!isFunction(func)) {
      throw new TypeError;
    }
    return function() {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  /**
   * Creates a function that, when called, invokes `func` with the `this`
   * binding of `thisArg` and prepends any additional `bind` arguments to those
   * provided to the bound function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to bind.
   * @param {*} [thisArg] The `this` binding of `func`.
   * @param {...*} [arg] Arguments to be partially applied.
   * @returns {Function} Returns the new bound function.
   * @example
   *
   * var func = function(greeting) {
   *   return greeting + ' ' + this.name;
   * };
   *
   * func = _.bind(func, { 'name': 'fred' }, 'hi');
   * func();
   * // => 'hi fred'
   */
  function bind(func, thisArg) {
    return arguments.length > 2
      ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
      : createWrapper(func, 1, null, null, thisArg);
  }

  /**
   * Binds methods of an object to the object itself, overwriting the existing
   * method. Method names may be specified as individual arguments or as arrays
   * of method names. If no method names are provided all the function properties
   * of `object` will be bound.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Object} object The object to bind and assign the bound methods to.
   * @param {...string} [methodName] The object method names to
   *  bind, specified as individual method names or arrays of method names.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var view = {
   *   'label': 'docs',
   *   'onClick': function() { console.log('clicked ' + this.label); }
   * };
   *
   * _.bindAll(view);
   * jQuery('#docs').on('click', view.onClick);
   * // => logs 'clicked docs', when the button is clicked
   */
  function bindAll(object) {
    var funcs = arguments.length > 1 ? baseFlatten(arguments, true, false, 1) : functions(object),
        index = -1,
        length = funcs.length;

    while (++index < length) {
      var key = funcs[index];
      object[key] = createWrapper(object[key], 1, null, null, object);
    }
    return object;
  }

  /**
   * Creates a function that is the composition of the provided functions,
   * where each function consumes the return value of the function that follows.
   * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
   * Each function is executed with the `this` binding of the composed function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {...Function} [func] Functions to compose.
   * @returns {Function} Returns the new composed function.
   * @example
   *
   * var realNameMap = {
   *   'pebbles': 'penelope'
   * };
   *
   * var format = function(name) {
   *   name = realNameMap[name.toLowerCase()] || name;
   *   return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
   * };
   *
   * var greet = function(formatted) {
   *   return 'Hiya ' + formatted + '!';
   * };
   *
   * var welcome = _.compose(greet, format);
   * welcome('pebbles');
   * // => 'Hiya Penelope!'
   */
  function compose() {
    var funcs = arguments,
        length = funcs.length;

    while (length--) {
      if (!isFunction(funcs[length])) {
        throw new TypeError;
      }
    }
    return function() {
      var args = arguments,
          length = funcs.length;

      while (length--) {
        args = [funcs[length].apply(this, args)];
      }
      return args[0];
    };
  }

  /**
   * Creates a function that will delay the execution of `func` until after
   * `wait` milliseconds have elapsed since the last time it was invoked.
   * Provide an options object to indicate that `func` should be invoked on
   * the leading and/or trailing edge of the `wait` timeout. Subsequent calls
   * to the debounced function will return the result of the last `func` call.
   *
   * Note: If `leading` and `trailing` options are `true` `func` will be called
   * on the trailing edge of the timeout only if the the debounced function is
   * invoked more than once during the `wait` timeout.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to debounce.
   * @param {number} wait The number of milliseconds to delay.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.leading=false] Specify execution on the leading edge of the timeout.
   * @param {number} [options.maxWait] The maximum time `func` is allowed to be delayed before it's called.
   * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // avoid costly calculations while the window size is in flux
   * var lazyLayout = _.debounce(calculateLayout, 150);
   * jQuery(window).on('resize', lazyLayout);
   *
   * // execute `sendMail` when the click event is fired, debouncing subsequent calls
   * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * });
   *
   * // ensure `batchLog` is executed once after 1 second of debounced calls
   * var source = new EventSource('/stream');
   * source.addEventListener('message', _.debounce(batchLog, 250, {
   *   'maxWait': 1000
   * }, false);
   */
  function debounce(func, wait, options) {
    var args,
        maxTimeoutId,
        result,
        stamp,
        thisArg,
        timeoutId,
        trailingCall,
        lastCalled = 0,
        maxWait = false,
        trailing = true;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    wait = nativeMax(0, wait) || 0;
    if (options === true) {
      var leading = true;
      trailing = false;
    } else if (isObject(options)) {
      leading = options.leading;
      maxWait = 'maxWait' in options && (nativeMax(wait, options.maxWait) || 0);
      trailing = 'trailing' in options ? options.trailing : trailing;
    }
    var delayed = function() {
      var remaining = wait - (now() - stamp);
      if (remaining <= 0) {
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        var isCalled = trailingCall;
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = null;
          }
        }
      } else {
        timeoutId = setTimeout(delayed, remaining);
      }
    };

    var maxDelayed = function() {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      maxTimeoutId = timeoutId = trailingCall = undefined;
      if (trailing || (maxWait !== wait)) {
        lastCalled = now();
        result = func.apply(thisArg, args);
        if (!timeoutId && !maxTimeoutId) {
          args = thisArg = null;
        }
      }
    };

    return function() {
      args = arguments;
      stamp = now();
      thisArg = this;
      trailingCall = trailing && (timeoutId || !leading);

      if (maxWait === false) {
        var leadingCall = leading && !timeoutId;
      } else {
        if (!maxTimeoutId && !leading) {
          lastCalled = stamp;
        }
        var remaining = maxWait - (stamp - lastCalled),
            isCalled = remaining <= 0;

        if (isCalled) {
          if (maxTimeoutId) {
            maxTimeoutId = clearTimeout(maxTimeoutId);
          }
          lastCalled = stamp;
          result = func.apply(thisArg, args);
        }
        else if (!maxTimeoutId) {
          maxTimeoutId = setTimeout(maxDelayed, remaining);
        }
      }
      if (isCalled && timeoutId) {
        timeoutId = clearTimeout(timeoutId);
      }
      else if (!timeoutId && wait !== maxWait) {
        timeoutId = setTimeout(delayed, wait);
      }
      if (leadingCall) {
        isCalled = true;
        result = func.apply(thisArg, args);
      }
      if (isCalled && !timeoutId && !maxTimeoutId) {
        args = thisArg = null;
      }
      return result;
    };
  }

  /**
   * Defers executing the `func` function until the current call stack has cleared.
   * Additional arguments will be provided to `func` when it is invoked.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to defer.
   * @param {...*} [arg] Arguments to invoke the function with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.defer(function(text) { console.log(text); }, 'deferred');
   * // logs 'deferred' after one or more milliseconds
   */
  function defer(func) {
    if (!isFunction(func)) {
      throw new TypeError;
    }
    var args = slice(arguments, 1);
    return setTimeout(function() { func.apply(undefined, args); }, 1);
  }

  /**
   * Executes the `func` function after `wait` milliseconds. Additional arguments
   * will be provided to `func` when it is invoked.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to delay.
   * @param {number} wait The number of milliseconds to delay execution.
   * @param {...*} [arg] Arguments to invoke the function with.
   * @returns {number} Returns the timer id.
   * @example
   *
   * _.delay(function(text) { console.log(text); }, 1000, 'later');
   * // => logs 'later' after one second
   */
  function delay(func, wait) {
    if (!isFunction(func)) {
      throw new TypeError;
    }
    var args = slice(arguments, 2);
    return setTimeout(function() { func.apply(undefined, args); }, wait);
  }

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided it will be used to determine the cache key for storing the result
   * based on the arguments provided to the memoized function. By default, the
   * first argument provided to the memoized function is used as the cache key.
   * The `func` is executed with the `this` binding of the memoized function.
   * The result cache is exposed as the `cache` property on the memoized function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] A function used to resolve the cache key.
   * @returns {Function} Returns the new memoizing function.
   * @example
   *
   * var fibonacci = _.memoize(function(n) {
   *   return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
   * });
   *
   * fibonacci(9)
   * // => 34
   *
   * var data = {
   *   'fred': { 'name': 'fred', 'age': 40 },
   *   'pebbles': { 'name': 'pebbles', 'age': 1 }
   * };
   *
   * // modifying the result cache
   * var get = _.memoize(function(name) { return data[name]; }, _.identity);
   * get('pebbles');
   * // => { 'name': 'pebbles', 'age': 1 }
   *
   * get.cache.pebbles.name = 'penelope';
   * get('pebbles');
   * // => { 'name': 'penelope', 'age': 1 }
   */
  function memoize(func, resolver) {
    var cache = {};
    return function() {
      var key = resolver ? resolver.apply(this, arguments) : keyPrefix + arguments[0];
      return hasOwnProperty.call(cache, key)
        ? cache[key]
        : (cache[key] = func.apply(this, arguments));
    };
  }

  /**
   * Creates a function that is restricted to execute `func` once. Repeat calls to
   * the function will return the value of the first call. The `func` is executed
   * with the `this` binding of the created function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new restricted function.
   * @example
   *
   * var initialize = _.once(createApplication);
   * initialize();
   * initialize();
   * // `initialize` executes `createApplication` once
   */
  function once(func) {
    var ran,
        result;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    return function() {
      if (ran) {
        return result;
      }
      ran = true;
      result = func.apply(this, arguments);

      // clear the `func` variable so the function may be garbage collected
      func = null;
      return result;
    };
  }

  /**
   * Creates a function that, when called, invokes `func` with any additional
   * `partial` arguments prepended to those provided to the new function. This
   * method is similar to `_.bind` except it does **not** alter the `this` binding.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to partially apply arguments to.
   * @param {...*} [arg] Arguments to be partially applied.
   * @returns {Function} Returns the new partially applied function.
   * @example
   *
   * var greet = function(greeting, name) { return greeting + ' ' + name; };
   * var hi = _.partial(greet, 'hi');
   * hi('fred');
   * // => 'hi fred'
   */
  function partial(func) {
    return createWrapper(func, 16, slice(arguments, 1));
  }

  /**
   * Creates a function that, when executed, will only call the `func` function
   * at most once per every `wait` milliseconds. Provide an options object to
   * indicate that `func` should be invoked on the leading and/or trailing edge
   * of the `wait` timeout. Subsequent calls to the throttled function will
   * return the result of the last `func` call.
   *
   * Note: If `leading` and `trailing` options are `true` `func` will be called
   * on the trailing edge of the timeout only if the the throttled function is
   * invoked more than once during the `wait` timeout.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {Function} func The function to throttle.
   * @param {number} wait The number of milliseconds to throttle executions to.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.leading=true] Specify execution on the leading edge of the timeout.
   * @param {boolean} [options.trailing=true] Specify execution on the trailing edge of the timeout.
   * @returns {Function} Returns the new throttled function.
   * @example
   *
   * // avoid excessively updating the position while scrolling
   * var throttled = _.throttle(updatePosition, 100);
   * jQuery(window).on('scroll', throttled);
   *
   * // execute `renewToken` when the click event is fired, but not more than once every 5 minutes
   * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
   *   'trailing': false
   * }));
   */
  function throttle(func, wait, options) {
    var leading = true,
        trailing = true;

    if (!isFunction(func)) {
      throw new TypeError;
    }
    if (options === false) {
      leading = false;
    } else if (isObject(options)) {
      leading = 'leading' in options ? options.leading : leading;
      trailing = 'trailing' in options ? options.trailing : trailing;
    }
    options = {};
    options.leading = leading;
    options.maxWait = wait;
    options.trailing = trailing;

    return debounce(func, wait, options);
  }

  /**
   * Creates a function that provides `value` to the wrapper function as its
   * first argument. Additional arguments provided to the function are appended
   * to those provided to the wrapper function. The wrapper is executed with
   * the `this` binding of the created function.
   *
   * @static
   * @memberOf _
   * @category Functions
   * @param {*} value The value to wrap.
   * @param {Function} wrapper The wrapper function.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var p = _.wrap(_.escape, function(func, text) {
   *   return '<p>' + func(text) + '</p>';
   * });
   *
   * p('Fred, Wilma, & Pebbles');
   * // => '<p>Fred, Wilma, &amp; Pebbles</p>'
   */
  function wrap(value, wrapper) {
    return createWrapper(wrapper, 16, [value]);
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Produces a callback bound to an optional `thisArg`. If `func` is a property
   * name the created callback will return the property value for a given element.
   * If `func` is an object the created callback will return `true` for elements
   * that contain the equivalent object properties, otherwise it will return `false`.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {*} [func=identity] The value to convert to a callback.
   * @param {*} [thisArg] The `this` binding of the created callback.
   * @param {number} [argCount] The number of arguments the callback accepts.
   * @returns {Function} Returns a callback function.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // wrap to create custom callback shorthands
   * _.createCallback = _.wrap(_.createCallback, function(func, callback, thisArg) {
   *   var match = /^(.+?)__([gl]t)(.+)$/.exec(callback);
   *   return !match ? func(callback, thisArg) : function(object) {
   *     return match[2] == 'gt' ? object[match[1]] > match[3] : object[match[1]] < match[3];
   *   };
   * });
   *
   * _.filter(characters, 'age__gt38');
   * // => [{ 'name': 'fred', 'age': 40 }]
   */
  function createCallback(func, thisArg, argCount) {
    var type = typeof func;
    if (func == null || type == 'function') {
      return baseCreateCallback(func, thisArg, argCount);
    }
    // handle "_.pluck" style callback shorthands
    if (type != 'object') {
      return property(func);
    }
    var props = keys(func);
    return function(object) {
      var length = props.length,
          result = false;

      while (length--) {
        if (!(result = object[props[length]] === func[props[length]])) {
          break;
        }
      }
      return result;
    };
  }

  /**
   * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
   * corresponding HTML entities.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} string The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('Fred, Wilma, & Pebbles');
   * // => 'Fred, Wilma, &amp; Pebbles'
   */
  function escape(string) {
    return string == null ? '' : String(string).replace(reUnescapedHtml, escapeHtmlChar);
  }

  /**
   * This method returns the first argument provided to it.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'name': 'fred' };
   * _.identity(object) === object;
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * Adds function properties of a source object to the destination object.
   * If `object` is a function methods will be added to its prototype as well.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {Function|Object} [object=lodash] object The destination object.
   * @param {Object} source The object of functions to add.
   * @param {Object} [options] The options object.
   * @param {boolean} [options.chain=true] Specify whether the functions added are chainable.
   * @example
   *
   * function capitalize(string) {
   *   return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
   * }
   *
   * _.mixin({ 'capitalize': capitalize });
   * _.capitalize('fred');
   * // => 'Fred'
   *
   * _('fred').capitalize().value();
   * // => 'Fred'
   *
   * _.mixin({ 'capitalize': capitalize }, { 'chain': false });
   * _('fred').capitalize();
   * // => 'Fred'
   */
  function mixin(object) {
    forEach(functions(object), function(methodName) {
      var func = lodash[methodName] = object[methodName];

      lodash.prototype[methodName] = function() {
        var args = [this.__wrapped__];
        push.apply(args, arguments);

        var result = func.apply(lodash, args);
        return this.__chain__
          ? new lodashWrapper(result, true)
          : result;
      };
    });
  }

  /**
   * Reverts the '_' variable to its previous value and returns a reference to
   * the `lodash` function.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @returns {Function} Returns the `lodash` function.
   * @example
   *
   * var lodash = _.noConflict();
   */
  function noConflict() {
    root._ = oldDash;
    return this;
  }

  /**
   * A no-operation function.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @example
   *
   * var object = { 'name': 'fred' };
   * _.noop(object) === undefined;
   * // => true
   */
  function noop() {
    // no operation performed
  }

  /**
   * Gets the number of milliseconds that have elapsed since the Unix epoch
   * (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @example
   *
   * var stamp = _.now();
   * _.defer(function() { console.log(_.now() - stamp); });
   * // => logs the number of milliseconds it took for the deferred function to be called
   */
  var now = isNative(now = Date.now) && now || function() {
    return new Date().getTime();
  };

  /**
   * Creates a "_.pluck" style function, which returns the `key` value of a
   * given object.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} key The name of the property to retrieve.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var characters = [
   *   { 'name': 'fred',   'age': 40 },
   *   { 'name': 'barney', 'age': 36 }
   * ];
   *
   * var getName = _.property('name');
   *
   * _.map(characters, getName);
   * // => ['barney', 'fred']
   *
   * _.sortBy(characters, getName);
   * // => [{ 'name': 'barney', 'age': 36 }, { 'name': 'fred',   'age': 40 }]
   */
  function property(key) {
    return function(object) {
      return object[key];
    };
  }

  /**
   * Produces a random number between `min` and `max` (inclusive). If only one
   * argument is provided a number between `0` and the given number will be
   * returned. If `floating` is truey or either `min` or `max` are floats a
   * floating-point number will be returned instead of an integer.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {number} [min=0] The minimum possible value.
   * @param {number} [max=1] The maximum possible value.
   * @param {boolean} [floating=false] Specify returning a floating-point number.
   * @returns {number} Returns a random number.
   * @example
   *
   * _.random(0, 5);
   * // => an integer between 0 and 5
   *
   * _.random(5);
   * // => also an integer between 0 and 5
   *
   * _.random(5, true);
   * // => a floating-point number between 0 and 5
   *
   * _.random(1.2, 5.2);
   * // => a floating-point number between 1.2 and 5.2
   */
  function random(min, max) {
    if (min == null && max == null) {
      max = 1;
    }
    min = +min || 0;
    if (max == null) {
      max = min;
      min = 0;
    } else {
      max = +max || 0;
    }
    return min + floor(nativeRandom() * (max - min + 1));
  }

  /**
   * Resolves the value of property `key` on `object`. If `key` is a function
   * it will be invoked with the `this` binding of `object` and its result returned,
   * else the property value is returned. If `object` is falsey then `undefined`
   * is returned.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {Object} object The object to inspect.
   * @param {string} key The name of the property to resolve.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = {
   *   'cheese': 'crumpets',
   *   'stuff': function() {
   *     return 'nonsense';
   *   }
   * };
   *
   * _.result(object, 'cheese');
   * // => 'crumpets'
   *
   * _.result(object, 'stuff');
   * // => 'nonsense'
   */
  function result(object, key) {
    if (object) {
      var value = object[key];
      return isFunction(value) ? object[key]() : value;
    }
  }

  /**
   * A micro-templating method that handles arbitrary delimiters, preserves
   * whitespace, and correctly escapes quotes within interpolated code.
   *
   * Note: In the development build, `_.template` utilizes sourceURLs for easier
   * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
   *
   * For more information on precompiling templates see:
   * https://lodash.com/custom-builds
   *
   * For more information on Chrome extension sandboxes see:
   * http://developer.chrome.com/stable/extensions/sandboxingEval.html
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} text The template text.
   * @param {Object} data The data object used to populate the text.
   * @param {Object} [options] The options object.
   * @param {RegExp} [options.escape] The "escape" delimiter.
   * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
   * @param {Object} [options.imports] An object to import into the template as local variables.
   * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
   * @param {string} [sourceURL] The sourceURL of the template's compiled source.
   * @param {string} [variable] The data object variable name.
   * @returns {Function|string} Returns a compiled function when no `data` object
   *  is given, else it returns the interpolated text.
   * @example
   *
   * // using the "interpolate" delimiter to create a compiled template
   * var compiled = _.template('hello <%= name %>');
   * compiled({ 'name': 'fred' });
   * // => 'hello fred'
   *
   * // using the "escape" delimiter to escape HTML in data property values
   * _.template('<b><%- value %></b>', { 'value': '<script>' });
   * // => '<b>&lt;script&gt;</b>'
   *
   * // using the "evaluate" delimiter to generate HTML
   * var list = '<% _.forEach(people, function(name) { %><li><%- name %></li><% }); %>';
   * _.template(list, { 'people': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
   * _.template('hello ${ name }', { 'name': 'pebbles' });
   * // => 'hello pebbles'
   *
   * // using the internal `print` function in "evaluate" delimiters
   * _.template('<% print("hello " + name); %>!', { 'name': 'barney' });
   * // => 'hello barney!'
   *
   * // using a custom template delimiters
   * _.templateSettings = {
   *   'interpolate': /{{([\s\S]+?)}}/g
   * };
   *
   * _.template('hello {{ name }}!', { 'name': 'mustache' });
   * // => 'hello mustache!'
   *
   * // using the `imports` option to import jQuery
   * var list = '<% jq.each(people, function(name) { %><li><%- name %></li><% }); %>';
   * _.template(list, { 'people': ['fred', 'barney'] }, { 'imports': { 'jq': jQuery } });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // using the `sourceURL` option to specify a custom sourceURL for the template
   * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
   * compiled(data);
   * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
   *
   * // using the `variable` option to ensure a with-statement isn't used in the compiled template
   * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
   * compiled.source;
   * // => function(data) {
   *   var __t, __p = '', __e = _.escape;
   *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
   *   return __p;
   * }
   *
   * // using the `source` property to inline compiled templates for meaningful
   * // line numbers in error messages and a stack trace
   * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
   *   var JST = {\
   *     "main": ' + _.template(mainText).source + '\
   *   };\
   * ');
   */
  function template(text, data, options) {
    var _ = lodash,
        settings = _.templateSettings;

    text = String(text || '');
    options = defaults({}, options, settings);

    var index = 0,
        source = "__p += '",
        variable = options.variable;

    var reDelimiters = RegExp(
      (options.escape || reNoMatch).source + '|' +
      (options.interpolate || reNoMatch).source + '|' +
      (options.evaluate || reNoMatch).source + '|$'
    , 'g');

    text.replace(reDelimiters, function(match, escapeValue, interpolateValue, evaluateValue, offset) {
      source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);
      if (escapeValue) {
        source += "' +\n_.escape(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;
      return match;
    });

    source += "';\n";
    if (!variable) {
      variable = 'obj';
      source = 'with (' + variable + ' || {}) {\n' + source + '\n}\n';
    }
    source = 'function(' + variable + ') {\n' +
      "var __t, __p = '', __j = Array.prototype.join;\n" +
      "function print() { __p += __j.call(arguments, '') }\n" +
      source +
      'return __p\n}';

    try {
      var result = Function('_', 'return ' + source)(_);
    } catch(e) {
      e.source = source;
      throw e;
    }
    if (data) {
      return result(data);
    }
    result.source = source;
    return result;
  }

  /**
   * Executes the callback `n` times, returning an array of the results
   * of each callback execution. The callback is bound to `thisArg` and invoked
   * with one argument; (index).
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {number} n The number of times to execute the callback.
   * @param {Function} callback The function called per iteration.
   * @param {*} [thisArg] The `this` binding of `callback`.
   * @returns {Array} Returns an array of the results of each `callback` execution.
   * @example
   *
   * var diceRolls = _.times(3, _.partial(_.random, 1, 6));
   * // => [3, 6, 4]
   *
   * _.times(3, function(n) { mage.castSpell(n); });
   * // => calls `mage.castSpell(n)` three times, passing `n` of `0`, `1`, and `2` respectively
   *
   * _.times(3, function(n) { this.cast(n); }, mage);
   * // => also calls `mage.castSpell(n)` three times
   */
  function times(n, callback, thisArg) {
    n = (n = +n) > -1 ? n : 0;
    var index = -1,
        result = Array(n);

    callback = baseCreateCallback(callback, thisArg, 1);
    while (++index < n) {
      result[index] = callback(index);
    }
    return result;
  }

  /**
   * The inverse of `_.escape` this method converts the HTML entities
   * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to their
   * corresponding characters.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} string The string to unescape.
   * @returns {string} Returns the unescaped string.
   * @example
   *
   * _.unescape('Fred, Barney &amp; Pebbles');
   * // => 'Fred, Barney & Pebbles'
   */
  function unescape(string) {
    return string == null ? '' : String(string).replace(reEscapedHtml, unescapeHtmlChar);
  }

  /**
   * Generates a unique ID. If `prefix` is provided the ID will be appended to it.
   *
   * @static
   * @memberOf _
   * @category Utilities
   * @param {string} [prefix] The value to prefix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * _.uniqueId('contact_');
   * // => 'contact_104'
   *
   * _.uniqueId();
   * // => '105'
   */
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a `lodash` object that wraps the given value with explicit
   * method chaining enabled.
   *
   * @static
   * @memberOf _
   * @category Chaining
   * @param {*} value The value to wrap.
   * @returns {Object} Returns the wrapper object.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney',  'age': 36 },
   *   { 'name': 'fred',    'age': 40 },
   *   { 'name': 'pebbles', 'age': 1 }
   * ];
   *
   * var youngest = _.chain(characters)
   *     .sortBy('age')
   *     .map(function(chr) { return chr.name + ' is ' + chr.age; })
   *     .first()
   *     .value();
   * // => 'pebbles is 1'
   */
  function chain(value) {
    value = new lodashWrapper(value);
    value.__chain__ = true;
    return value;
  }

  /**
   * Invokes `interceptor` with the `value` as the first argument and then
   * returns `value`. The purpose of this method is to "tap into" a method
   * chain in order to perform operations on intermediate results within
   * the chain.
   *
   * @static
   * @memberOf _
   * @category Chaining
   * @param {*} value The value to provide to `interceptor`.
   * @param {Function} interceptor The function to invoke.
   * @returns {*} Returns `value`.
   * @example
   *
   * _([1, 2, 3, 4])
   *  .tap(function(array) { array.pop(); })
   *  .reverse()
   *  .value();
   * // => [3, 2, 1]
   */
  function tap(value, interceptor) {
    interceptor(value);
    return value;
  }

  /**
   * Enables explicit method chaining on the wrapper object.
   *
   * @name chain
   * @memberOf _
   * @category Chaining
   * @returns {*} Returns the wrapper object.
   * @example
   *
   * var characters = [
   *   { 'name': 'barney', 'age': 36 },
   *   { 'name': 'fred',   'age': 40 }
   * ];
   *
   * // without explicit chaining
   * _(characters).first();
   * // => { 'name': 'barney', 'age': 36 }
   *
   * // with explicit chaining
   * _(characters).chain()
   *   .first()
   *   .pick('age')
   *   .value();
   * // => { 'age': 36 }
   */
  function wrapperChain() {
    this.__chain__ = true;
    return this;
  }

  /**
   * Extracts the wrapped value.
   *
   * @name valueOf
   * @memberOf _
   * @alias value
   * @category Chaining
   * @returns {*} Returns the wrapped value.
   * @example
   *
   * _([1, 2, 3]).valueOf();
   * // => [1, 2, 3]
   */
  function wrapperValueOf() {
    return this.__wrapped__;
  }

  /*--------------------------------------------------------------------------*/

  // add functions that return wrapped values when chaining
  lodash.after = after;
  lodash.bind = bind;
  lodash.bindAll = bindAll;
  lodash.chain = chain;
  lodash.compact = compact;
  lodash.compose = compose;
  lodash.countBy = countBy;
  lodash.debounce = debounce;
  lodash.defaults = defaults;
  lodash.defer = defer;
  lodash.delay = delay;
  lodash.difference = difference;
  lodash.filter = filter;
  lodash.flatten = flatten;
  lodash.forEach = forEach;
  lodash.functions = functions;
  lodash.groupBy = groupBy;
  lodash.indexBy = indexBy;
  lodash.initial = initial;
  lodash.intersection = intersection;
  lodash.invert = invert;
  lodash.invoke = invoke;
  lodash.keys = keys;
  lodash.map = map;
  lodash.max = max;
  lodash.memoize = memoize;
  lodash.min = min;
  lodash.omit = omit;
  lodash.once = once;
  lodash.pairs = pairs;
  lodash.partial = partial;
  lodash.pick = pick;
  lodash.pluck = pluck;
  lodash.range = range;
  lodash.reject = reject;
  lodash.rest = rest;
  lodash.shuffle = shuffle;
  lodash.sortBy = sortBy;
  lodash.tap = tap;
  lodash.throttle = throttle;
  lodash.times = times;
  lodash.toArray = toArray;
  lodash.union = union;
  lodash.uniq = uniq;
  lodash.values = values;
  lodash.where = where;
  lodash.without = without;
  lodash.wrap = wrap;
  lodash.zip = zip;

  // add aliases
  lodash.collect = map;
  lodash.drop = rest;
  lodash.each = forEach;
  lodash.extend = assign;
  lodash.methods = functions;
  lodash.object = zipObject;
  lodash.select = filter;
  lodash.tail = rest;
  lodash.unique = uniq;

  /*--------------------------------------------------------------------------*/

  // add functions that return unwrapped values when chaining
  lodash.clone = clone;
  lodash.contains = contains;
  lodash.escape = escape;
  lodash.every = every;
  lodash.find = find;
  lodash.has = has;
  lodash.identity = identity;
  lodash.indexOf = indexOf;
  lodash.isArguments = isArguments;
  lodash.isArray = isArray;
  lodash.isBoolean = isBoolean;
  lodash.isDate = isDate;
  lodash.isElement = isElement;
  lodash.isEmpty = isEmpty;
  lodash.isEqual = isEqual;
  lodash.isFinite = isFinite;
  lodash.isFunction = isFunction;
  lodash.isNaN = isNaN;
  lodash.isNull = isNull;
  lodash.isNumber = isNumber;
  lodash.isObject = isObject;
  lodash.isRegExp = isRegExp;
  lodash.isString = isString;
  lodash.isUndefined = isUndefined;
  lodash.lastIndexOf = lastIndexOf;
  lodash.mixin = mixin;
  lodash.noConflict = noConflict;
  lodash.random = random;
  lodash.reduce = reduce;
  lodash.reduceRight = reduceRight;
  lodash.result = result;
  lodash.size = size;
  lodash.some = some;
  lodash.sortedIndex = sortedIndex;
  lodash.template = template;
  lodash.unescape = unescape;
  lodash.uniqueId = uniqueId;

  // add aliases
  lodash.all = every;
  lodash.any = some;
  lodash.detect = find;
  lodash.findWhere = findWhere;
  lodash.foldl = reduce;
  lodash.foldr = reduceRight;
  lodash.include = contains;
  lodash.inject = reduce;

  /*--------------------------------------------------------------------------*/

  // add functions capable of returning wrapped and unwrapped values when chaining
  lodash.first = first;
  lodash.last = last;
  lodash.sample = sample;

  // add aliases
  lodash.take = first;
  lodash.head = first;

  /*--------------------------------------------------------------------------*/

  // add functions to `lodash.prototype`
  mixin(lodash);

  /**
   * The semantic version number.
   *
   * @static
   * @memberOf _
   * @type string
   */
  lodash.VERSION = '2.4.2';

  // add "Chaining" functions to the wrapper
  lodash.prototype.chain = wrapperChain;
  lodash.prototype.value = wrapperValueOf;

    // add `Array` mutator functions to the wrapper
    forEach(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayRef[methodName];
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__;
        func.apply(value, arguments);

        // avoid array-like object bugs with `Array#shift` and `Array#splice`
        // in Firefox < 10 and IE < 9
        if (!support.spliceObjects && value.length === 0) {
          delete value[0];
        }
        return this;
      };
    });

    // add `Array` accessor functions to the wrapper
    forEach(['concat', 'join', 'slice'], function(methodName) {
      var func = arrayRef[methodName];
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            result = func.apply(value, arguments);

        if (this.__chain__) {
          result = new lodashWrapper(result);
          result.__chain__ = true;
        }
        return result;
      };
    });

  /*--------------------------------------------------------------------------*/

  // some AMD build optimizers like r.js check for condition patterns like the following:
  if (true) {
    // Expose Lo-Dash to the global object even when an AMD loader is present in
    // case Lo-Dash is loaded with a RequireJS shim config.
    // See http://requirejs.org/docs/api.html#config-shim
    root._ = lodash;

    // define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return lodash;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // check for `exports` after `define` in case a build optimizer adds an `exports` object
  else if (freeExports && freeModule) {
    // in Node.js or RingoJS
    if (moduleExports) {
      (freeModule.exports = lodash)._ = lodash;
    }
    // in Narwhal or Rhino -require
    else {
      freeExports._ = lodash;
    }
  }
  else {
    // in a browser or Rhino
    root._ = lodash;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)(module), __webpack_require__(8)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.1.2

//     (c) 2010-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(root, factory) {

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore');
    factory(root, exports, _);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

}(this, function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.1.2';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = void 0;
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      return base.replace(/([^\/])$/, '$1/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      var singular = !_.isArray(models);
      models = singular ? [models] : _.clone(models);
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = models[i] = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model, options);
      }
      return singular ? models[0] : models;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults({}, options, setOptions);
      if (options.parse) models = this.parse(models, options);
      var singular = !_.isArray(models);
      models = singular ? (models ? [models] : []) : _.clone(models);
      var i, l, id, model, attrs, existing, sort;
      var at = options.at;
      var targetModel = this.model;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};
      var add = options.add, merge = options.merge, remove = options.remove;
      var order = !sortable && add && remove ? [] : false;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        attrs = models[i] || {};
        if (attrs instanceof Model) {
          id = model = attrs;
        } else {
          id = attrs[targetModel.prototype.idAttribute || 'id'];
        }

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(id)) {
          if (remove) modelMap[existing.cid] = true;
          if (merge) {
            attrs = attrs === model ? model.attributes : attrs;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(attrs, options);
          if (!model) continue;
          toAdd.push(model);
          this._addReference(model, options);
        }

        // Do not add multiple models with the same `id`.
        model = existing || model;
        if (order && (model.isNew() || !modelMap[model.id])) order.push(model);
        modelMap[model.id] = true;
      }

      // Remove nonexistent models if appropriate.
      if (remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length || (order && order.length)) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          for (i = 0, l = toAdd.length; i < l; i++) {
            this.models.splice(at + i, 0, toAdd[i]);
          }
        } else {
          if (order) this.models.length = 0;
          var orderedModels = order || toAdd;
          for (i = 0, l = orderedModels.length; i < l; i++) {
            this.models.push(orderedModels[i]);
          }
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort events.
      if (!options.silent) {
        for (i = 0, l = toAdd.length; i < l; i++) {
          (model = toAdd[i]).trigger('add', model, this, options);
        }
        if (sort || (order && order.length)) this.trigger('sort', this, options);
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] || this._byId[obj.id] || this._byId[obj.cid];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(model, resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) return attrs;
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      if (model.id != null) this._byId[model.id] = model;
      if (!model.collection) model.collection = this;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'difference', 'indexOf', 'shuffle',
    'lastIndexOf', 'isEmpty', 'chain', 'sample'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy', 'indexBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    options || (options = {});
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && noXhrPatch) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  var noXhrPatch =
    typeof window !== 'undefined' && !!window.ActiveXObject &&
      !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        router.execute(callback, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root;
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = decodeURI(this.location.pathname + this.location.search);
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.slice(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        var frame = Backbone.$('<iframe src="javascript:0" tabindex="-1">');
        this.iframe = frame.hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          this.fragment = this.getFragment(null, true);
          this.location.replace(this.root + '#' + this.fragment);
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot() && loc.hash) {
          this.fragment = this.getHash().replace(routeStripper, '');
          this.history.replaceState({}, document.title, this.root + this.fragment);
        }

      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      fragment = this.fragment = this.getFragment(fragment);
      return _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      var url = this.root + (fragment = this.getFragment(fragment || ''));

      // Strip the hash for matching.
      fragment = fragment.replace(pathStripper, '');

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // Don't include a trailing slash on the root.
      if (fragment === '' && url !== '/') url = url.slice(0, -1);

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;

}));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(19);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);

module.exports = _.extend({}, Backbone.Events);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {
	        function F() {}

	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                F.prototype = this;
	                var subtype = new F();

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init')) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var app = __webpack_require__(45);
var connect = __webpack_require__(46);
var facebook = __webpack_require__(47);
var voteButtons = __webpack_require__(48);

module.exports = _.extend({}, {
    app: app,
    connect: connect,
    facebook: facebook,
    voteButtons: voteButtons
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(17);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = {

    createCookie: function( name, value, seconds ) {
        var expires = '';
        if ( seconds ) {
            var date = new Date();
            date.setTime( date.getTime()+( seconds * 1000 ) );
            expires = '; expires='+date.toGMTString();
        }
        document.cookie = name+'='+value+expires+'; path=/';
    },

    readCookie: function( name ) {
        var nameEQ = name + '=';
        var ca = document.cookie.split( ';' );
        for( var i=0; i < ca.length; i++ ) {
            var c = ca[ i ];
            while ( c.charAt( 0 )==' ' ) c = c.substring( 1, c.length );
            if ( c.indexOf( nameEQ ) == 0 ) return c.substring( nameEQ.length, c.length );
        }
        return null;
    },

    eraseCookie: function( name ) {
        this.createCookie( name, '', -1 );
    }
};

// source: http://www.quirksmode.org/js/cookies.html?

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var template = __webpack_require__(66);

'use strict';

module.exports = Backbone.View.extend({
    className: 'view-user',
    events: {
        'click .logout' : 'logout'
    },
        
    initialize: function (options) {
        _.bindAll(this, 'render');
        
        this.cms = options.cms;
        this.auth = options.auth;

        this.listenTo(this.auth, 'change:userName', _.bind(this.render, this));
        this.listenTo(this.auth, 'change:isAuthorized', _.bind(this.render, this));
        this.listenTo(this.cms, 'change:windowStatus', _.bind(this.render, this));
    },
    
    render: function () {
        
        var username = this.auth.get('userName');
        var user = null;
        var welcome = null;
        var hello = null;
        if(this.auth.get('userName')){
            user = username.length > 31 ? this.auth.get('userName').substr(0, 31) + '...' : this.auth.get('userName');
            welcome = this.cms.get('text')['views_login'].welcome_copy;
            hello = welcome.replace('{user}','<span class="username">'+user+'</span>');
        }
        var copy = {
            welcome_copy: hello,
            login: this.cms.get('text')['views_login'].login_cta_copy,
            logout: this.cms.get('text')['views_login'].logout_copy
        };
        console.log('LOGIN',copy);
        this.$el.html(template({
            user: user,
            copy: copy,
            window: this.cms.get('windowStatus')
        }));
        
        return this;
    },
    
    logout: function (e) {
        console.log('logout', e);
        e.preventDefault();
        this.auth.deAuthorize();
        
        var evt = {
            target: this
        };

        this.trigger('clearUser',evt);
        evt.name = 'eventClickLogout';
        evt.origEvent = e;
        this.trigger('trackEvent',evt);
    }
    
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var $ = __webpack_require__(2);
var template = __webpack_require__(70);
var templateAlt = __webpack_require__(71);
var PubSub = __webpack_require__(3);
var imagesLoaded = __webpack_require__(72);

module.exports = Backbone.View.extend({
    className: 'view-vote-item',
    tagName: 'li',
    events: {
        'click .contestant' : 'selectContestant',
        'mouseenter .contestant' : 'changeColor',
        'mouseleave .contestant' : 'changeColor'
    },
    /**
     *
     */
    initialize: function (options) {
        
        this.cms = options.cms;
        this.voteOption = options.voteOption;
        this.router = options.router;
        this.dataLength = options.dataLength;

    },
    /**
     *
     */
    render: function () {
            
        var dataLength = this.dataLength;
        var model = this.model.toJSON();
        
        // check length of vote option name and slice it
        var fullName = model.firstname + ' ' + model.lastname;
        if(fullName.length >= 74) fullName = fullName.slice(0,73);
        model.fullname = fullName;

        var text = this.cms.get('text')['views_nominee_grid'];
        //check the length of the contestants, render different layout based on contestant length
        if (dataLength === 2 || dataLength === 4) {
            this.$el.html(templateAlt({
                model: model,
                text: text
            }));
            return this;
        }

        this.$el.html(template({
            model: model,
            text: text
        }));

        return this;
    },
    renderedToDOM: function(){
        imagesLoaded(this.el.querySelector('.contestant-img'), function(){
            this.relayVoteItemHeight();
            this.listenTo(PubSub, 'AnimationFrame', this.relayVoteItemHeight.bind(this));
        }.bind(this));

    },
    /**
     *
     */
    selectContestant: function (e) {
        
        e.preventDefault();
        this.voteOption.setSelected(this.model.get('id'));
        
        // pass vote event to google if 1 click vote enabled
        // if (this.cms.get('text')['views_nominee_grid'].disable_confirmation_modal == "true" && this.controller.Models.Auth.get('isAuthorized')) {
        //  this.controller.trackEvent(e, 'eventClickVote');
        // } else {
        //  this.controller.trackEvent(e, "eventClickContestant");
        // }

        this.router.scrollToTop();
    },
    /**
     *
     */
    changeColor: function (e) {
        var $target = $(e.currentTarget).find('.vote');

        if($target.length === 0) {
            $target = $(e.currentTarget).find('.eliminated-vote');
            $target.toggleClass('hoverElim');
            return;
        }
        $target.toggleClass('hover');
    },
    /**
     * [relayVoteItemHeight description]
     * @return {[type]} [description]
     */
    relayVoteItemHeight: function () {

        if(typeof this.myHeight === 'undefined' || this.myHeight !== this.$('.item-measure-contents').outerHeight()){
            if ( this.$('.contestant').length ) {
                this.myHeight = this.$('.item-measure-contents').outerHeight();
                console.log('relayVoteItemHeight', this.myHeight);
                PubSub.trigger('relayVoteItemHeight', this.myHeight);
            }
        }

    }
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);
var Backbone = __webpack_require__(1);
var $ = __webpack_require__(2);

Backbone.$ = $;

__webpack_require__(20);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(24)($);

var VoteWidgetWidget = __webpack_require__(26);

module.exports = function (options) {
    options = options || {};
    var widget = {};

    options.container = options.container || $(document.body);
    options.uniqueId = options.uniqueId || $(options.container).attr('id') || function () {
        var retval = 'vote-widget-';
        if (options.widget_id) {
            retval += options.widget_id + '-';
        } else {
            retval += 'widget-';
        }
        retval += Date.now() % 1e6;
        return retval;
    }();

    var counterView = VoteWidgetWidget(options);
    if (typeof options.onCreated == 'function') {
        options.onCreated(counterView);
    }

    return widget;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(15);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../webpack/loaders/purifycss-custom-loader.js??ref--1-2!../../node_modules/postcss-loader/lib/index.js??postcss!../../node_modules/sass-loader/lib/loader.js!./main.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../webpack/loaders/purifycss-custom-loader.js??ref--1-2!../../node_modules/postcss-loader/lib/index.js??postcss!../../node_modules/sass-loader/lib/loader.js!./main.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)(undefined);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:300,400,500,700);", ""]);

// module
exports.push([module.i, ".clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.hidden{display:none}*{-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-tap-highlight-color:transparent}.fb_center{left:50%!important;top:50%!important;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}body{font-family:Source Sans Pro,Helvetica,sans-serif;font-size:16px;line-height:1;color:#333;width:100%;max-width:1500px;background-color:#fff;min-height:775px}body,html{padding:0;margin:0 auto}h1,h2,h3,h4,h5,h6{color:#000}img{max-width:100%;height:auto}input[type=color],input[type=date],input[type=datetime-local],input[type=datetime],input[type=email],input[type=month],input[type=number],input[type=password],input[type=search],input[type=tel],input[type=text],input[type=time],input[type=url],input[type=week],select{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-style:solid}button{outline:none!important}.browsehappy{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}h3{font-weight:500}[class*=telescope_icon_]{font-family:telescope_icons;display:inline-block;vertical-align:middle;line-height:1;font-weight:400;font-style:normal;speak:none;text-decoration:inherit;text-transform:none;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.view-home{text-align:center}.view-home h1{vertical-align:top}@media (max-width:750px){.mobile-hidden{display:none}}.header{margin:0;line-height:1.5}.header-container{width:100%;min-height:175px;padding:10px;position:relative;z-index:0}.header-container .logo{display:inline-block;width:auto;height:100%}.header-image{text-align:left;height:48px;display:block}.header-text{max-width:100%;text-align:left;margin-bottom:0;padding-top:30px}.header-text h1{margin:0;font-size:30px;font-weight:500;letter-spacing:-.025em;line-height:1.25}.header-text p{margin:0;color:#fff;font-size:16px;font-weight:400;letter-spacing:-.01em;line-height:1.25}.search-container{overflow:hidden;width:100%;position:relative;padding:10px;display:table}.search-text{width:100%;text-align:left;line-height:1.5}.search-form,.search-text{display:table-cell;position:relative}.search-form{width:0;white-space:nowrap;vertical-align:top}.search-form:before{position:absolute;top:50%;left:5px;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);pointer-events:none;font-size:14px}input[type=search]{width:22px;height:30px;padding:0;padding-left:22px;-webkit-transition:width .5s ease;-o-transition:width .5s ease;transition:width .5s ease}#search-clear,input[type=search]::-webkit-search-cancel-button{display:none!important}input[type=search]:focus{width:170px;padding-right:25px;outline:none}.clear-search{position:absolute;right:0;top:0;height:30px;width:40px;cursor:pointer;opacity:1;-webkit-transition:opacity 1s ease;-o-transition:opacity 1s ease;transition:opacity 1s ease;visibility:hidden;text-align:center}.clear-search:before{line-height:30px}input[type=search]:focus+.clear-search{visibility:visible}@media (min-width:550px){.header-image{height:75px}.header-text h1{font-size:30px}.header-text p{font-size:20px}}@media (min-width:750px){.header-container{padding:20px}.header-text h1{font-size:40px}.header-text p{font-size:20px}.search-container{padding:20px}}@media (min-width:970px){.header-image{text-align:right}input[type=search]{width:270px;padding-right:25px}input[type=search]:focus{width:270px}.clear-search{visibility:visible}.header-text{padding-top:0}}body.geo{background-color:#e8e8e8}.geo{margin-bottom:90px;padding-top:40px;text-align:center}.geo h3{margin:0 auto;padding:20px;font-size:20px}.geo .copy{padding:20px;line-height:1.5;font-size:16px;font-weight:200;max-width:225px;margin:auto}@media (min-width:750px){.geo{padding-top:60px}.geo h3{font-size:22px}.geo .copy{font-size:18px;max-width:240px}}.footer{font-size:100%;line-height:1.5;padding:10px 0 0}.footer a,.footer a:active,.footer a:hover,.footer a:visited{color:#fff;text-decoration:none}.footer-container{position:relative;width:100%;height:90px}.footer-text{position:relative;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);padding:5px 20px;color:#fff;width:auto;text-align:left;font-size:18px;line-height:20px;letter-spacing:-.01em;overflow:hidden}.footer-text img{display:inline-block;padding-bottom:5px}.footer-text .conditions{font-size:12px;line-height:10px}.button{width:auto;height:auto;margin:auto;text-align:center}.button .vote{font-family:Lato,sans-serif;padding:8.5px 0;color:#fff;vertical-align:middle;cursor:pointer;font-weight:500;font-size:14px;width:100%;max-width:150px;margin:0 auto;background-color:#000;letter-spacing:0;line-height:20px;display:inline-block}.button .vote:hover{outline:none;background-color:#7caa57}.button .vote:focus{outline:none}.button .eliminated-vote{background-color:#333;color:#fff;padding:6px 0 7px;vertical-align:middle;-webkit-transition:background-color 1s ease;-o-transition:background-color 1s ease;transition:background-color 1s ease}.button .eliminated-vote:hover{outline:none;background-color:#969696}.button .hover{background-color:#7caa57}.contestant{margin:0;overflow:hidden;background-color:#fff;cursor:pointer;width:100%;position:relative}.contestant figure{margin:0;padding:0;width:100%}.contestant img{width:100%;max-height:100%;display:block}.contestant-view{display:block;margin:12px 0 11px;min-height:16px;position:relative;text-align:center;width:100%}.contestant-view .firstname,.contestant-view .lastname{font-size:24px;display:inline-block;padding-bottom:5px}.contestant-view .details{font-size:18px;font-weight:400;padding:5px 0 4px;color:#999797}.contestant-view .third-details{font-size:16px;padding:5px 0}.contestant-view .description{font-weight:400;font-size:16px;padding:0 0 25px;line-height:1.5;text-align:center}.contestant-view .name{line-height:20px;letter-spacing:-.01em;font-weight:500;font-size:16px}.col-opt-3 li .contestant-view{margin:10px 0;min-height:40px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.contestant-detail{display:block;padding-top:2px;font-weight:400;font-size:16px;line-height:20px;letter-spacing:-.01em}.contestant.eliminated{opacity:.2}@media (min-width:750px){.contestant-view .name{font-size:18px}.col-opt-1 li .contestant-view,.col-opt-3 li .contestant-view{margin:16px 0 7px}.col-opt-2 li .contestant-view{margin:24px 0 22px}}.modal{position:fixed;padding:10px 0;background-color:rgba(0,0,0,.9);width:100%;height:100%;top:0;left:0;bottom:0;z-index:9000;overflow-y:scroll;-ms-overflow-style:none;scrollbar-width:none;display:none}.modal::-webkit-scrollbar{display:none}.view-modal{background-color:#fff;width:100%;margin:auto;position:absolute;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);border:0 solid transparent;min-height:600px;max-width:375px;padding-top:0}.view-modal h3{margin:0 auto;padding:70px 0 25px;width:100%;font-weight:400;font-size:22px;line-height:1.25}.view-modal h3,.view-modal p{text-align:center}.view-modal .text{text-align:left;width:90%;margin:0 auto;line-height:1.5}.view-modal>[class*=view-]{position:relative;width:100%;text-align:center;z-index:1}.view-modal>.view-vote-detail{position:unset}.modal .telescope_icon_close{text-shadow:0 0 2px #fff,0 0 2px #fff;z-index:100;cursor:pointer;position:absolute;top:9px;right:9px;display:inline-block;font-size:18px;padding:0;text-align:center;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out;height:50px;width:50px;border:none;background-color:transparent!important;-webkit-tap-highlight-color:transparent!important}.modal .telescope_icon_close:before{position:absolute;pointer-events:none;right:10px;top:10px}.view-error,.view-loading{text-align:center;padding:10px}.view-error .button,.view-loading .button{margin:25px 0}.view-error .button .vote,.view-loading .button .vote{max-width:289px}.view-error h3,.view-loading h3{padding:100px 0 55px;max-width:250px}.loading-gif img{width:120px;margin:0 auto}.loading-label{color:#909090}.headline-modal{font-size:18px;color:#a70000;font-weight:500;padding:25px 20px 10px;text-align:center}.error-detail{font-family:Lato,sans-serif;text-align:center;width:100%;font-weight:200;max-width:250px;margin:auto;font-size:19px;line-height:30px}.reauth-description{padding-bottom:30px}@media (max-width:395px){.view-modal{max-width:95%}}@media (min-width:750px){.modal{padding:25px 0}}.view-auth{text-align:center;color:#000}.view-auth .optin-form{padding-bottom:5px}.view-auth h3{padding:35px 0 10px}.socialBoxes{width:100%;padding:5px;height:auto}.socialBoxes span:not(.telescope_icon_facebook){font-size:14px;line-height:35px;font-family:Lato,sans-serif}.socialBoxes .telescope_icon_email,.socialBoxes .telescope_icon_facebook{padding-right:5px;line-height:22px;height:25px;font-size:20px;font-weight:500}.socialBoxes .eliminated{cursor:default;opacity:.2}.socialBox{border:1px solid transparent;height:37px;margin:10px auto;width:80%;border-radius:30px;color:#fff;text-align:center;cursor:pointer}.checkbox-parent{display:block;font-family:Lato,sans-serif;font-size:14px;font-weight:300;margin:15px auto;width:100%;max-width:252px;line-height:1.5;position:relative}.checkbox-parent a{-webkit-box-shadow:inset 0 -4px #90e4fd;box-shadow:inset 0 -4px #90e4fd;border-bottom:1px solid #90e4fd;color:#000;text-decoration:none}.checkbox-parent a:hover{border-bottom:0;-webkit-box-shadow:none;box-shadow:none}.checkbox-parent input[type=checkbox]{visibility:hidden;position:absolute}.checkbox-parent input[type=checkbox]+label{cursor:pointer;position:relative;padding-left:25px;display:block}.checkbox-parent label>span{display:inline-block;vertical-align:top}.checkbox-parent input[type=checkbox]+label:before{content:\"\";position:absolute;width:12px;height:12px;border:2px solid #8d8d8d;border-radius:3px;background-color:#f1f1f1;top:4px;left:0}.checkbox-parent input[type=checkbox]:checked+label:after{content:\"\";position:absolute;top:8px;left:4px;width:8px;height:3px;border:none;border-bottom:2px solid #000;border-left:2px solid #000;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.checkbox-parent input[type=checkbox].ui-state-error+label:before{border:2px solid red}.email-vote{width:100%;padding:0 0 40px}.email-vote h1{margin:5px auto}.email-vote h3{color:#909090;font-size:18px;font-weight:200;padding:5px 35px}.email-vote [type=email]{padding:10px 10px 10px 20px;margin:0 auto 15px}.email-vote [type=email],.email-vote [type=text]{border:2px solid transparent;background:#f1f1f1;width:80%;font-size:14px;font-weight:200;height:40px;padding:10px;display:block;margin:0 auto 11px;text-align:left;border-radius:4px}.email-vote [type=email]::-webkit-input-placeholder,.email-vote [type=text]::-webkit-input-placeholder{color:#000}.email-vote [type=email]:focus,.email-vote [type=email]:hover,.email-vote [type=text]:focus,.email-vote [type=text]:hover{outline:none}.email-vote [type=submit]{height:40px;display:block;width:80%;margin:5px auto;color:#fff;border:none;font-family:Lato,sans-serif;font-weight:500;border-radius:30px;padding:5px;font-size:14px;-webkit-transition:all 1s ease;-o-transition:all 1s ease;transition:all 1s ease}.email-vote [type=submit].eliminated{cursor:default;opacity:.2}.email-vote .email-address.email-invalid{border:2px solid red}.message{color:red;display:block}#emailAuthForm{margin:0 10px 15px}.facebook{background-color:#395ca9}.google{background-color:#dd4b39}.email{background:#dd4b39}.twitter{cursor:pointer;background-color:#55acee}@media (max-width:395px){.email-vote [type=email],.email-vote [type=submit],.socialBox{width:90%}}.view-thanks .thanks-wrapper{font-size:18px;font-weight:300;margin:0 auto 30px;max-width:300px}.view-thanks .votes-remaining span{font-weight:400}.view-thanks .sub-headline{line-height:1.25;margin:30px 0;font-weight:200;font-size:16px}.thanks-container{padding-bottom:20px;text-align:center}.thanks-container .share-copy{color:#000;font-size:18px;font-weight:300;padding:5px 0;margin-bottom:10px}.thanks-container h3{padding:30px 0 0}.thanks-container h4{font-size:16px;font-weight:500;margin:0}.thanks-container p{color:#000;font-size:16px}.thanks-container .button{margin:40px 0 30px}.thanks-container .button .vote{max-width:289px;width:90%}.thanks-container .btn-twitter-vote{background:-webkit-gradient(linear,left top,left bottom,from(#7bc0f3),to(#5fa8dd));background:-webkit-linear-gradient(top,#7bc0f3,#5fa8dd);background:-o-linear-gradient(top,#7bc0f3,#5fa8dd);background:linear-gradient(180deg,#7bc0f3,#5fa8dd)}.thanks-container .btn-twitter-vote:hover{cursor:pointer}.thanks-container .both-btns.twitter-button-div{margin-bottom:0}.thanks-container .both-btns.vote-again-button-div{margin-top:10px}.thanks-social{width:50%;margin:auto;text-align:center}.thanks-social .thanks{width:35px;height:35px;margin:0 5px;display:inline-block;vertical-align:middle;background:#00caf3;border-radius:30px}.thanks-social .thanks svg{fill:#fff!important}.thanks-social .facebook{width:35px;margin:0 auto;color:#fff;padding:7px 0;display:inline-block;background:none;text-align:center}.thanks-social .facebook:hover{-webkit-box-shadow:none;box-shadow:none}.thanks-social .facebook svg{height:22px;width:11px;fill:#395ca9}.thanks-social .twitter{width:30px;margin:0 auto;color:#fff;padding:8px 0;display:inline-block;text-align:center;background:none}.thanks-social .twitter:hover{-webkit-box-shadow:none;box-shadow:none}.thanks-social .twitter svg{height:20px;width:21px;fill:#55acee}.thanks-social .google{-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);box-shadow:0 2px 4px rgba(0,0,0,.2);width:35px;color:#fff;margin:0 auto;padding:5px 0;display:inline-block;background-color:#dd4b39;text-align:center}.thanks-social .google:hover{-webkit-box-shadow:none;box-shadow:none}.thanks-social .google img{display:inline-block;margin:0 5px;width:25px}.view-grid ul{width:100%;margin:0;font-size:0;padding:0}.view-grid [class^=col-opt-]{display:flex;display:-ms-flexbox;flex-wrap:wrap;-ms-flex-wrap:wrap;width:100%}.view-grid [class^=col-opt-] li{vertical-align:top;display:inline-block;padding:5px 5px 10px;list-style-type:none;text-align:center}.view-grid .remnant-1{-ms-flex-pack:center;justify-content:center}.view-grid .remnant-2{-ms-flex-pack:start;justify-content:start}.view-grid .col-opt-1 li,.view-grid .col-opt-2 li,.view-grid .col-opt-3 li{width:100%;padding:5px 0 10px}.view-grid .col-opt-1 li:not(:last-child),.view-grid .col-opt-2 li:not(:last-child),.view-grid .col-opt-3 li:not(:last-child){padding-bottom:27px}.view-grid .grid-header{text-align:left;padding-top:50px}.view-grid .grid-header .sponsor-wrapper{float:right;margin-top:20px}.view-grid h3{line-height:1.2;margin:0;max-width:75%;font-size:22px;font-weight:400;padding-bottom:15px}.view-grid p{line-height:25px;margin:0;max-width:75%}.view-grid .grid-footer,.view-grid p{font-family:Lato,sans-serif;font-size:19px;font-weight:300}.view-grid .grid-footer .rules-wrapper,.view-grid .grid-footer .user-wrapper{display:inline-block;vertical-align:middle;padding:20px 5px}.view-grid .grid-footer .rules-wrapper{margin-left:5px}.view-grid .grid-footer .user-wrapper{text-align:right}.view-grid .grid-footer a{color:#000;text-decoration:none;-webkit-box-shadow:inset 0 -4px #90e4fd;box-shadow:inset 0 -4px #90e4fd;border-bottom:1px solid #90e4fd}.view-grid .grid-footer a:hover{border-bottom:0;-webkit-box-shadow:none;box-shadow:none}.view-grid .grid-footer .greeting{display:none}@media (min-width:550px){.view-grid h3,.view-grid p{max-width:none}.view-grid .sponsor-wrapper{margin-top:0}.view-grid .col-opt-1 li,.view-grid .col-opt-3 li{width:33.33333%;padding:18px 9px}.view-grid .col-opt-1 li:not(:last-child),.view-grid .col-opt-3 li:not(:last-child){padding-bottom:65px}.view-grid .col-opt-1:not(.remnant-1) li:nth-child(3n),.view-grid .col-opt-3:not(.remnant-1) li:nth-child(3n){padding-right:0;padding-left:18px}.view-grid .col-opt-1:not(.remnant-1) li:first-child,.view-grid .col-opt-1:not(.remnant-1) li:nth-child(3n+1),.view-grid .col-opt-3:not(.remnant-1) li:first-child,.view-grid .col-opt-3:not(.remnant-1) li:nth-child(3n+1){padding-left:0;padding-right:18px}.view-grid .col-opt-2 li{width:50%;padding:18px 15px}.view-grid .col-opt-2 li:not(:last-child){padding-bottom:41px}.view-grid .col-opt-2 li:nth-child(odd){padding-left:0}.view-grid .col-opt-2 li:nth-child(2n){padding-right:0}.view-grid .grid-header{padding-top:50px}.view-grid .grid-footer .rules-wrapper{margin-left:20px}.view-grid .grid-footer .greeting{display:none}.view-grid h3{padding-bottom:5px}}@media (min-width:970px){.view-grid .grid-header{margin:0;padding-top:20px}.view-grid .grid-header .wrapper-text{padding-top:12px}.view-grid h3{display:inline-block;line-height:1.5}.view-grid p{display:inline-block;margin-left:5px}}.view-vote-detail .contestant-container{padding:0 0 35px}.view-vote-detail .contestant-container [class*=telescope_icon_arrow_]:before{font-size:23px;bottom:7px;position:absolute;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2}.view-vote-detail .contestant-container .prev-contestant:before{left:22px}.view-vote-detail .contestant-container .next-contestant:before{right:8px}.view-vote-detail [class*=telescope_icon_arrow_]{text-shadow:0 0 2px #fff,0 0 2px #fff}.view-vote-detail .button{margin:13px 0 0}.view-vote-detail .button .vote{width:165px;padding:10px 0}.view-vote-detail .votes-left{font-weight:300;margin:10px 0 24px}.gallery,.gallery .video{position:relative}.gallery .video{padding-bottom:56.25%;height:0}.gallery .video img{padding:0;margin:0 auto;width:100%}.gallery iframe{position:absolute;top:0;left:0;width:100%;height:100%;background-image:url(\"//ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1422567111.993.gif\");background-repeat:no-repeat;background-position:50%;background-color:#ccc}.gallery .image{position:relative;z-index:-1}.gallery .image img{width:100%;margin:0 auto;background-image:url(" + __webpack_require__(16) + ");background-repeat:no-repeat;background-position:50%;background-color:#ccc}.last-arrow-left,.last-arrow-right,.next-contestant,.prev-contestant{position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:22px;display:inline-block;font-size:20px;cursor:pointer;z-index:1;-webkit-tap-highlight-color:transparent}.prev-contestant{left:5px}.prev-contestant:hover{opacity:.75}.next-contestant{right:5px}.next-contestant:hover{opacity:.75}.last-arrow-left{left:5px}.last-arrow-left:hover{background-color:none;opacity:.2}.last-arrow-right{right:5px}.last-arrow-right:hover{background-color:none;opacity:.2}@media (min-width:550px){.view-vote-detail .last-arrow-left,.view-vote-detail .last-arrow-right,.view-vote-detail .next-contestant,.view-vote-detail .prev-contestant{width:27px}}@media (min-width:750px){.view-vote-detail .contestant-container [class*=telescope_icon_arrow_]{top:85%;height:15%}.view-vote-detail .last-arrow-left,.view-vote-detail .last-arrow-right,.view-vote-detail .next-contestant,.view-vote-detail .prev-contestant{width:36px}}.finalist-container{position:relative}.finalist-container .contestant-detail{height:auto;display:block}.finalist-container .contestant-detail .detail-info{display:inline}.finalist-container .contestant-view{height:auto;display:block}.finalist-container .contestant-view .name{display:inline}.finalist-container .button{width:35%;display:inline-block;position:absolute;height:50px;padding:0 10px;right:0;top:0;border:none}.finalist-container .button .vote{height:100%;padding-top:17px}.countdown-view-home{text-align:center}.countdown-view-home .branding-container{height:55px;margin-top:5px;text-align:center}.countdown-view-home .branding-container img{margin:auto;height:100%}.countdown-container{width:100%;margin:0 auto;margin-top:5px;padding:5px 2%}.countdown-container .intro-text{padding-bottom:5px;font-size:24px;font-weight:500}.countdown-unit{display:inline-block;vertical-align:middle;margin:5px auto;height:60px}.countdown-value{background:#fff;padding:10px;font-size:24px;width:100%;margin-bottom:-7px;font-weight:900}.countdown-unit-label{font-size:12px;color:#000;font-weight:500}.countdown-time{width:100%;margin:0 auto}.colon{vertical-align:middle;display:inline-block;position:relative;font-size:24px;margin:7px 0;height:100%;font-weight:900;color:#8a8a8a}@media (min-width:750px){.countdown-value{font-size:36px}}body.window{background-color:#e8e8e8}.window{margin-bottom:90px;padding-top:40px;text-align:center}.window h3{margin:0 auto;padding:20px;font-size:20px}.window .copy{padding:20px;line-height:1.5;font-size:16px;font-weight:200;max-width:240px;margin:auto}@media (min-width:750px){.window{padding-top:60px}.window h3{font-size:22px}.window .copy{font-size:18px;max-width:260px}}.view-winner{padding:20px}.view-winner h3{font-size:22px}.view-winner p{font-size:16px;font-weight:300}.view-winner .winner-copy span{font-weight:400}.view-winner .winner-image{max-width:650px}.view-winner .button{display:inline-block;margin:25px 0 20px;text-align:center;width:100%}.view-winner .button a{background-color:#444151;color:#fff;font-size:14px;line-height:50px;padding:12px 15px;text-decoration:none}@media (min-width:750px){.view-winner h3{font-size:26px}.view-winner p{font-size:19px}.view-winner .button{margin:45px 0 20px;text-align:left;width:auto}.view-winner .button a{font-size:16px;padding:15px 30px}}", ""]);

// exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/4abd850f2827de8b1d3b72798072be43.gif";

/***/ }),
/* 17 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(21);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(7)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../webpack/loaders/purifycss-custom-loader.js??ref--3-2!../../../node_modules/webfonts-loader/index.js!../../../node_modules/babel-loader/lib/index.js??ref--5-0!../../../node_modules/eslint-loader/index.js!./telescope_icons.font.js", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../webpack/loaders/purifycss-custom-loader.js??ref--3-2!../../../node_modules/webfonts-loader/index.js!../../../node_modules/babel-loader/lib/index.js??ref--5-0!../../../node_modules/eslint-loader/index.js!./telescope_icons.font.js");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)(undefined);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: \"telescope_icons\";\n  src: url(\"/fonts/telescope_icons.eot?#iefix\") format(\"embedded-opentype\"),url(\"/fonts/telescope_icons.woff\") format(\"woff\"),url(\"/fonts/telescope_icons.woff2\") format(\"woff2\"),url(\"/fonts/telescope_icons.ttf\") format(\"truetype\"),url(\"/fonts/telescope_icons.svg#telescope_icons\") format(\"svg\");\n}\n\n.telescope_icon {\n  line-height: 1;\n}\n\n.telescope_icon:before {\n  font-family: telescope_icons !important;\n  font-style: normal;\n  font-weight: normal !important;\n  vertical-align: top;\n}\n\n.telescope_icon_a_checkmark:before {\n  content: \"\\F101\";\n}\n\n.telescope_icon_arrow_left:before {\n  content: \"\\F102\";\n}\n\n.telescope_icon_arrow_right:before {\n  content: \"\\F103\";\n}\n\n.telescope_icon_clear:before {\n  content: \"\\F104\";\n}\n\n.telescope_icon_close:before {\n  content: \"\\F105\";\n}\n\n.telescope_icon_email:before {\n  content: \"\\F106\";\n}\n\n.telescope_icon_facebook:before {\n  content: \"\\F107\";\n}\n\n.telescope_icon_search:before {\n  content: \"\\F108\";\n}", ""]);

// exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

_.mixin({
    /**
     * @param string
     * @returns {string}
     */
    capitalize: function capitalize(string) {
        return string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
    },
    /**
     * Get query string param by name
     * window.location.search()
     *
     * @param name - String of param name
     * @return {string} value or empty string if not found
     */
    getQueryParamByName: function getQueryParamByName(name) {
        var regexS = '[\\?&]' + name + '=([^&#]*)';
        var regex = new RegExp(regexS);
        var results = regex.exec(window.location.search);
        if (results === null) {
            return '';
        } else {
            return decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
    },
    /**
     * https://github.com/kvz/phpjs/blob/master/functions/url/urlencode.js
     * @param url
     * @return {string} encoded url
     */
    urlencode: function urlencode(str) {
        str = (str + '').toString();
        // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
        // PHP behavior, you would need to add '.replace(/~/g, '%7E');' to the following.
        return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
    },
    /**
     * Returns a copy of the object with these values removed: null, "", undefined
     *
     * @param o - object literal
     * @return {object} clone of o, with falsy values removed
     */
    compactObject: function compactObject(o) {
        var clone = _.clone(o);
        _.each(clone, function (v, k) {
            if (_.isNull(v) || _.isUndefined(v) || _.isString(v) && v.length === 0) {
                delete clone[k];
            }
        });
        return clone;
    },
    /**
     * Returns if the given parameter has a truthy value or not
     */
    checkIfTrue: function checkIfTrue(val) {
        return ['true', '1', true, 1, 'yes'].indexOf(val) >= 0;
    }

});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var jQuery = __webpack_require__(2);

(function ($) {

    /**
     * Backbone does not have a native way to listen for a "Remove Event"
     * when any View is removed. If your View has some kind of Pooling or
     * Timer, it is handy to have a trigger stopping these processes
     * and preventing memory leaks.
     *
     * this plugin will dispatch a custom jQuery event when a DOM is removed
     * which we can listen on in our view
     *
     * i.e.
     *
     * var MainView = Backbone.View.extend({
     *   initialize : function(){
     *     _.bindAll(this);
     *     this.$el.on('destroyed', this.removeHandler);
     *   },
     *   removeHandler : function(){
     *     console.log('View has been destroyed, do we need to stop any Timer?');
     *   }
     * });
     *
     */
    $.event.special.destroyed = {
        remove: function remove(o) {
            if (o.handler) {
                o.handler();
            }
        }
    };

    /**
     * jQuery plugin
     * Mobile Web - Disable long-touch/taphold text selection
     *
     * code snippet from http://stackoverflow.com/questions/11237936/mobile-web-disable-long-touch-taphold-text-selection
     * http://jsfiddle.net/ebEqu/1/
     * usage $('.notSelectable').disableSelection();
     *
     */
    $.fn.extend({
        disableSelection: function disableSelection() {
            this.each(function () {
                this.onselectstart = function () {
                    return false;
                };
                this.unselectable = 'on';
                $(this).css('-moz-user-select', 'none');
                $(this).css('-webkit-user-select', 'none');
            });
        }
    });

    /**
     * jQuery alterClass plugin
     *
     * Remove element classes with wildcard matching. Optionally add classes:
     *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
     *
     * https://gist.github.com/peteboere/1517285
     *
     * Copyright (c) 2011 Pete Boere (the-echoplex.net)
     * Free under terms of the MIT license: http://www.opensource.org/licenses/mit-license.php
     *
     */
    $.fn.alterClass = function (removals, additions) {

        var self = this;

        if (removals.indexOf('*') === -1) {
            // Use native jQuery methods if there is no wildcard matching
            self.removeClass(removals);
            return !additions ? self : self.addClass(additions);
        }

        var patt = new RegExp('\\s' + removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') + '\\s', 'g');

        self.each(function (i, it) {
            var cn = ' ' + it.className + ' ';
            while (patt.test(cn)) {
                cn = cn.replace(patt, ' ');
            }
            it.className = $.trim(cn);
        });

        return !additions ? self : self.addClass(additions);
    };
})(jQuery);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modal = __webpack_require__(25);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _modal2.default;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.1.1
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2014 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

module.exports = function($) {
    // MODAL CLASS DEFINITION
    // ======================

    var Modal = function(element, options) {
        this.options = options;
        this.$body = $(document.body);
        this.$element = $(element);
        this.$backdrop = this.isShown = null;
        this.scrollbarWidth = 0;

        if (this.options.remote) {
            this.$element.find('.modal-content').load(
                this.options.remote,
                $.proxy(function() {
                    this.$element.trigger('loaded.bs.modal');
                }, this)
            );
        }
    };

    Modal.DEFAULTS = {
        backdrop: true,
        keyboard: true,
        show: true
    };

    Modal.prototype.toggle = function(_relatedTarget) {
        return this.isShown ? this.hide() : this.show(_relatedTarget);
    };

    Modal.prototype.show = function(_relatedTarget) {
        var that = this;
        var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });

        this.$element.trigger(e);

        if (this.isShown || e.isDefaultPrevented()) return;

        this.isShown = true;

        this.checkScrollbar();
        this.$body.addClass('modal-open');

        this.setScrollbar();
        this.escape();

        this.$element.on(
            'click.dismiss.bs.modal',
            '[data-dismiss="modal"]',
            $.proxy(this.hide, this)
        );

        this.backdrop(function() {
            var transition =
                $.support.transition && that.$element.hasClass('fade');

            if (!that.$element.parent().length) {
                that.$element.appendTo(that.$body); // don't move modals dom position
            }

            that.$element.show().scrollTop(0);

            if (transition) {
                that.$element[0].offsetWidth; // force reflow
            }

            that.$element.addClass('in').attr('aria-hidden', false);

            that.enforceFocus();

            var e = $.Event('shown.bs.modal', {
                relatedTarget: _relatedTarget
            });

            transition
                ? that.$element
                    .find('.modal-dialog') // wait for modal to slide in
                    .one($.support.transition.end, function() {
                        that.$element.trigger('focus').trigger(e);
                    })
                    .emulateTransitionEnd(300)
                : that.$element.trigger('focus').trigger(e);
        });
    };

    Modal.prototype.hide = function(e) {
        if (e) e.preventDefault();

        e = $.Event('hide.bs.modal');

        this.$element.trigger(e);

        if (!this.isShown || e.isDefaultPrevented()) return;

        this.isShown = false;

        this.$body.removeClass('modal-open');

        this.resetScrollbar();
        this.escape();

        $(document).off('focusin.bs.modal');

        this.$element
            .removeClass('in')
            .attr('aria-hidden', true)
            .off('click.dismiss.bs.modal');

        $.support.transition && this.$element.hasClass('fade')
            ? this.$element
                .one($.support.transition.end, $.proxy(this.hideModal, this))
                .emulateTransitionEnd(300)
            : this.hideModal();
    };

    Modal.prototype.enforceFocus = function() {
        $(document)
            .off('focusin.bs.modal') // guard against infinite focus loop
            .on(
                'focusin.bs.modal',
                $.proxy(function(e) {
                    if (
                        this.$element[0] !== e.target &&
                        !this.$element.has(e.target).length
                    ) {
                        this.$element.trigger('focus');
                    }
                }, this)
            );
    };

    Modal.prototype.escape = function() {
        if (this.isShown && this.options.keyboard) {
            this.$element.on(
                'keyup.dismiss.bs.modal',
                $.proxy(function(e) {
                    e.which == 27 && this.hide();
                }, this)
            );
        } else if (!this.isShown) {
            this.$element.off('keyup.dismiss.bs.modal');
        }
    };

    Modal.prototype.hideModal = function() {
        var that = this;
        this.$element.hide();
        this.backdrop(function() {
            that.$element.trigger('hidden.bs.modal');
        });
    };

    Modal.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove();
        this.$backdrop = null;
    };

    Modal.prototype.backdrop = function(callback) {
        var that = this;
        var animate = this.$element.hasClass('fade') ? 'fade' : '';

        if (this.isShown && this.options.backdrop) {
            var doAnimate = $.support.transition && animate;

            this.$backdrop = $(
                '<div class="modal-backdrop ' + animate + '" />'
            ).appendTo(this.$body);

            this.$element.on(
                'click.dismiss.bs.modal',
                $.proxy(function(e) {
                    if (e.target !== e.currentTarget) return;
                    this.options.backdrop == 'static'
                        ? this.$element[0].focus.call(this.$element[0])
                        : this.hide.call(this);
                }, this)
            );

            if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

            this.$backdrop.addClass('in');

            if (!callback) return;

            doAnimate
                ? this.$backdrop
                    .one($.support.transition.end, callback)
                    .emulateTransitionEnd(150)
                : callback();
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass('in');

            var callbackRemove = function() {
                that.removeBackdrop();
                callback && callback();
            };
            $.support.transition && this.$element.hasClass('fade')
                ? this.$backdrop
                    .one($.support.transition.end, callbackRemove)
                    .emulateTransitionEnd(150)
                : callbackRemove();
        } else if (callback) {
            callback();
        }
    };

    Modal.prototype.checkScrollbar = function() {
        if (document.body.clientWidth >= window.innerWidth) return;
        this.scrollbarWidth = this.scrollbarWidth || this.measureScrollbar();
    };

    Modal.prototype.setScrollbar = function() {
        var bodyPad = parseInt(this.$body.css('padding-right') || 0);
        if (this.scrollbarWidth)
            this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
    };

    Modal.prototype.resetScrollbar = function() {
        this.$body.css('padding-right', '');
    };

    Modal.prototype.measureScrollbar = function() {
        // thx walsh
        var scrollDiv = document.createElement('div');
        scrollDiv.className = 'modal-scrollbar-measure';
        this.$body.append(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.$body[0].removeChild(scrollDiv);
        return scrollbarWidth;
    };

    // MODAL PLUGIN DEFINITION
    // =======================

    var old = $.fn.modal;

    $.fn.modal = function(option, _relatedTarget) {
        return this.each(function() {
            var $this = $(this);
            var data = $this.data('bs.modal');
            var options = $.extend(
                {},
                Modal.DEFAULTS,
                $this.data(),
                typeof option == 'object' && option
            );

            if (!data)
                $this.data('bs.modal', (data = new Modal(this, options)));
            if (typeof option == 'string') data[option](_relatedTarget);
            else if (options.show) data.show(_relatedTarget);
        });
    };

    $.fn.modal.Constructor = Modal;

    // MODAL NO CONFLICT
    // =================

    $.fn.modal.noConflict = function() {
        $.fn.modal = old;
        return this;
    };

    // MODAL DATA-API
    // ==============

    $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function(
        e
    ) {
        var $this = $(this);
        var href = $this.attr('href');
        var $target = $(
            $this.attr('data-target') ||
                (href && href.replace(/.*(?=#[^\s]+$)/, ''))
        ); //strip for ie7
        var option = $target.data('bs.modal')
            ? 'toggle'
            : $.extend(
                { remote: !/#/.test(href) && href },
                $target.data(),
                $this.data()
            );

        if ($this.is('a')) e.preventDefault();

        $target.modal(option, this).one('hide', function() {
            $this.is(':visible') && $this.trigger('focus');
        });
    });
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var $ = __webpack_require__(2);

var Cms = __webpack_require__(27);
var Geo = __webpack_require__(31);
var Google = __webpack_require__(32);
var Connect = __webpack_require__(34);
var Facebook = __webpack_require__(39);
var Auth = __webpack_require__(44);
var Router = __webpack_require__(50);
var Countdown = __webpack_require__(117);
var VoteOption = __webpack_require__(120);
var PubSub = __webpack_require__(3);
var cookie = __webpack_require__(123);
var constants = __webpack_require__(5);

var AUTH_METHOD_EMAIL = constants.connect.AUTH_METHOD_EMAIL;
var AUTH_METHOD_FB = constants.connect.AUTH_METHOD_FB;

function getQueryParamByName(name, url) {
    var regexS = '[\\?&]' + name + '=([^&#]*)';
    var regex = new RegExp(regexS);
    var results = regex.exec(url || window.location.toString());
    if (results === null) return '';else return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/**
 * Returns true if app is iframed and parent site is opened in mobile FB app
 * @return {[type]} [description]
 */
function detectAppLocation() {
    return top !== self && /FBAV/.test(navigator.userAgent) ? true : false;
}

module.exports = function init(opts) {
    var options = opts || {};
    options.container = options.container || $(document.body);
    options.widget_id = options.widget_id || '714000e0c3842403';

    options.endpoints = _.extend({
        cms: 'https://widgetstate.votenow.tv/v1/state/',
        connect: 'https://voteapi.votenow.tv/s2/vote'
    }, $.type(options.endpoints) === 'object' ? options.endpoints : {});

    return new Controller(options);
};

function Controller(options) {
    this.Models = {};
    this.Collections = {};
    this.Views = {};
    this.Routers = {};

    this.options = options;

    //Detect the current environment.
    var env = _.getQueryParamByName('env');
    this.env = env;

    this.insideMobileApp = detectAppLocation();

    //Load config.php
    this.loadEnvironmentConfig().then(this.updateEndpoints.bind(this)) // Update endpoints
    .then(this.loadDashboardWidget.bind(this)) // Set up CMS then fetch
    // Set up the models, router, etc.
    .then(this.setUpGeo.bind(this)).then(this.setUpGoogle.bind(this)).then(this.setUpCollection.bind(this)).then(this.setUpFacebook.bind(this)).then(this.setUpCountdown.bind(this)).then(this.setUpAuth.bind(this)).then(this.setUpConnect.bind(this)).then(this.getSubmittedVotes.bind(this)).then(this.setUpPym.bind(this)).then(this.setUpRouter.bind(this, options)).then(this.setUpListeners.bind(this)).then(this.startApp.bind(this)).fail(function (error) {
        console.warn('error setting up:', error);
    });
}

_.extend(Controller.prototype, {
    loadEnvironmentConfig: function loadEnvironmentConfig() {
        return $.ajax('/config/endpoints.php?env=' + this.env);
    },

    updateEndpoints: function updateEndpoints(response) {
        var options = this.options;
        options.endpoints = _.extend(options.endpoints, response);
        return options;
    },

    loadDashboardWidget: function loadDashboardWidget() {
        var def = $.Deferred();
        var options = this.options;

        this.Models.Cms = new Cms({
            wid: options.widget_id,
            apiUrl: options.endpoints.cms,
            updateFrequency: 30
        }, {
            poll: true,
            ignoreQSP: false
        });

        var defCms = $.Deferred();
        $.when(defCms).always(function () {
            def.resolve();
        });

        return this.Models.Cms.fetch();
    },

    setUpGeo: function setUpGeo() {
        this.Models.Geo = new Geo({
            countries: this.Models.Cms.get('settings').countries
        });
        return this.Models.Geo.fetch({
            url: this.options.endpoints.geo
        });
    },

    setUpGoogle: function setUpGoogle() {
        this.Models.Google = new Google({}, {
            ga_id: this.Models.Cms.get('settings').google_analytics,
            ga_domain: 'auto'
        });
    },

    setUpCollection: function setUpCollection() {
        var sorting_key_cms = this.Models.Cms.get('text').views_nominee_grid.sorting_key;

        var show_eliminated = _.checkIfTrue(this.Models.Cms.get('text').views_nominee_grid.show_eliminated);
        var randomize = _.checkIfTrue(this.Models.Cms.get('text').views_nominee_grid.randomize_order);
        var sorting_key = sorting_key_cms !== '' ? sorting_key_cms : 'firstname';

        var data = this.Models.Cms.get('data');

        if (!show_eliminated) {
            this.Collections.VoteOption = new VoteOption(_.where(data, {
                eliminated: '0'
            }), {
                randomize: randomize,
                sorting_key: sorting_key
            }, {
                enable_eliminated: show_eliminated
            });
        } else {
            this.Collections.VoteOption = new VoteOption(data, {
                randomize: randomize,
                sorting_key: sorting_key
            }, {
                enable_eliminated: show_eliminated
            });
        }
    },

    setUpFacebook: function setUpFacebook() {
        var isReauthEnabled = this.Models.Cms.get('text')['view_reauth']['enable_reauth'];
        this.Models.Facebook = new Facebook({
            appId: this.Models.Cms.get('social').fb.id,
            insideMobileApp: this.insideMobileApp,
            reauthEnabled: _.checkIfTrue(isReauthEnabled)
        }, {});
    },

    setUpCountdown: function setUpCountdown() {
        this.Models.Countdown = new Countdown({
            //future_time: controller.Models.Cms.getCountdownTime(controller.Models.Cms.get('startTime')),
            //countdown_status: controller.Models.Cms.get('countdownStatus'),
            name: 'start timer'
        }, {
            cms: this.Models.Cms
        });
    },

    setUpAuth: function setUpAuth() {
        this.Models.Auth = new Auth({}, {
            facebook: this.Models.Facebook
        });

        this.listenTo(this.Models.Auth, 'change:isAuthorized', this.getSubmittedVotes.bind(this));
    },

    setUpConnect: function setUpConnect() {
        var settings = this.Models.Cms.get('settings');
        var options = this.options;

        this.Models.Connect = new Connect({
            apiKey: settings.apiKey
        }, {
            apiUrl: options.endpoints.connect,
            apiSecret: settings.secretKey,
            version_id: settings.version_id
        });
        this.Models.Connect.apiUrl = options.endpoints.connect;
        this.Models.Connect.versionCheck = 'fmuWGPAfZK7WD8T3Ug8u';
    },

    getSubmittedVotes: function getSubmittedVotes() {

        if (this.Models.Connect && this.Models.Auth.get('isAuthorized')) {

            var attrs = {
                action_type: constants.connect.ACTION_TYPE_GET,
                method: this.Models.Auth.get('authType'),
                timestamp: this.Models.Cms.get('ts'),
                user_id: this.Models.Auth.get('userID')
            };

            this.Models.Connect.save(attrs).then(function (response) {
                var totalSubmittedVotes = response.total_votes.length > 0 ? parseInt(response.total_votes, 10) : 0;
                this.Models.Auth.setSubmittedVotes(totalSubmittedVotes);
            }.bind(this));
        }
    },

    setUpPym: function setUpPym() {
        // initialize pym.js if app is iframed
        if (top !== self) {
            //moved to router
            // this.Models.pymChild = new pymJS.Child( { polling: 500 } );

            if (this.insideMobileApp) {
                // var url = this.Models.pymChild.parentUrl;
                var url = _.getQueryParamByName('parentUrl');
                var accessToken = getQueryParamByName('#access_token', url) || getQueryParamByName('access_token', url) || cookie.readCookie('manualLogin');
                var accessTokenExpiration = parseInt(getQueryParamByName('expires_in') || 0, 10);

                if (accessToken) {
                    this.manualOAuth(accessToken, accessTokenExpiration);
                }
            }
        }
    },

    setUpRouter: function setUpRouter(options) {
        this.Routers.Router = new Router({
            controller: this,
            cms: this.Models.Cms,
            facebook: this.Models.Facebook,
            connect: this.Models.Connect,
            auth: this.Models.Auth,
            voteOption: this.Collections.VoteOption,
            container: options.container,
            uniqueId: options.uniqueId
        });
    },

    setUpListeners: function setUpListeners() {
        // add to setUpListeners
        this.listenTo(this.Models.Auth, 'clearUser', this.clearUser.bind(this));
        this.listenTo(this.Models.Connect, 'sync', this.handleVoteApiResponse.bind(this));

        this.listenTo(PubSub, 'cast-vote', this.castVote.bind(this));
        this.listenTo(PubSub, 'clearUser', this.clearUser.bind(this));
        this.listenTo(PubSub, 'trackGoogle', this.trackGoogle.bind(this));

        this.listenTo(this.Models.Cms, 'change:sid', function () {
            this.setUpCollection();
            if (this.isWindowOpen()) {
                // Update the router with the new CMS data
                this.Routers.Router.voteOption = this.Collections.VoteOption;
                this.Routers.Router.home();
            } else {
                this.Routers.Router.window();
            }
        }.bind(this));
    },

    startApp: function startApp() {
        var isInRegion = this.Models.Geo.get('inRegion');
        var isWindowOpen = this.isWindowOpen();

        //if the user is not in a valid region, show the geo view
        if (!isInRegion) {
            this.Routers.Router.geo();
        } else {
            //if the user is in a valid region and the window is open
            if (isWindowOpen) {
                this.Routers.Router.home();
                //if the user in in a valid region but the window is closed
            } else {
                this.Routers.Router.window();
            }
        }
    },

    isWindowOpen: function isWindowOpen() {

        var windowStatus = parseInt(this.Models.Cms.get('settings')['window_status'], 10);

        if (windowStatus === 1) {
            return true;
        }

        return false;
    },

    trackGoogle: function trackGoogle(params) {
        this.Models.Google.save({
            eventCategory: params.category,
            eventAction: params.action,
            eventLabel: params.label
        });
    },

    clearUser: function clearUser() {
        console.log('CLEAR USER');
        if (!_.isUndefined(this.Models.Vote)) {
            this.Models.Vote.clear();
            this.Models.Vote = null;
            delete this.Models.Vote;
        }

        this.Models.Auth.set(this.Models.Auth.defaults);
        this.Models.Auth.setSubmittedVotes(0);
        this.Models.Facebook.clearUser();
        this.Collections.VoteOption.clearVoteCount();
        this.Models.Connect.clear({ silent: true }).set(this.Models.Connect.defaults);
        this.Models.Connect.set('apiKey', this.Models.Cms.get('settings').apiKey);

        // clear out stored opt-ins, if any

        for (var x in localStorage) {
            if (localStorage.hasOwnProperty(x)) {
                if (x.indexOf('optin_') !== -1) {
                    localStorage.removeItem(x);
                }
            }
        }

        // close any open models
        this.Routers.Router.closeCurrentModal();
    },

    manualOAuth: function manualOAuth(accessToken, accessTokenExpiration) {
        cookie.createCookie('manualLogin', accessToken, accessTokenExpiration);

        console.log('manualOAuth', accessToken);
        var deferred = $.Deferred();

        this.Models.Facebook.set({ accessToken: accessToken });
        this.Models.Facebook.setUserDataWithToken(deferred);

        deferred.then(function (user) {
            this.Models.Auth.set({
                isAuthorized: true,
                authType: 'facebook',
                userName: user.name,
                userID: user.email
            });
        }.bind(this));
    },

    stopPolling: function stopPolling() {
        var cms = this.Models.Cms;
        cms.stopPolling();
    },

    patchCmsData: function patchCmsData(newData) {
        var cms = this.Models.Cms;
        // why not _.extend? we want a deep extend below, and might
        // as well use the same method in both cases
        var data = $.extend({}, cms.attributes);

        data = $.extend(true, data, newData);

        cms.set(data);
        console.info('votewidget.js data: ', data);
        console.info('votewidget.js cms: ', cms);

        cms.trigger('change:text');
        this.Routers.Router.home();
    },

    randomizeData: function randomizeData() {
        var cms = this.Models.Cms;

        // why not _.extend? we want a deep extend below, and might
        // as well use the same method in both cases
        var data = $.extend({}, cms.attributes);

        var colorValue = parseInt(Math.random() * 0xffffff, 10).toString(16);
        var newData = {
            ts: Math.random(),
            text: {
                design: {
                    css: {
                        vote_button: {
                            color: '#' + colorValue
                        }
                    }
                }
            }
        };

        data = $.extend(true, data, newData, {
            foobar: Math.random()
        });

        this.Models.Cms.set(data);

        this.Routers.Router.home();
    },

    /* We need a way for the user to cleanly remove our widget. */
    remove: function remove() {
        console.log(this);
        if (this.Routers.Router) {
            this.Routers.Router.destroy();
            this.Routers.Router.controller = null;

            _.each(this.Models, function (model, key) {
                console.log('removing ', key);
                if (model.off) {
                    model.off();
                    model.stopListening();
                    model.controller = null;
                }
                delete this.Models[key];
            });

            _.each(this.Collections, function (collection, key) {
                console.log('removing ', key);
                if (collection) {
                    collection.off();
                    collection.stopListening();
                    collection.reset();
                    collection.controller = null;
                }
                delete this.Collections[key];
            });

            this.Collections = {};

            _.each(this.Views, function (view, key) {
                console.log('removing ', key);
                if (view) {
                    view.off();
                    view.stopListening();
                    view.remove();
                    view.controller = null;
                }
                delete this.Views[key];
            });

            this.Models = {};
            this.Views = {};
            this.Controllers = {};
            this.Routers = {};
        } else {
            console.warn('Vote Widget:  Cannot be removed before initialization.');
        }
    },

    //util functions for connect
    getUserData: function getUserData() {
        var data = {};
        var fbModel = this.Models.Facebook;
        var authModel = this.Models.Auth;
        var authType = authModel.get('authType');

        if (authType === AUTH_METHOD_EMAIL) {

            _.extend(data, {
                user_id: authModel.get('userID'),
                method: AUTH_METHOD_EMAIL
            });
        } else if (authType === AUTH_METHOD_FB) {

            _.extend(data, {
                user_id: fbModel.get('user').identifier,
                fb_first_name: fbModel.get('user').first_name,
                fb_last_name: fbModel.get('user').last_name,
                fb_email: fbModel.get('user').email,
                method: AUTH_METHOD_FB
            });
        }

        return data;
    },
    /**
     * [ getVoteData ]
     */
    getVoteData: function getVoteData(voteCount) {
        var data = {};
        var selected = this.Collections.VoteOption.getSelected();

        if (_.isObject(selected)) {

            data.v = selected.get('id');
            data.total = voteCount;

            return data;
        } else {
            return null;
        }
    },

    /**
     * @todo: ask tech ops if they can expose an endpoint to access optin or other user data
     * instead of storing data on the client side
     *
     */
    getOptinData: function getOptinData() {
        var optins = {};
        for (var x in localStorage) {
            if (localStorage.hasOwnProperty(x)) {
                if (x.indexOf('optin_') !== -1) {
                    optins[x] = localStorage[x];
                }
            }
        }
        return optins;
    },

    castVote: function castVote(voteCount) {
        // return when no vote data is available
        var voteData = this.getVoteData(voteCount);
        if (voteData === null) return;

        var attrs = {
            action_type: constants.connect.ACTION_TYPE_VOTE,
            timestamp: this.Models.Cms.get('ts'),
            country: this.Models.Geo.get('country'),
            state: this.Models.Geo.get('geoheaders').region
        };

        _.extend(attrs, this.getOptinData(), this.getUserData(), voteData);

        this.Models.Connect.save(attrs);

        //show loading animation
        this.Routers.Router.loading();
    },

    handleVoteApiResponse: function handleVoteApiResponse(model) {
        console.log('requestActionVoteSuccess:\t', model);

        if (!model.get('action_type') || model.get('action_type') === constants.connect.ACTION_TYPE_GET) {
            return;
        }

        var totalVotes = model.get('response').total_votes.length > 0 ? parseInt(model.get('response').total_votes, 10) : 0;
        this.Models.Auth.setSubmittedVotes(totalVotes);

        switch (model.get('response').response_code) {
            case '20':
                this.Routers.Router.thanks();
                break;
            case '21':
                this.Routers.Router.error('overlimit');
                break;
            case '16':
                this.Routers.Router.error();
                break;
            case '40':
                this.Routers.Router.error('window');
                break;
            case '22':
                this.Routers.Router.error('ge0');
                break;
            default:
                this.Routers.Router.error();
        }
    }
}, Backbone.Events);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cms = __webpack_require__(28);

var _cms2 = _interopRequireDefault(_cms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _cms2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var CmsModel = __webpack_require__(29);

module.exports = CmsModel.extend({

    parse: function(response) {
        //etags: 304 response
        if( response === undefined ) {
            return undefined;
        }
        response = CmsModel.prototype.parse.call( this, response );

        var data = response.data;

        for(var i = 0; i < data.length; i++) {
            data[i].image = data[i].image.replace(/^http:\/\//i, 'https://');
        }

        response.data = data;

        console.log(response);

        response.windowStatus = parseInt(response.settings.window_status);

        return response;
    }

});


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var getQueryParamByName = __webpack_require__(30);
var managerSingleton = null;

function CMSManager (){
    var cmsList = [];

    // Simple count of all CMS objects in the system
    this.count = function() {
        return cmsList.length;
    };

    // This is called automatically by every CMS object
    // created, and should never need to be called manually
    this.add = function (cms) {
        var manager = this;
        function eventHandler(model){
            manager.trigger('change', model);
        }
        this.listenTo(cms,'change',eventHandler);
        cmsList.push(cms);
    };

    // Returns all CMS objects with the given widget ID,
    // or if widget ID is not set, returns all tracked
    // CMS objects.
    this.get = function(wid) {
        if(typeof wid !== 'string') {
            return cmsList.slice();
        }
        var retList = [];
        for(var i = 0; i < cmsList.length; i ++) {
            if(cmsList[i].get('wid') == wid) {
                retList.push(cmsList[i]);
            }
        }
        return retList;
    }

    // Allows an individual CMS object to be removed from
    // the system.  Use this when the CMS object is destroyed.
    // Stops listening to this object's events.  Boolean
    // return for whether the CMS object existed to begin with.
    this.remove = function(cms) {
        for(var i = 0; i < cmsList.length; i ++) {
            if(cms === cmsList[i]) {
                this.stopListening(cms);
                cmsList.splice(i,1);

                // There should only ever be one instance
                // of this object in the array, so return
                // now
                return true;
            }
        }
        return false;
    };

    // Remove all CMS objects from the system. Stops listening
    // to all objects.
    this.clear = function() {
        var tempList = cmsList.slice();
        for(var i = 0; i < tempList.length; i ++) {
            this.remove(tempList[i]);
        }
    };
};

managerSingleton = new CMSManager();
_.extend(managerSingleton, Backbone.Events);

var TSComCMS = Backbone.Model.extend({

    defaults: {
        /**
         * Where to pull the data from.
         * Different servers have different needs / capabilities.  Like caching.
         */
        apiUrl: 'https://widgetstate.votenow.tv/v1/state/',
        /**
         * The widget ID to retrieve.
         * Should be found in the URL Query String Parameter or hardcoded in 'initialize()'
         */
        wid: 'data/data.json', // default template widget
        /**
         * The etag.
         * to access the cdn's etag cache
         */
        etag: null,
        /**
         * The snapshot ID (if necessary).
         * Should be found in the URL Query String Parameter
         */
        sid: null,
        useSID: null,
        /**
         *  Timestamp of widget
         */
        ts: null,
        /**
         * Window Status, abstracted from the widget 'settings' key
         */
        windowStatus: null,
        /**
         * Widget Text
         */
        text: {},
        /**
         * Widget Settings
         */
        settings: {},
        /**
         * Widget CSS
         */
        css: {},
        /**
         * Widget Data: Vote Options, Poll and Trivia Questions, Mood Buttons
         */
        data: [],
        /**
         * Social Configuration: Facebook and Twitter app and share info
         */
        social: {},
        /**
         * All data from CMS API
         */
        raw: {},
        /**
         * The number of seconds to wait before updating again.
         */
        updateFrequency: 30,
        /**
         *
         */
        pollTimer: null,
        /**
         *
         */
        initialized: false
    },

    /**
     * enable polling?
     */
    poll: true,

    /**
     * [initialize description]
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     */
    initialize: function(attrs, options) {
        managerSingleton.add(this);

        var wid = ((getQueryParamByName('wid').length === 0 || options.ignoreQSP) ? undefined : getQueryParamByName('wid')) || attrs.wid || this.defaults.wid,
            sid = ((getQueryParamByName('sid').length === 0 || options.ignoreQSP) ? undefined : getQueryParamByName('sid')) || attrs.sid || this.defaults.sid,
            useSID = (!_.isNull(sid)) ? sid : null; // Force the Cms to use a specific Snapshot ID from Connect's CMS

        // console.log('CmsModel initialize', wid, sid, useSID);
        if (typeof options === 'object') {
            for (var prop in options) {
                if (typeof this[prop] !== 'undefined') {
                    this[prop] = options[prop];
                }
            }
        }

        this.set({
            wid: wid,
            useSID: useSID
        });
    },

    /**
     * Builds the URL to fetch data from the Connect API
     * @return {[type]} [description]
     */
    urlRoot: function() {
        var url = (
            this.get('wid').search(/\//) === -1 ?
            // If there is a numeric wid provided, then use the base
            // url and query for that particular id.
            this.get('apiUrl') + '/' + this.get('wid') + (!_.isNull(this.get('useSID')) ? '/snapshot/' + this.get('useSID') : '')
            // Otherwise, get the file specified by the wid field, i.e. '/test/cms/widget_data.php'
            : this.get('wid') + '?' + Math.random()
        );
        return url;
    },

    /**
     * [sync description]
     * @param  {[type]} crud    [description]
     * @param  {[type]} model   [description]
     * @param  {Object} options [description]
     * @return {[type]}         [description]
     */
    sync: function(crud, model, options) {
      var params = {
          url: this.urlRoot(),
          type: 'GET',
          dataType: 'json',
          crossDomain: true
      };
      var etag = this.get('etag');
      if(etag){
          options.beforeSend = function(xhr) {
              xhr.setRequestHeader('if-none-match', etag);
          };
      }
      _.extend(params, options);

      this.xhr = Backbone.sync(crud, model, params);

      return this.xhr;
    },


    /**
     * [save description]
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     */
    save: function(attrs, options) {
        console.warn('The CMS model does not support "save"');
    },

    /**
     * [destroy description]
     * @param  {Object} options [description]
     */
    destroy: function(options) {
        console.warn('The CMS model does not support "destroy"');
    },

    /**
     * [requestData description]
     * @param  {Object} options [description]
     */
    requestData: function(options) {
        this.fetch(options);
    },

    fetch: function(options) {
        if (this.poll) {
            this.pollData();
        }
        //changed to return to return the sync, useful for calling .done() after
        return Backbone.Model.prototype.fetch.call(this, options);
    },


    parse: function(data, option) {
        if( data === undefined ) {
          return undefined;
        }

        var parsedData = _.extend({}, {
          initialized: true,
          raw: data, // Update full CMS output

          metadata: {
            current_timestamp: data.current_timestamp,
            snapshot_start_timestamp: data.snapshot.schedule,
            name: data.snapshot.name,
          },

          sid: data.snapshot.snapshot_id,
          data: data.snapshot.data.data,
          settings: data.snapshot.data.settings,
          social: data.snapshot.data.social,
          text: data.snapshot.data.text,
          windowStatus: parseInt(data.snapshot.data.settings.window_status),
          ts: data.current_timestamp,
          etag: this.xhr.getResponseHeader('etag')
        });

        return parsedData;
    },

    /**
     * Sets the polling timer
     */
    pollData: function() {
        clearTimeout(this.get('pollTimer'));

        this.set({
            pollTimer: setTimeout(_.bind(this.fetch, this), parseInt(this.get('updateFrequency'), 10) * 1000)
        });
    },

    /**
     * Stop polling and clear the timer
     */
    stopPolling: function() {
        this.poll = false;
        var pollTimer = this.get('pollTimer');
        if(typeof pollTimer == 'number') clearTimeout(pollTimer);
        this.set('pollTimer', null);
    }
});

module.exports = TSComCMS;
module.exports.manager = managerSingleton;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Get query string param by name
 * window.location.search()
 *
 * @param name - String of param name
 * @return {string} value or empty string if not found
 */
module.exports = function (name) {
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(window.location.search);

	if (results === null) return '';
	else return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__(2);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
Backbone.$ = $;

module.exports = Backbone.Model.extend({
    urlRoot: '/api/getregion.json',
    url: '/api/getregion.json',

    defaults: {
        inRegion: null,
        geoheaders: {
            city: null,
            country: null,
            region: null,
            timezone: null,
            zipcode: null
        }
    },

    /**
     * Initialize
     * @param  {Object} options [description]
     */
    initialize: function (options) {
        this.countries = this.parseCountries(options.countries);
    },

    /**
     * Fetch
     * @param {Object} options [options to pass onto fetch]
     */
    fetch: function(options) {
        var deferred = $.Deferred();
        this.once('change:geoheaders', this.handleSync.bind(this,deferred,this));
        
        // call original fetch function
        Backbone.Model.prototype.fetch.call(this, options);
        
        // Returning deferred instead of fetch. 
        // Will resolve deferred after parsing geoheaders  
        return deferred;
    },

    /**
     * [parseCountries description]
     * @param  {String/Array} list [description]
     * @return {Array}             [description]
     */
    parseCountries:function(list) {
        var countries = [];
        if (list) {
            if(_.isString(list) ) {
                var splitCountries = list.split(",");
                $.each(splitCountries, function (index, country) {
                    countries.push($.trim(country));
                });
            } else if(_.isArray(list) ) {
                countries = list;
            }
        }
        return countries;
    },

    /**
     * [handleSync description]
     * @param  {Object} deferred [jQuery deferred to be resolved/rejected]
     * @param  {[type]} model [description]
     */
    handleSync: function (deferred, model) {
        var geoheaders = model.get('geoheaders');

        if (geoheaders) {
            var inRegion = this.countries.indexOf( geoheaders.country ) > -1;
            if (inRegion || this.countries.length === 0) {
                this.set({
                    inRegion: true,
                    country: geoheaders.country
                });
            } else {
                this.set({
                    inRegion: false,
                    country: 'undefined'
                });
            }
            deferred.resolve(model);
        } else {
            this.set({
                inRegion: false,
                country: 'undefined'
            });
            deferred.resolve(model);
            //deferred.reject(model);
        }
    }
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GoogleModel = __webpack_require__(33);

// https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#using_localstorage_to_store_the_client_id
module.exports = GoogleModel.extend({
    /**
     * Creates ga object with namespace name from attribute
     */
    createGA: function createGA() {

        var GA_LOCAL_STORAGE_KEY = 'ga:clientId';
        if (window.localStorage) {
            //create GA with namespace
            ga('create', this.ga_id, this.ga_domain, {
                'name': this.get('namespace'),
                'storage': 'none',
                'clientId': localStorage.getItem(GA_LOCAL_STORAGE_KEY)
            });

            ga(function (tracker) {
                localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
            });
        } else {
            ga('create', this.ga_id, this.ga_domain, {
                'name': this.get('namespace')
            });
        }

        ga(this.get('namespace') + '.send', 'pageview');
    }
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global TLSCP, Backbone, _ */


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);

var GA_LOCAL_STORAGE_KEY = 'ga:clientId';

module.exports = Backbone.Model.extend({

    defaults: {
        eventCategory: "",
        eventAction: "",
        eventLabel: "",
        windowStatus: -1,
        //default namespace for telescope apps
        namespace: "telescopeinc"
    },
    /**
     * init function
     */
    initialize: function (attributes, options) {
        "use strict";
        try {
            if (_.isUndefined(options.ga_id)) {
                throw Error('Google Analytics ID must be provided');
            }
        } catch (e) {
            console.log(e);
        }

        this.ga_id = options.ga_id;
        this.ga_domain = options.ga_domain || 'auto';
        if (options.windowStatus)
            this.set({ windowStatus: options.windowStatus });
        //custom namespaces appended to end of telescopeinc-
        if (options.namespace)
            this.set({ namespace: "telescopeinc-" + options.namespace });

        this.useLocalStorage = options.useLocalStorage || false;

        //check if GA is initialized and if same name space has been initialized
        if (typeof ga !== 'undefined'
            && typeof ga.getByName(this.get('namespace')) !== 'undefined') {
            //display warning if imnitialized and namespace already exists
            console.warn('Google Analytics with same namespace has already been initialized.');
        }
        else if (typeof ga !== 'undefined'
            && typeof ga.getByName(this.get('namespace')) === 'undefined') {
            // don't load script but create ga with new namespace
            this.createGA();
        }
        else {
            // requires a ga_id
            this.loadScript();
        }

        _.bindAll(this, "getWindowStage");

    },
    /**
     * Saves attribute data if it exists then calls function to send data
     * @param attr  Holds attributes to set. Optional.
     * @param options  Not used
     */
    save: function (attrs, options) {
        attrs = attrs || {};
        this.set(attrs, { silent: true });
        this.sendGA();
    },
    /**
     * This uses the attributes to send data to google
     */
    sendGA: function () {
        var category = this.get('eventCategory')
            , action = this.get('eventAction')
            , label = this.get('eventLabel') + " : " + this.getWindowStage();
        ;

        console.log('send', 'event', category, action, label);

        ga(this.get('namespace') + '.send', 'event', category, action, label);
    },
    /**
     * Older function that depended on passed in params to sendData
     * @param {getEvent}
     * @param {windowStatus} text to use
     * @param {addText} Text to add to action
     */
    log: function (getEvent, windowStatus, addText) {
        var params = this.get(getEvent);

        if (_.isUndefined(params)) {
            params = {
                category: getEvent,
                action: getEvent
            }

            if (!_.isUndefined(addText)) {
                params.action += " " + addText;
            }

            if (!_.isUndefined(windowStatus)) {
                var windowStage = this.getWindowStage(windowStatus);
                params.action += " : " + windowStage;
            }

            params.label = params.action + " : " + this.device;

            console.log(" (unmapped): getEvent=%o; params=%o;", getEvent, params);
        } else {
            params.action = params.category + " : " + params.name;
            if (params.addDescription && !_.isUndefined(addText)) {
                params.action += " " + addText;
            }

            if (params.useWindow && !_.isUndefined(windowStatus)) {
                var windowStage = this.getWindowStage(windowStatus);
                params.action += " : " + windowStage;
            }
            params.label = params.action + " : " + this.device;

            console.log("Google: getEvent=%o; params=%o;", getEvent, params);
        }

        console.log("%o %o %o %o %o %o", 'send', 'event', params.category, params.action, params.label, this.get("ga_id"));
        ga(this.get('namespace') + '.send', 'event', params.category, params.action, params.label);
    },
    /**
     * gets window status from attribute to determine window
     */
    getWindowStage: function () {
        var windowStage;

        switch (this.get('windowStatus')) {
            case 0:
                windowStage = "window closed";
                break;
            case 1:
                windowStage = "window open";
                break;
            default:
                windowStage = "window unknown";
                break;
        }
        return windowStage;
    },
    /**
     * Loads google analytics script and then calls function to create ga object
     */
    loadScript: function () {

        (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
            m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        this.createGA();

    },
    /**
     * Creates ga object with namespace name from attribute
     */
    createGA: function () {

        if (window.localStorage && this.useLocalStorage) {
            ga('create', this.ga_id, this.ga_domain, {
                'name': this.get('namespace'),
                'storage': 'none',
                'clientId': localStorage.getItem(GA_LOCAL_STORAGE_KEY)
            });
            ga(function (tracker) {
                localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
            });
        }
        else {
            ga('create', this.ga_id, this.ga_domain, { 'name': this.get('namespace') });
        }

        ga(this.get('namespace') + '.send', 'pageview');

    }

});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);

var BASE64 = __webpack_require__(35);
var SHA256 = __webpack_require__(36);

module.exports = Backbone.Model.extend({

    apiUrl: 'https://voteapi.votenow.tv/s2/vote',

    defaults: {
        apiKey: ''
    },

    /**
     * Internal options and values
     */
    secretKey: '',
    version_id: '',
    device: 'unknownpc',
    response: null,
    versionCheck: '',

    /**
     * Initialize
     * @param  {Object} attr    [description]
     * @param  {Object} options [description]
     */
    initialize: function(attr, options) {
        _.bindAll(this, 'syncSuccess', 'syncError');

        if (typeof options === 'object') {
            for (var prop in options) {
                if (typeof this[prop] !== 'undefined') {
                    this[prop] = options[prop];
                }
            }
        }

    },

    /**
     * Override sync method to make requests to the Vote API.
     * @param {String}         crud    - Will be one of: 'create', 'read', 'update', 'destroy'.  We use the value to determine action type.
     * @param {Backbone.Model} model   - A reference to this model.
     * @param {Object}         options - A JS object with options for $.ajax.
     * @return {[type]}                [description]
     */
    sync: function(crud, model, options) {
        var qsp = this.paramsLiteralToQsp(model.toJSON());
        var b64hash = this.qspToHash(qsp);

        var params = {
            url: this.urlRoot(),
            type: 'POST',
            crossDomain: true,
            dataType: 'json',
            data: 'Authorization=' + encodeURIComponent(b64hash)
        };

        _.extend(params, options);

        return Backbone.sync(crud, model, params).done(this.syncSuccess).fail(this.syncFail);
    },

    /**
     * Fetch
     * @param  {Object} options [description]
     */
    fetch: function(options) {
        this.set({ action_type: 'get' }, { silent: true });
        return this.sync('read', this, options);
    },

    /**
     * Save
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     * @return {[type]}         [description]
     */
    save: function(attrs, options) {
        attrs = attrs || {};
        attrs.action_type = attrs.action_type || this.get('action_type') || 'vote';

        delete attrs.response;
        delete attrs.status;
        this.unset('response', { silent: true });
        this.unset('status', { silent: true });

        this.set(attrs, { silent: true });
        return this.sync('create', this, options);
    },

    /**
     * Override Backbone's urlRoot to generate the URL with hashed params.
     * @return {String} [description]
     */
    urlRoot: function() {
        var params = this.paramsLiteralToQsp(this.toJSON());
        var b64hash = this.qspToHash(params);

        return this.apiUrl + '?' + params;
    },

    /**
     * Connect doesn't support 'destroy' so let's warn the user.
     * @param {Object} options [description]
     */
    destroy: function(options) {
        console.warn('Connect API does not support the "destroy" method.');
    },

    /**
     * Callback for If AJAX send vote success
     * @param {[type]} response [description]
     */
    syncSuccess: function(response) {
        if (!response) response = {};
        this.set({
            response: response,
            status: "success"
        });

        this.trigger('sync', this);
    },

    /**
     * Callback for AJAX send vote fail
     * @param {[type]} response [description]
     */
    syncError: function(response) {
        this.set({
            response: {},
            status: 'error'
        });

        this.trigger('error', this);
    },

    /**
     * [qspToHash description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    qspToHash: function(data) {
        var secret = this.version_id + this.versionCheck;
        var hash = SHA256(data, secret);
        return BASE64.stringify(hash);
    },

    /**
     * [paramsLiteralToQsp description]
     * @param  {Object} params [description]
     * @return {String}        [description]
     */
    paramsLiteralToQsp: function(params) {
        var pars = [],
            params_str;
        _.each(params, _.bind(function(value, key, list) {
            if (typeof value !== 'undefined') {
                pars.push(key + '=' + this.fixedEncodeURIComponent(value));
            }
        }, this));
        params_str = pars.join('&');
        return params_str;
    },

    /**
     * [fixedEncodeURIComponent description]
     * @param  {String} str [description]
     * @return {[type]}     [description]
     */
    fixedEncodeURIComponent: function(str) {
        return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    }
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(4));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex != -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            var words = [];
	            var nBytes = 0;
	            for (var i = 0; i < base64StrLength; i++) {
	                if (i % 4) {
	                    var bits1 = map.indexOf(base64Str.charAt(i - 1)) << ((i % 4) * 2);
	                    var bits2 = map.indexOf(base64Str.charAt(i)) >>> (6 - (i % 4) * 2);
	                    words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	                    nBytes++;
	                }
	            }

	            return WordArray.create(words, nBytes);
	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(4), __webpack_require__(37), __webpack_require__(38));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(4));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(4));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _facebook = __webpack_require__(40);

var _facebook2 = _interopRequireDefault(_facebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _facebook2.default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var cookie = __webpack_require__(9);
var PubSub = __webpack_require__(3);
var AUTH_CONST = __webpack_require__(41).facebook;

module.exports = Backbone.Model.extend({
    scriptLoaded: false,

    defaults: {
        appId: null,
        authResponse: null,
        status: null,
        scope: 'email',
        namespace: null,
        insideMobileApp: null,
        reauthEnabled: false,
        user: null,

        share: {
            method: 'share',
            caption: ''
        },
        shareResponse: null,
        timelineSharing: 0,
        publishActionPermRequested: 0,
        VoteArtistShareID: null,
        VoteArtistShared: 0,
        voteRemoved: null,
        VoteArtistMessageAdded: null,

        scriptLoaded: false,

        postToTimeline: true,
        showEpisode: null,
        envCon: null,

        publishImplicitWatchActionID: null,
        publishExplicitWatchActionID: null,
        publishExplicitWatchActionRemoved: null
    },
    /**
     * [ initialize ]
     */
    initialize: function() {
        _.bindAll(this, 'getLoginStatus', 'loginResponse');
        this.checkScript();
    },
    /**
     * [ checkScript ]
     */
    checkScript: function() {
        if (_.isUndefined(window.fbAsyncInit)) {
            this.initScript();
        } else {
            this.getLoginStatus();
            this.set('scriptLoaded', true);
        }
    },
    /**
     * [ initScript ]
     */
    initScript: function() {
        var e = document.createElement('script');
        e.async = true;
        e.src = 'https://connect.facebook.net/en_US/sdk.js';
        document.getElementById('fb-root').appendChild(e);

        window.fbAsyncInit = this.loadScript.bind(this);
    },
    /**
     * [ loadScript ]
     */
    loadScript: function() {

        this.set('scriptLoaded', true);

        FB.init({
            appId: this.get('appId'),
            status: true,
            version: 'v3.2'
        });

        this.getLoginStatus();
    },
    /**
     * [ clearUser ]
     */
    clearUser: function() {
        this.set({ user: null });
    },
    /**
     * [ getLoginStatus ]
     */
    getLoginStatus: function() {
        console.log('run getLoginStatus');
        FB.getLoginStatus(this.loginResponse.bind(this), true);
    },
    /**
     * [ loginResponse ]
     */
    loginResponse: function(response) {
        console.log('fb login response', response);

        this.set({
            authResponse: response.authResponse,
            status: response.status
        });

        this.getUserData();
    },
    /**
     * [ manualLoginResponse ]
     */
    manualLoginResponse: function(deferred, response) {
        console.log('manualLoginResponse', response);

        var identifier = response.id;
        delete response.id;

        var user = _.extend({}, response, {
            identifier: identifier
        });

        this.set('user', user);

        deferred.resolve(user);
    },
    /**
     * [ getUserData ]
     */
    getUserData: function() {
        if (this.get('status') === AUTH_CONST.LOGIN_STATUS.CONNECTED) {
            if (
                !this.get('user') &&
                this.get('authResponse') &&
                this.get('authResponse').userID
            ) {
                FB.api(
                    '/' +
                        this.get('authResponse').userID +
                        '?fields=id,first_name,last_name,email,name,permissions',
                    this.handleFbUserData.bind(this),
                    true
                );
            }
        } else {
            // do something else
            // FB.login(_.bind(this.loginResponse, this), {scope: this.get('scope'), auth_type: 'rerequest'});
            //this.getUserData();
        }
    },
    /**
     * Check user permissions if email is granted, then set the user data
     */
    handleFbUserData: function(response) {
        console.log('FB Response User Data with Permissions',response);
        if(!this.get('reauthEnabled') || (response.permissions && !response.permissions.data.length)) return this.setUser(response);

        // Use Array.filter instead of Array.find to support previous IE versions
        var emailPermission = response.permissions.data.filter(function(obj) {
            return obj.permission === 'email';
        })[0];

        if(emailPermission.status === AUTH_CONST.PERMISSION_STATUS.DECLINED) {
            PubSub.trigger('facebook:rerequest');
            return;
        }

        this.setUser(response);
    },
    /**
     * Prompt the user to grant permissions
     */
    requestPermissions: function() {
        FB.login(this.loginResponse.bind(this), {
            auth_type: AUTH_CONST.AUTH_TYPE.REAUTH,
            scope: this.get('scope')
        });
    },
    /**
     * [ setUser ]
     */
    setUser: function(response) {
        console.log('setUser response:\t', response);

        var user = {
            identifier: response.id,
            first_name: response.first_name,
            last_name: response.last_name,
            name: response.name,
            email: response.email,
            permissions: !_.isObject(response.permissions.data[0]) ? {} : response.permissions.data[0]
        };

        console.log('formatted user ->\t', user);
        this.set({ user: user });
    },
    /**
     * [ setUserDataWithToken ]
     */
    setUserDataWithToken: function(deferred) {
        if (this.get('scriptLoaded') === false) {
            // once we know the SDK has loaded we can init the Router
            this.once(
                'change:scriptLoaded',
                function() {
                    this.setUserDataWithToken(deferred);
                }.bind(this)
            );
            return false;
        }

        console.log('setUserDataWithToken');

        FB.api(
            '/me',
            {
                fields: 'id,first_name,last_name,email,name,permissions',
                access_token: this.get('accessToken')
            },
            this.manualLoginResponse.bind(this, deferred)
        );
    },
    /**
     * [ manualRedirectURI ]
     */
    manualRedirectURI: function() {
        var redirectURI = (top !== self
            ? document.referrer
            : window.location.href
        )
            .split('#')[0]
            .replace(/(.*\?).*/g, '$1');
        var qspWhitelist = {
            app: _.contains(['native'], _.getQueryParamByName('app'))
                ? _.getQueryParamByName('app')
                : ''
        };

        _.each(qspWhitelist, function(value, key) {
            qspWhitelist =
                value.length === 0 ? _.omit(qspWhitelist, key) : qspWhitelist;
        });

        return (
            redirectURI +
            (redirectURI.charAt(redirectURI.length - 1) === '?' ? '' : '?') +
            $.param(qspWhitelist) +
            '#auth'
        );
    },
    /**
     * [ manualLogin ]
     */
    manualLogin: function() {
        var params = $.param({
            client_id: this.get('appId'),
            response_type: 'token',
            scope: { scope: 'email' },
            redirect_uri: this.manualRedirectURI() //'http://local.smpd.votenow.tv/#auth?app=native'
        });

        console.info(
            'manual login',
            encodeURI('https://www.facebook.com/v2.2/dialog/oauth?') + params
        );
        window.top.location =
            encodeURI('https://www.facebook.com/v2.2/dialog/oauth?') + params;
    },
    /**
     * [ login ]
     */
    login: function() {
        console.log('scope: ', this.get('scope'));
        FB.login(this.loginResponse.bind(this), {
            scope: this.get('scope')
        });
    },
    /**
     * [ logout ]
     */
    logout: function(callback) {
        if (typeof callback != 'function') callback = null;

        FB.getLoginStatus(
            function(response) {
                // Make sure user is logged in before trying to logout, otherwise there is an error
                if (response.status === AUTH_CONST.LOGIN_STATUS.CONNECTED) {
                    FB.logout(this.logoutResponse.bind(this, callback));
                } else {
                    this.logoutResponse(response, callback);
                }
            }.bind(this),
            true
        );

        if (this.get('insideMobileApp')) {
            cookie.eraseCookie('manualLogin');
        }
    },
    /**
     * [ logoutResponse ]
     */
    logoutResponse: function(response, callback) {
        console.log('response', response, 'callback', callback);
        // Flip the params and retry
        if (_.isFunction(response)) {
            console.log('response is a function');
            this.logoutResponse(callback, response);
            return;
        }

        console.log('logoutResponse', callback, response);
        this.set({ authResponse: null, status: null });
        this.clearUser();
        if (typeof callback == 'function') callback();
    },
    /**
     * [ isConnected ]
     */
    isConnected: function(callback) {
        console.log('isConnected',callback);

        if (typeof callback != 'function') return;

        if (this.get('status') === AUTH_CONST.LOGIN_STATUS.CONNECTED && this.get('user')) {
            console.log('status user');
            callback(true);
        } else {
            this.set({ status: null }, { silent: true });
            this.once(
                'change:status',
                function(model, value) {
                    console.log('isConnected listener value',value,'status:',this.get('status'),'authresponse:',this.get('authResponse'));
                    if (this.get('status') === AUTH_CONST.LOGIN_STATUS.CONNECTED) {
                        // get user data before sending back true
                        this.once('change:user',function() {
                            callback(true);
                        });

                        this.getUserData();
                    } else {
                        callback(false);
                    }
                }.bind(this)
            );
            // make sure the SDK has loaded and the FB object is defined
            if (this.get('scriptLoaded') === true) {
                console.log('script loaded');
                this.get('insideMobileApp') ? this.manualLogin() : this.login();
            } else {
                console.log('wait for script');
                // once we know the SDK has loaded we can init the Router
                this.once(
                    'change:scriptLoaded',
                    function() {
                        this.get('insideMobileApp') ? this.manualLogin() : this.login();
                    }.bind(this)
                );
            }
        }
    },
    /**
     * [ share ]
     */
    share: function(shareURL) {
        var shareDefaults = this.get('share');
        shareDefaults.href = shareURL;
        FB.ui(shareDefaults, this.shareResponse.bind(this));
    },
    /**
     * [ shareResponse ]
     */
    shareResponse: function(response) {
        console.log('shareResponse', response, $.type(response));

        if ($.type(response) === 'object' && _.has(response, 'post_id')) {
            this.set({ VoteArtistShared: 1 });
        }

        this.set({ shareResponse: response });
    }
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var connect = __webpack_require__(42);
var facebook = __webpack_require__(43);

module.exports = _.extend({},{
    connect: connect,
    facebook: facebook
});


/***/ }),
/* 42 */
/***/ (function(module, exports) {

/**
 * constants for Connect Model
 * @type {Object}
 */
module.exports = {
    AUTH_TYPE_EMAIL: 'email',
    AUTH_TYPE_FB: 'facebook',
    AUTH_METHOD_EMAIL: 'email',
    AUTH_METHOD_FB: 'fb'
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = {
    AUTH_TYPE: {
        REAUTH: 'reauthorize',
        REREQUEST: 'rerequest'
    },
    LOGIN_STATUS: {
        CONNECTED: 'connected',
        AUTH_EXPIRED: 'authorization_expired',
        NO_AUTH: 'not_authorized'
    },
    PERMISSION_STATUS: {
        GRANTED: 'granted',
        DECLINED: 'declined'
    }
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CONST = __webpack_require__(5).connect;
var AuthModel = __webpack_require__(49);

module.exports = AuthModel.extend({

    _submittedVotes: 0,

    defaults: {
        authType: null,
        isAuthorized: false,
        userImage: null,
        userName: null,
        userID: null
    },

    initializeType: function initializeType() {

        if (this.facebook.get('status') === null) {
            this.facebook.once('change:status', _.bind(function () {
                this.initializeType();
            }, this));
        } else {
            switch (this.facebook.get('status')) {
                case 'connected':
                    this.setUpFBUser();
                    this.set({ authType: CONST.AUTH_METHOD_FB });
                    break;
                default:
                    this.set({ authType: CONST.AUTH_METHOD_EMAIL });
                    break;
            }
        }
    },

    setUpEmailUser: function setUpEmailUser(data) {

        this.set({
            authType: CONST.AUTH_METHOD_EMAIL,
            userName: data,
            userID: data,
            isAuthorized: true
        });
    },

    setUpFBUser: function setUpFBUser() {

        if (!_.isNull(this.facebook.get('user'))) {

            var user = this.facebook.get('user');

            this.set({
                authType: CONST.AUTH_METHOD_FB,
                fbData: user,
                userImage: user.avatar,
                userName: user.name,
                userID: user.identifier,
                isAuthorized: true
            });
        } else {

            // Add listener for when the Facebook user data is available
            this.facebook.once('change:user', _.bind(function () {
                console.log('waiting for user to initialize');
                this.setUpFBUser();
            }, this));
        }
    },

    deAuthorize: function deAuthorize() {

        switch (this.get('authType')) {
            case CONST.AUTH_METHOD_FB:
                console.log('deauthorize facebook');
                this.facebook.logout();
                break;
            case CONST.AUTH_METHOD_EMAIL:
                console.log('deauthorize email');
                break;
            default:
                console.log('deauthorize default');
        }

        this.set(this.defaults);
    },

    getSubmittedVotes: function getSubmittedVotes() {
        return this._submittedVotes;
    },

    setSubmittedVotes: function setSubmittedVotes(votes) {
        this._submittedVotes = votes;
    }

});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    EMAIL_MAX_LENGTH: 40
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * constants for Connect Model
 * @type {Object}
 */
module.exports = {
    AUTH_TYPE_EMAIL: 'email',
    AUTH_TYPE_FB: 'facebook',
    AUTH_METHOD_EMAIL: 'email',
    AUTH_METHOD_FB: 'fb',
    ACTION_TYPE_GET: 'get',
    ACTION_TYPE_VOTE: 'vote'
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    AUTH_TYPE: {
        REAUTH: 'reauthorize',
        REREQUEST: 'rerequest'
    },
    LOGIN_STATUS: {
        CONNECTED: 'connected',
        AUTH_EXPIRED: 'authorization_expired',
        NO_AUTH: 'not_authorized'
    },
    PERMISSION_STATUS: {
        GRANTED: 'granted',
        DECLINED: 'declined'
    }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * constants for Vote Buttons
 * @type {Object}
 */
module.exports = {
    TEN: 10,
    TWENTY: 20,
    THIRTY: 30,
    FORTY: 40
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);

module.exports = Backbone.Model.extend({
  
    defaults: {
        authType: null,
        isAuthorized: false,
        userImage: null,
        userName: null,
        userID: null
    },
  
    initialize: function (attributes, options) {

        this.facebook = options.facebook;
        this.listenTo(this, 'change:userID', _.bind(this.defineUser, this));
        this.listenTo(this, 'change:authType', _.bind(this.isEmailUser, this));
        this.initializeType();
    },
    /**
     *
     */
    initializeType: function () {
    
    // // if FB SDK hasn't loaded, add listener
        if (this.facebook.get('status') === null) {
            this.facebook.once('change:status', _.bind(function () {
                this.initializeType();
            }, this));
        } else {
            switch (this.facebook.get('status')) {
            case 'connected':
                this.setUpFBUser();
                this.set({authType: 'facebook'});
                break;
            default:
                this.set({authType: 'email'});
                break;
            }
        }
    },
    /**
   *
   */
    setUpFBUser: function () {
        console.log('setUpFBUser', this.facebook.get('user'));
    
        if (!_.isNull(this.facebook.get('user'))) {
      
            var user = this.facebook.get('user');
      
            this.set({
                authType: 'facebook',
                fbData: user,
                userImage: user.avatar,
                userName: user.name,
                userID: user.email,
                isAuthorized: true
            });
      
        } else {
      
            // Add listener for when the Facebook user data is available
            this.facebook.once('change:user', _.bind(function () {
                console.log('waiting for user to initialize');
                this.setUpFBUser();
      
            }, this));
        }
    
    },
    /**
   *
   */
    defineUser: function (model, value, options) {
        console.log('defineUser', model, value, options);
    
        if ($.type(value) === 'null') {
            // if the user logs out, we no longer what their email address in localStorage
            if (!_.isUndefined(localStorage['vote_auth_email'])) {
                localStorage.removeItem('vote_auth_email');
            }
        } else {
            if (this.get('authType') === 'email' && _.isUndefined(localStorage['vote_auth_email'])) {
                localStorage['vote_auth_email'] = this.get('userID');
            }
        }
    },
    /**
   *
   */
    isEmailUser: function (model, value) {
        console.log('isEmailUser', model, value);
        if (value === 'email' && !_.isUndefined(localStorage['vote_auth_email']) && this.get('userID') === null) {
            console.log('Pulling userID from localStorage and setting it in the auth model', localStorage['vote_auth_email']);
            this.setUpEmailUser(localStorage['vote_auth_email']);
        }
    },
    /**
   *
   */
    deAuthorize: function () {
        console.log('calling deauthorize', this.get('authType'));
    
        switch (this.get('authType')) {
        case 'facebook':
            console.log('log out facebook');
            this.facebook.logout();
            break;
        case 'email':
            console.log('email');
            break;
        default:
            console.log('nothing');
            // do nothing
            break;
        }
    
        this.set(this.defaults);
    },
    /**
   *
   */
    signInSuccess: function(type, data){

        if(type === 'email'){
            if(!_.isNull(this.get('userID')) && this.get('userID') !== data){
                this.trigger('clearUser',{
                    target: this
                });
            }
            this.setUpEmailUser(data);
        } else if(type === 'facebook'){
            if($.type(this.facebook.get('user')) != 'null') {
                if(!_.isNull(this.get('userID')) && this.get('userID') !== this.facebook.get('user').email){
                    this.trigger('clearUser',{
                        target: this
                    });
                }
                this.setUpFBUser();
            } else {
                // Add listener for when the Facebook user data is available
                this.facebook.once('change:user', _.bind(function(){
                    console.log('waiting for user to initialize...');
                    this.signInSuccess('facebook');
                }, this));
            }
        }
    },
    /**
   *
   */
    setUpEmailUser: function (data) {
        console.log('setupEmailUser data:', data);
    
        this.set({
            authType: 'email',
            userName: data,
            userID: data,
            isAuthorized: true
        });
    }
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ErrorView = __webpack_require__(51);
var PageView = __webpack_require__(54);
var GridView = __webpack_require__(63);
var VoteDetailView = __webpack_require__(76);
var WindowView = __webpack_require__(80);
var ModalView = __webpack_require__(83);
var GeoView = __webpack_require__(86);
var LoadingView = __webpack_require__(90);
var FaqView = __webpack_require__(93);
var AuthView = __webpack_require__(96);
var ThanksView = __webpack_require__(101);
var WinnerView = __webpack_require__(105);
var ReAuthView = __webpack_require__(107);
var CountdownView = __webpack_require__(110);
var TLDRC = __webpack_require__(112);
var PubSub = __webpack_require__(3);

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);

module.exports = Backbone.Router.extend({
    controller: null,
    currentView: null,
    currentModal: null,
    history: [],
    routes: {
        '': 'home',
        home: 'home',
        'error/:name': 'error',
        'loading/:name': 'loading',
        faq: 'faq',
        voting: 'voting',
        auth: 'auth',
        thanks: 'thanks',
        window: 'window',
        countdown: 'countdown'
    },
    /**
     *
     */
    initialize: function initialize(options) {
        if (_.isUndefined(options)) {
            return;
        }
        this.initialLoad = true;

        this.controller = options.controller;
        this.cms = options.cms;
        this.facebook = options.facebook;
        this.connect = options.connect;
        this.authModel = options.auth;
        this.voteOption = options.voteOption;
        this.uniqueId = options.uniqueId;

        //pym child init
        this.pymChildId = 'telescope-app';
        this.pym = TLDRC.Child({ polling: 500, id: this.pymChildId });
        this.pym.child.id = this.pymChildId;

        this.listenTo(Backbone.history, 'route', _.bind(this.saveHistory, this));

        this.page = new PageView({
            cms: this.cms,
            voteOption: this.voteOption,
            router: this,
            uniqueId: this.uniqueId
        }).render();
        this.$body = $(options.container || document.body);
        this.$app = this.page.$('div[role="main"]');
        this.$header = this.page.$('header');
        this.$footer = this.page.$('footer');
        this.$modal = $('<div />');

        this.$body.html(this.page.$el.addClass(top === self ? 'frame-false' : 'frame-true'));
        document.body.classList.add(top === self ? 'frame-false' : 'frame-true');
        this.$body.append(this.$modal);

        this.$modal.attr({
            class: 'modal',
            role: 'dialog',
            'aria-labelledby': 'modalLabel',
            'aria-hidden': 'true',
            'data-backdrop': 'static'
        }).on('hidden.bs.modal', _.bind(this.closedCurrentModal, this));

        this.page.updateCSS(this.cms);

        var animationFrameHandler = _.bind(function (timestamp) {
            PubSub.trigger('AnimationFrame', timestamp);
            window.requestAnimationFrame(animationFrameHandler);
        }, this);
        window.requestAnimationFrame(animationFrameHandler);

        this.listenTo(PubSub, 'facebook:rerequest', this.reauth.bind(this));
        this.listenTo(PubSub, 'modal:close', this.closeCurrentModal.bind(this));
        this.listenTo(PubSub, 'route:auth', this.auth.bind(this));
        this.listenTo(PubSub, 'route:loading', this.loading.bind(this));
        this.listenTo(PubSub, 'scrollToTop', this.scrollToTop.bind(this));
    },
    /* CLEAN IT ALL UP */
    destroy: function destroy() {
        this.stopListening();
        if (this.page) {
            this.page.remove();
        }
        $('#' + this.uniqueId + '-style').remove();
        this.$modal.off();
        this.$modal.remove();
        this.currentView.remove();
        this.closedCurrentModal();
    },
    /**
     *
     */
    setCurrentView: function setCurrentView(view) {
        this.closeCurrentModal();
        this.$app.html(view.render().$el);

        var bodyContext = 'body-' + view.className;
        this.$app.alterClass('body-*', bodyContext);

        // remove old view
        if (this.currentView !== null) {
            this.currentView.remove();
            this.currentView = null;
        }
        // store current view
        this.currentView = view;
        if (typeof this.currentView.renderedToDOM === 'function') {
            this.currentView.renderedToDOM();
        }

        if (!this.initialLoad) {
            this.scrollToTop();
        }
        this.initialLoad = false;
    },
    /**
     *
     */
    customCSS: function customCSS(rootView) {
        rootView = rootView || $('body');
        var text = this.cms.get('text');

        //main_background_color
        if (text.design.css.vote_button.color) rootView.find('.vote').css('background-color', text.design.css.vote_button.color);
    },

    /**
     *
     */
    setCurrentModal: function setCurrentModal(view) {
        var modalContext = 'modal-has-' + view.className;
        var modal = new ModalView({
            model: { view: view }
        });

        modal.$el.addClass(view.className.replace('view-', 'style-'));

        this.$body.alterClass('modal-has-*', modalContext);
        this.$modal.html(modal.render().$el);

        this.$modal.modal({
            show: true,
            keyboard: false,
            backdrop: 'static'
        });

        // remove old modal
        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
        }
        // store current modal
        this.currentModal = this.controller.Views.Modal = modal;

        if (typeof view.renderedToDOM === 'function') {
            view.renderedToDOM();
        }
        if (this.cms.get('text').design.scrollable_background_with_modal === 'false') {
            $('html').css('overflow', 'hidden');
        }

        if (!this.initialLoad) {
            this.scrollToTop();
        }
        this.initialLoad = false;
    },
    /**
     *
     */
    closedCurrentModal: function closedCurrentModal() {
        console.log('MODAL HIDDEN!!');
        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.currentModal.model.view.remove();
            }
            this.currentModal.remove();
            this.currentModal = this.controller.Views.Modal = null;
            this.$body.alterClass('modal-has-*', '');

            if ($('html').attr('style') != 'undefined') {
                $('html').removeAttr('style');
            }
        }
    },
    /**
     *
     */
    closeCurrentModal: function closeCurrentModal() {
        console.log('CLOSE CURRENT MODAL');

        if (this.currentModal !== null) {
            if (_.isObject(this.currentModal.model.view)) {
                this.undoSelected();
            }
        }

        this.$modal.modal('hide');

        if ($('html').attr('style') != 'undefined') {
            $('html').removeAttr('style');
        }
    },
    /**
     *
     */
    home: function home() {
        if (!this._isOpen()) return;

        if ($('footer').hasClass('posfix')) $('footer').removeClass('posfix');
        document.body.classList.remove('geo', 'window');
        var view = new GridView({
            cms: this.cms,
            connect: this.connect,
            auth: this.authModel,
            voteOption: this.voteOption,
            router: this
        });

        this.setCurrentView(view);

        PubSub.trigger('trackGoogle', {
            category: 'Page View',
            action: 'Page View: Landing Page',
            label: 'Page View: Landing Page'
        });
    },
    /**
     * Prompt the user to grant permission
     */
    reauth: function reauth() {
        var data = this.cms.get('text')['view_reauth'];
        var view = new ReAuthView({
            facebook: this.facebook,
            model: data
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    winner: function winner() {
        var view = new WinnerView({
            model: this.cms.get('text')['view_winner']
        });
        this.setCurrentView(view);
    },
    /**
     *
     */
    error: function error(name) {
        var data = this.cms.get('text')['views_error'][name];
        data = _.isObject(data) ? data : this.cms.get('text')['views_error']['generic'];
        var view = new ErrorView({
            model: data,
            router: this
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    geo: function geo() {
        var data = this.cms.get('text')['views_error'].geo;
        data = _.isObject(data) ? data : this.cms.get('text')['views_error']['generic'];
        var view = new GeoView({
            model: data
        });
        this.setCurrentView(view);
    },
    /**
     *
     */
    loading: function loading(name) {
        var data = this.cms.get('text')['views_loading'][name];
        data = _.isObject(data) ? data : this.cms.get('text')['views_loading']['generic'];
        var view = new LoadingView({
            model: data
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    faq: function faq() {
        var data = this.cms.get('text')['views_faq'];
        var view = new FaqView({
            model: data,
            router: this
        });
        this.setCurrentModal(view);
    },
    /**
     *
     */
    voting: function voting(model) {

        var view = new VoteDetailView({
            model: model,
            cms: this.cms,
            auth: this.authModel,
            connect: this.connect,
            voteOption: this.voteOption,
            router: this
        });

        this.setCurrentModal(view);
    },
    /**
     *
     */
    auth: function auth() {
        //var data = this.controller.Models.Home.get('data');
        var view = new AuthView({
            cms: this.cms,
            auth: this.authModel,
            facebook: this.facebook,
            router: this
        });
        this.setCurrentModal(view);
    },
    /**
     * This is called when user closes the auth view modal
     */
    undoSelected: function undoSelected() {
        // if login modal is closed undo the selected
        var selected = this.voteOption.findWhere({
            selected: true
        });
        if (_.isObject(selected)) selected.set({ selected: false }, { silent: true });
    },
    /**
     *
     */
    thanks: function thanks() {
        var view = new ThanksView({
            controller: this.controller
        });

        this.setCurrentModal(view);
        this.listenTo(view, 'voteagain', _.bind(this.voting, this));
    },
    /**
     *
     */

    countdown: function countdown() {
        var countdown = this.controller.Models.Countdown.toJSON();
        var cmsData = this.cms.get('text').countdown_clock;

        var model = new Backbone.Model({
            show_branding: '',
            copy_text: cmsData.description,
            show_copy_text: 1,
            show_labels: cmsData.labels.display,

            show_month: cmsData.countdown_units.show_month,
            show_days: cmsData.countdown_units.show_days,
            show_hours: cmsData.countdown_units.show_hours,
            show_minutes: cmsData.countdown_units.show_minutes,
            show_seconds: cmsData.countdown_units.show_seconds,

            time_months: countdown.time_months,
            time_days: countdown.time_days,
            time_hours: countdown.time_hours,
            time_minutes: countdown.time_minutes,
            time_seconds: countdown.time_seconds,

            style: {}
        });

        this.listenTo(this.controller.Models.Countdown, 'change', function (countdownModel) {
            model.set(countdownModel.attributes);
        });

        var view = new CountdownView({
            controller: this.controller,
            model: model,
            className: 'countdown-view-home'
        });

        return view;
    },
    /**
     *
     */

    window: function window() {
        var model = this.cms.get('text')['views_snapshot_closed'];
        var share = this.cms.get('text')['views_share'];
        var countdownCms = this.cms.get('text')['countdown_clock'];
        console.warn('model is: ' + model);
        var view = new WindowView({
            controller: this.controller,
            model: model,
            share: share
        });

        this.setCurrentView(view);
        document.body.classList.add('window');
        var show_countdown = countdownCms.enable;
        if (show_countdown === 'true') {
            var countdown = this.countdown();
            countdown.render();
            countdown.$el.insertAfter($('.text'));
            view.$el.append(countdown.$el);
        }
    },
    /**
     *
     */

    _isOpen: function _isOpen() {
        // is the user out of the geographically acceptable region
        if (_.isNull(this.controller.Models.Geo.get('inRegion'))) {
            this.controller.Models.Geo.once('change:inRegion', _.bind(function () {
                //this.navigate(requestedFragment, {trigger: true})
                this.home();
            }, this));
            //this.navigate('loading/generic', {trigger: false});
            return false;
        } else if (!this.controller.Models.Geo.get('inRegion')) {
            this.geo();
            return false;
        }

        // is the window closed?
        if (this.cms.get('window_status') === '0') {
            //this.navigate('error/window', {trigger: true});
            this.error('window');

            return false;
        }

        // is the winner displayed?
        if (_.checkIfTrue(this.cms.get('text')['view_winner'].display)) {
            this.winner();
            return false;
        }

        return true;
    },
    /**
     *
     */
    saveHistory: function saveHistory(router, route, params) {
        this.history.push({
            name: route,
            args: params,
            fragment: Backbone.history.fragment
        });
        console.log('saveHistory', Backbone.history.fragment, route);
    },

    /**
     * scrollToTop
     */
    scrollToTop: function scrollToTop() {
        console.log('scroll to top');

        if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            window.scrollTo(0, 0);
        } else {
            $('html, body').animate({
                scrollTop: -100
            }, '600');
        }

        if (this.pym) this.pym.sendMessage('scrollToChildPosition', JSON.stringify({ y: -150 }));
    }

});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _error = __webpack_require__(52);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _error2.default;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var template = __webpack_require__(53);

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-error',
    events: {
        'click .vote': 'home'
    },
    /**
   *
   */
    initialize: function(options) {
        this.model = options.model;
        this.router = options.router;
    },
    /**
   *
   */
    render: function() {
        this.$el.html(template(this.model));
        return this;
    },
    /**
   *
   */
    home: function() {
        this.router.closeCurrentModal();
    },
  
    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- copy.headline_copy %></h3> <div class=\"error-detail\"><%- copy.description_copy %></div> <div class=\"contestant-container\"> <div class=\"button\"> <div class=\"vote\" data-route=\"<%- button.route %>\"><%- button.copy %></div> </div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  copy.headline_copy ), '</h3> <div class="error-detail">', (__stack.lineno=1,  copy.description_copy ), '</div> <div class="contestant-container"> <div class="button"> <div class="vote" data-route="', (__stack.lineno=1,  button.route ), '">', (__stack.lineno=1,  button.copy ), '</div> </div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var cssTemplate = __webpack_require__(55);

var PageView = __webpack_require__(56);

module.exports = PageView.extend({

    updateCSS: function updateCSS(cms) {
        var text = cms.get('text');
        var design = text.design;
        var header = text.views_page_header;
        var footer = text.views_page_footer;
        var gridStyling = text.views_nominee_grid;
        var customCss = design.css;

        //create variables for custom CSS
        var templateVars = {
            uniqueId: this.uniqueId,
            header: _.extend({}, customCss.header, header),
            footer: _.extend({}, customCss.footer, footer),
            grid: _.extend({}, customCss.grid, gridStyling),
            voteButton: customCss.vote_button,
            customFonts: design.custom_fonts,
            closeButton: customCss.x_close_button,
            voteModal: customCss.vote_modal,
            emailButton: customCss.email_button,
            login: customCss.login,
            page: customCss.page_background,
            container: customCss.container_background,
            countdown: customCss.countdown,
            closed: customCss.closed_page,
            voteItem: customCss.vote_item,
            thanks: customCss.thanks,
            auth: customCss.auth
        };

        var randomId = 'style_' + Math.round(Math.random() * 1000000);
        var lastId = this.lastId;

        if (lastId) {
            console.info($('#' + this.lastId), $('#' + this.lastId).length);
            $('#' + this.lastId).remove();
        }

        var css = cssTemplate(templateVars);
        var style = $('<style />');

        style.prop('id', randomId).append(css).appendTo('head');

        this.lastId = randomId;
    }

});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "@import url(<%- customFonts.font_import %>); body { <% if ( page.color ) { %> background-color: <%- page.color %>; <% } %> <% if ( page.image ) { %> background-image: url('<%- page.image %>'); background-repeat: <%- page.repeat || 'no-repeat' %>; background-size: cover; <% } %> <% if ( page.position ) { %> background-position: <%- page.position %>; <% } %> <% if ( customFonts.font_family ) { %> font-family: <%- customFonts.font_family %>, sans-serif !important; <% } %> } /* Container ------------------------------------ */ #<%- uniqueId %> { <% if ( container.color ) { %> background-color: <%- container.color %> !important; <% } %> <% if ( container.image ) { %> background-image: url('<%- container.image %>'); background-repeat: <%- container.repeat || 'no-repeat' %>; background-size: cover; <% } %> <% if ( container.position ) { %> background-position: <%- container.position %>; <% } %> <% if ( customFonts.font_family ) { %> font-family: <%- customFonts.font_family %>, sans-serif !important; <% } %> } <% if ( grid.button_border_radius ) { %> #<%-uniqueId %> .button .vote { border-radius: <%- grid.button_border_radius %>; } <% } %> /* Vote Modal ------------------------------------ */ #<%- uniqueId %> .view-modal .modal-window .modal-wrapper .modal-layout .modal-content { <% if( voteModal.background_color ){ %> background-color: <%- voteModal.background_color %>; <% } %> } <% if ( voteModal.background_color ) { %> #<%- uniqueId %> .style-vote-detail { background-color: <%- voteModal.background_color %>; } <% } %> <% if ( voteModal.headline.color || voteModal.headline.font_size ) { %> #<%- uniqueId %> .style-vote-detail .headline-modal { <%- voteModal.headline.color ? 'color:' + voteModal.headline.color + ';' : '' %> <%- voteModal.headline.font_size ? 'font-size:' + voteModal.headline.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.firstname.color || voteModal.firstname.font_size ) { %> #<%- uniqueId %> .style-vote-detail .firstname { <%- voteModal.firstname.color ? 'color:' + voteModal.firstname.color + ';' : '' %> <%- voteModal.firstname.font_size ? 'font-size:' + voteModal.firstname.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.lastname.color || voteModal.lastname.font_size ) { %> #<%- uniqueId %> .style-vote-detail .lastname { <%- voteModal.lastname.color ? 'color:' + voteModal.lastname.color + ';' : '' %> <%- voteModal.lastname.font_size ? 'font-size:' + voteModal.lastname.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.details.color || voteModal.details.font_size ) { %> #<%- uniqueId %> .style-vote-detail .details { <%- voteModal.details.color ? 'color:' + voteModal.details.color + ';' : '' %> <%- voteModal.details.font_size ? 'font-size:' + voteModal.details.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.third_details.color || voteModal.third_details.font_size ) { %> #<%- uniqueId %> .style-vote-detail .third-details { <%- voteModal.third_details.color ? 'color:' + voteModal.third_details.color + ';' : '' %> <%- voteModal.third_details.font_size ? 'font-size:' + voteModal.third_details.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.description.color || voteModal.description.font_size ) { %> #<%- uniqueId %> .style-vote-detail .description { <%- voteModal.description.color ? 'color:' + voteModal.description.color + ';' : '' %> <%- voteModal.description.font_size ? 'font-size:' + voteModal.description.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.link.color || voteModal.link.font_size ) { %> #<%- uniqueId %> .style-vote-detail .moreVote { <%- voteModal.link.color ? 'color:' + voteModal.link.color + '!important;' : '' %> <%- voteModal.link.font_size ? 'font-size:' + voteModal.link.font_size+ ';' : '' %> } <% } %> #<%- uniqueId %> .view-modal .modal-window { <% if( voteModal.overlay_color ){ %> background-colr: <%- voteModal.overlay_color %>; <% } %> } /* Thanks Modal ------------------------------------ */ #<%- uniqueId %> .view-thanks .thanks-social .thanks svg { <% if( voteModal.social_icon_colors ){ %> fill: <%- voteModal.social_icon_colors %>; <% } %> } <% if ( thanks.headline.color || thanks.headline.font_size ) { %> #<%- uniqueId %> .view-thanks h3 { <%- thanks.headline.color ? 'color:' + thanks.headline.color + ';' : '' %> <%- thanks.headline.font_size ? 'font-size:' + thanks.headline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.subheadline.color || thanks.subheadline.font_size ) { %> #<%- uniqueId %> .view-thanks .thanks-view { <%- thanks.subheadline.color ? 'color:' + thanks.subheadline.color + ';' : '' %> <%- thanks.subheadline.font_size ? 'font-size:' + thanks.subheadline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.twitter_headline.color || thanks.twitter_headline.font_size ) { %> #<%- uniqueId %> .view-thanks .twitter-vote h4 { <%- thanks.twitter_headline.color ? 'color:' + thanks.twitter_headline.color + ';' : '' %> <%- thanks.twitter_headline.font_size ? 'font-size:' + thanks.twitter_headline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.twitter_subheadline.color || thanks.twitter_subheadline.font_size ) { %> #<%- uniqueId %> .view-thanks .twitter-vote p { <%- thanks.twitter_subheadline.color ? 'color:' + thanks.twitter_subheadline.color + ';' : '' %> <%- thanks.twitter_subheadline.font_size ? 'font-size:' + thanks.twitter_subheadline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.share_cta.color || thanks.share_cta.font_size ) { %> #<%- uniqueId %> .thanks-container p { <%- thanks.share_cta.color ? 'color:' + thanks.share_cta.color + ';' : '' %> <%- thanks.share_cta.font_size ? 'font-size:' + thanks.share_cta.font_size+ ';' : '' %> } <% } %> /* Buttons ------------------------------------ */ .view-vote-item .button .vote, .contestant-container .button .vote, .email-vote input[type=submit], .view-vote-detail .button .vote, .view-error .button .vote, .view-thanks .button .btn-vote-again { background-image: -webkit-linear-gradient(top,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); background-image: -moz-linear-gradient(top,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); background-image: -o-linear-gradient(top,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); background-image: linear-gradient(to bottom,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); color: <%- voteButton.text_color %> !important; } .view-vote-detail .button .vote.disabled { background: #CDCDCD !important; } .view-vote-item .button .hover, .contestant-container .button .hover, .email-vote input[type=submit]:hover, .view-vote-detail .button .vote:hover, .view-error .button .vote:hover, .view-thanks .button .btn-vote-again:hover { background-image: -webkit-linear-gradient(top,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); background-image: -moz-linear-gradient(top,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); background-image: -o-linear-gradient(top,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); background-image: linear-gradient(to bottom,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); cursor: pointer; } /* Grid Item ------------------------------------ */ .contestant { background-color: <%- voteItem.background_color %>; <%- voteItem.color ? 'color:' + voteItem.color + ';' : '' %> } <% if ( voteItem.font_size ) { %> .contestant .name { font-size: <%- voteItem.font_size %>!important; } <% } %> .login, .logout { color: <%- login.login_link_color %> !important; <%- login.font_size ? 'font-size:' + login.font_size + '!important;' : '' %>; } .greeting { color: <%- login.greeting_text_color %> !important; <%- login.font_size ? 'font-size:' + login.font_size + '!important;' : '' %>; } .grid-header h3 { color: <%- grid.headline_color %> !important; <%- grid.headline_font_size ? 'font-size:' + grid.headline_font_size + ';' : '' %> } .grid-header p { color: <%- grid.description_color %> !important; <%- grid.description_font_size ? 'font-size:' + grid.description_font_size + ';' : '' %> } .moreVote { color: <%- voteButton.color %> !important; } .btn-close { color: <%- closeButton.mobile_color %>; } .btn-close:hover { color: #369; } <% if( voteModal.arrow_colors.prev_mobile ){ %> .view-vote-detail .gallery .telescope_icon_arrow_left { color: <%- voteModal.arrow_colors.prev_mobile %>; } <% } %> <% if( voteModal.arrow_colors.next_mobile ){ %> .view-vote-detail .gallery .telescope_icon_arrow_right { color: <%- voteModal.arrow_colors.next_mobile %>; } <% } %> <% if( voteModal.arrow_colors.prev ){ %> @media (min-width: 750px) { .view-vote-detail .gallery .telescope_icon_arrow_left { color: <%- voteModal.arrow_colors.prev %>; } } <% } %> <% if( voteModal.arrow_colors.next ){ %> @media (min-width: 750px) { .view-vote-detail .gallery .telescope_icon_arrow_right { color: <%- voteModal.arrow_colors.next %>; } } <% } %> .view-auth .socialBoxes .email { background-image: -webkit-linear-gradient(top,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; background-image: -moz-linear-gradient(top,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; background-image: -o-linear-gradient(top,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; background-image: linear-gradient(to bottom,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; } .view-auth .socialBoxes .email:hover { background-image: -webkit-linear-gradient(top,<%- emailButton.hover_color %>,<%- emailButton.hover_bottom_gradient %>) !important; background-image: -moz-linear-gradient(top,<%- emailButton.hover_color %>,<%- emailButton.hover_bottom_gradient %>) !important; background-image: -o-linear-gradient(top,<%- emailButton.hover_color %>,<%- emailButton.hover_bottom_gradient %>) !important; background-image: linear-gradient(to bottom,<%- emailButton.hover_color %>,<%- emailButton.hover_bottom_gradient %>) !important; } .header-container { background-image: url(<%- header.background_image_mobile %>); background-position: 0 0; background-position: inherit; background-size: cover; background-repeat: no-repeat; background-color: <%- header.background_color %>; } .header-text h1, .header-text h4 { color: <%- header.headline_color %> !important; } .header-text p { color: <%- header.description_color %> !important; } <% if ( header.headline_font_size ) {%> .header-text h1 { font-size: <%- header.headline_font_size %>; } <% } %> <% if ( header.paragraph_font_size ) { %> .header-text p { font-size: <%- header.paragraph_font_size %>; } <% } %> /* Footer ------------------------------------ */ .footer .footer-container { background-image: url(<%- footer.background_image %>); background-position: inherit; background-size: cover; background-repeat: no-repeat; <%- footer.background_color ? 'background-color:' + footer.background_color + ';' : '' %> } .footer .footer-container a { color: <%- footer.link_color %> !important; <%- footer.font_size ? 'font-size:' + footer.font_size + ';' : '' %> } @media (min-width: 750px) { .header-container { background-image: url(<%- header.background_image %>); } .btn-close { color: <%- closeButton.color %>; } } /* Countdown ------------------------------------ */ <% if( countdown.labels_color ){ %> .countdown-unit-label { color: <%- countdown.labels_color %> !important; } <% } %> <% if( countdown.countdown_unit_background_color ){ %> .countdown-value { background-color: <%- countdown.countdown_unit_background_color %> !important; } <% } %> <% if( countdown.countdown_unit_copy_color ){ %> .countdown-value { color: <%- countdown.countdown_unit_copy_color %> !important; } <% } %> <% if( countdown.colon_color ){ %> .colon { color: <%- countdown.colon_color %> !important; } <% } %> /* Window ------------------------------------ */ <% if( closed.headline_color ){ %> .window h3, .countdown-view-home .countdown-container .intro-text { color: <%- closed.headline_color %> !important; } <% } %> .window .copy { color: <%- closed.description_color %> !important; } /* Auth Modal ------------------------------------ */ <% if ( auth.headline.color || auth.headline.font_size ) { %> #<%- uniqueId %> .view-modal .view-auth h3 { <%- auth.headline.color ? 'color:' + auth.headline.color + ';' : '' %> <%- auth.headline.font_size ? 'font-size:' + auth.headline.font_size + ';' : '' %> } <% } %> <% if ( auth.checkbox_label.color || auth.checkbox_label.font_size ) { %> #<%- uniqueId %> .view-auth .checkbox-parent input[type=checkbox]+label { <%- auth.checkbox_label.color ? 'color:' + auth.checkbox_label.color + ';' : '' %> <%- auth.checkbox_label.font_size ? 'font-size:' + auth.checkbox_label.font_size + ';' : '' %> } <% } %> <% if ( auth.checkbox_label_link.color || auth.checkbox_label_link.font_size ) { %> #<%- uniqueId %> .view-auth .checkbox-parent input[type=checkbox]+label a { <%- auth.checkbox_label_link.color ? 'color:' + auth.checkbox_label_link.color + ';' : '' %> <%- auth.checkbox_label_link.font_size ? 'font-size:' + auth.checkbox_label_link.font_size + ';' : '' %> } <% } %> <% if ( auth.error.color || auth.error.font_size ) { %> #<%- uniqueId %> .view-auth .message { <%- auth.error.color ? 'color:' + auth.error.color + ';' : '' %> <%- auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' %> } <% } %> <% if ( auth.error.color || auth.error.font_size ) { %> #<%- uniqueId %> .view-auth .message { <%- auth.error.color ? 'color:' + auth.error.color + ';' : '' %> <%- auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' %> } <% } %> <% if ( auth.email_cta.color || auth.email_cta.font_size ) { %> #<%- uniqueId %> .view-auth .email-vote h3 { <%- auth.email_cta.color ? 'color:' + auth.email_cta.color + ';' : '' %> <%- auth.email_cta.font_size ? 'font-size:' + auth.email_cta.font_size + ';' : '' %> } <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('@import url(', (__stack.lineno=1,  customFonts.font_import ), '); body { ');__stack.lineno=1; if ( page.color ) { ; buf.push(' background-color: ', (__stack.lineno=1,  page.color ), '; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( page.image ) { ; buf.push(' background-image: url(\'', (__stack.lineno=1,  page.image ), '\'); background-repeat: ', (__stack.lineno=1,  page.repeat || 'no-repeat' ), '; background-size: cover; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( page.position ) { ; buf.push(' background-position: ', (__stack.lineno=1,  page.position ), '; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( customFonts.font_family ) { ; buf.push(' font-family: ', (__stack.lineno=1,  customFonts.font_family ), ', sans-serif !important; ');__stack.lineno=1; } ; buf.push(' } /* Container ------------------------------------ */ #', (__stack.lineno=1,  uniqueId ), ' { ');__stack.lineno=1; if ( container.color ) { ; buf.push(' background-color: ', (__stack.lineno=1,  container.color ), ' !important; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( container.image ) { ; buf.push(' background-image: url(\'', (__stack.lineno=1,  container.image ), '\'); background-repeat: ', (__stack.lineno=1,  container.repeat || 'no-repeat' ), '; background-size: cover; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( container.position ) { ; buf.push(' background-position: ', (__stack.lineno=1,  container.position ), '; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( customFonts.font_family ) { ; buf.push(' font-family: ', (__stack.lineno=1,  customFonts.font_family ), ', sans-serif !important; ');__stack.lineno=1; } ; buf.push(' } ');__stack.lineno=1; if ( grid.button_border_radius ) { ; buf.push(' #', (__stack.lineno=1, uniqueId ), ' .button .vote { border-radius: ', (__stack.lineno=1,  grid.button_border_radius ), '; } ');__stack.lineno=1; } ; buf.push(' /* Vote Modal ------------------------------------ */ #', (__stack.lineno=1,  uniqueId ), ' .view-modal .modal-window .modal-wrapper .modal-layout .modal-content { ');__stack.lineno=1; if( voteModal.background_color ){ ; buf.push(' background-color: ', (__stack.lineno=1,  voteModal.background_color ), '; ');__stack.lineno=1; } ; buf.push(' } ');__stack.lineno=1; if ( voteModal.background_color ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail { background-color: ', (__stack.lineno=1,  voteModal.background_color ), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.headline.color || voteModal.headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .headline-modal { ', (__stack.lineno=1,  voteModal.headline.color ? 'color:' + voteModal.headline.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.headline.font_size ? 'font-size:' + voteModal.headline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.firstname.color || voteModal.firstname.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .firstname { ', (__stack.lineno=1,  voteModal.firstname.color ? 'color:' + voteModal.firstname.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.firstname.font_size ? 'font-size:' + voteModal.firstname.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.lastname.color || voteModal.lastname.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .lastname { ', (__stack.lineno=1,  voteModal.lastname.color ? 'color:' + voteModal.lastname.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.lastname.font_size ? 'font-size:' + voteModal.lastname.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.details.color || voteModal.details.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .details { ', (__stack.lineno=1,  voteModal.details.color ? 'color:' + voteModal.details.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.details.font_size ? 'font-size:' + voteModal.details.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.third_details.color || voteModal.third_details.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .third-details { ', (__stack.lineno=1,  voteModal.third_details.color ? 'color:' + voteModal.third_details.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.third_details.font_size ? 'font-size:' + voteModal.third_details.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.description.color || voteModal.description.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .description { ', (__stack.lineno=1,  voteModal.description.color ? 'color:' + voteModal.description.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.description.font_size ? 'font-size:' + voteModal.description.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.link.color || voteModal.link.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .moreVote { ', (__stack.lineno=1,  voteModal.link.color ? 'color:' + voteModal.link.color + '!important;' : '' ), ' ', (__stack.lineno=1,  voteModal.link.font_size ? 'font-size:' + voteModal.link.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-modal .modal-window { ');__stack.lineno=1; if( voteModal.overlay_color ){ ; buf.push(' background-colr: ', (__stack.lineno=1,  voteModal.overlay_color ), '; ');__stack.lineno=1; } ; buf.push(' } /* Thanks Modal ------------------------------------ */ #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .thanks-social .thanks svg { ');__stack.lineno=1; if( voteModal.social_icon_colors ){ ; buf.push(' fill: ', (__stack.lineno=1,  voteModal.social_icon_colors ), '; ');__stack.lineno=1; } ; buf.push(' } ');__stack.lineno=1; if ( thanks.headline.color || thanks.headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks h3 { ', (__stack.lineno=1,  thanks.headline.color ? 'color:' + thanks.headline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.headline.font_size ? 'font-size:' + thanks.headline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.subheadline.color || thanks.subheadline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .thanks-view { ', (__stack.lineno=1,  thanks.subheadline.color ? 'color:' + thanks.subheadline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.subheadline.font_size ? 'font-size:' + thanks.subheadline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.twitter_headline.color || thanks.twitter_headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .twitter-vote h4 { ', (__stack.lineno=1,  thanks.twitter_headline.color ? 'color:' + thanks.twitter_headline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.twitter_headline.font_size ? 'font-size:' + thanks.twitter_headline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.twitter_subheadline.color || thanks.twitter_subheadline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .twitter-vote p { ', (__stack.lineno=1,  thanks.twitter_subheadline.color ? 'color:' + thanks.twitter_subheadline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.twitter_subheadline.font_size ? 'font-size:' + thanks.twitter_subheadline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.share_cta.color || thanks.share_cta.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .thanks-container p { ', (__stack.lineno=1,  thanks.share_cta.color ? 'color:' + thanks.share_cta.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.share_cta.font_size ? 'font-size:' + thanks.share_cta.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' /* Buttons ------------------------------------ */ .view-vote-item .button .vote, .contestant-container .button .vote, .email-vote input[type=submit], .view-vote-detail .button .vote, .view-error .button .vote, .view-thanks .button .btn-vote-again { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); background-image: -o-linear-gradient(top,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); background-image: linear-gradient(to bottom,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); color: ', (__stack.lineno=1,  voteButton.text_color ), ' !important; } .view-vote-detail .button .vote.disabled { background: #CDCDCD !important; } .view-vote-item .button .hover, .contestant-container .button .hover, .email-vote input[type=submit]:hover, .view-vote-detail .button .vote:hover, .view-error .button .vote:hover, .view-thanks .button .btn-vote-again:hover { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); background-image: -o-linear-gradient(top,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); background-image: linear-gradient(to bottom,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); cursor: pointer; } /* Grid Item ------------------------------------ */ .contestant { background-color: ', (__stack.lineno=1,  voteItem.background_color ), '; ', (__stack.lineno=1,  voteItem.color ? 'color:' + voteItem.color + ';' : '' ), ' } ');__stack.lineno=1; if ( voteItem.font_size ) { ; buf.push(' .contestant .name { font-size: ', (__stack.lineno=1,  voteItem.font_size ), '!important; } ');__stack.lineno=1; } ; buf.push(' .login, .logout { color: ', (__stack.lineno=1,  login.login_link_color ), ' !important; ', (__stack.lineno=1,  login.font_size ? 'font-size:' + login.font_size + '!important;' : '' ), '; } .greeting { color: ', (__stack.lineno=1,  login.greeting_text_color ), ' !important; ', (__stack.lineno=1,  login.font_size ? 'font-size:' + login.font_size + '!important;' : '' ), '; } .grid-header h3 { color: ', (__stack.lineno=1,  grid.headline_color ), ' !important; ', (__stack.lineno=1,  grid.headline_font_size ? 'font-size:' + grid.headline_font_size + ';' : '' ), ' } .grid-header p { color: ', (__stack.lineno=1,  grid.description_color ), ' !important; ', (__stack.lineno=1,  grid.description_font_size ? 'font-size:' + grid.description_font_size + ';' : '' ), ' } .moreVote { color: ', (__stack.lineno=1,  voteButton.color ), ' !important; } .btn-close { color: ', (__stack.lineno=1,  closeButton.mobile_color ), '; } .btn-close:hover { color: #369; } ');__stack.lineno=1; if( voteModal.arrow_colors.prev_mobile ){ ; buf.push(' .view-vote-detail .gallery .telescope_icon_arrow_left { color: ', (__stack.lineno=1,  voteModal.arrow_colors.prev_mobile ), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( voteModal.arrow_colors.next_mobile ){ ; buf.push(' .view-vote-detail .gallery .telescope_icon_arrow_right { color: ', (__stack.lineno=1,  voteModal.arrow_colors.next_mobile ), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( voteModal.arrow_colors.prev ){ ; buf.push(' @media (min-width: 750px) { .view-vote-detail .gallery .telescope_icon_arrow_left { color: ', (__stack.lineno=1,  voteModal.arrow_colors.prev ), '; } } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( voteModal.arrow_colors.next ){ ; buf.push(' @media (min-width: 750px) { .view-vote-detail .gallery .telescope_icon_arrow_right { color: ', (__stack.lineno=1,  voteModal.arrow_colors.next ), '; } } ');__stack.lineno=1; } ; buf.push(' .view-auth .socialBoxes .email { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; background-image: -o-linear-gradient(top,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; background-image: linear-gradient(to bottom,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; } .view-auth .socialBoxes .email:hover { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  emailButton.hover_color ), ',', (__stack.lineno=1,  emailButton.hover_bottom_gradient ), ') !important; background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  emailButton.hover_color ), ',', (__stack.lineno=1,  emailButton.hover_bottom_gradient ), ') !important; background-image: -o-linear-gradient(top,', (__stack.lineno=1,  emailButton.hover_color ), ',', (__stack.lineno=1,  emailButton.hover_bottom_gradient ), ') !important; background-image: linear-gradient(to bottom,', (__stack.lineno=1,  emailButton.hover_color ), ',', (__stack.lineno=1,  emailButton.hover_bottom_gradient ), ') !important; } .header-container { background-image: url(', (__stack.lineno=1,  header.background_image_mobile ), '); background-position: 0 0; background-position: inherit; background-size: cover; background-repeat: no-repeat; background-color: ', (__stack.lineno=1,  header.background_color ), '; } .header-text h1, .header-text h4 { color: ', (__stack.lineno=1,  header.headline_color ), ' !important; } .header-text p { color: ', (__stack.lineno=1,  header.description_color ), ' !important; } ');__stack.lineno=1; if ( header.headline_font_size ) {; buf.push(' .header-text h1 { font-size: ', (__stack.lineno=1,  header.headline_font_size ), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( header.paragraph_font_size ) { ; buf.push(' .header-text p { font-size: ', (__stack.lineno=1,  header.paragraph_font_size ), '; } ');__stack.lineno=1; } ; buf.push(' /* Footer ------------------------------------ */ .footer .footer-container { background-image: url(', (__stack.lineno=1,  footer.background_image ), '); background-position: inherit; background-size: cover; background-repeat: no-repeat; ', (__stack.lineno=1,  footer.background_color ? 'background-color:' + footer.background_color + ';' : '' ), ' } .footer .footer-container a { color: ', (__stack.lineno=1,  footer.link_color ), ' !important; ', (__stack.lineno=1,  footer.font_size ? 'font-size:' + footer.font_size + ';' : '' ), ' } @media (min-width: 750px) { .header-container { background-image: url(', (__stack.lineno=1,  header.background_image ), '); } .btn-close { color: ', (__stack.lineno=1,  closeButton.color ), '; } } /* Countdown ------------------------------------ */ ');__stack.lineno=1; if( countdown.labels_color ){ ; buf.push(' .countdown-unit-label { color: ', (__stack.lineno=1,  countdown.labels_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( countdown.countdown_unit_background_color ){ ; buf.push(' .countdown-value { background-color: ', (__stack.lineno=1,  countdown.countdown_unit_background_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( countdown.countdown_unit_copy_color ){ ; buf.push(' .countdown-value { color: ', (__stack.lineno=1,  countdown.countdown_unit_copy_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( countdown.colon_color ){ ; buf.push(' .colon { color: ', (__stack.lineno=1,  countdown.colon_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' /* Window ------------------------------------ */ ');__stack.lineno=1; if( closed.headline_color ){ ; buf.push(' .window h3, .countdown-view-home .countdown-container .intro-text { color: ', (__stack.lineno=1,  closed.headline_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' .window .copy { color: ', (__stack.lineno=1,  closed.description_color ), ' !important; } /* Auth Modal ------------------------------------ */ ');__stack.lineno=1; if ( auth.headline.color || auth.headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-modal .view-auth h3 { ', (__stack.lineno=1,  auth.headline.color ? 'color:' + auth.headline.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.headline.font_size ? 'font-size:' + auth.headline.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.checkbox_label.color || auth.checkbox_label.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .checkbox-parent input[type=checkbox]+label { ', (__stack.lineno=1,  auth.checkbox_label.color ? 'color:' + auth.checkbox_label.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.checkbox_label.font_size ? 'font-size:' + auth.checkbox_label.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.checkbox_label_link.color || auth.checkbox_label_link.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .checkbox-parent input[type=checkbox]+label a { ', (__stack.lineno=1,  auth.checkbox_label_link.color ? 'color:' + auth.checkbox_label_link.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.checkbox_label_link.font_size ? 'font-size:' + auth.checkbox_label_link.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.error.color || auth.error.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .message { ', (__stack.lineno=1,  auth.error.color ? 'color:' + auth.error.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.error.color || auth.error.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .message { ', (__stack.lineno=1,  auth.error.color ? 'color:' + auth.error.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.email_cta.color || auth.email_cta.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .email-vote h3 { ', (__stack.lineno=1,  auth.email_cta.color ? 'color:' + auth.email_cta.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.email_cta.font_size ? 'font-size:' + auth.email_cta.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var template = __webpack_require__(57);
var cssTemplate = __webpack_require__(58);
var HeaderView = __webpack_require__(59);
var FooterView = __webpack_require__(61);

('use strict');

module.exports = Backbone.View.extend({
    className: 'container-fluid',
    events: {},
    /**
     *
     */
    initialize: function(options) {
        _.bindAll(this, 'render');

        this.cms = options.cms;
        this.voteOption = options.voteOption;
        this.router = options.router;
        this.uniqueId = options.uniqueId;
        this.lastId = null;

        console.info('page: ', this.cms);
        this.listenTo(this.cms, 'change', function() {
            console.info('inside page');
            _.bind(this.updateCSS, this, this.cms);
        });
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template());

        var displayHeader = this.cms.get('text')['views_page_header'].display_header;
        var displayFooter = this.cms.get('text')['views_page_footer'].display_footer;

        if (displayHeader && displayHeader === 'true') {
            this.header = new HeaderView({
                cms: this.cms,
                voteOption: this.voteOption,
                model: this.cms.get('text').views_page_header
            });
            this.$('header').append(this.header.render().$el);
        }

        if (displayFooter && displayFooter === 'true') {
            this.footer = new FooterView({
                cms: this.cms,
                router: this.router
            });
            this.$('footer').append(this.footer.render().$el);
        }

        return this;
    },
    /**
     *
     */
    updateCSS: function(cms) {
        var text = cms.get('text');
        var design = text.design;
        var header = text.views_page_header;
        var footer = text.views_page_footer;
        var gridStyling = text.views_nominee_grid;
        var customCss = design.css;

        //create variables for custom CSS
        var templateVars = {
            uniqueId: this.uniqueId,
            header: _.extend( {}, customCss.header, header ),
            footer: _.extend( {}, customCss.footer, footer ),
            grid: _.extend( {}, customCss.grid, gridStyling ),
            voteButton: customCss.vote_button,
            customFonts: design.custom_fonts,
            closeButton: customCss.x_close_button,
            voteModal: customCss.vote_modal,
            emailButton: customCss.email_button,
            login: customCss.login,
            page: customCss.page_background,
            container: customCss.container_background,
            countdown: customCss.countdown,
            closed: customCss.closed_page,
            voteItem: customCss.vote_item,
            thanks: customCss.thanks,
            auth: customCss.auth
        };

        var randomId = 'style_' + Math.round(Math.random() * 1000000);
        var lastId = this.lastId;

        if (lastId) {
            console.info($('#' + this.lastId), $('#' + this.lastId).length);
            $('#' + this.lastId).remove();
        }

        var css = cssTemplate(templateVars);
        var style = $('<style />');

        style.prop('id', randomId)
            .append(css)
            .appendTo('head');

        this.lastId = randomId;
    },

    remove: function() {
        console.info(this.lastId);

        if (this.lastId) {
            console.info($('#' + this.lastId), $('#' + this.lastId).length);
            $('#' + this.lastId).remove();
        }

        if (this.header) {
            this.header.remove();
        }

        if (this.footer) {
            this.footer.remove();
        }

        Backbone.View.prototype.remove.call(this);
    }
});


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<header></header> <div role=\"main\" id=\"main\"> </div> <footer></footer>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<header></header> <div role="main" id="main"> </div> <footer></footer>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "@import url(<%- customFonts.font_import %>); body { <% if ( page.color ) { %> background-color: <%- page.color %> !important; <% } %> <% if ( page.image ) { %> background-image: url('<%- page.image %>'); background-repeat: <%- page.repeat || 'no-repeat' %>; background-size: cover; <% } %> <% if ( page.position ) { %> background-position: <%- page.position %>; <% } %> <% if ( customFonts.font_family ) { %> font-family: <%- customFonts.font_family %>, sans-serif !important; <% } %> } /* Container ------------------------------------ */ #<%- uniqueId %> { <% if ( container.color ) { %> background-color: <%- container.color %> !important; <% } %> <% if ( container.image ) { %> background-image: url('<%- container.image %>'); background-repeat: <%- container.repeat || 'no-repeat' %>; background-size: cover; <% } %> <% if ( container.position ) { %> background-position: <%- container.position %>; <% } %> <% if ( customFonts.font_family ) { %> font-family: <%- customFonts.font_family %>, sans-serif !important; <% } %> } <% if ( grid.button_border_radius ) { %> #<%-uniqueId %> .button .vote { border-radius: <%- grid.button_border_radius %>; } <% } %> /* Vote Modal ------------------------------------ */ #<%- uniqueId %> .view-modal .modal-window .modal-wrapper .modal-layout .modal-content { <% if( voteModal.background_color ){ %> background-color: <%- voteModal.background_color %>; <% } %> } <% if ( voteModal.background_color ) { %> #<%- uniqueId %> .style-vote-detail { background-color: <%- voteModal.background_color %>; } <% } %> <% if ( voteModal.headline.color || voteModal.headline.font_size ) { %> #<%- uniqueId %> .style-vote-detail .headline-modal { <%- voteModal.headline.color ? 'color:' + voteModal.headline.color + ';' : '' %> <%- voteModal.headline.font_size ? 'font-size:' + voteModal.headline.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.firstname.color || voteModal.firstname.font_size ) { %> #<%- uniqueId %> .style-vote-detail .firstname { <%- voteModal.firstname.color ? 'color:' + voteModal.firstname.color + ';' : '' %> <%- voteModal.firstname.font_size ? 'font-size:' + voteModal.firstname.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.lastname.color || voteModal.lastname.font_size ) { %> #<%- uniqueId %> .style-vote-detail .lastname { <%- voteModal.lastname.color ? 'color:' + voteModal.lastname.color + ';' : '' %> <%- voteModal.lastname.font_size ? 'font-size:' + voteModal.lastname.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.details.color || voteModal.details.font_size ) { %> #<%- uniqueId %> .style-vote-detail .details { <%- voteModal.details.color ? 'color:' + voteModal.details.color + ';' : '' %> <%- voteModal.details.font_size ? 'font-size:' + voteModal.details.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.third_details.color || voteModal.third_details.font_size ) { %> #<%- uniqueId %> .style-vote-detail .third-details { <%- voteModal.third_details.color ? 'color:' + voteModal.third_details.color + ';' : '' %> <%- voteModal.third_details.font_size ? 'font-size:' + voteModal.third_details.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.description.color || voteModal.description.font_size ) { %> #<%- uniqueId %> .style-vote-detail .description { <%- voteModal.description.color ? 'color:' + voteModal.description.color + ';' : '' %> <%- voteModal.description.font_size ? 'font-size:' + voteModal.description.font_size+ ';' : '' %> } <% } %> <% if ( voteModal.link.color || voteModal.link.font_size ) { %> #<%- uniqueId %> .style-vote-detail .moreVote { <%- voteModal.link.color ? 'color:' + voteModal.link.color + '!important;' : '' %> <%- voteModal.link.font_size ? 'font-size:' + voteModal.link.font_size+ ';' : '' %> } <% } %> #<%- uniqueId %> .view-modal .modal-window { <% if( voteModal.overlay_color ){ %> background-colr: <%- voteModal.overlay_color %>; <% } %> } /* Thanks Modal ------------------------------------ */ #<%- uniqueId %> .view-thanks .thanks-social .thanks svg { <% if( voteModal.social_icon_colors ){ %> fill: <%- voteModal.social_icon_colors %>; <% } %> } <% if ( thanks.headline.color || thanks.headline.font_size ) { %> #<%- uniqueId %> .view-thanks h3 { <%- thanks.headline.color ? 'color:' + thanks.headline.color + ';' : '' %> <%- thanks.headline.font_size ? 'font-size:' + thanks.headline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.subheadline.color || thanks.subheadline.font_size ) { %> #<%- uniqueId %> .view-thanks .thanks-view { <%- thanks.subheadline.color ? 'color:' + thanks.subheadline.color + ';' : '' %> <%- thanks.subheadline.font_size ? 'font-size:' + thanks.subheadline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.twitter_headline.color || thanks.twitter_headline.font_size ) { %> #<%- uniqueId %> .view-thanks .twitter-vote h4 { <%- thanks.twitter_headline.color ? 'color:' + thanks.twitter_headline.color + ';' : '' %> <%- thanks.twitter_headline.font_size ? 'font-size:' + thanks.twitter_headline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.twitter_subheadline.color || thanks.twitter_subheadline.font_size ) { %> #<%- uniqueId %> .view-thanks .twitter-vote p { <%- thanks.twitter_subheadline.color ? 'color:' + thanks.twitter_subheadline.color + ';' : '' %> <%- thanks.twitter_subheadline.font_size ? 'font-size:' + thanks.twitter_subheadline.font_size+ ';' : '' %> } <% } %> <% if ( thanks.share_cta.color || thanks.share_cta.font_size ) { %> #<%- uniqueId %> .thanks-container p { <%- thanks.share_cta.color ? 'color:' + thanks.share_cta.color + ';' : '' %> <%- thanks.share_cta.font_size ? 'font-size:' + thanks.share_cta.font_size+ ';' : '' %> } <% } %> /* Buttons ------------------------------------ */ .view-vote-item .button .vote, .contestant-container .button .vote, .email-vote input[type=submit], .view-vote-detail .buttons .vote, .view-thanks .button .btn-vote-again { background-image: -webkit-linear-gradient(top,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); background-image: -moz-linear-gradient(top,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); background-image: -o-linear-gradient(top,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); background-image: linear-gradient(to bottom,<%- voteButton.color %>,<%- voteButton.bottom_gradient %>); color: <%- voteButton.text_color %> !important; } .view-vote-item .button .hover, .contestant-container .button .hover, .email-vote input[type=submit]:hover, .view-vote-detail .buttons .vote:hover, .view-thanks .button .btn-vote-again:hover { background-image: -webkit-linear-gradient(top,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); background-image: -moz-linear-gradient(top,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); background-image: -o-linear-gradient(top,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); background-image: linear-gradient(to bottom,<%- voteButton.hover_color %>,<%- voteButton.hover_bottom_gradient || voteButton.hover_color %>); cursor: pointer; } /* Grid Item ------------------------------------ */ .contestant { background-color: <%- voteItem.background_color %>; <%- voteItem.color ? 'color:' + voteItem.color + ';' : '' %> } <% if ( voteItem.font_size ) { %> .contestant .name { font-size: <%- voteItem.font_size %>!important; } <% } %> .login, .logout { color: <%- login.login_link_color %> !important; <%- login.font_size ? 'font-size:' + login.font_size + '!important;' : '' %>; } .greeting { color: <%- login.greeting_text_color %> !important; <%- login.font_size ? 'font-size:' + login.font_size + '!important;' : '' %>; } .grid-header h3 { color: <%- grid.headline_color %> !important; <%- grid.headline_font_size ? 'font-size:' + grid.headline_font_size + ';' : '' %> } .grid-header p { color: <%- grid.description_color %> !important; <%- grid.description_font_size ? 'font-size:' + grid.description_font_size + ';' : '' %> } .moreVote { color: <%- voteButton.color %> !important; } .btn-close { color: <%- closeButton.mobile_color %> !important; } .btn-close:hover { color: #369; } .view-modal { border: 10px solid <%= voteModal.border_color %> !important; } <% if( voteModal.arrow_colors.prev ){ %> .telescope_icon_arrow_left { color: <%- voteModal.arrow_colors.prev %> !important; } <% } %> <% if( voteModal.arrow_colors.next ){ %> .telescope_icon_arrow_right { color: <%- voteModal.arrow_colors.next %> !important; } <% } %> .view-auth .socialBoxes .email { background-image: -webkit-linear-gradient(top,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; background-image: -moz-linear-gradient(top,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; background-image: -o-linear-gradient(top,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; background-image: linear-gradient(to bottom,<%- emailButton.color %>,<%- emailButton.bottom_gradient %>) !important; } .header-container { background-image: url(<%- header.background_image_mobile %>); background-position: 0 0; background-position: inherit; background-size: cover; background-repeat: no-repeat; background-color: <%- header.background_color %>; } .header-text h1, .header-text h4 { color: <%- header.headline_color %> !important; } .header-text p { color: <%- header.description_color %> !important; } <% if ( header.headline_font_size ) {%> .header-text h1 { font-size: <%- header.headline_font_size %>; } <% } %> <% if ( header.paragraph_font_size ) { %> .header-text p { font-size: <%- header.paragraph_font_size %>; } <% } %> /* Footer ------------------------------------ */ .footer .footer-container { background-image: url(<%- footer.background_image %>); background-position: inherit; background-size: cover; background-repeat: no-repeat; <%- footer.background_color ? 'background-color:' + footer.background_color + ';' : '' %> } .footer .footer-container a { color: <%- footer.link_color %> !important; <%- footer.font_size ? 'font-size:' + footer.font_size + ';' : '' %> } @media (min-width: 750px) { .header-container { background-image: url(<%- header.background_image %>); } .btn-close { color: <%- closeButton.color %> !important; } } /* Countdown ------------------------------------ */ <% if( countdown.labels_color ){ %> .countdown-unit-label { color: <%- countdown.labels_color %> !important; } <% } %> <% if( countdown.countdown_unit_background_color ){ %> .countdown-value { background-color: <%- countdown.countdown_unit_background_color %> !important; } <% } %> <% if( countdown.countdown_unit_copy_color ){ %> .countdown-value { color: <%- countdown.countdown_unit_copy_color %> !important; } <% } %> <% if( countdown.colon_color ){ %> .colon { color: <%- countdown.colon_color %> !important; } <% } %> /* Window ------------------------------------ */ <% if( closed.headline_color ){ %> .window h3, .countdown-view-home .countdown-container .intro-text { color: <%- closed.headline_color %> !important; } <% } %> .window .copy { color: <%- closed.description_color %> !important; } /* Auth Modal ------------------------------------ */ <% if ( auth.headline.color || auth.headline.font_size ) { %> #<%- uniqueId %> .view-modal .view-auth h3 { <%- auth.headline.color ? 'color:' + auth.headline.color + ';' : '' %> <%- auth.headline.font_size ? 'font-size:' + auth.headline.font_size + ';' : '' %> } <% } %> <% if ( auth.checkbox_label.color || auth.checkbox_label.font_size ) { %> #<%- uniqueId %> .view-auth .checkbox-parent input[type=checkbox]+label { <%- auth.checkbox_label.color ? 'color:' + auth.checkbox_label.color + ';' : '' %> <%- auth.checkbox_label.font_size ? 'font-size:' + auth.checkbox_label.font_size + ';' : '' %> } <% } %> <% if ( auth.checkbox_label_link.color || auth.checkbox_label_link.font_size ) { %> #<%- uniqueId %> .view-auth .checkbox-parent input[type=checkbox]+label a { <%- auth.checkbox_label_link.color ? 'color:' + auth.checkbox_label_link.color + ';' : '' %> <%- auth.checkbox_label_link.font_size ? 'font-size:' + auth.checkbox_label_link.font_size + ';' : '' %> } <% } %> <% if ( auth.error.color || auth.error.font_size ) { %> #<%- uniqueId %> .view-auth .message { <%- auth.error.color ? 'color:' + auth.error.color + ';' : '' %> <%- auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' %> } <% } %> <% if ( auth.error.color || auth.error.font_size ) { %> #<%- uniqueId %> .view-auth .message { <%- auth.error.color ? 'color:' + auth.error.color + ';' : '' %> <%- auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' %> } <% } %> <% if ( auth.email_cta.color || auth.email_cta.font_size ) { %> #<%- uniqueId %> .view-auth .email-vote h3 { <%- auth.email_cta.color ? 'color:' + auth.email_cta.color + ';' : '' %> <%- auth.email_cta.font_size ? 'font-size:' + auth.email_cta.font_size + ';' : '' %> } <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('@import url(', (__stack.lineno=1,  customFonts.font_import ), '); body { ');__stack.lineno=1; if ( page.color ) { ; buf.push(' background-color: ', (__stack.lineno=1,  page.color ), ' !important; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( page.image ) { ; buf.push(' background-image: url(\'', (__stack.lineno=1,  page.image ), '\'); background-repeat: ', (__stack.lineno=1,  page.repeat || 'no-repeat' ), '; background-size: cover; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( page.position ) { ; buf.push(' background-position: ', (__stack.lineno=1,  page.position ), '; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( customFonts.font_family ) { ; buf.push(' font-family: ', (__stack.lineno=1,  customFonts.font_family ), ', sans-serif !important; ');__stack.lineno=1; } ; buf.push(' } /* Container ------------------------------------ */ #', (__stack.lineno=1,  uniqueId ), ' { ');__stack.lineno=1; if ( container.color ) { ; buf.push(' background-color: ', (__stack.lineno=1,  container.color ), ' !important; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( container.image ) { ; buf.push(' background-image: url(\'', (__stack.lineno=1,  container.image ), '\'); background-repeat: ', (__stack.lineno=1,  container.repeat || 'no-repeat' ), '; background-size: cover; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( container.position ) { ; buf.push(' background-position: ', (__stack.lineno=1,  container.position ), '; ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( customFonts.font_family ) { ; buf.push(' font-family: ', (__stack.lineno=1,  customFonts.font_family ), ', sans-serif !important; ');__stack.lineno=1; } ; buf.push(' } ');__stack.lineno=1; if ( grid.button_border_radius ) { ; buf.push(' #', (__stack.lineno=1, uniqueId ), ' .button .vote { border-radius: ', (__stack.lineno=1,  grid.button_border_radius ), '; } ');__stack.lineno=1; } ; buf.push(' /* Vote Modal ------------------------------------ */ #', (__stack.lineno=1,  uniqueId ), ' .view-modal .modal-window .modal-wrapper .modal-layout .modal-content { ');__stack.lineno=1; if( voteModal.background_color ){ ; buf.push(' background-color: ', (__stack.lineno=1,  voteModal.background_color ), '; ');__stack.lineno=1; } ; buf.push(' } ');__stack.lineno=1; if ( voteModal.background_color ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail { background-color: ', (__stack.lineno=1,  voteModal.background_color ), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.headline.color || voteModal.headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .headline-modal { ', (__stack.lineno=1,  voteModal.headline.color ? 'color:' + voteModal.headline.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.headline.font_size ? 'font-size:' + voteModal.headline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.firstname.color || voteModal.firstname.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .firstname { ', (__stack.lineno=1,  voteModal.firstname.color ? 'color:' + voteModal.firstname.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.firstname.font_size ? 'font-size:' + voteModal.firstname.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.lastname.color || voteModal.lastname.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .lastname { ', (__stack.lineno=1,  voteModal.lastname.color ? 'color:' + voteModal.lastname.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.lastname.font_size ? 'font-size:' + voteModal.lastname.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.details.color || voteModal.details.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .details { ', (__stack.lineno=1,  voteModal.details.color ? 'color:' + voteModal.details.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.details.font_size ? 'font-size:' + voteModal.details.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.third_details.color || voteModal.third_details.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .third-details { ', (__stack.lineno=1,  voteModal.third_details.color ? 'color:' + voteModal.third_details.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.third_details.font_size ? 'font-size:' + voteModal.third_details.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.description.color || voteModal.description.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .description { ', (__stack.lineno=1,  voteModal.description.color ? 'color:' + voteModal.description.color + ';' : '' ), ' ', (__stack.lineno=1,  voteModal.description.font_size ? 'font-size:' + voteModal.description.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( voteModal.link.color || voteModal.link.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .style-vote-detail .moreVote { ', (__stack.lineno=1,  voteModal.link.color ? 'color:' + voteModal.link.color + '!important;' : '' ), ' ', (__stack.lineno=1,  voteModal.link.font_size ? 'font-size:' + voteModal.link.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-modal .modal-window { ');__stack.lineno=1; if( voteModal.overlay_color ){ ; buf.push(' background-colr: ', (__stack.lineno=1,  voteModal.overlay_color ), '; ');__stack.lineno=1; } ; buf.push(' } /* Thanks Modal ------------------------------------ */ #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .thanks-social .thanks svg { ');__stack.lineno=1; if( voteModal.social_icon_colors ){ ; buf.push(' fill: ', (__stack.lineno=1,  voteModal.social_icon_colors ), '; ');__stack.lineno=1; } ; buf.push(' } ');__stack.lineno=1; if ( thanks.headline.color || thanks.headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks h3 { ', (__stack.lineno=1,  thanks.headline.color ? 'color:' + thanks.headline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.headline.font_size ? 'font-size:' + thanks.headline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.subheadline.color || thanks.subheadline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .thanks-view { ', (__stack.lineno=1,  thanks.subheadline.color ? 'color:' + thanks.subheadline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.subheadline.font_size ? 'font-size:' + thanks.subheadline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.twitter_headline.color || thanks.twitter_headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .twitter-vote h4 { ', (__stack.lineno=1,  thanks.twitter_headline.color ? 'color:' + thanks.twitter_headline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.twitter_headline.font_size ? 'font-size:' + thanks.twitter_headline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.twitter_subheadline.color || thanks.twitter_subheadline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-thanks .twitter-vote p { ', (__stack.lineno=1,  thanks.twitter_subheadline.color ? 'color:' + thanks.twitter_subheadline.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.twitter_subheadline.font_size ? 'font-size:' + thanks.twitter_subheadline.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( thanks.share_cta.color || thanks.share_cta.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .thanks-container p { ', (__stack.lineno=1,  thanks.share_cta.color ? 'color:' + thanks.share_cta.color + ';' : '' ), ' ', (__stack.lineno=1,  thanks.share_cta.font_size ? 'font-size:' + thanks.share_cta.font_size+ ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' /* Buttons ------------------------------------ */ .view-vote-item .button .vote, .contestant-container .button .vote, .email-vote input[type=submit], .view-vote-detail .buttons .vote, .view-thanks .button .btn-vote-again { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); background-image: -o-linear-gradient(top,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); background-image: linear-gradient(to bottom,', (__stack.lineno=1,  voteButton.color ), ',', (__stack.lineno=1,  voteButton.bottom_gradient ), '); color: ', (__stack.lineno=1,  voteButton.text_color ), ' !important; } .view-vote-item .button .hover, .contestant-container .button .hover, .email-vote input[type=submit]:hover, .view-vote-detail .buttons .vote:hover, .view-thanks .button .btn-vote-again:hover { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); background-image: -o-linear-gradient(top,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); background-image: linear-gradient(to bottom,', (__stack.lineno=1,  voteButton.hover_color ), ',', (__stack.lineno=1,  voteButton.hover_bottom_gradient || voteButton.hover_color ), '); cursor: pointer; } /* Grid Item ------------------------------------ */ .contestant { background-color: ', (__stack.lineno=1,  voteItem.background_color ), '; ', (__stack.lineno=1,  voteItem.color ? 'color:' + voteItem.color + ';' : '' ), ' } ');__stack.lineno=1; if ( voteItem.font_size ) { ; buf.push(' .contestant .name { font-size: ', (__stack.lineno=1,  voteItem.font_size ), '!important; } ');__stack.lineno=1; } ; buf.push(' .login, .logout { color: ', (__stack.lineno=1,  login.login_link_color ), ' !important; ', (__stack.lineno=1,  login.font_size ? 'font-size:' + login.font_size + '!important;' : '' ), '; } .greeting { color: ', (__stack.lineno=1,  login.greeting_text_color ), ' !important; ', (__stack.lineno=1,  login.font_size ? 'font-size:' + login.font_size + '!important;' : '' ), '; } .grid-header h3 { color: ', (__stack.lineno=1,  grid.headline_color ), ' !important; ', (__stack.lineno=1,  grid.headline_font_size ? 'font-size:' + grid.headline_font_size + ';' : '' ), ' } .grid-header p { color: ', (__stack.lineno=1,  grid.description_color ), ' !important; ', (__stack.lineno=1,  grid.description_font_size ? 'font-size:' + grid.description_font_size + ';' : '' ), ' } .moreVote { color: ', (__stack.lineno=1,  voteButton.color ), ' !important; } .btn-close { color: ', (__stack.lineno=1,  closeButton.mobile_color ), ' !important; } .btn-close:hover { color: #369; } .view-modal { border: 10px solid ', escape((__stack.lineno=1,  voteModal.border_color )), ' !important; } ');__stack.lineno=1; if( voteModal.arrow_colors.prev ){ ; buf.push(' .telescope_icon_arrow_left { color: ', (__stack.lineno=1,  voteModal.arrow_colors.prev ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( voteModal.arrow_colors.next ){ ; buf.push(' .telescope_icon_arrow_right { color: ', (__stack.lineno=1,  voteModal.arrow_colors.next ), ' !important; } ');__stack.lineno=1; } ; buf.push(' .view-auth .socialBoxes .email { background-image: -webkit-linear-gradient(top,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; background-image: -moz-linear-gradient(top,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; background-image: -o-linear-gradient(top,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; background-image: linear-gradient(to bottom,', (__stack.lineno=1,  emailButton.color ), ',', (__stack.lineno=1,  emailButton.bottom_gradient ), ') !important; } .header-container { background-image: url(', (__stack.lineno=1,  header.background_image_mobile ), '); background-position: 0 0; background-position: inherit; background-size: cover; background-repeat: no-repeat; background-color: ', (__stack.lineno=1,  header.background_color ), '; } .header-text h1, .header-text h4 { color: ', (__stack.lineno=1,  header.headline_color ), ' !important; } .header-text p { color: ', (__stack.lineno=1,  header.description_color ), ' !important; } ');__stack.lineno=1; if ( header.headline_font_size ) {; buf.push(' .header-text h1 { font-size: ', (__stack.lineno=1,  header.headline_font_size ), '; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( header.paragraph_font_size ) { ; buf.push(' .header-text p { font-size: ', (__stack.lineno=1,  header.paragraph_font_size ), '; } ');__stack.lineno=1; } ; buf.push(' /* Footer ------------------------------------ */ .footer .footer-container { background-image: url(', (__stack.lineno=1,  footer.background_image ), '); background-position: inherit; background-size: cover; background-repeat: no-repeat; ', (__stack.lineno=1,  footer.background_color ? 'background-color:' + footer.background_color + ';' : '' ), ' } .footer .footer-container a { color: ', (__stack.lineno=1,  footer.link_color ), ' !important; ', (__stack.lineno=1,  footer.font_size ? 'font-size:' + footer.font_size + ';' : '' ), ' } @media (min-width: 750px) { .header-container { background-image: url(', (__stack.lineno=1,  header.background_image ), '); } .btn-close { color: ', (__stack.lineno=1,  closeButton.color ), ' !important; } } /* Countdown ------------------------------------ */ ');__stack.lineno=1; if( countdown.labels_color ){ ; buf.push(' .countdown-unit-label { color: ', (__stack.lineno=1,  countdown.labels_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( countdown.countdown_unit_background_color ){ ; buf.push(' .countdown-value { background-color: ', (__stack.lineno=1,  countdown.countdown_unit_background_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( countdown.countdown_unit_copy_color ){ ; buf.push(' .countdown-value { color: ', (__stack.lineno=1,  countdown.countdown_unit_copy_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( countdown.colon_color ){ ; buf.push(' .colon { color: ', (__stack.lineno=1,  countdown.colon_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' /* Window ------------------------------------ */ ');__stack.lineno=1; if( closed.headline_color ){ ; buf.push(' .window h3, .countdown-view-home .countdown-container .intro-text { color: ', (__stack.lineno=1,  closed.headline_color ), ' !important; } ');__stack.lineno=1; } ; buf.push(' .window .copy { color: ', (__stack.lineno=1,  closed.description_color ), ' !important; } /* Auth Modal ------------------------------------ */ ');__stack.lineno=1; if ( auth.headline.color || auth.headline.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-modal .view-auth h3 { ', (__stack.lineno=1,  auth.headline.color ? 'color:' + auth.headline.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.headline.font_size ? 'font-size:' + auth.headline.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.checkbox_label.color || auth.checkbox_label.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .checkbox-parent input[type=checkbox]+label { ', (__stack.lineno=1,  auth.checkbox_label.color ? 'color:' + auth.checkbox_label.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.checkbox_label.font_size ? 'font-size:' + auth.checkbox_label.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.checkbox_label_link.color || auth.checkbox_label_link.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .checkbox-parent input[type=checkbox]+label a { ', (__stack.lineno=1,  auth.checkbox_label_link.color ? 'color:' + auth.checkbox_label_link.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.checkbox_label_link.font_size ? 'font-size:' + auth.checkbox_label_link.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.error.color || auth.error.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .message { ', (__stack.lineno=1,  auth.error.color ? 'color:' + auth.error.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.error.color || auth.error.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .message { ', (__stack.lineno=1,  auth.error.color ? 'color:' + auth.error.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.error.font_size ? 'font-size:' + auth.error.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if ( auth.email_cta.color || auth.email_cta.font_size ) { ; buf.push(' #', (__stack.lineno=1,  uniqueId ), ' .view-auth .email-vote h3 { ', (__stack.lineno=1,  auth.email_cta.color ? 'color:' + auth.email_cta.color + ';' : '' ), ' ', (__stack.lineno=1,  auth.email_cta.font_size ? 'font-size:' + auth.email_cta.font_size + ';' : '' ), ' } ');__stack.lineno=1; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var template = __webpack_require__(60);

'use strict';
module.exports = Backbone.View.extend({
    className: 'header',
    events: {
        'click .clear-search': 'resetSearch',
        'input .search': 'search'   
    },
    /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render');

        this.cms = options.cms;
        this.collection = options.voteOption;
        this.dataLength = this.collection.models.length;
        this.cloned_collection = _.clone(this.collection);
        this.windowStat = this.cms.get('settings')['window_status'];
        this.search = _.debounce(this.search, 300);
    },

    /**
   *
   */
    render: function() {
        this.createModel();
        console.log('Window status: ', this.windowStat);

        this.$el.html(template(this.model));
    
        this.$searchText = this.$('.search-text');
        this.$closeButton = this.$('.clear-search');
        this.$searchInput = this.$('.search');

        return this;
    },
    /**
   *
   */
    createModel: function() {
        var numContestants = this.collection.models.length;
        var params = {
            'copy': this.cms.get('text')['views_nominee_grid'],
            'design': this.cms.get('text')['design'],
            // 'image': this.cms.get('text')['views_page_header']['category_image'],
            'search': this.cms.get('text')['views_nominee_grid'].search.enabled,
            'length': numContestants,
            'windowStat': this.windowStat
        };

        var headlineLength = this.model.headline_copy.length;
        var paragraphLength = this.model.description_copy.length;

        if(headlineLength > 31 || paragraphLength > 74) {
            this.model.headline_copy = this.model.headline_copy.slice(0,31);
            this.model.description_copy = this.model.description_copy.slice(0,74);
        }

        _.extend(this.model, params);
    },
    /**
   *
   */
    search: function(e) {
        var term = e.target.value;
        var collection = this.cloned_collection;

        console.log('Search terms: ', term);

        var pattern = new RegExp(term, 'gi');

        //search for both first and last names store the value in search variable
        var search = collection.models.filter(function(data) {
            return pattern.test(data.get('firstname') + ' ' + data.get('lastname')) || pattern.test(data.get('secondaryinfo'));
        });

        //reset collection based on search results
        if (search.length > 0) {
            this.collection.reset(search);
        } else if (search == '') {
            this.collection.reset();
        }

    },

    /**
   *
   */
    resetSearch: function(e) {
        console.log('e', e, this.cloned_collection);
        // restore the cloned collection
        this.collection.reset(this.cloned_collection.models);
        this.$searchInput.val('');
    },
    /**
   *
   */
    contestantCount: function() {
        var total = this.collection.models.length;
        return total;
    }
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"header-container\"> <% if(logo != \"\") { %> <div class=\"header-image\"><img src=\"<%- logo %>\" class=\"logo\"></div> <% } %> <% if(headline_copy != \"\" || description_copy != \"\"){ %> <div class=\"header-text\"> <% if(headline_copy != \"\"){ %><h1><%- headline_copy %></h1><% } %> <% if(description_copy != \"\"){ %><p><%- description_copy %></p><% } %> </div> <% } %> </div> <% if (windowStat === \"1\") { %> <% if (length > 15 && search === \"true\") { %> <div class=\"search-container\"> <div class=\"search-text\"><%- copy.search.description %></div> <div class=\"search-form telescope_icon_search\"> <input type=\"search\" placeholder=\"Search Contestants\" class=\"search\"> <div class=\"clear-search telescope_icon_clear\"></div> </div> </div> <% } else { %> <% } %> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="header-container"> ');__stack.lineno=1; if(logo != "") { ; buf.push(' <div class="header-image"><img src="', (__stack.lineno=1,  logo ), '" class="logo"></div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(headline_copy != "" || description_copy != ""){ ; buf.push(' <div class="header-text"> ');__stack.lineno=1; if(headline_copy != ""){ ; buf.push('<h1>', (__stack.lineno=1,  headline_copy ), '</h1>');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(description_copy != ""){ ; buf.push('<p>', (__stack.lineno=1,  description_copy ), '</p>');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if (windowStat === "1") { ; buf.push(' ');__stack.lineno=1; if (length > 15 && search === "true") { ; buf.push(' <div class="search-container"> <div class="search-text">', (__stack.lineno=1,  copy.search.description ), '</div> <div class="search-form telescope_icon_search"> <input type="search" placeholder="Search Contestants" class="search"> <div class="clear-search telescope_icon_clear"></div> </div> </div> ');__stack.lineno=1; } else { ; buf.push(' ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var template = __webpack_require__(62);

'use strict';
module.exports = Backbone.View.extend({
    className: 'footer',
    events: {
        'click .route-faq': 'routeFAQ'
    },
    /**
   *
   */
    initialize: function (options) {
        this.cms = options.cms;
        this.router = options.router;
    },
    /**
   *
   */
    render: function () {

        var styles = this.cms.get('text').design;
        var footer = this.cms.get('text').views_page_footer;
        var footerCopy = footer.footer_copy;

        var regEx = /.<img./;

        if (!_.isArray(footerCopy.match(regEx))) {
            footerCopy = footerCopy.slice(0,57);
            footer.footer_copy = footerCopy;
        }

        var model = {
            text: footer,
            faq: this.cms.get('text').views_faq,
            copy: styles.css.footer.link_color
        };
        console.log(model.faq, ' Footer VIEW RENDER');
        this.$el.html(template(model));

        return this;
    },
    /**
   *
   */
    routeFAQ: function (e) {
    //this.router.navigate('loading/generic', {trigger: true});
        var faq = this.cms.get('text').views_faq;
        if(faq.enable_faq_modal == 'true'){
            e.preventDefault();
            this.router.faq();
        }
    }
});


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"footer-container\"> <%- text.footer_copy %> <% if(!_.isNull(text.link_url) && (text.link_url).trim() !== \"\") { %> <a href=\"<%- text.link_url %>\" target=\"_blank\" class=\"conditions\"><%- text.link_copy %></a> <% } if(!_.isNull(faq.link_url) && (faq.link_url).trim() !== \"\") { %> <a href=\"<%- faq.link_url %>\" target=\"_blank\" class=\"conditions route-faq\"><%- faq.link_copy %></a> <% }; %> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="footer-container"> ', (__stack.lineno=1,  text.footer_copy ), ' ');__stack.lineno=1; if(!_.isNull(text.link_url) && (text.link_url).trim() !== "") { ; buf.push(' <a href="', (__stack.lineno=1,  text.link_url ), '" target="_blank" class="conditions">', (__stack.lineno=1,  text.link_copy ), '</a> ');__stack.lineno=1; } if(!_.isNull(faq.link_url) && (faq.link_url).trim() !== "") { ; buf.push(' <a href="', (__stack.lineno=1,  faq.link_url ), '" target="_blank" class="conditions route-faq">', (__stack.lineno=1,  faq.link_copy ), '</a> ');__stack.lineno=1; }; ; buf.push(' </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var PubSub = __webpack_require__(3);
var template = __webpack_require__(64);

var UserView = __webpack_require__(65);
var VoteOptionView = __webpack_require__(67);

var GridView = __webpack_require__(74);

module.exports = GridView.extend({
    events: function events() {
        return _.extend({}, GridView.prototype.events, {
            'click .rules-wrapper a': 'handleLinkClick'
        });
    },

    handleLinkClick: function handleLinkClick(e) {
        var evt = {
            category: 'Link Click',
            action: 'Link Click: ' + e.target.innerText,
            label: 'Link Click: ' + e.target.innerText
        };

        PubSub.trigger('trackGoogle', evt);
    },

    render: function render() {

        this.$el.html(template({
            length: this.collection.models.length,
            copy: this.cms.get('text').views_nominee_grid
        }));

        var user = new UserView({
            cms: this.cms,
            auth: this.auth
        });

        this.$('.user-wrapper').append(user.render().$el);

        var gridName = '';
        // RUN-4 Depending on number of Contestants we will show different columns
        if (this.dataLength % 3 === 0 && this.dataLength % 2 === 0) {
            // Round One/Two -> 6 contestants
            gridName = 'col-opt-1';
        } else if (this.dataLength % 2 === 0) {
            // Round Three -> 4 contestants
            gridName = 'col-opt-2';
        } else if (this.dataLength % 3 <= 2) {
            // Round Four -> 3 contestants
            gridName = 'col-opt-3 remnant-' + this.dataLength % 3;
        }

        var el = $('<ul/>').addClass(gridName);

        this.voteOptions = this.voteOptions || [];
        this.removeOptions();

        _.each(this.collection.models, function (value) {

            var option = new VoteOptionView({
                model: value,
                dataLength: this.dataLength,
                cms: this.cms,
                voteOption: this.collection,
                router: this.router
            });

            this.voteOptions.push(option);
            el.append(option.render().$el.css({
                'opacity': 0
            }));

            // option.renderedToDOM();
        }.bind(this));

        this.$('.voting-grid-options').html(el);

        return this;
    },

    voteLogin: function voteLogin(e) {
        e.preventDefault();

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Login',
            label: 'Button Click: Login'
        };

        PubSub.trigger('route:auth');
        PubSub.trigger('trackGoogle', evt);
    }
});

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<section class=\"grid-header\"> <div class=\"sponsor-wrapper\"> <img src=\"<%= copy.sponsor_image %>\"> </div> <div class=\"wrapper-text<%- (copy.headline_copy.length===0 && copy.description_copy.length===0? ' hidden' : '' ) %>\"> <h3 <%- (copy.headline_copy.length>0? '' : ' class=\"hidden\" ' ) %>><%- copy.headline_copy %></h3> <p <%- (copy.description_copy.length>0? '' : ' class=\"hidden\" ' ) %>><%- copy.description_copy %></p> </div> </section> <% if (length < 1) { %> <div class=\"grid-error\"> <h2>No Results</h2> <p>Expand your search and try again.</p> </div> <% } else { %> <div class=\"voting-grid-options\"></div> <% }  %> <div class=\"grid-footer\"> <div class=\"rules-wrapper\"> <a href=\"<%= copy.rules_url %>\" target=\"_blank\" rel=\"noopener noreferrer\"><%= copy.rules_copy %></a> </div> | <div class=\"user-wrapper\"></div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<section class="grid-header"> <div class="sponsor-wrapper"> <img src="', escape((__stack.lineno=1,  copy.sponsor_image )), '"> </div> <div class="wrapper-text', (__stack.lineno=1,  (copy.headline_copy.length===0 && copy.description_copy.length===0? ' hidden' : '' ) ), '"> <h3 ', (__stack.lineno=1,  (copy.headline_copy.length>0? '' : ' class="hidden" ' ) ), '>', (__stack.lineno=1,  copy.headline_copy ), '</h3> <p ', (__stack.lineno=1,  (copy.description_copy.length>0? '' : ' class="hidden" ' ) ), '>', (__stack.lineno=1,  copy.description_copy ), '</p> </div> </section> ');__stack.lineno=1; if (length < 1) { ; buf.push(' <div class="grid-error"> <h2>No Results</h2> <p>Expand your search and try again.</p> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="voting-grid-options"></div> ');__stack.lineno=1; }  ; buf.push(' <div class="grid-footer"> <div class="rules-wrapper"> <a href="', escape((__stack.lineno=1,  copy.rules_url )), '" target="_blank" rel="noopener noreferrer">', escape((__stack.lineno=1,  copy.rules_copy )), '</a> </div> | <div class="user-wrapper"></div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PubSub = __webpack_require__(3);

var UserView = __webpack_require__(10);

module.exports = UserView.extend({

    logout: function logout(e) {

        e.preventDefault();

        this.auth.deAuthorize();

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Logout',
            label: 'Button Click: Logout'
        };

        PubSub.trigger('clearUser');
        PubSub.trigger('trackGoogle', evt);
    }
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if (window != 0) { %> <% if (user != null) { %> <span class=\"greeting\"><%- copy.welcome_copy %></span> <a href=\"#\" class=\"logout\"><%- copy.logout %></a> <% } else { %> <a href=\"#\" alt=\"log-in\" class=\"login\"><%- copy.login %></a> <% } %> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if (window != 0) { ; buf.push(' ');__stack.lineno=1; if (user != null) { ; buf.push(' <span class="greeting">', (__stack.lineno=1,  copy.welcome_copy ), '</span> <a href="#" class="logout">', (__stack.lineno=1,  copy.logout ), '</a> ');__stack.lineno=1; } else { ; buf.push(' <a href="#" alt="log-in" class="login">', (__stack.lineno=1,  copy.login ), '</a> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var PubSub = __webpack_require__(3);
var template = __webpack_require__(68);
var templateAlt = __webpack_require__(69);

var VoteOptionView = __webpack_require__(11);

module.exports = VoteOptionView.extend({

    render: function render() {

        var dataLength = this.dataLength;
        var model = this.model.toJSON();

        var isEliminated = _.checkIfTrue(model.eliminated);

        // check length of vote option name and slice it
        var fullName = model.firstname + ' ' + model.lastname;
        if (fullName.length >= 74) fullName = fullName.slice(0, 73);
        model.fullname = fullName;

        var text = this.cms.get('text')['views_nominee_grid'];

        //check the length of the contestants, render different layout based on contestant length
        if (dataLength === 2 || dataLength === 4) {
            this.$el.html(templateAlt({
                model: model,
                text: text,
                isEliminated: isEliminated
            }));
            return this;
        }

        this.$el.html(template({
            model: model,
            text: text,
            isEliminated: isEliminated
        }));

        return this;
    },

    selectContestant: function selectContestant(e) {
        e.preventDefault();
        this.voteOption.setSelected(this.model.get('id'));

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Select Contestant',
            label: 'Button Click: Select Contestant'
        };

        PubSub.trigger('scrollToTop');
        PubSub.trigger('trackGoogle', evt);
    }

});

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"contestant<% if(isEliminated){ %> eliminated<% } %>\"> <div class=\"item-measure-contents\"> <div> <figure> <% if (model.image.length > 0) { %> <img class=\"contestant-img\" src=\"<%- model.image %>\"> <% } %> </figure> </div> <div class=\"clearfix\"> <div class=\"contestant-wrapper\"> <div class=\"contestant-view\"> <div class=\"name\"><%- model.fullname %></div> </div> <% if(model.secondaryinfo != '') { %> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <% } %> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <% if(!isEliminated){ %> <div class=\"vote\"><%- text.vote_button_copy %></div> <% } else { %> <div class=\"eliminated-vote\"><%- text.eliminated_button_copy %></div> <% } %> </div> </div> </div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="contestant');__stack.lineno=1; if(isEliminated){ ; buf.push(' eliminated');__stack.lineno=1; } ; buf.push('"> <div class="item-measure-contents"> <div> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img class="contestant-img" src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' </figure> </div> <div class="clearfix"> <div class="contestant-wrapper"> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.fullname ), '</div> </div> ');__stack.lineno=1; if(model.secondaryinfo != '') { ; buf.push(' <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> ');__stack.lineno=1; } ; buf.push(' </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> ');__stack.lineno=1; if(!isEliminated){ ; buf.push(' <div class="vote">', (__stack.lineno=1,  text.vote_button_copy ), '</div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated-vote">', (__stack.lineno=1,  text.eliminated_button_copy ), '</div> ');__stack.lineno=1; } ; buf.push(' </div> </div> </div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"contestant clearfix<% if(isEliminated){ %> eliminated<% } %>\"> <div class=\"item-measure-contents clearfix\"> <div> <figure> <% if (model.image.length > 0) { %> <img src=\"<%- model.image %>\"> <% } %> </figure> </div> <div> <div class=\"contestant-wrapper\"> <div class=\"contestant-view\"> <div class=\"name\"><%- model.fullname %></div> </div> <% if(model.secondaryinfo != '') { %> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <% } %> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <% if(!isEliminated){ %> <div class=\"vote\"><%- text.vote_button_copy %></div> <% } else { %> <div class=\"eliminated-vote\"><%- text.eliminated_button_copy %></div> <% } %> </div> </div> </div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="contestant clearfix');__stack.lineno=1; if(isEliminated){ ; buf.push(' eliminated');__stack.lineno=1; } ; buf.push('"> <div class="item-measure-contents clearfix"> <div> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' </figure> </div> <div> <div class="contestant-wrapper"> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.fullname ), '</div> </div> ');__stack.lineno=1; if(model.secondaryinfo != '') { ; buf.push(' <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> ');__stack.lineno=1; } ; buf.push(' </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> ');__stack.lineno=1; if(!isEliminated){ ; buf.push(' <div class="vote">', (__stack.lineno=1,  text.vote_button_copy ), '</div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated-vote">', (__stack.lineno=1,  text.eliminated_button_copy ), '</div> ');__stack.lineno=1; } ; buf.push(' </div> </div> </div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if (model.eliminated === \"0\") { %> <div class=\"contestant\"> <div class=\"item-measure-contents\"> <div> <figure> <% if (model.image.length > 0) { %> <img class=\"contestant-img\" src=\"<%- model.image %>\"> <% } %> <figcaption> </figcaption> </figure> </div> <div> <div class=\"contestant-wrapper\"> <div class=\"contestant-view\"> <div class=\"name\"><%- model.fullname %></div> </div> <% if(model.secondaryinfo != '') { %> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <% } %> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <div class=\"vote\"><%- text.vote_button_copy %></div> </div> </div> </div> </div> <% } else { %> <div class=\"contestant eliminated\"> <div class=\"item-measure-contents\"> <figure> <% if (model.image.length > 0) { %> <img class=\"contestant-img\" src=\"<%- model.image %>\"> <% } %> <figcaption> </figcaption> </figure> <div class=\"contestant-view\"> <div class=\"name\"><%- model.firstname %> <%- model.lastname %></div> </div> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <div class=\"eliminated-vote\"><%- text.eliminated_button_copy %></div> </div> </div> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if (model.eliminated === "0") { ; buf.push(' <div class="contestant"> <div class="item-measure-contents"> <div> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img class="contestant-img" src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' <figcaption> </figcaption> </figure> </div> <div> <div class="contestant-wrapper"> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.fullname ), '</div> </div> ');__stack.lineno=1; if(model.secondaryinfo != '') { ; buf.push(' <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> ');__stack.lineno=1; } ; buf.push(' </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> <div class="vote">', (__stack.lineno=1,  text.vote_button_copy ), '</div> </div> </div> </div> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="contestant eliminated"> <div class="item-measure-contents"> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img class="contestant-img" src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' <figcaption> </figcaption> </figure> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.firstname ), ' ', (__stack.lineno=1,  model.lastname ), '</div> </div> <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> <div class="eliminated-vote">', (__stack.lineno=1,  text.eliminated_button_copy ), '</div> </div> </div> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if (model.eliminated === \"0\") { %> <div class=\"contestant clearfix\"> <div class=\"item-measure-contents clearfix\"> <div> <figure> <% if (model.image.length > 0) { %> <img src=\"<%- model.image %>\"> <% } %> <figcaption> </figcaption> </figure> </div> <div> <div class=\"contestant-wrapper\"> <div class=\"contestant-view\"> <div class=\"name\"><%- model.fullname %></div> </div> <% if(model.secondaryinfo != '') { %> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <% } %> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <div class=\"vote\"><%- text.vote_button_copy %></div> </div> </div> </div> </div> <% } else { %> <div class=\"contestant eliminated clearfix\"> <div class=\"item-measure-contents clearfix\"> <figure> <% if (model.image.length > 0) { %> <img src=\"<%- model.image %>\"> <% } %> <figcaption> </figcaption> </figure> <div class=\"contestant-view\"> <div class=\"name\"><%- model.firstname %> <%- model.lastname %></div> </div> <div class=\"contestant-detail\"> <div class=\"detail-info\"><%- model.secondaryinfo %></div> </div> <div class=\"button\" data-id=\"<%- model.id %>\"> <div class=\"eliminated-vote\"><%- text.eliminated_button_copy %></div> </div> </div> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if (model.eliminated === "0") { ; buf.push(' <div class="contestant clearfix"> <div class="item-measure-contents clearfix"> <div> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' <figcaption> </figcaption> </figure> </div> <div> <div class="contestant-wrapper"> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.fullname ), '</div> </div> ');__stack.lineno=1; if(model.secondaryinfo != '') { ; buf.push(' <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> ');__stack.lineno=1; } ; buf.push(' </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> <div class="vote">', (__stack.lineno=1,  text.vote_button_copy ), '</div> </div> </div> </div> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="contestant eliminated clearfix"> <div class="item-measure-contents clearfix"> <figure> ');__stack.lineno=1; if (model.image.length > 0) { ; buf.push(' <img src="', (__stack.lineno=1,  model.image ), '"> ');__stack.lineno=1; } ; buf.push(' <figcaption> </figcaption> </figure> <div class="contestant-view"> <div class="name">', (__stack.lineno=1,  model.firstname ), ' ', (__stack.lineno=1,  model.lastname ), '</div> </div> <div class="contestant-detail"> <div class="detail-info">', (__stack.lineno=1,  model.secondaryinfo ), '</div> </div> <div class="button" data-id="', (__stack.lineno=1,  model.id ), '"> <div class="eliminated-vote">', (__stack.lineno=1,  text.eliminated_button_copy ), '</div> </div> </div> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * imagesLoaded v4.1.3
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( true ) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
      __webpack_require__(73)
    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
      return factory( window, EvEmitter );
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  if ( typeof elem == 'string' ) {
    elem = document.querySelectorAll( elem );
  }

  this.elements = makeArray( elem );
  this.options = extend( {}, this.options );

  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( function() {
    this.check();
  }.bind( this ));
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  return this.img.complete && this.img.naturalWidth !== undefined;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( true ) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var template = __webpack_require__(75);
var VoteOptionView = __webpack_require__(11);
var UserView = __webpack_require__(10);
var PubSub = __webpack_require__(3);

'use strict';
module.exports = Backbone.View.extend({
    className: 'view-grid',
    events: {
        'click .login': 'voteLogin'
    },  
    /**
  /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render', 'hasSelected');

        this.cms = options.cms;
        this.connect = options.connect;
        this.auth = options.auth;
        this.collection = options.voteOption;
        this.router = options.router;
        this.dataLength = this.collection.models.length;
        this.cloned_collection = _.clone(this.collection);

        this.listenTo(this.collection, 'change:selected', this.hasSelected);
        this.listenTo(this.collection, 'reset', this.render, this);
        this.listenTo(this.auth, 'change:isAuthorized', this.hasSelected);

        this.listenTo(PubSub, 'relayVoteItemHeight', _.bind(this.setCollectiveHeight, this));
        this.itemHeight = 0;
        Backbone.$(window).on('resize', _.bind(function(){
            this.itemHeight = 0;
        }, this));
    },
    /**
   *
   */
    render: function() {

        this.$el.html(template({
            length: this.collection.models.length,
            copy: this.cms.get('text').views_nominee_grid
        }));

        var user = new UserView({
            cms: this.cms,
            auth: this.auth
        });
        this.$('.user-wrapper').append(user.render().$el);
        this.listenTo(user,'trackEvent', function(evt){ this.trigger('trackEvent',evt); });
        this.listenTo(user,'clearUser', function(evt){ this.trigger('clearUser',evt); });

        var columnOption = this.cms.get('text').views_nominee_grid.column_options.toLowerCase();
        var gridName = 'col-opt-'+columnOption;
        var el = $('<ul/>').addClass(gridName);

        this.voteOptions = this.voteOptions || [];
        this.removeOptions();

        _.each(this.collection.models, _.bind(function(value) {

            var option = new VoteOptionView({
                model: value,
                dataLength: this.dataLength,
                cms: this.cms,
                voteOption: this.collection,
                router: this.router
            });
            this.voteOptions.push(option);
            el.append(option.render().$el.css({
                'opacity': 0,
            }));

            option.renderedToDOM();

        }, this));

        this.$('.voting-grid-options').html(el);

        return this;
    },
    removeOptions: function() {
        if(this.voteOptions && this.voteOptions.length > 0) {
            for(var i = 0; i < this.voteOptions.length; i++) {
                this.voteOptions[i].remove();
            }
        }
        this.voteOptions = [];
    },
    /**
   *
   */
    voteLogin: function(e) {
        e.preventDefault();
        this.router.auth();
    },  
    /**
   *
   */
    hasSelected: function(e) {

        console.log('from has selected', e);

        var selected = this.collection.findWhere({
            selected: true
        });

        if (_.isObject(selected)) {

            console.log('1 click', this.cms.get('text')['views_nominee_grid'].disable_confirmation_modal);

            if (this.cms.get('text')['views_nominee_grid'].disable_confirmation_modal == 'true') {

                if (this.auth.get('isAuthorized')) {
                    // this.controller.trackEvent(e, 'eventClickVote');
                    PubSub.trigger('cast-vote');
                } else {
                    this.router.auth();
                    return;
                }
            } else {
                this.router.voting(selected);
            }
        }
    },
    renderedToDOM: function() {
        this.gridTransition();
    },
    /**
   * [setCollectiveHeight description]
   * @param {[type]} height [description]
   */
    setCollectiveHeight: function (height) {
        if(height > this.itemHeight){
            this.itemHeight = height;
            console.log('setCollectiveHeight', this.itemHeight, height);
            var item = this.$('.contestant');
            item.removeAttr('style');
            item.height(height);
        }
    },
    /**
   *
   */
    gridTransition: function() {
        this.$el.find('li').each(function(i, el) {
            console.log('gridTransition', el);
            $(el).delay(i * 50).animate({
                'opacity': 1
            }, 250);

        });
    },
    /**
   *
   */
    shiftText: function() {
        $('.search-text').toggleClass('shift');
    },

    remove: function() {
        this.removeOptions();
    
        Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"user-wrapper\"></div> <section class=\"grid-header\"> <div class=\"wrapper-text<%- (copy.headline_copy.length===0 && copy.description_copy.length===0? ' hidden' : '' ) %>\"> <h3 <%- (copy.headline_copy.length>0? '' : ' class=\"hidden\" ' ) %>><%- copy.headline_copy %></h3> <p <%- (copy.description_copy.length>0? '' : ' class=\"hidden\" ' ) %>><%- copy.description_copy %></p> </div> </section> <% if (length < 1) { %> <div class=\"grid-error\"> <h2>No Results</h2> <p>Expand your search and try again.</p> </div> <% } else { %> <div class=\"voting-grid-options\"></div> <% }  %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="user-wrapper"></div> <section class="grid-header"> <div class="wrapper-text', (__stack.lineno=1,  (copy.headline_copy.length===0 && copy.description_copy.length===0? ' hidden' : '' ) ), '"> <h3 ', (__stack.lineno=1,  (copy.headline_copy.length>0? '' : ' class="hidden" ' ) ), '>', (__stack.lineno=1,  copy.headline_copy ), '</h3> <p ', (__stack.lineno=1,  (copy.description_copy.length>0? '' : ' class="hidden" ' ) ), '>', (__stack.lineno=1,  copy.description_copy ), '</p> </div> </section> ');__stack.lineno=1; if (length < 1) { ; buf.push(' <div class="grid-error"> <h2>No Results</h2> <p>Expand your search and try again.</p> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="voting-grid-options"></div> ');__stack.lineno=1; }  ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var PubSub = __webpack_require__(3);
var template = __webpack_require__(77);

var VoteDetailView = __webpack_require__(78);

var voteButtons = __webpack_require__(5).voteButtons;

module.exports = VoteDetailView.extend({

    render: function render() {

        var voteLimit = parseInt(this.cms.get('settings').vote_limit);

        this.$el.html(template(_.extend(this.model.toJSON(), {
            text: this.cms.get('text')['views_vote'],
            design: this.cms.get('text')['design'],
            model: this.collection.indexOf(this.model),
            length: this.collection.length,
            voteButtons: voteButtons,
            votesLeft: voteLimit - this.auth.getSubmittedVotes()
        })));

        //handle rendering the close button on IE 11
        var video = this.$el.find('iframe');
        var src = video.attr('src');
        video.attr('src', src + '?wmode=transparent');

        return this;
    },

    castVote: function castVote(e) {
        e.preventDefault();

        // don't submit vote for inactive
        if (this.model.get('eliminated') == '1') {
            return;
        }

        if ($(e.currentTarget).hasClass('disabled')) return;

        if (!this.auth.get('isAuthorized')) {
            this.router.auth();
            this.auth.off('change:isAuthorized');
            this.listenToOnce(this.auth, 'change:isAuthorized', this.castVote.bind(this, e));
            return;
        }

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Vote',
            label: 'Button Click: Vote'
        };

        var voteCount = null;
        var target = $(e.currentTarget);

        if (target.hasClass('ten')) voteCount = voteButtons.TEN;else if (target.hasClass('twenty')) voteCount = voteButtons.TWENTY;else if (target.hasClass('thirty')) voteCount = voteButtons.THIRTY;else if (target.hasClass('forty')) voteCount = voteButtons.FORTY;

        PubSub.trigger('trackGoogle', evt);
        PubSub.trigger('cast-vote', voteCount);
    }

});

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if (design.vote_modal.show_video === \"true\" || design.vote_modal.show_image === \"true\") { %> <div class=\"gallery\"> <% if (design.vote_modal.show_video === \"false\" && design.vote_modal.show_image === \"true\") { %> <div class=\"image\"> <img src=\"<%- image %>\"> </div> <% } else if (design.vote_modal.show_video === \"true\" && design.vote_modal.show_image === \"false\") { %> <div class=\"video\"> <%- video %> </div> <% } %> <% if (model > 0) { %> <div class=\"prev-contestant telescope_icon_arrow_left\"> </div> <% } %> <% if (model < length - 1) { %> <div class=\"next-contestant telescope_icon_arrow_right\"></div> <% } %> </div> <% } %> <div class=\"contestant-container\"> <div class=\"headline-modal\"> <%- text.title.use_nominee_title == \"true\" ? title : text.title.universal_title %> </div> <% if ( design.vote_modal.show_votes_left === \"true\" && votesLeft ) { %> <div class=\"votes-left\"> You have <%= votesLeft %> votes remaining </div> <% } %> <div class=\"button\"> <div class=\"vote forty<% if(votesLeft < 40) { %> disabled<% } %>\" data-id=\"<%- id %>\"> <%- voteButtons.FORTY %> Votes </div> </div> <div class=\"button\"> <div class=\"vote thirty<% if(votesLeft < 30) { %> disabled<% } %>\" data-id=\"<%- id %>\"> <%- voteButtons.THIRTY %> Votes </div> </div> <div class=\"button\"> <div class=\"vote twenty<% if(votesLeft < 20) { %> disabled<% } %>\" data-id=\"<%- id %>\"> <%- voteButtons.TWENTY %> Votes </div> </div> <div class=\"button\"> <div class=\"vote ten<% if(votesLeft < 10) { %> disabled<% } %>\" data-id=\"<%- id %>\"> <%- voteButtons.TEN %> Votes </div> </div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if (design.vote_modal.show_video === "true" || design.vote_modal.show_image === "true") { ; buf.push(' <div class="gallery"> ');__stack.lineno=1; if (design.vote_modal.show_video === "false" && design.vote_modal.show_image === "true") { ; buf.push(' <div class="image"> <img src="', (__stack.lineno=1,  image ), '"> </div> ');__stack.lineno=1; } else if (design.vote_modal.show_video === "true" && design.vote_modal.show_image === "false") { ; buf.push(' <div class="video"> ', (__stack.lineno=1,  video ), ' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (model > 0) { ; buf.push(' <div class="prev-contestant telescope_icon_arrow_left"> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (model < length - 1) { ; buf.push(' <div class="next-contestant telescope_icon_arrow_right"></div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' <div class="contestant-container"> <div class="headline-modal"> ', (__stack.lineno=1,  text.title.use_nominee_title == "true" ? title : text.title.universal_title ), ' </div> ');__stack.lineno=1; if ( design.vote_modal.show_votes_left === "true" && votesLeft ) { ; buf.push(' <div class="votes-left"> You have ', escape((__stack.lineno=1,  votesLeft )), ' votes remaining </div> ');__stack.lineno=1; } ; buf.push(' <div class="button"> <div class="vote forty');__stack.lineno=1; if(votesLeft < 40) { ; buf.push(' disabled');__stack.lineno=1; } ; buf.push('" data-id="', (__stack.lineno=1,  id ), '"> ', (__stack.lineno=1,  voteButtons.FORTY ), ' Votes </div> </div> <div class="button"> <div class="vote thirty');__stack.lineno=1; if(votesLeft < 30) { ; buf.push(' disabled');__stack.lineno=1; } ; buf.push('" data-id="', (__stack.lineno=1,  id ), '"> ', (__stack.lineno=1,  voteButtons.THIRTY ), ' Votes </div> </div> <div class="button"> <div class="vote twenty');__stack.lineno=1; if(votesLeft < 20) { ; buf.push(' disabled');__stack.lineno=1; } ; buf.push('" data-id="', (__stack.lineno=1,  id ), '"> ', (__stack.lineno=1,  voteButtons.TWENTY ), ' Votes </div> </div> <div class="button"> <div class="vote ten');__stack.lineno=1; if(votesLeft < 10) { ; buf.push(' disabled');__stack.lineno=1; } ; buf.push('" data-id="', (__stack.lineno=1,  id ), '"> ', (__stack.lineno=1,  voteButtons.TEN ), ' Votes </div> </div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var template = __webpack_require__(79);
var PubSub = __webpack_require__(3);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-vote-detail',
    events: {
        'click .next-contestant': 'nextContestant',
        'click .prev-contestant': 'prevContestant',
        'click .vote': 'castVote',
        'mouseenter .button' : 'changeColor',
        'mouseleave .button' : 'changeColor'
    },
    /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render');

        this.model = options.model;
        this.cms = options.cms;
        this.auth = options.auth;
        this.connect = options.connect;
        this.collection = options.voteOption;
        this.router = options.router;
        console.log('detail view model', this.model);
    },
    /**
   *
   */
    nextContestant: function(e) {
        e.preventDefault();
        var model = this.collection.next(this.model);
        this.collection.setSelected(model.get('id'));
    },
    /**
   *
   */
    prevContestant: function(e) {
        e.preventDefault();
        var model = this.collection.prev(this.model);
        this.collection.setSelected(model.get('id'));
    },
    /**
   *
   */
    castVote: function(e) {
        e.preventDefault();

        // don't submit vote for inactive
        if (this.model.get('eliminated') == '1') {
            return;
        }

        if (!this.auth.get('isAuthorized')) {
            this.router.auth();
            this.listenToOnce(this.auth, 'change:isAuthorized', _.bind(this.castVote, this, e));
            return;
        }

        var evt = {
            target: this,
            name: 'eventClickVote',
            origEvent: e
        };

        this.trigger('trackEvent',evt);
        PubSub.trigger('cast-vote');

    },
    /**
   *
   */
    render: function() {

        this.$el.html(template(_.extend(this.model.toJSON(), {
            text: this.cms.get('text')['views_vote'],
            design: this.cms.get('text')['design'],
            model: this.collection.indexOf(this.model),
            length: this.collection.length
        })));

        //handle rendering the close button on IE 11
        var video = this.$el.find('iframe');
        var src = video.attr('src');
        video.attr('src', src + '?wmode=transparent');

        return this;
    },

    /**
   *
   */
    changeColor: function (e) {
        var $target = $(e.currentTarget).find('.vote');

        if($target.length === 0) {
            $target = $(e.currentTarget).find('.eliminated-vote');
            $target.toggleClass('hoverElim');
            return;
        }
    
        $target.toggleClass('hover');
    },

    renderedToDOM: function() {
        var videoContainer = this.$('.gallery');
        FB.XFBML.parse(videoContainer.get(0));
    }
});

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<% if (design.vote_modal.show_video === \"false\" && design.vote_modal.show_image === \"true\") { %> <div class=\"gallery\"> <% if (model > 0) { %> <div class=\"prev-contestant telescope_icon_arrow_left\"> </div> <% } else { %> <div class=\"eliminated last-arrow-left telescope_icon_arrow_left\"></div> <% } %> <div class=\"image\"> <img src=\"<%- image %>\"> </div> <% if (model < length - 1) { %> <div class=\"next-contestant telescope_icon_arrow_right\"></div> <% } else { %> <div class=\"eliminated last-arrow-right telescope_icon_arrow_right\"></div> <% } %> </div> <% } else if (design.vote_modal.show_video === \"true\" && design.vote_modal.show_image === \"false\") { %> <div class=\"gallery\"> <% if (model > 0) { %> <div class=\"prev-contestant telescope_icon_arrow_left\"></div> <% } else { %> <div class=\"eliminated last-arrow-left telescope_icon_arrow_left\"></div> <% } %> <div class=\"video\"> <%- video %> </div> <% if (model < length - 1) { %> <div class=\"next-contestant telescope_icon_arrow_right\"></div> <% } else { %> <div class=\"eliminated last-arrow-right telescope_icon_arrow_right\"></div> <% } %> </div> <% } %> <div class=\"headline-modal\"> <%- text.title.use_nominee_title == \"true\" ? title : text.title.universal_title %> </div> <div class=\"contestant-container\"> <div class=\"contestant-view\"> <div class=\"firstname\"><%- firstname %></div> <div class=\"lastname\"><%- lastname %></div> <div class=\"details\"><%- secondaryinfo %></div> <% if (design.show_third_detail === \"true\") { %> <div class=\"third-details\"><%- thirdinfo %></div> <% } %> <% if (design.show_description_detail === \"true\") { %> <div class=\"description\"><%- description %></div> <% } %> </div> <% if (text.external_url.display === \"true\" && eliminated === \"0\") { %> <a href=\"<%- externalURL %>\" target=\"_blank\" class=\"moreVote\"><%- text.external_url.copy %></a> <div class=\"button\"> <div class=\"vote\" data-id=\"<%- id %>\"> <%- text.vote_button.active_nominee_copy %> </div> </div> <% } else if (eliminated === \"1\") { %> <div class=\"button\"> <div class=\"eliminated\" data-id=\"<%- id %>\"><%- text.vote_button.eliminated_nominee_copy %></div> </div> <% } else { %> <div class=\"button\"> <div class=\"vote\" data-id=\"<%- id %>\"> <%- text.vote_button.active_nominee_copy %> </div> </div> <% } %> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('');__stack.lineno=1; if (design.vote_modal.show_video === "false" && design.vote_modal.show_image === "true") { ; buf.push(' <div class="gallery"> ');__stack.lineno=1; if (model > 0) { ; buf.push(' <div class="prev-contestant telescope_icon_arrow_left"> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated last-arrow-left telescope_icon_arrow_left"></div> ');__stack.lineno=1; } ; buf.push(' <div class="image"> <img src="', (__stack.lineno=1,  image ), '"> </div> ');__stack.lineno=1; if (model < length - 1) { ; buf.push(' <div class="next-contestant telescope_icon_arrow_right"></div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated last-arrow-right telescope_icon_arrow_right"></div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } else if (design.vote_modal.show_video === "true" && design.vote_modal.show_image === "false") { ; buf.push(' <div class="gallery"> ');__stack.lineno=1; if (model > 0) { ; buf.push(' <div class="prev-contestant telescope_icon_arrow_left"></div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated last-arrow-left telescope_icon_arrow_left"></div> ');__stack.lineno=1; } ; buf.push(' <div class="video"> ', (__stack.lineno=1,  video ), ' </div> ');__stack.lineno=1; if (model < length - 1) { ; buf.push(' <div class="next-contestant telescope_icon_arrow_right"></div> ');__stack.lineno=1; } else { ; buf.push(' <div class="eliminated last-arrow-right telescope_icon_arrow_right"></div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' <div class="headline-modal"> ', (__stack.lineno=1,  text.title.use_nominee_title == "true" ? title : text.title.universal_title ), ' </div> <div class="contestant-container"> <div class="contestant-view"> <div class="firstname">', (__stack.lineno=1,  firstname ), '</div> <div class="lastname">', (__stack.lineno=1,  lastname ), '</div> <div class="details">', (__stack.lineno=1,  secondaryinfo ), '</div> ');__stack.lineno=1; if (design.show_third_detail === "true") { ; buf.push(' <div class="third-details">', (__stack.lineno=1,  thirdinfo ), '</div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (design.show_description_detail === "true") { ; buf.push(' <div class="description">', (__stack.lineno=1,  description ), '</div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if (text.external_url.display === "true" && eliminated === "0") { ; buf.push(' <a href="', (__stack.lineno=1,  externalURL ), '" target="_blank" class="moreVote">', (__stack.lineno=1,  text.external_url.copy ), '</a> <div class="button"> <div class="vote" data-id="', (__stack.lineno=1,  id ), '"> ', (__stack.lineno=1,  text.vote_button.active_nominee_copy ), ' </div> </div> ');__stack.lineno=1; } else if (eliminated === "1") { ; buf.push(' <div class="button"> <div class="eliminated" data-id="', (__stack.lineno=1,  id ), '">', (__stack.lineno=1,  text.vote_button.eliminated_nominee_copy ), '</div> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="button"> <div class="vote" data-id="', (__stack.lineno=1,  id ), '"> ', (__stack.lineno=1,  text.vote_button.active_nominee_copy ), ' </div> </div> ');__stack.lineno=1; } ; buf.push(' </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _window = __webpack_require__(81);

var _window2 = _interopRequireDefault(_window);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _window2.default;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var template = __webpack_require__(82);

module.exports = Backbone.View.extend({
    className: 'window',
    events: {
        'click .facebook': 'routeFacebook',
        'click .twitter': 'routeTwitter',
        'click .google': 'routeGoogle'
    },

    initialize: function(options) {
        _.bindAll(this, 'render');

        try {
            if (_.isUndefined(options.controller)) {
                throw Error(
                    'The controller is a dependency. Please inject the controller into the view.'
                );
            }
        } catch (e) {
            console.log(e);
        }

        this.controller = options.controller;
        this.share = options.share;

        console.log('Window view initialized', this.controller, this.model);
    },
    /**
     *
     */
    render: function() {
        var scope = {};
        var model = this.model;
        var cms = this.controller.Models.Cms.get('social');
        var twShare = this.share.tweet_copy;
        var googlePlus = cms.fb.share.link;

        console.log(twShare);
        //Build Twitter share link and info
        var twShareUrl = 'https://twitter.com/intent/tweet';
        twShareUrl +=
            '?text=' +
            encodeURIComponent(twShare) +
            ' ' +
            encodeURIComponent(location);

        scope.twShareUrl = twShareUrl;
        scope.google = googlePlus;
        scope.share = this.share;

        _.extend(scope, model);

        console.log('extended scope: ', scope);
        console.log('model: ', model);

        this.$el.html(template(scope));
        $('footer').addClass('posfix');
        $('.container-fluid').addClass('closed');

        return this;
    },
    /**
     *
     */
    routeFacebook: function(e) {
        e.preventDefault();
        var shareParams = this.buildFacebookShareURL();
        // console.log("Share", shareParams);

        this.controller.Models.Facebook.share(shareParams);
        this.controller.trackEvent(e, 'eventShareFacebook');
    },
    /**
     *
     */
    routeGoogle: function(e) {
        //e.preventDefault();
        this.controller.trackEvent(e, 'eventShareGooglePlus');
        console.log('route to google');
    },
    /**
     *
     */
    routeTwitter: function(e) {
        //e.preventDefault();
        this.controller.trackEvent(e, 'eventShareTwitter');
        console.log('route to twitter');
    },
    /**
     *
     */
    buildFacebookShareURL: function() {
        var data = this.controller.Models.Cms.get('social').fb.share;

        var params = {
            name: data.name,
            description: data.description,
            image: data.picture,
            caption: data.caption,
            link: data.link,
            href: data.link,
            appId: this.controller.Models.Facebook.get('appId'),
            display: data.display,
            redirect_uri: data.redirect_uri
        };

        var url = window.location.href.split('?')[0];
        url = url + 'share/?' + $.param(params);

        return url;
    }
});


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- headline_copy %></h3> <div class=\"copy\"><%- sub_headline_copy %></div> <% if(share.display_on_closed === 'true') { %> <div class=\"thanks-social\"> <h3 class=\"share-copy\"><%- share.share_copy %></h3> <% if(share.display_facebook === \"true\") { %> <div class=\"thanks\"> <a href=\"javascript:void(0)\"> <div class=\"facebook\"> <img src=\"https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678194.5674.png\"> <%- share.text %> </div> </a> </div> <% }; %> <% if(share.display_twitter === 'true') { %> <div class=\"thanks\"> <a href=\"<%- twShareUrl %>\" target=\"_blank\" data-url=\"<%- twShareUrl %>\"> <div class=\"twitter\"> <img src=\"https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1420659330.8224.png\"> <%- share.tweet %> </div> </a> </div> <% }; %> <% if(share.display_google === 'true') { %> <div class=\"thanks\"> <a href=\"https://plus.google.com/share?url={<%- google %>}\" onclick=\"window.open(this.href,\n  '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;\"> <div class=\"google\"> <img src=\"https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678218.7284.png\"> </div> </a> </div> <% }; %> </div> <% } %> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  headline_copy ), '</h3> <div class="copy">', (__stack.lineno=1,  sub_headline_copy ), '</div> ');__stack.lineno=1; if(share.display_on_closed === 'true') { ; buf.push(' <div class="thanks-social"> <h3 class="share-copy">', (__stack.lineno=1,  share.share_copy ), '</h3> ');__stack.lineno=1; if(share.display_facebook === "true") { ; buf.push(' <div class="thanks"> <a href="javascript:void(0)"> <div class="facebook"> <img src="https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678194.5674.png"> ', (__stack.lineno=1,  share.text ), ' </div> </a> </div> ');__stack.lineno=1; }; ; buf.push(' ');__stack.lineno=1; if(share.display_twitter === 'true') { ; buf.push(' <div class="thanks"> <a href="', (__stack.lineno=1,  twShareUrl ), '" target="_blank" data-url="', (__stack.lineno=1,  twShareUrl ), '"> <div class="twitter"> <img src="https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1420659330.8224.png"> ', (__stack.lineno=1,  share.tweet ), ' </div> </a> </div> ');__stack.lineno=1; }; ; buf.push(' ');__stack.lineno=1; if(share.display_google === 'true') { ; buf.push(' <div class="thanks"> <a href="https://plus.google.com/share?url={', (__stack.lineno=1,  google ), '}" onclick="window.open(this.href,\n  \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600\');return false;"> <div class="google"> <img src="https://ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678218.7284.png"> </div> </a> </div> ');__stack.lineno=2; }; ; buf.push(' </div> ');__stack.lineno=2; } ; buf.push(' '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var PubSub = __webpack_require__(3);

var ModalView = __webpack_require__(84);

module.exports = ModalView.extend({
    events: function events() {
        return _.extend({}, ModalView.prototype.events, {
            'click .optin-form a': 'handleLinkClick'
        });
    },

    handleLinkClick: function handleLinkClick(e) {
        var evt = {
            category: 'Link Click',
            action: 'Link Click: ' + e.target.innerText,
            label: 'Link Click: ' + e.target.innerText
        };

        PubSub.trigger('trackGoogle', evt);
    },

    initialize: function initialize() {
        $('.modal').click(this.onModalClick.bind(this));
    },
    close: function close() {
        PubSub.trigger('modal:close');
    },
    onModalClick: function onModalClick(e) {
        if (e.target.className == 'modal in') {
            PubSub.trigger('modal:close');
        }
    }
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var template = __webpack_require__(85);
var PubSub = __webpack_require__(3);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-modal',
    events: {
        'click .btn-close': 'close'
    },
    /**
     *
     */
    initialize: function(options) {
        this.router =
            typeof options.model.view.controller !== 'undefined'
                ? options.model.view.controller.Routers.Router
                : options.model.view.router;
        this.listenTo(PubSub, 'close-modal', this.close.bind(this));
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template());
        this.$el.append(
            _.isObject(this.model.view)
                ? this.model.view.render().$el
                : this.model.view
        );
        return this;
    },
    /**
     *
     */
    close: function() {
        this.router.closeCurrentModal();
    }
});


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<button class=\"btn-close telescope_icon_close\"></button> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<button class="btn-close telescope_icon_close"></button> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var template = __webpack_require__(87);
var GeoView = __webpack_require__(88);

module.exports = GeoView.extend({

    render: function render() {
        document.body.classList.add('geo');
        this.$el.html(template(this.model));
        return this;
    }

});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%= copy.headline_copy %></h3> <div class=\"copy\"><%= copy.description_copy %></div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', escape((__stack.lineno=1,  copy.headline_copy )), '</h3> <div class="copy">', escape((__stack.lineno=1,  copy.description_copy )), '</div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var $ = __webpack_require__(2);
var template = __webpack_require__(89);


module.exports = Backbone.View.extend({
    className: 'geo',

    /**
     *
     */
    render: function () {

        this.$el.html(template(this.model));
        $('footer').addClass('posfix');

        return this;
    }

});

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%= headline1 %></h3> <div class=\"text\"><%= paragraph1 %></div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', escape((__stack.lineno=1,  headline1 )), '</h3> <div class="text">', escape((__stack.lineno=1,  paragraph1 )), '</div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _loading = __webpack_require__(91);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _loading2.default;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var template = __webpack_require__(92);

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-loading',
    /**
   *
   */
    initialize: function () {
        _.bindAll(this, 'render');
    },
    /**
   *
   */
    render: function () {
        this.$el.html(template(this.model));
        return this;
    }

});



/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- headline_copy %></h3> <p><%- description_copy %></p> <div class=\"loading-gif\"> <img src=\"//ts-cms-production.votenow.tv/campaign/10/00/1000344/143932985055ca6e3aedbc91.09990490.gif\"> </div> <div> <p class=\"loading-label\"><%- sub_headline_copy %></p> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  headline_copy ), '</h3> <p>', (__stack.lineno=1,  description_copy ), '</p> <div class="loading-gif"> <img src="//ts-cms-production.votenow.tv/campaign/10/00/1000344/143932985055ca6e3aedbc91.09990490.gif"> </div> <div> <p class="loading-label">', (__stack.lineno=1,  sub_headline_copy ), '</p> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _faq = __webpack_require__(94);

var _faq2 = _interopRequireDefault(_faq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _faq2.default;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var template = __webpack_require__(95);

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-faq',
    /**
   *
   */
    initialize: function(options) {
        this.model = options.model;
        this.router = options.router;
    },
    /**
   *
   */
    render: function() {
        this.$el.html(template(this.model));
        return this;
    },
    /**
   *
   */
    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3 class=\"title\"><%- headline_copy %></h3> <div class=\"text\"><%- description_copy %></div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3 class="title">', (__stack.lineno=1,  headline_copy ), '</h3> <div class="text">', (__stack.lineno=1,  description_copy ), '</div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var PubSub = __webpack_require__(3);
var template = __webpack_require__(97);
var APP_CONST = __webpack_require__(5).app;

var AuthView = __webpack_require__(98);

module.exports = AuthView.extend({
    events: function events() {
        return _.extend({}, AuthView.prototype.events, {
            'keyup #email': 'handleEmail',
            'click .socialBox.email': 'triggerEmailContainer'
        });
    },

    triggerEmailContainer: function triggerEmailContainer() {
        $('.email-address').focus();
        $(document).delegate('.email-address', function (e) {
            if (e.target.id) {
                window.location.hash = e.target.id;
            }
        });
    },

    storeOptins: function storeOptins() {
        // they are prefixed with 'optin_'
        $.each(this.$el.find('form [type=checkbox]'), _.bind(function (i, el) {
            var evt = {
                target: this,
                name: 'eventClickOptin',
                origEvent: 'optin_' + $(el).attr('name')
            };
            this.trigger('trackEvent', evt);
            localStorage['optin_' + $(el).attr('name')] = $(el).prop('checked');
        }, this));
    },

    emailSignin: function emailSignin(e) {
        e.preventDefault();

        var validOptins = $.fn.h5Validate.call(this.$('.optin-form'), 'allValid');
        var validEmail = $.fn.h5Validate.call(this.$('#emailAuthForm'), 'allValid');

        if (!validOptins) {
            $('.terms-label').addClass('terms-invalid');
            return;
        }

        if (validEmail) {
            var email = this.$('#email').val();
            this.storeOptins();
            this.auth.signInSuccess('email', email);

            var evt = {
                category: 'Button Click',
                action: 'Button Click: Login Email',
                label: 'Button Click: Login Email'
            };

            PubSub.trigger('modal:close');
            PubSub.trigger('trackGoogle', evt);
        }
    },

    fbSignin: function fbSignin(e) {
        e.preventDefault();

        if ($(e.currentTarget).hasClass('eliminated')) return;

        if ($.fn.h5Validate.call(this.$('.optin-form'), 'allValid')) {
            this.facebook.isConnected(this.fbSignInResponse.bind(this));
            PubSub.trigger('route:loading', 'facebook');
        } else {
            $('.terms-label').addClass('terms-invalid');
        }
    },

    fbSignInResponse: function fbSignInResponse(response) {

        if (response) {
            this.storeOptins();
            this.router.closeCurrentModal();
            this.auth.signInSuccess('facebook');

            var evt = {
                category: 'Button Click',
                action: 'Button Click: Login Facebook',
                label: 'Button Click: Login Facebook'
            };

            PubSub.trigger('trackGoogle', evt);
        } else {
            PubSub.trigger('route:auth');
        }
    },

    render: function render() {

        this.createModel();

        var params = {
            emailMaxLength: APP_CONST.EMAIL_MAX_LENGTH,
            text: this.model.text,
            terms: this.cms.get('text').views_page_footer
        };

        this.$el.html(template(params));

        $.fn.h5Validate.call(this.$('.optin-form'));
        $.fn.h5Validate.call(this.$('#emailAuthForm'));

        _.each(this.$('.checkbox-parent'), function (el) {
            var $faux = $(el).find('.faux-box');
            var $checkbox = $(el).find('[type=\'checkbox\']');
            if ($checkbox.is(':checked')) {
                $faux.addClass('checked');
                $checkbox.prop('checked', true);
            }
        });

        return this;
    },

    activeSubmit: _.debounce(function (e) {
        var valid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e.target.value);
        this.$('#submitEmailAuth').attr('disabled', !valid);
        valid ? this.$('#submitEmailAuth').removeClass('eliminated') : this.$('#submitEmailAuth').addClass('eliminated');

        if (!valid) this.$('.email-address').addClass('email-invalid');else this.$('.email-address').removeClass('email-invalid');
    }, 50),

    toggleCheck: function toggleCheck(e) {
        if ($('#terms').prop('checked')) $(e.currentTarget).addClass('terms-invalid');else $(e.currentTarget).removeClass('terms-invalid');
    },

    handleEmail: function handleEmail() {
        var email = $('#email');
        var emailVal = email.val();
        var max = APP_CONST.EMAIL_MAX_LENGTH;

        if (emailVal.length > max) {
            emailVal = emailVal.slice(0, max);
            email.val(emailVal);
        }
    }
});

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- text.headline_copy %></h3> <div class=\"socialBoxes\"> <% if (_.checkIfTrue(text.facebook_login.enable)) { %> <div class=\"socialBox facebook\"> <span class=\"telescope_icon_facebook\"></span> <span><%- text.facebook_login.login_cta_copy %></span> </div> <% } %> <% if (_.checkIfTrue(text.email_login.enable)) { %> <div class=\"socialBox email\"> <span><%-  text.email_login.login_cta_copy %></span> </div> <% } %> </div> <form class=\"optin-form\" action=\"#\"> <% if(_.checkIfTrue(text.opt_ins.terms.display_opt_in) && text.opt_ins.terms.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %>> <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.terms.name %>\" name=\"<%- text.opt_ins.terms.name %>\" value=\"1\" <% if(_.checkIfTrue(text.opt_ins.terms.prechecked)) { %> checked=\"checked\" <% } %> <% if(_.checkIfTrue(text.opt_ins.terms.require_opt_in)){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.terms.name %>\" <% } %>> <% var checkbox_terms = text.opt_ins.terms.terms_copy.replace('{url}','<a href=\"'+text.opt_ins.terms.terms_url+'\" target=\"_blank\" rel=\"noopener noreferrer\">' + text.opt_ins.terms.link_copy + '</a>'); %> <label for=\"<%- text.opt_ins.terms.name %>\" class=\"terms-label label\"><span><%- checkbox_terms %><span></span></span></label> </div> <% } %> <% if(_.checkIfTrue(text.opt_ins.opt_in_1.display_opt_in) && text.opt_ins.opt_in_1.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %> > <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.opt_in_1.name %>\" name=\"<%- text.opt_ins.opt_in_1.name %>\" value=\"1\" <% if(_.checkIfTrue(text.opt_ins.opt_in_1.prechecked)) { %> checked=\"checked\" <% } %> <% if(_.checkIfTrue(text.opt_ins.opt_in_1.require_opt_in)){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.opt_in_1.name %>\" <% } %>> <label for=\"<%- text.opt_ins.opt_in_1.name %>\"><span><%- text.opt_ins.opt_in_1.opt_in_copy %></span></label> <% if(_.checkIfTrue(text.opt_ins.opt_in_1.require_opt_in)){ %> <span id=\"invalid-<%- text.opt_ins.opt_in_1.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.opt_in_1.error_message %></span> <% } %> </div> <% } %> <% if(_.checkIfTrue(text.opt_ins.opt_in_2.display_opt_in) && text.opt_ins.opt_in_2.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %> > <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.opt_in_2.name %>\" name=\"<%- text.opt_ins.opt_in_2.name %>\" value=\"1\" <% if(_.checkIfTrue(text.opt_ins.opt_in_2.prechecked)) { %> checked=\"checked\" <% } %> <% if(_.checkIfTrue(text.opt_ins.opt_in_2.require_opt_in)){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.opt_in_2.name %>\" <% } %>> <label for=\"<%- text.opt_ins.opt_in_2.name %>\" class=\"label\"><%- text.opt_ins.opt_in_2.opt_in_copy %></label> <% if(_.checkIfTrue(text.opt_ins.opt_in_2.require_opt_in)){ %> <span id=\"invalid-<%- text.opt_ins.opt_in_2.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.opt_in_2.error_message %></span> <% } %> </div> <% } %> <% if(_.checkIfTrue(text.opt_ins.opt_in_3.display_opt_in) && text.opt_ins.opt_in_3.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %>> <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.opt_in_3.name %>\" name=\"<%- text.opt_ins.opt_in_3.name %>\" value=\"1\" <% if(_.checkIfTrue(text.opt_ins.opt_in_3.prechecked)) { %> checked=\"checked\" <% } %> <% if(_.checkIfTrue(text.opt_ins.opt_in_3.require_opt_in)){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.opt_in_3.name %>\" <% } %>> <label for=\"<%- text.opt_ins.opt_in_3.name %>\" class=\"label\"><%- text.opt_ins.opt_in_3.opt_in_copy %></label> <% if(_.checkIfTrue(text.opt_ins.opt_in_3.require_opt_in)){ %> <span id=\"invalid-<%- text.opt_ins.opt_in_3.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.opt_in_3.error_message %></span> <% } %> </div> <% } %> </form> <% if (_.checkIfTrue(text.email_login.enable)) { %> <form id=\"emailAuthForm\" class=\"auth-form\" action=\"#\"> <div class=\"email-vote hidden\"> <input type=\"email\" placeholder=\"Enter your email\" maxlength=\"<%= emailMaxLength %>\" class=\"email-address\" pattern=\"^(([^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+(\\.[^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+)*)|(\\&quot;.+\\&quot;))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$\" required id=\"email\" name=\"email\" data-h5-errorid=\"invalid-email\" autocomplete=\"off\"> <input type=\"submit\" value=\"<%- text.email_login.button_copy %>\" class=\"email-submit eliminated\" id=\"submitEmailAuth\" disabled=\"disabled\"> </div> <% } %> </form> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  text.headline_copy ), '</h3> <div class="socialBoxes"> ');__stack.lineno=1; if (_.checkIfTrue(text.facebook_login.enable)) { ; buf.push(' <div class="socialBox facebook"> <span class="telescope_icon_facebook"></span> <span>', (__stack.lineno=1,  text.facebook_login.login_cta_copy ), '</span> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (_.checkIfTrue(text.email_login.enable)) { ; buf.push(' <div class="socialBox email"> <span>', (__stack.lineno=1,   text.email_login.login_cta_copy ), '</span> </div> ');__stack.lineno=1; } ; buf.push(' </div> <form class="optin-form" action="#"> ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.terms.display_opt_in) && text.opt_ins.terms.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push('> <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.terms.name ), '" name="', (__stack.lineno=1,  text.opt_ins.terms.name ), '" value="1" ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.terms.prechecked)) { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.terms.require_opt_in)){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.terms.name ), '" ');__stack.lineno=1; } ; buf.push('> ');__stack.lineno=1; var checkbox_terms = text.opt_ins.terms.terms_copy.replace('{url}','<a href="'+text.opt_ins.terms.terms_url+'" target="_blank" rel="noopener noreferrer">' + text.opt_ins.terms.link_copy + '</a>'); ; buf.push(' <label for="', (__stack.lineno=1,  text.opt_ins.terms.name ), '" class="terms-label label"><span>', (__stack.lineno=1,  checkbox_terms ), '<span></span></span></label> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_1.display_opt_in) && text.opt_ins.opt_in_1.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push(' > <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" name="', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" value="1" ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_1.prechecked)) { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_1.require_opt_in)){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" ');__stack.lineno=1; } ; buf.push('> <label for="', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '"><span>', (__stack.lineno=1,  text.opt_ins.opt_in_1.opt_in_copy ), '</span></label> ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_1.require_opt_in)){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.opt_in_1.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_2.display_opt_in) && text.opt_ins.opt_in_2.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push(' > <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" name="', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" value="1" ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_2.prechecked)) { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_2.require_opt_in)){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" ');__stack.lineno=1; } ; buf.push('> <label for="', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" class="label">', (__stack.lineno=1,  text.opt_ins.opt_in_2.opt_in_copy ), '</label> ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_2.require_opt_in)){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.opt_in_2.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_3.display_opt_in) && text.opt_ins.opt_in_3.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push('> <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" name="', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" value="1" ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_3.prechecked)) { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_3.require_opt_in)){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" ');__stack.lineno=1; } ; buf.push('> <label for="', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" class="label">', (__stack.lineno=1,  text.opt_ins.opt_in_3.opt_in_copy ), '</label> ');__stack.lineno=1; if(_.checkIfTrue(text.opt_ins.opt_in_3.require_opt_in)){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.opt_in_3.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' </form> ');__stack.lineno=1; if (_.checkIfTrue(text.email_login.enable)) { ; buf.push(' <form id="emailAuthForm" class="auth-form" action="#"> <div class="email-vote hidden"> <input type="email" placeholder="Enter your email" maxlength="', escape((__stack.lineno=1,  emailMaxLength )), '" class="email-address" pattern="^(([^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+(\\.[^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+)*)|(\\&quot;.+\\&quot;))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$" required id="email" name="email" data-h5-errorid="invalid-email" autocomplete="off"> <input type="submit" value="', (__stack.lineno=1,  text.email_login.button_copy ), '" class="email-submit eliminated" id="submitEmailAuth" disabled="disabled"> </div> ');__stack.lineno=1; } ; buf.push(' </form> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var jQuery = __webpack_require__(2);
var template = __webpack_require__(99);

// h5validate plugin
__webpack_require__( 100 );
var $ = jQuery;

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-auth',
    events: {
        'click .facebook': 'fbSignin',
        //, 'click .google' : 'googleSignin'
        'click .email': 'email',
        'click .terms': 'terms',
        'click .faux-box': 'toggleCheck',
        'click .label': 'toggleCheck',
        'click #submitEmailAuth': 'emailSignin',
        'change .email-address': 'activeSubmit',
        'keydown .email-address': 'activeSubmit'
    },
    /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render', 'activeSubmit');
        this.cms = options.cms;
        this.auth = options.auth;
        this.facebook = options.facebook;
        this.router = options.router;
    },
    /**
   *
   */
    fbSignin: function(e) {
        e.preventDefault();
        console.log('fbSignin', e);

        if( jQuery.fn.h5Validate.call( this.$( '.optin-form' ), 'allValid' ) ){
            this.facebook.isConnected(_.bind(this.fbSignInResponse, this));
            this.router.loading('facebook');
        }
    },
    /**
   *
   */
    fbSignInResponse: function(response) {
        console.log('fbSignInResponse', response);
        if (response) {
            this.storeOptins();
            this.router.closeCurrentModal();
            this.auth.signInSuccess('facebook');
            var evt = {
                target: this,
                name: 'eventLoginFacebook',
                origEvent: response
            };
            this.trigger('trackEvent',evt);
        } else {
            // re-render the auth view
            this.router.auth();
        }
    },
    /**
   *
   */
    emailSignin: function(e) {
        e.preventDefault();

        var validOptins = jQuery.fn.h5Validate.call( this.$('.optin-form'), 'allValid' );
        var validEmail = jQuery.fn.h5Validate.call( this.$('#emailAuthForm'), 'allValid' );

        if (validEmail && validOptins) {
            var email = this.$('#email').val();
            this.storeOptins();
            this.router.closeCurrentModal();
            this.auth.signInSuccess('email', email);
            var evt = {
                target: this,
                name: 'eventLoginEmail',
                origEvent: e
            };
            this.trigger('trackEvent',evt);
        }
    },
    /**
   *
   */
    googleSignin: function(e) {
        console.log('e:', e);
        e.preventDefault();
    //this.controller.Models.GoogleAuth.login();
    },
    /**
   *
   */
    email: function(e) {
        e.preventDefault();

        $('div.email-vote').toggleClass('hidden');
        $('div.facebook').toggleClass('eliminated');
        //$("div.google").toggleClass("eliminated");

        //Animate scrolling down modal to allow users to see email form
        $('div.modal').animate({
            scrollTop: $('#emailAuthForm').offset().top
        },
        'slow');
    },
    /**
   *
   */
    terms: function(e) {
        e.preventDefault();
        console.log('show terms and conditions');
    },
    /**
   *
   */
    render: function() {
        var that = this;
        this.createModel();
        that.$el.html(template({
            text: this.model.text,
            terms: this.cms.get('text').views_page_footer
        }));
        console.log('auth view[model]', this.model);

        // this.$('.optin-form').h5validate();
        // this.$('#emailAuthForm').h5validate();

        jQuery.fn.h5Validate.call( this.$( '.optin-form' ) );
        jQuery.fn.h5Validate.call( this.$( '#emailAuthForm' ) );

        _.each(this.$('.checkbox-parent'), _.bind(function(el) {
            var $faux = $(el).find('.faux-box');
            var $checkbox = $(el).find('[type=\'checkbox\']');
            if ($checkbox.is(':checked')) {
                $faux.addClass('checked');
                $checkbox.prop('checked', true);
            }
        }, this));

        return this;
    },
    toggleCheck: function(e) {
        e.preventDefault();
        var $parent = $(e.currentTarget).parent();
        var $checkmark = $parent.find('.check-mark');
        var $checkbox = $parent.find('[type=\'checkbox\']');

        if ($checkbox.is(':checked')) {
            $checkbox.prop('checked', false);
            $checkmark.css('display', 'none');
        } else {
            $checkbox.prop('checked', true);
            $checkmark.css('display', '');
        }
    },
    /**
   *
   */
    createModel: function() {
        this.model = {
            'text': this.cms.get('text')['views_login']
        };

        console.log(this.model);
        console.log('%c Model for login view', 'background-color: blue;');
    },
    /**
   *
   */
    activeSubmit: _.debounce(function(e) {
        var valid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( e.target.value );
        this.$('#submitEmailAuth').attr('disabled', !valid);
        valid ? this.$('#submitEmailAuth').removeClass('eliminated') : this.$('#submitEmailAuth').addClass('eliminated');
    },50),
    /**
   *
   */
    storeOptins: function() {
    // they are prefixed with '-optin'
        $.each(this.$el.find('form [type=checkbox]'), _.bind(function(i, el) {
            var evt = {
                target: this,
                name: 'eventClickOptin',
                origEvent: 'optin-' + $(el).attr('name')
            };
            this.trigger('trackEvent',evt);
            localStorage['optin-' + $(el).attr('name')] = ($(el).prop('checked') ? 'true' : 'false');
        }, this));

    },

    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- text.headline_copy %></h3> <div class=\"socialBoxes\"> <% if (text.facebook_login.enable === 'true') { %> <div class=\"socialBox facebook\"> <span class=\"telescope_icon_facebook\"></span> <span><%- text.facebook_login.login_cta_copy %></span> </div> <% } %> <% if (text.email_login.enable === 'true') { %> <div class=\"socialBox email\"> <span class=\"telescope_icon_email\"></span> <span><%-  text.email_login.login_cta_copy %></span> </div> <% } %> </div> <form class=\"optin-form\" action=\"#\"> <% if( text.opt_ins.terms.display_opt_in == \"true\" && text.opt_ins.terms.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %>> <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.terms.name %>\" name=\"<%- text.opt_ins.terms.name %>\" value=\"1\" <% if(text.opt_ins.terms.prechecked === \"true\") { %> checked=\"checked\" <% } %> <% if(text.opt_ins.terms.require_opt_in == \"true\"){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.terms.name %>\" <% } %>> <% var checkbox_terms = text.opt_ins.terms.terms_copy.replace('{url}','<a href=\"'+text.opt_ins.terms.terms_url+'\" style=\"text-decoration:none;\">' + text.opt_ins.terms.link_copy + '</a>'); %> <label for=\"<%- text.opt_ins.terms.name %>\"><%- checkbox_terms %></label> <% if(text.opt_ins.terms.require_opt_in == \"true\"){ %> <span id=\"invalid-<%- text.opt_ins.terms.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.terms.error_message %></span> <% } %> </div> <% } %> <% if( text.opt_ins.opt_in_1.display_opt_in == \"true\" && text.opt_ins.opt_in_1.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %> > <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.opt_in_1.name %>\" name=\"<%- text.opt_ins.opt_in_1.name %>\" value=\"1\" <% if(text.opt_ins.opt_in_1.prechecked === \"true\") { %> checked=\"checked\" <% } %> <% if(text.opt_ins.opt_in_1.require_opt_in == \"true\"){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.opt_in_1.name %>\" <% } %>> <label for=\"<%- text.opt_ins.opt_in_1.name %>\"><%- text.opt_ins.opt_in_1.opt_in_copy %></label> <% if(text.opt_ins.opt_in_1.require_opt_in == \"true\"){ %> <span id=\"invalid-<%- text.opt_ins.opt_in_1.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.opt_in_1.error_message %></span> <% } %> </div> <% } %> <% if( text.opt_ins.opt_in_2.display_opt_in == \"true\" && text.opt_ins.opt_in_2.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %> > <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.opt_in_2.name %>\" name=\"<%- text.opt_ins.opt_in_2.name %>\" value=\"1\" <% if(text.opt_ins.opt_in_2.prechecked === \"true\") { %> checked=\"checked\" <% } %> <% if(text.opt_ins.opt_in_2.require_opt_in == \"true\"){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.opt_in_2.name %>\" <% } %>> <label for=\"<%- text.opt_ins.opt_in_2.name %>\"><%- text.opt_ins.opt_in_2.opt_in_copy %></label> <% if(text.opt_ins.opt_in_2.require_opt_in == \"true\"){ %> <span id=\"invalid-<%- text.opt_ins.opt_in_2.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.opt_in_2.error_message %></span> <% } %> </div> <% } %> <% if( text.opt_ins.opt_in_3.display_opt_in == \"true\" && text.opt_ins.opt_in_3.name) { %> <div class=\"checkbox-parent\" <% if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ %> style=\"text-align:<%- text.opt_ins.alignment %>\" <% } %>> <input type=\"checkbox\" class=\"opt-in\" id=\"<%- text.opt_ins.opt_in_3.name %>\" name=\"<%- text.opt_ins.opt_in_3.name %>\" value=\"1\" <% if(text.opt_ins.opt_in_3.prechecked === \"true\") { %> checked=\"checked\" <% } %> <% if(text.opt_ins.opt_in_3.require_opt_in == \"true\"){ %> required data-h5-errorid=\"invalid-<%- text.opt_ins.opt_in_3.name %>\" <% } %>> <label for=\"<%- text.opt_ins.opt_in_3.name %>\"><%- text.opt_ins.opt_in_3.opt_in_copy %></label> <% if(text.opt_ins.opt_in_3.require_opt_in == \"true\"){ %> <span id=\"invalid-<%- text.opt_ins.opt_in_3.name %>\" style=\"display: none;\" class=\"ui-state-error message\"><%- text.opt_ins.opt_in_3.error_message %></span> <% } %> </div> <% } %> </form> <% if (text.email_login.enable === 'true') { %> <form id=\"emailAuthForm\" class=\"auth-form\" action=\"#\"> <div class=\"email-vote hidden\"> <h3>Enter email address to vote</h3> <div id=\"invalid-email\" style=\"display: none;\" class=\"ui-state-error message\">Please enter a valid email</div> <input type=\"email\" placeholder=\"Enter email\" class=\"email-address\" pattern=\"^(([^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+(\\.[^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+)*)|(\\&quot;.+\\&quot;))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$\" required id=\"email\" name=\"email\" data-h5-errorid=\"invalid-email\" autocomplete=\"off\"> <input type=\"submit\" value=\"<%- text.email_login.button_copy %>\" class=\"email-submit eliminated\" id=\"submitEmailAuth\" disabled=\"disabled\"> </div> <% } %> </form> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  text.headline_copy ), '</h3> <div class="socialBoxes"> ');__stack.lineno=1; if (text.facebook_login.enable === 'true') { ; buf.push(' <div class="socialBox facebook"> <span class="telescope_icon_facebook"></span> <span>', (__stack.lineno=1,  text.facebook_login.login_cta_copy ), '</span> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (text.email_login.enable === 'true') { ; buf.push(' <div class="socialBox email"> <span class="telescope_icon_email"></span> <span>', (__stack.lineno=1,   text.email_login.login_cta_copy ), '</span> </div> ');__stack.lineno=1; } ; buf.push(' </div> <form class="optin-form" action="#"> ');__stack.lineno=1; if( text.opt_ins.terms.display_opt_in == "true" && text.opt_ins.terms.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push('> <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.terms.name ), '" name="', (__stack.lineno=1,  text.opt_ins.terms.name ), '" value="1" ');__stack.lineno=1; if(text.opt_ins.terms.prechecked === "true") { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(text.opt_ins.terms.require_opt_in == "true"){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.terms.name ), '" ');__stack.lineno=1; } ; buf.push('> ');__stack.lineno=1; var checkbox_terms = text.opt_ins.terms.terms_copy.replace('{url}','<a href="'+text.opt_ins.terms.terms_url+'" style="text-decoration:none;">' + text.opt_ins.terms.link_copy + '</a>'); ; buf.push(' <label for="', (__stack.lineno=1,  text.opt_ins.terms.name ), '">', (__stack.lineno=1,  checkbox_terms ), '</label> ');__stack.lineno=1; if(text.opt_ins.terms.require_opt_in == "true"){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.terms.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.terms.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( text.opt_ins.opt_in_1.display_opt_in == "true" && text.opt_ins.opt_in_1.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push(' > <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" name="', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" value="1" ');__stack.lineno=1; if(text.opt_ins.opt_in_1.prechecked === "true") { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(text.opt_ins.opt_in_1.require_opt_in == "true"){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" ');__stack.lineno=1; } ; buf.push('> <label for="', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '">', (__stack.lineno=1,  text.opt_ins.opt_in_1.opt_in_copy ), '</label> ');__stack.lineno=1; if(text.opt_ins.opt_in_1.require_opt_in == "true"){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_1.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.opt_in_1.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( text.opt_ins.opt_in_2.display_opt_in == "true" && text.opt_ins.opt_in_2.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push(' > <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" name="', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" value="1" ');__stack.lineno=1; if(text.opt_ins.opt_in_2.prechecked === "true") { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(text.opt_ins.opt_in_2.require_opt_in == "true"){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" ');__stack.lineno=1; } ; buf.push('> <label for="', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '">', (__stack.lineno=1,  text.opt_ins.opt_in_2.opt_in_copy ), '</label> ');__stack.lineno=1; if(text.opt_ins.opt_in_2.require_opt_in == "true"){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_2.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.opt_in_2.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if( text.opt_ins.opt_in_3.display_opt_in == "true" && text.opt_ins.opt_in_3.name) { ; buf.push(' <div class="checkbox-parent" ');__stack.lineno=1; if(typeof text.opt_ins.alignment != 'undefined' && text.opt_ins.alignment.length > 0){ ; buf.push(' style="text-align:', (__stack.lineno=1,  text.opt_ins.alignment ), '" ');__stack.lineno=1; } ; buf.push('> <input type="checkbox" class="opt-in" id="', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" name="', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" value="1" ');__stack.lineno=1; if(text.opt_ins.opt_in_3.prechecked === "true") { ; buf.push(' checked="checked" ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(text.opt_ins.opt_in_3.require_opt_in == "true"){ ; buf.push(' required data-h5-errorid="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" ');__stack.lineno=1; } ; buf.push('> <label for="', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '">', (__stack.lineno=1,  text.opt_ins.opt_in_3.opt_in_copy ), '</label> ');__stack.lineno=1; if(text.opt_ins.opt_in_3.require_opt_in == "true"){ ; buf.push(' <span id="invalid-', (__stack.lineno=1,  text.opt_ins.opt_in_3.name ), '" style="display: none;" class="ui-state-error message">', (__stack.lineno=1,  text.opt_ins.opt_in_3.error_message ), '</span> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' </form> ');__stack.lineno=1; if (text.email_login.enable === 'true') { ; buf.push(' <form id="emailAuthForm" class="auth-form" action="#"> <div class="email-vote hidden"> <h3>Enter email address to vote</h3> <div id="invalid-email" style="display: none;" class="ui-state-error message">Please enter a valid email</div> <input type="email" placeholder="Enter email" class="email-address" pattern="^(([^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+(\\.[^&lt;&gt;()[\\]\\\\.,;:\\s@\\&quot;]+)*)|(\\&quot;.+\\&quot;))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$" required id="email" name="email" data-h5-errorid="invalid-email" autocomplete="off"> <input type="submit" value="', (__stack.lineno=1,  text.email_login.button_copy ), '" class="email-submit eliminated" id="submitEmailAuth" disabled="disabled"> </div> ');__stack.lineno=1; } ; buf.push(' </form> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

/**
 * h5Validate
 * 
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Developed under the sponsorship of RootMusic, and Zumba Fitness
 */

/*global jQuery, window, console */
(function ($) {
	'use strict';
	var console = window.console || function () {},
		h5 = { // Public API
			defaults : {
				debug: false,

				RODom: false,

				// HTML5-compatible validation pattern library that can be extended and/or overriden.
				patternLibrary : { //** TODO: Test the new regex patterns. Should I apply these to the new input types?
					// **TODO: password
					phone: /([\+][0-9]{1,3}([ \.\-])?)?([\(][0-9]{1,6}[\)])?([0-9A-Za-z \.\-]{1,32})(([A-Za-z \:]{1,11})?[0-9]{1,4}?)/,

					// Shamelessly lifted from Scott Gonzalez via the Bassistance Validation plugin http://projects.scottsplayground.com/email_address_validation/
					email: /((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?/,

					// Shamelessly lifted from Scott Gonzalez via the Bassistance Validation plugin http://projects.scottsplayground.com/iri/
					url: /(https?|ftp):\/\/(((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?/,

					// Number, including positive, negative, and floating decimal. Credit: bassistance
					number: /-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?/,

					// Date in ISO format. Credit: bassistance
					dateISO: /\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/,

					alpha: /[a-zA-Z]+/,
					alphaNumeric: /\w+/,
					integer: /-?\d+/
				},

				// The prefix to use for dynamically-created class names.
				classPrefix: 'h5-',

				errorClass: 'ui-state-error', // No prefix for these.
				validClass: 'ui-state-valid', // "
				activeClass: 'active', // Prefix will get prepended.
				requiredClass: 'required',
				requiredAttribute: 'required',
				patternAttribute: 'pattern',

				// Attribute which stores the ID of the error container element (without the hash).
				errorAttribute: 'data-h5-errorid',

				// Events API
				customEvents: {
					'validate': true
				},

				// Setup KB event delegation.
				kbSelectors: ':input:not(:button):not(:disabled):not(.novalidate)',
				focusout: true,
				focusin: false,
				change: true,
				keyup: false,
				activeKeyup: true,

				// Setup mouse event delegation.
				mSelectors: '[type="range"]:not(:disabled):not(.novalidate), :radio:not(:disabled):not(.novalidate), :checkbox:not(:disabled):not(.novalidate), select:not(:disabled):not(.novalidate), option:not(:disabled):not(.novalidate)',
				click: true,

				// What do we name the required .data variable?
				requiredVar: 'h5-required',

				// What do we name the pattern .data variable?
				patternVar: 'h5-pattern',
				stripMarkup: true,

				// Run submit related checks and prevent form submission if any fields are invalid?
				submit: true,

				// Move focus to the first invalid field on submit?
				focusFirstInvalidElementOnSubmit: true,

				// When submitting, validate elements that haven't been validated yet?
				validateOnSubmit: true,

				// Callback stubs
				invalidCallback: function () {},
				validCallback: function () {},

				// Elements to validate with allValid (only validating visible elements)
				allValidSelectors: ':input:visible:not(:button):not(:disabled):not(.novalidate)',

				// Mark field invalid.
				// ** TODO: Highlight labels
				// ** TODO: Implement setCustomValidity as per the spec:
				// http://www.whatwg.org/specs/web-apps/current-work/multipage/association-of-controls-and-forms.html#dom-cva-setcustomvalidity
				markInvalid: function markInvalid(options) {
					var $element = $(options.element),
						$errorID = $(options.errorID);
					$element.addClass(options.errorClass).removeClass(options.validClass);

					// User needs help. Enable active validation.
					$element.addClass(options.settings.activeClass);

					if ($errorID.length) { // These ifs are technically not needed, but improve server-side performance 
						if ($element.attr('title')) {
							$errorID.text($element.attr('title'));
						}
						$errorID.show();
					}
					$element.data('valid', false);
					options.settings.invalidCallback.call(options.element, options.validity);
					return $element;
				},

				// Mark field valid.
				markValid: function markValid(options) {
					var $element = $(options.element),
						$errorID = $(options.errorID);

					$element.addClass(options.validClass).removeClass(options.errorClass);
					if ($errorID.length) {
						$errorID.hide();
					}
					$element.data('valid', true);
					options.settings.validCallback.call(options.element, options.validity);
					return $element;
				},

				// Unmark field
				unmark: function unmark(options) {
					var $element = $(options.element);
					$element.removeClass(options.errorClass).removeClass(options.validClass);
					$element.form.find("#" + options.element.id).removeClass(options.errorClass).removeClass(options.validClass);
					return $element;
				}
			}
		},

		// Aliases
		defaults = h5.defaults,
		patternLibrary = defaults.patternLibrary,

		createValidity = function createValidity(validity) {
			return $.extend({
				customError: validity.customError || false,
				patternMismatch: validity.patternMismatch || false,
				rangeOverflow: validity.rangeOverflow || false,
				rangeUnderflow: validity.rangeUnderflow || false,
				stepMismatch: validity.stepMismatch || false,
				tooLong: validity.tooLong || false,
				typeMismatch: validity.typeMismatch || false,
				valid: validity.valid || true,
				valueMissing: validity.valueMissing || false
			}, validity);
		},

		methods = {
			/**
			 * Check the validity of the current field
			 * @param  {object}  settings   instance settings
			 * @param  {object}  options
			 *			.revalidate - trigger validation function first?
			 * @return {Boolean}
			 */
			isValid: function (settings, options) {
				var $this = $(this);

				options = (settings && options) || {};

				// Revalidate defaults to true
				if (options.revalidate !== false) {
					$this.trigger('validate');
				}

				return $this.data('valid'); // get the validation result
			},
			allValid: function (config, options) {
				var valid = true,
					formValidity = [],
					$this = $(this),
					$allFields,
					$filteredFields,
					radioNames = [],
					getValidity = function getValidity(e, data) {
						data.e = e;
						formValidity.push(data);
					},
					settings = $.extend({}, config, options); // allow options to override settings

				options = options || {};

				$this.trigger('formValidate', {settings: $.extend(true, {}, settings)});

				// Make sure we're not triggering handlers more than we need to.
				$this.undelegate(settings.allValidSelectors,
					'.allValid', getValidity);
				$this.delegate(settings.allValidSelectors,
					'validated.allValid', getValidity);

				$allFields = $this.find(settings.allValidSelectors);

				// Filter radio buttons with the same name and keep only one,
				// since they will be checked as a group by isValid()
				$filteredFields = $allFields.filter(function(index) {
					var name;

					if(this.tagName === "INPUT"
						&& this.type === "radio") {
						name = this.name;
						if(radioNames[name] === true) {
							return false;
						}
						radioNames[name] = true;
					}
					return true;
				});

				$filteredFields.each(function () {
					var $this = $(this);
					valid = $this.h5Validate('isValid', options) && valid;
				});

				$this.trigger('formValidated', {valid: valid, elements: formValidity});
				return valid;
			},
			validate: function (settings) {
				// Get the HTML5 pattern attribute if it exists.
				// ** TODO: If a pattern class exists, grab the pattern from the patternLibrary, but the pattern attrib should override that value.
				var $this = $(this),
					pattern = $this.filter('[pattern]')[0] ? $this.attr('pattern') : false,

					// The pattern attribute must match the whole value, not just a subset:
					// "...as if it implied a ^(?: at the start of the pattern and a )$ at the end."
					re = new RegExp('^(?:' + pattern + ')$'),
					$radiosWithSameName = null,
					value = ($this.is('[type=checkbox]')) ?
							$this.is(':checked') : ($this.is('[type=radio]') ?
								// Cache all radio buttons (in the same form) with the same name as this one
								($radiosWithSameName = $this.parents('form')
									// **TODO: escape the radio buttons' name before using it in the jQuery selector
									.find('input[name="' + $this.attr('name') + '"]'))
									.filter(':checked')
									.length > 0 : $this.val()),
					errorClass = settings.errorClass,
					validClass = settings.validClass,
					errorIDbare = $this.attr(settings.errorAttribute) || false, // Get the ID of the error element.
					errorID = errorIDbare ? '#' + errorIDbare.replace(/(:|\.|\[|\])/g,'\\$1') : false, // Add the hash for convenience. This is done in two steps to avoid two attribute lookups.
					required = false,
					validity = createValidity({element: this, valid: true}),
					$checkRequired = $('<input required>'),
					maxlength;

				/*	If the required attribute exists, set it required to true, unless it's set 'false'.
				*	This is a minor deviation from the spec, but it seems some browsers have falsey 
				*	required values if the attribute is empty (should be true). The more conformant 
				*	version of this failed sanity checking in the browser environment.
				*	This plugin is meant to be practical, not ideologically married to the spec.
				*/
				// Feature fork
				if ($checkRequired.filter('[required]') && $checkRequired.filter('[required]').length) {
					required = ($this.filter('[required]').length && $this.attr('required') !== 'false');
				} else {
					required = ($this.attr('required') !== undefined);
				}

				if (settings.debug && window.console) {
					console.log('Validate called on "' + value + '" with regex "' + re + '". Required: ' + required); // **DEBUG
					console.log('Regex test: ' + re.test(value) + ', Pattern: ' + pattern); // **DEBUG
				}

				maxlength = parseInt($this.attr('maxlength'), 10);
				if (!isNaN(maxlength) && value.length > maxlength) {
						validity.valid = false;	
						validity.tooLong = true;
				}

				if (required && !value) {
					validity.valid = false;
					validity.valueMissing = true;
				} else if (pattern && !re.test(value) && value) {
					validity.valid = false;
					validity.patternMismatch = true;
				} else {
					if (!settings.RODom) {
						settings.markValid({
							element: this,
							validity: validity,
							errorClass: errorClass,
							validClass: validClass,
							errorID: errorID,
							settings: settings
						});
					}
				}

				if (!validity.valid) {
					if (!settings.RODom) {
						settings.markInvalid({
							element: this,
							validity: validity,
							errorClass: errorClass,
							validClass: validClass,
							errorID: errorID,
							settings: settings
						});
					}
				}
				$this.trigger('validated', validity);

				// If it's a radio button, also validate the other radio buttons with the same name
				// (while making sure the call is not recursive)
				if($radiosWithSameName !== null
					&& settings.alreadyCheckingRelatedRadioButtons !== true) {

					settings.alreadyCheckingRelatedRadioButtons = true;

					$radiosWithSameName
						.not($this)
						.trigger('validate');

					settings.alreadyCheckingRelatedRadioButtons = false;

				}
			},

			/**
			 * Take the event preferences and delegate the events to selected
			 * objects.
			 * 
			 * @param {object} eventFlags The object containing event flags.
			 * 
			 * @returns {element} The passed element (for method chaining).
			 */
			delegateEvents: function (selectors, eventFlags, element, settings) {
				var events = {},
					key = 0,
					validate = function () {
						settings.validate.call(this, settings);
					};
				$.each(eventFlags, function (key, value) {
					if (value) {
						events[key] = key;
					}
				});
				// key = 0;
				for (key in events) {
					if (events.hasOwnProperty(key)) {
						$(element).delegate(selectors, events[key] + '.h5Validate', validate);
					}
				}
				return element;
			},
			/**
			 * Prepare for event delegation.
			 * 
			 * @param {object} settings The full plugin state, including
			 * options. 
			 * 
			 * @returns {object} jQuery object for chaining.
			 */
			bindDelegation: function (settings) {
				var $this = $(this),
					$forms;
				// Attach patterns from the library to elements.
				// **TODO: pattern / validation method matching should
				// take place inside the validate action.
				$.each(patternLibrary, function (key, value) {
					var pattern = value.toString();
					pattern = pattern.substring(1, pattern.length - 1);
					$('.' + settings.classPrefix + key).attr('pattern', pattern);
				});

				$forms = $this.filter('form')
						.add($this.find('form'))
						.add($this.parents('form'));

				$forms
					.attr('novalidate', 'novalidate')
					.submit(checkValidityOnSubmitHandler);
					
				$forms.find("input[formnovalidate][type='submit']").click(function(){
					$(this).closest("form").unbind('submit', checkValidityOnSubmitHandler);
				});

				return this.each(function () {
					var kbEvents = {
							focusout: settings.focusout,
							focusin: settings.focusin,
							change: settings.change,
							keyup: settings.keyup
						},
						mEvents = {
							click: settings.click
						},
						activeEvents = {
							keyup: settings.activeKeyup
						};

					settings.delegateEvents(':input', settings.customEvents, this, settings);
					settings.delegateEvents(settings.kbSelectors, kbEvents, this, settings);
					settings.delegateEvents(settings.mSelectors, mEvents, this, settings);
					settings.delegateEvents(settings.activeClassSelector, activeEvents, this, settings);
					settings.delegateEvents('textarea[maxlength]', {keyup: true}, this, settings);
				});
			}
		},

		/**
		 * Event handler for the form submit event.
		 * When settings.submit is enabled:
		 *  - prevents submission if any invalid fields are found.
		 *  - Optionally validates all fields.
		 *  - Optionally moves focus to the first invalid field.
		 * 
		 * @param {object} evt The jQuery Event object as from the submit event. 
		 * 
		 * @returns {object} undefined if no validation was done, true if validation passed, false if validation didn't.
		 */
		checkValidityOnSubmitHandler = function(evt) {

			var $this,
				settings = getInstance.call(this),
				allValid;

			if(settings.submit !== true) {
				return;
			}

			$this = $(this);
			allValid = $this.h5Validate('allValid', { revalidate: settings.validateOnSubmit === true });

			if(allValid !== true) {
				evt.preventDefault();

				if(settings.focusFirstInvalidElementOnSubmit === true){
					var $invalid = $(settings.allValidSelectors, $this)
									.filter(function(index){
										return $(this).h5Validate('isValid', { revalidate: false }) !== true;
									});

					$invalid.first().focus();
				}
			}

			return allValid;
		},

		instances = [],

		buildSettings = function buildSettings(options) {
			// Combine defaults and options to get current settings.
			var settings = $.extend({}, defaults, options, methods),
				activeClass = settings.classPrefix + settings.activeClass;

			return $.extend(settings, {
				activeClass: activeClass,
				activeClassSelector: '.' + activeClass,
				requiredClass: settings.classPrefix + settings.requiredClass,
				el: this
			});
		},

		getInstance = function getInstance() {
			var $parent = $(this).closest('[data-h5-instanceId]');
			return instances[$parent.attr('data-h5-instanceId')];
		},

		setInstance = function setInstance(settings) {
			var instanceId = instances.push(settings) - 1;
			if (settings.RODom !== true) {
				$(this).attr('data-h5-instanceId', instanceId);
			}
			$(this).trigger('instance', { 'data-h5-instanceId': instanceId });
		};

	$.h5Validate = {
		/**
		 * Take a map of pattern names and HTML5-compatible regular
		 * expressions, and add them to the patternLibrary. Patterns in
		 * the library are automatically assigned to HTML element pattern
		 * attributes for validation.
		 * 
		 * @param {Object} patterns A map of pattern names and HTML5 compatible
		 * regular expressions.
		 * 
		 * @returns {Object} patternLibrary The modified pattern library
		 */
		addPatterns: function (patterns) {
			var patternLibrary = defaults.patternLibrary,
				key;
			for (key in patterns) {
				if (patterns.hasOwnProperty(key)) {
					patternLibrary[key] = patterns[key];
				}
			}
			return patternLibrary;
		},
		/**
		 * Take a valid jQuery selector, and a list of valid values to
		 * validate against.
		 * If the user input isn't in the list, validation fails.
		 * 
		 * @param {String} selector Any valid jQuery selector.
		 *
		 * @param {Array} values A list of valid values to validate selected 
		 * fields against.
		 */
		validValues: function (selector, values) {
			var i = 0,
				ln = values.length,
				pattern = '',
				re;
			// Build regex pattern
			for (i = 0; i < ln; i += 1) {
				pattern = pattern ? pattern + '|' + values[i] : values[i];
			}
			re = new RegExp('^(?:' + pattern + ')$');
			$(selector).data('regex', re);
		}
	};

	$.fn.h5Validate = function h5Validate(options) {
		var	action,
			args,
			settings;

		if (typeof options === 'string' && typeof methods[options] === 'function') {
			// Whoah, hold on there! First we need to get the instance:
			settings = getInstance.call(this);

			args = [].slice.call(arguments, 0);
			action = options;
			args.shift();
			args = $.merge([settings], args);

			// Use settings here so we can plug methods into the instance dynamically?
			return settings[action].apply(this, args);
		}

		settings = buildSettings.call(this, options);
		setInstance.call(this, settings);

		// Returning the jQuery object allows for method chaining.
		return methods.bindDelegation.call(this, settings);
	};
}(jQuery));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var PubSub = __webpack_require__(3);
var template = __webpack_require__(102);

var ThanksView = __webpack_require__(103);

module.exports = ThanksView.extend({

    render: function render() {
        var scope = {};
        var model = this.voteOption;

        var text = this.controller.Models.Cms.get('text')['views_vote_confirmation'];
        var design = this.controller.Models.Cms.get('text')['design'];
        var twShare = this.controller.Models.Cms.get('text')['views_share'].twitter_copy;
        var shareSettings = this.controller.Models.Cms.get('text')['views_share'];

        //Parse through twitter share for first name and last name
        var firstName = model.firstname;
        var lastName = model.lastname;
        twShare = twShare.replace('{firstname}', firstName);
        twShare = twShare.replace('{lastname}', lastName);

        var contestant = lastName != '' ? firstName + ' ' + lastName : firstName;
        var twVoteText = text.twitter_vote.tweet_copy.replace('{contestant}', contestant);

        //Build Twitter share link and info
        var twShareUrl = encodeURIComponent(twShare);
        var twVoteTextUrl = encodeURIComponent(twVoteText);

        scope.twShareUrl = twShareUrl;
        scope.twitterVoteText = twVoteTextUrl;

        var voteLimit = parseInt(this.controller.Models.Cms.get('settings').vote_limit, 10);
        var votesLeft = voteLimit - this.controller.Models.Auth.getSubmittedVotes();

        //Add CMS data to the scope object
        scope.text = text;
        scope.design = design;
        scope.shareSettings = shareSettings;
        scope.votesLeft = votesLeft;

        _.extend(scope, model);

        console.log('extended scope: ', scope);

        this.$el.html(template(scope));

        return this;
    },

    buildFacebookShareURL: function buildFacebookShareURL() {
        var data = this.controller.Models.Cms.get('social').fb.share;

        return 'https://www.facebook.com/dialog/share?' + 'app_id=' + this.controller.Models.Facebook.get('appId') + '&display=popup' + '&href=' + data.link + '&quote=' + data.description + '&redirect_uri=' + data.redirect_uri;
    },

    routeFacebook: function routeFacebook(e) {
        e.preventDefault();

        var shareURL = this.buildFacebookShareURL();
        var width = 520;
        var height = 360;
        var leftPosition = window.screen.width / 2 - width / 2;
        var topPosition = window.screen.height / 2 - height / 2;
        window.open(shareURL, 'sharer', 'top=' + topPosition + ',left=' + leftPosition + ',toolbar=0,status=0,width=' + width + ',height=' + height);

        var evt = {
            category: 'Button Click',
            action: 'Button Click: Share Facebook',
            label: 'Button Click: Share Facebook'
        };

        PubSub.trigger('trackGoogle', evt);
    },

    routeTwitter: function routeTwitter() {
        var evt = {
            category: 'Button Click',
            action: 'Button Click: Share Twitter',
            label: 'Button Click: Share Twitter'
        };

        PubSub.trigger('trackGoogle', evt);
    },

    close: function close() {
        PubSub.trigger('modal:close');
    }
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"thanks-container\"> <% if (design.vote_modal.show_video === \"true\" || design.vote_modal.show_image === \"true\") { %> <div class=\"gallery\"> <% if (design.vote_modal.show_video === \"false\" && design.vote_modal.show_image === \"true\") { %> <div class=\"image\"> <img src=\"<%- image %>\"> </div> <% } else if (design.vote_modal.show_video === \"true\" && design.vote_modal.show_image === \"false\") { %> <div class=\"video\"> <%- video %> </div> <% } %> </div> <% } %> <h3><%- text.thank_you_copy.headline %></h3> <div class=\"thanks-wrapper\"> <% if ( design.vote_modal.show_votes_left === \"true\" && votesLeft ) { %> <p class=\"votes-remaining\"> You have <span><%= votesLeft %></span> votes remaining </p> <% } %> <% if (_.checkIfTrue(shareSettings.display_on_confirmation)) { %> <p class=\"share-copy\"><%- text.twitter_vote.cta_copy %></p> <div class=\"thanks-social\"> <% if (_.checkIfTrue(shareSettings.display_facebook)) { %> <div class=\"thanks\"> <a href=\"javascript:void(0)\"> <div class=\"facebook\"> <svg id=\"facebook-svg\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 117.67 226.55\"> <title>Facebook</title> <path id=\"f\" class=\"cls-1\" d=\"M184.15,266.9V163.54h34.7L224,123.26H184.15V97.55c0-11.66,3.24-19.61,20-19.61h21.3v-36a285.42,285.42,0,0,0-31.08-1.59c-30.75,0-51.81,18.77-51.81,53.24V123.3H107.78v40.28h34.78V266.9h41.59Z\" transform=\"translate(-107.78 -40.35)\"/> </svg> </div> </a> </div> <% } if (_.checkIfTrue(shareSettings.display_twitter)) { %> <div class=\"thanks\"> <a href=\"https://twitter.com/intent/tweet/?text=<%- twShareUrl %>\"> <div class=\"twitter\"> <svg id=\"twitter-svg\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 273.39 222.18\"> <title>Twitter</title> <path class=\"cls-1\" d=\"M340.73,115.23a112.12,112.12,0,0,1-32.21,8.83,56.25,56.25,0,0,0,24.66-31,112.3,112.3,0,0,1-35.62,13.61A56.14,56.14,0,0,0,202,157.8,159.24,159.24,0,0,1,86.37,99.2a56.15,56.15,0,0,0,17.36,74.88,55.86,55.86,0,0,1-25.41-7c0,0.23,0,.47,0,0.71a56.12,56.12,0,0,0,45,55,56.23,56.23,0,0,1-25.33,1,56.15,56.15,0,0,0,52.4,39,112.54,112.54,0,0,1-69.66,24,114.17,114.17,0,0,1-13.38-.78,158.76,158.76,0,0,0,86,25.2c103.17,0,159.58-85.47,159.58-159.59q0-3.65-.16-7.26A114,114,0,0,0,340.73,115.23Z\" transform=\"translate(-67.34 -88.93)\"/> </svg> </div> </a> </div> <% } %> </div> <% } %> <% if(!votesLeft) { %> <p class=\"sub-headline\"><%- text.thank_you_copy.sub_headline %></p> <% } %> </div> <% if(_.checkIfTrue(text.vote_again.enable) && votesLeft) { %> <div class=\"button vote-again-button-div <%- (_.checkIfTrue(text.twitter_vote.enable) && _.checkIfTrue(text.vote_again.enable)) ? 'both-btns':'' %>\"> <div class=\"vote btn-vote-again\"> <%- text.vote_again.button_copy %> </div> </div> <% } %> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="thanks-container"> ');__stack.lineno=1; if (design.vote_modal.show_video === "true" || design.vote_modal.show_image === "true") { ; buf.push(' <div class="gallery"> ');__stack.lineno=1; if (design.vote_modal.show_video === "false" && design.vote_modal.show_image === "true") { ; buf.push(' <div class="image"> <img src="', (__stack.lineno=1,  image ), '"> </div> ');__stack.lineno=1; } else if (design.vote_modal.show_video === "true" && design.vote_modal.show_image === "false") { ; buf.push(' <div class="video"> ', (__stack.lineno=1,  video ), ' </div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' <h3>', (__stack.lineno=1,  text.thank_you_copy.headline ), '</h3> <div class="thanks-wrapper"> ');__stack.lineno=1; if ( design.vote_modal.show_votes_left === "true" && votesLeft ) { ; buf.push(' <p class="votes-remaining"> You have <span>', escape((__stack.lineno=1,  votesLeft )), '</span> votes remaining </p> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (_.checkIfTrue(shareSettings.display_on_confirmation)) { ; buf.push(' <p class="share-copy">', (__stack.lineno=1,  text.twitter_vote.cta_copy ), '</p> <div class="thanks-social"> ');__stack.lineno=1; if (_.checkIfTrue(shareSettings.display_facebook)) { ; buf.push(' <div class="thanks"> <a href="javascript:void(0)"> <div class="facebook"> <svg id="facebook-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.67 226.55"> <title>Facebook</title> <path id="f" class="cls-1" d="M184.15,266.9V163.54h34.7L224,123.26H184.15V97.55c0-11.66,3.24-19.61,20-19.61h21.3v-36a285.42,285.42,0,0,0-31.08-1.59c-30.75,0-51.81,18.77-51.81,53.24V123.3H107.78v40.28h34.78V266.9h41.59Z" transform="translate(-107.78 -40.35)"/> </svg> </div> </a> </div> ');__stack.lineno=1; } if (_.checkIfTrue(shareSettings.display_twitter)) { ; buf.push(' <div class="thanks"> <a href="https://twitter.com/intent/tweet/?text=', (__stack.lineno=1,  twShareUrl ), '"> <div class="twitter"> <svg id="twitter-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 273.39 222.18"> <title>Twitter</title> <path class="cls-1" d="M340.73,115.23a112.12,112.12,0,0,1-32.21,8.83,56.25,56.25,0,0,0,24.66-31,112.3,112.3,0,0,1-35.62,13.61A56.14,56.14,0,0,0,202,157.8,159.24,159.24,0,0,1,86.37,99.2a56.15,56.15,0,0,0,17.36,74.88,55.86,55.86,0,0,1-25.41-7c0,0.23,0,.47,0,0.71a56.12,56.12,0,0,0,45,55,56.23,56.23,0,0,1-25.33,1,56.15,56.15,0,0,0,52.4,39,112.54,112.54,0,0,1-69.66,24,114.17,114.17,0,0,1-13.38-.78,158.76,158.76,0,0,0,86,25.2c103.17,0,159.58-85.47,159.58-159.59q0-3.65-.16-7.26A114,114,0,0,0,340.73,115.23Z" transform="translate(-67.34 -88.93)"/> </svg> </div> </a> </div> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(!votesLeft) { ; buf.push(' <p class="sub-headline">', (__stack.lineno=1,  text.thank_you_copy.sub_headline ), '</p> ');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if(_.checkIfTrue(text.vote_again.enable) && votesLeft) { ; buf.push(' <div class="button vote-again-button-div ', (__stack.lineno=1,  (_.checkIfTrue(text.twitter_vote.enable) && _.checkIfTrue(text.vote_again.enable)) ? 'both-btns':'' ), '"> <div class="vote btn-vote-again"> ', (__stack.lineno=1,  text.vote_again.button_copy ), ' </div> </div> ');__stack.lineno=1; } ; buf.push(' </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var template = __webpack_require__(104);
var PubSub = __webpack_require__(3);

module.exports = Backbone.View.extend({
    tagName: 'div'
    , className: 'view-thanks'
    , events: {
        'click .facebook': 'routeFacebook',
        'click .twitter': 'routeTwitter',
        'click .google': 'routeGoogle',
        'click .btn-vote-again': 'close'
    }
    /**
   *
   */
    , initialize: function (options) {
        _.bindAll(this, 'render');

        try {
            if(_.isUndefined(options.controller)){
                throw Error('The controller is a dependency. Please inject the controller into the view.');
            }
        } catch (e) {
            console.log(e);
        }

        this.controller = options.controller;
        this.voteOption = this.controller.Collections.VoteOption.getSelected().toJSON();
        this.selectedModel = this.controller.Collections.VoteOption.getSelected();
    }
    /**
   *
   */
    , render: function () {
        var scope = {};
        var model = this.voteOption;

        var text = this.controller.Models.Cms.get('text')['views_vote_confirmation'];
        var design = this.controller.Models.Cms.get('text')['design'];
        var cms = this.controller.Models.Cms.get('social');
        var twShare = this.controller.Models.Cms.get('text')['views_share'].twitter_copy;
        var googlePlus = cms.fb.share.link;
        var shareSettings = this.controller.Models.Cms.get('text')['views_share'];

        //Parse through twitter share for first name and last name
        var firstName = model.firstname;
        var lastName = model.lastname;
        twShare = twShare.replace('{firstname}', firstName);
        twShare = twShare.replace('{lastname}',lastName);

        var contestant = lastName != '' ? firstName+' '+lastName : firstName;
        var twVoteText = text.twitter_vote.tweet_copy.replace('{contestant}',contestant);

        //Build Twitter share link and info
        var twShareUrl = encodeURIComponent(twShare);
        var twVoteTextUrl = encodeURIComponent(twVoteText);

        scope.twShareUrl = twShareUrl;
        scope.twitterVoteText = twVoteTextUrl;

        //Add CMS data to the scope object
        scope.google = googlePlus;
        scope.text = text;
        scope.design = design;
        scope.shareSettings = shareSettings;

        _.extend(scope, model);

        console.log('extended scope: ', scope);

        this.$el.html(template(scope));

        return this;
    }
    /**
   *
   */
    , routeGoogle: function (e) {
        e.preventDefault();
        this.controller.trackEvent(e, 'eventShareGooglePlus');
    }
    /**
   *
   */
    , routeFacebook: function (e) {
        e.preventDefault();

        var shareURL = this.buildFacebookShareURL();

        this.controller.Models.Facebook.share(shareURL);
        this.controller.trackEvent(e, 'eventShareFacebook');
    }
    /**
   *
   */
    , buildFacebookShareURL: function() {
        var data = this.controller.Models.Cms.get('social').fb.share;

        var fullName = this.voteOption.firstname + ' ' + this.voteOption.lastname;

        data.description = data.description.replace('<<CONTESTANT>>', fullName);

        var params = {
            name: data.name
            ,description: data.description
            ,image: this.voteOption.image
            ,caption: data.caption
            ,link: data.link
            ,href: data.link
            ,appId: this.controller.Models.Facebook.get('appId')
            ,display: 'popup'
            ,redirect_uri: data.redirect_uri
        };

        var url = window.location.href.split('?')[0];
        url = url+'share/?'+$.param(params);

        return url;
    },
    /**
   *
   */
    routeTwitter: function (e) {
        this.controller.trackEvent(e, 'eventShareTwitter');
    },

    voteAgain: function(e){

        e.preventDefault();
        this.trigger('voteagain',this.selectedModel);
    },
    /**
   *
   */
    close: function() {
        PubSub.trigger('close-modal');
    }
});



/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"gallery\"> <div class=\"image\"> <img src=\"<%- image %>\"> </div> </div> <div class=\"thanks-container\"> <h3><%- text.thank_you_copy.headline %></h3> <div class=\"thanks-view\"> <%- text.thank_you_copy.sub_headline %> </div> <% if(text.twitter_vote.enable === 'true') { %> <div class=\"twitter-vote\"> <h4><%- text.secondary_copy.headline %></h4> <p><%- text.secondary_copy.sub_headline %></p> </div> <div class=\"button twitter-button-div <%- (text.twitter_vote.enable === \"true\" && text.vote_again.enable === \"true\") ? 'both-btns':'' %>\"> <a href=\"https://twitter.com/intent/tweet/?text=<%- twitterVoteText %>\"> <div class=\"vote btn-twitter-vote\"><%- text.twitter_vote.button_copy %></div> </a> </div> <% } %> <% if(text.vote_again.enable === 'true') { %> <div class=\"button vote-again-button-div <%- (text.twitter_vote.enable === \"true\" && text.vote_again.enable === \"true\") ? 'both-btns':'' %>\"> <div class=\"vote btn-vote-again\"><%- text.vote_again.button_copy %></div> </div> <% } %> <% if (shareSettings.display_on_confirmation === 'true') { %> <p><%- text.twitter_vote.cta_copy %></p> <div class=\"thanks-social\"> <% if (shareSettings.display_twitter === 'true') { %> <div class=\"thanks\"> <a href=\"https://twitter.com/intent/tweet/?text=<%- twShareUrl %>\"> <div class=\"twitter\"> <svg id=\"twitter-svg\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 273.39 222.18\"><title>Twitter</title><path class=\"cls-1\" d=\"M340.73,115.23a112.12,112.12,0,0,1-32.21,8.83,56.25,56.25,0,0,0,24.66-31,112.3,112.3,0,0,1-35.62,13.61A56.14,56.14,0,0,0,202,157.8,159.24,159.24,0,0,1,86.37,99.2a56.15,56.15,0,0,0,17.36,74.88,55.86,55.86,0,0,1-25.41-7c0,0.23,0,.47,0,0.71a56.12,56.12,0,0,0,45,55,56.23,56.23,0,0,1-25.33,1,56.15,56.15,0,0,0,52.4,39,112.54,112.54,0,0,1-69.66,24,114.17,114.17,0,0,1-13.38-.78,158.76,158.76,0,0,0,86,25.2c103.17,0,159.58-85.47,159.58-159.59q0-3.65-.16-7.26A114,114,0,0,0,340.73,115.23Z\" transform=\"translate(-67.34 -88.93)\"/></svg> </div> </a> </div> <% } %> <% if (shareSettings.display_facebook === 'true') { %> <div class=\"thanks\"> <a href=\"javascript:void(0)\"> <div class=\"facebook\"> <svg id=\"facebook-svg\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 117.67 226.55\"><title>Facebook</title><path id=\"f\" class=\"cls-1\" d=\"M184.15,266.9V163.54h34.7L224,123.26H184.15V97.55c0-11.66,3.24-19.61,20-19.61h21.3v-36a285.42,285.42,0,0,0-31.08-1.59c-30.75,0-51.81,18.77-51.81,53.24V123.3H107.78v40.28h34.78V266.9h41.59Z\" transform=\"translate(-107.78 -40.35)\"/></svg> </div> </a> </div> <% } %> <% if(shareSettings.display_google === 'true') { %> <div class=\"thanks\"> <a href=\"https://plus.google.com/share?url={<%- google %>}\" onclick=\"window.open(this.href,\n              '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;\"> <div class=\"google\"> <img src=\"//ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678218.7284.png\"> </div> </a> </div> <% }; %> </div> <% } %> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="gallery"> <div class="image"> <img src="', (__stack.lineno=1,  image ), '"> </div> </div> <div class="thanks-container"> <h3>', (__stack.lineno=1,  text.thank_you_copy.headline ), '</h3> <div class="thanks-view"> ', (__stack.lineno=1,  text.thank_you_copy.sub_headline ), ' </div> ');__stack.lineno=1; if(text.twitter_vote.enable === 'true') { ; buf.push(' <div class="twitter-vote"> <h4>', (__stack.lineno=1,  text.secondary_copy.headline ), '</h4> <p>', (__stack.lineno=1,  text.secondary_copy.sub_headline ), '</p> </div> <div class="button twitter-button-div ', (__stack.lineno=1,  (text.twitter_vote.enable === "true" && text.vote_again.enable === "true") ? 'both-btns':'' ), '"> <a href="https://twitter.com/intent/tweet/?text=', (__stack.lineno=1,  twitterVoteText ), '"> <div class="vote btn-twitter-vote">', (__stack.lineno=1,  text.twitter_vote.button_copy ), '</div> </a> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(text.vote_again.enable === 'true') { ; buf.push(' <div class="button vote-again-button-div ', (__stack.lineno=1,  (text.twitter_vote.enable === "true" && text.vote_again.enable === "true") ? 'both-btns':'' ), '"> <div class="vote btn-vote-again">', (__stack.lineno=1,  text.vote_again.button_copy ), '</div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (shareSettings.display_on_confirmation === 'true') { ; buf.push(' <p>', (__stack.lineno=1,  text.twitter_vote.cta_copy ), '</p> <div class="thanks-social"> ');__stack.lineno=1; if (shareSettings.display_twitter === 'true') { ; buf.push(' <div class="thanks"> <a href="https://twitter.com/intent/tweet/?text=', (__stack.lineno=1,  twShareUrl ), '"> <div class="twitter"> <svg id="twitter-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 273.39 222.18"><title>Twitter</title><path class="cls-1" d="M340.73,115.23a112.12,112.12,0,0,1-32.21,8.83,56.25,56.25,0,0,0,24.66-31,112.3,112.3,0,0,1-35.62,13.61A56.14,56.14,0,0,0,202,157.8,159.24,159.24,0,0,1,86.37,99.2a56.15,56.15,0,0,0,17.36,74.88,55.86,55.86,0,0,1-25.41-7c0,0.23,0,.47,0,0.71a56.12,56.12,0,0,0,45,55,56.23,56.23,0,0,1-25.33,1,56.15,56.15,0,0,0,52.4,39,112.54,112.54,0,0,1-69.66,24,114.17,114.17,0,0,1-13.38-.78,158.76,158.76,0,0,0,86,25.2c103.17,0,159.58-85.47,159.58-159.59q0-3.65-.16-7.26A114,114,0,0,0,340.73,115.23Z" transform="translate(-67.34 -88.93)"/></svg> </div> </a> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if (shareSettings.display_facebook === 'true') { ; buf.push(' <div class="thanks"> <a href="javascript:void(0)"> <div class="facebook"> <svg id="facebook-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.67 226.55"><title>Facebook</title><path id="f" class="cls-1" d="M184.15,266.9V163.54h34.7L224,123.26H184.15V97.55c0-11.66,3.24-19.61,20-19.61h21.3v-36a285.42,285.42,0,0,0-31.08-1.59c-30.75,0-51.81,18.77-51.81,53.24V123.3H107.78v40.28h34.78V266.9h41.59Z" transform="translate(-107.78 -40.35)"/></svg> </div> </a> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(shareSettings.display_google === 'true') { ; buf.push(' <div class="thanks"> <a href="https://plus.google.com/share?url={', (__stack.lineno=1,  google ), '}" onclick="window.open(this.href,\n              \'\', \'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600\');return false;"> <div class="google"> <img src="//ts-cms-production.votenow.tv/widgets/71/40/714000e0c3842403/1000344_1418678218.7284.png"> </div> </a> </div> ');__stack.lineno=2; }; ; buf.push(' </div> ');__stack.lineno=2; } ; buf.push(' </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var template = __webpack_require__(106);

'use strict';

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-winner',
    /**
     *
     */
    initialize: function initialize(options) {
        this.model = options.model;
        this.model.winnerCopy = options.model.paragraph1.replace('{winner}', '<span>' + options.model.winner_name + '</span>');
    },
    /**
     *
     */
    render: function render() {
        this.$el.html(template(this.model));
        return this;
    },
    /**
     *
     */
    remove: function remove() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%= headline %></h3> <div class=\"winner-wrapper\"> <p class=\"winner-copy\"><%- winnerCopy %></p> <p><%= paragraph2 %></p> </div> <div class=\"winner-image\"> <img src=\"<%= image %>\"> </div> <div class=\"button\"> <a href=\"<%= button_url %>\" target=\"_blank\" rel=\"noopener noreferrer\"><%= button_copy %></a> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', escape((__stack.lineno=1,  headline )), '</h3> <div class="winner-wrapper"> <p class="winner-copy">', (__stack.lineno=1,  winnerCopy ), '</p> <p>', escape((__stack.lineno=1,  paragraph2 )), '</p> </div> <div class="winner-image"> <img src="', escape((__stack.lineno=1,  image )), '"> </div> <div class="button"> <a href="', escape((__stack.lineno=1,  button_url )), '" target="_blank" rel="noopener noreferrer">', escape((__stack.lineno=1,  button_copy )), '</a> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reauth = __webpack_require__(108);

var _reauth2 = _interopRequireDefault(_reauth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _reauth2.default;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Backbone = __webpack_require__(1);
var template = __webpack_require__(109);

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-reauth',
    events: {
        'click .btn-reauth': 'requestFbPermission'
    },
    /**
     *
     */
    initialize: function(options) {
        this.facebook = options.facebook;
    },
    /**
     *
     */
    render: function() {
        this.$el.html(template(this.model));
        return this;
    },
    requestFbPermission: function() {
        this.facebook.requestPermissions();
    },
    /**
     * 
     */
    remove: function() {
        this.off();
        Backbone.View.prototype.remove.call(this);
    }

});

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h3><%- headline %></h3> <div class=\"reauth-description\"><%- description %></div> <div class=\"contestant-container\"> <div class=\"button\"> <div class=\"vote btn-reauth\"><%- button_text %></div> </div> </div>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h3>', (__stack.lineno=1,  headline ), '</h3> <div class="reauth-description">', (__stack.lineno=1,  description ), '</div> <div class="contestant-container"> <div class="button"> <div class="vote btn-reauth">', (__stack.lineno=1,  button_text ), '</div> </div> </div>'); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/*global Countdown, Backbone*/
var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(2);
var template = __webpack_require__(111);

'use strict';

module.exports = Backbone.View.extend({
    template: template['home'],
    className: 'view-home',
    /**
     *
     */
    initialize: function (options) {
      _.bindAll(this, 'render');

      this.listenTo(this.model, 'change:time_months', this.changeMonths);
      this.listenTo(this.model, 'change:time_hours', this.changeHours);
      this.listenTo(this.model, 'change:time_minutes', this.changeMinutes);
      this.listenTo(this.model, 'change:time_days', this.changeDays);
      this.listenTo(this.model, 'change:time_seconds', this.changeSeconds);
    }
    /**
     *
     */
    , render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      
      this.changeMonths(this.model);
      this.changeDays(this.model);
      this.changeHours(this.model);
      this.changeMinutes(this.model);
      this.changeSeconds(this.model);

      return this;
    }
    , customCSS: function(rootView) {
      rootView = rootView || $('body');

      var styles = this.model.get('styles');

      //Font font
      if(styles.font) 
        rootView.css('font-family', styles.font);

      //Colors\\
      //copy_color
      if(styles.colors.copy_color) 
        rootView.find('.countdown-container .intro-text').css('color', styles.colors.copy_color);
      //column_label_color
      if(styles.colors.column_label_color) 
        rootView.find('.countdown-unit-label').css('color', styles.colors.column_label_color);
      //number_color
      if(styles.colors.number_color) 
        rootView.find('.countdown-value').css('color', styles.colors.number_color);
      //colon_color
      if(styles.colors.colon_color) 
        rootView.find('.colon .text').css('color', styles.colors.colon_color);

      //Background colors\\
      //number_cell_background
      if(styles.colors.number_cell_background) 
        rootView.find('.countdown-value').css('background-color', styles.colors.number_cell_background);
      //counter_background_color
      if(styles.colors.counter_background_color) 
        rootView.find('.countdown-container').css('background-color', styles.colors.counter_background_color);
      //main_background_color
      if(styles.colors.main_background_color) 
        rootView.css('background-color', styles.colors.main_background_color);
    }
    /**
     *
     */
    ,changeMonths: function(model, value, options){
        var value = value || model.get('time_months');
        $('.countdown-months .countdown-value').html(value < 10? '0'+value : value)
        if(value === 1){
            this.$el.find('.countdown-months .countdown-unit-label').html('Month');
        } else if(model.previous('time_months') === 1){
            this.$el.find('.countdown-months .countdown-unit-label').html('Months');
        }
    }
    /**
    /**
     *
     */
    ,changeDays: function(model, value, options){
        var value = value || model.get('time_days');
        $('.countdown-days .countdown-value').html(value < 10? '0'+value : value)
        if(value === 1){
            this.$el.find('.countdown-days .countdown-unit-label').html('Day');
        } else if(model.previous('time_days') === 1){
            this.$el.find('.countdown-days .countdown-unit-label').html('Days');
        }
    }
    /**
     *
     */
    ,changeHours: function(model, value, options){
        var value = value || model.get('time_hours');
        $('.countdown-hours .countdown-value').html(value < 10? '0'+value : value)
        if(value === 1){
            this.$el.find('.countdown-hours .countdown-unit-label').html('Hour');
        } else if(model.previous('time_hours') === 1){
            this.$el.find('.countdown-hours .countdown-unit-label').html('Hours');
        }

    }
    /**
     *
     */
    ,changeMinutes: function(model, value, options){
        var value = value || model.get('time_minutes');
        $('.countdown-minutes .countdown-value').html(value < 10? '0'+value : value);
        if(value === 1){
            this.$el.find('.countdown-minutes .countdown-unit-label').html('Min');
        } else if(model.previous('time_minutes') === 1){
            this.$el.find('.countdown-minutes .countdown-unit-label').html('Mins');
        }

    }
    /**
     *
     */
    ,changeSeconds: function(model, value, options){
        var value = value || this.model.get('time_seconds');

        this.$('.countdown-seconds .countdown-value').html(value < 10? '0'+value : value);
        if(value === 1){
            this.$('.countdown-seconds .countdown-unit-label').html('Sec');
        } else if(this.model.previous('time_seconds') === 1){
            this.$('.countdown-seconds .countdown-unit-label').html('Secs');
        }

    }
  });

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict;"

var _ = __webpack_require__(0);
exports["home"] = function (obj) {
  obj || (obj = {});
  var __t, __p = '',
      __e = _.escape,
      __j = Array.prototype.join;

  function print() {
    __p += __j.call(arguments, '')
  }
  with(obj) {

    if (parseInt(show_branding)) {;
      __p += '\n\t<div class="branding-container">\n\t\t';
      if (branding_image_600x300) {;
        __p += '\n\t\t\t<img src="' + ((__t = (branding_image_600x300)) == null ? '' : __t) + '">\n\t\t';
      };
      __p += '\n\t</div>\n';
    };
    __p += '\n<div class="countdown-container">\n\t';
    if (parseInt(show_copy_text)) {;
      __p += '\n\t\t<div class="intro-text">' + ((__t = (copy_text)) == null ? '' : __t) + '</div>\n\t';
    };
    __p += '\n\t\n\t<div class="countdown-time">\n\t\t';
    if (parseInt(show_month)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-months">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_months < 10 ? '0' + time_months : time_months)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_months === 1 ? 'Month' : 'Months'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_days)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-days">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_days < 10 ? '0' + time_days : time_days)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_days === 1 ? 'Day' : 'Days'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_hours)) {;
      __p += '\t\n\t\t\t<div class="countdown-unit countdown-hours">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_hours < 10 ? '0' + time_hours : time_hours)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_hours === 1 ? 'Hour' : 'Hours'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_minutes)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-minutes">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_minutes < 10 ? '0' + time_minutes : time_minutes)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_minutes === 1 ? 'Min' : 'Mins'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t\t<div class="colon">\n\t\t\t\t<div class="text">:</div>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t\t';
    if (parseInt(show_seconds)) {;
      __p += '\n\t\t\t<div class="countdown-unit countdown-seconds last">\n\t\t\t\t<span class="countdown-unit-cell">\n\t\t\t\t\t<div class="countdown-value">' + ((__t = (time_seconds < 10 ? '0' + time_seconds : time_seconds)) == null ? '' : __t) + '</div>\n\t\t\t\t\t<br>\n\t\t\t\t\t';
      if (parseInt(show_labels)) {;
        __p += '<span class="countdown-unit-label"> ' + ((__t = ((time_seconds === 1 ? 'Sec' : 'Secs'))) == null ? '' : __t) + '</span>';
      };
      __p += '\n\t\t\t\t</span>\n\t\t\t</div>\n\t\t';
    };
    __p += '\n\t</div>\n\n</div>';

  }
  return __p
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var pym = __webpack_require__(113);
var assignIn = __webpack_require__(114);

function TelescopeLoaderChild(options) {
    //
}

// Child is a class should return itself as well as references to function: http://blog.apps.npr.org/pym.js/api/pym.js/1.0.0/pym.js.html#line520
TelescopeLoaderChild.prototype.Child = function(options) {
    var defaults = {
        //standard pym child options, all optional
        renderCallback: null,
        polling: 0,
        xdomain: '*',
        id: ''
    };

    options = assignIn({}, defaults, options);

    this.child = pym.Child(options);
    this.navigateParentTo = navigateParentTo.bind(this);
    this.remove = remove.bind(this);
    this.scrollParentTo = scrollParentTo.bind(this);
    this.sendHeight = sendHeight.bind(this);
    this.sendMessage = sendMessage.bind(this);
    this.onMessage = onMessage.bind(this);

    return this;

}

function navigateParentTo( url ){
    this.child.navigateParentTo(url);
}

function onMessage( messageType, callback ){
    //if messageType is not a string stringify it
    var msgType = (typeof messageType !== 'string') ? JSON.stringify(messageType) : messageType;
    this.child.onMessage(msgType, callback);
}

function remove(){
    this.child.remove();
}

function scrollParentTo( hash ){
    this.child.scrollParentTo(hash);
}

function sendHeight(){
    this.child.sendHeight();
}

function sendMessage( messageType, message ){
    //if messageType is not a string stringify it
    var msgType = (typeof messageType !== 'string') ? JSON.stringify(messageType) : messageType;
    //if message is not a string stringify it
    var msg = (typeof message !== 'string') ? JSON.stringify(message) : message;
    this.child.sendMessage(msgType, msg);
}

module.exports = ( new TelescopeLoaderChild );

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! pym.js - v1.3.1 - 2017-07-25 */
/*
* Pym.js is library that resizes an iframe based on the width of the parent and the resulting height of the child.
* Check out the docs at http://blog.apps.npr.org/pym.js/ or the readme at README.md for usage.
*/

/** @module pym */
(function(factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory();
    } else {
        window.pym = factory.call(this);
    }
})(function() {
    var MESSAGE_DELIMITER = 'xPYMx';

    var lib = {};

    /**
    * Create and dispatch a custom pym event
    *
    * @method _raiseCustomEvent
    * @inner
    *
    * @param {String} eventName
    */
   var _raiseCustomEvent = function(eventName) {
     var event = document.createEvent('Event');
     event.initEvent('pym:' + eventName, true, true);
     document.dispatchEvent(event);
   };

    /**
    * Generic function for parsing URL params.
    * Via http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    *
    * @method _getParameterByName
    * @inner
    *
    * @param {String} name The name of the paramter to get from the URL.
    */
    var _getParameterByName = function(name) {
        var regex = new RegExp("[\\?&]" + name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]') + '=([^&#]*)');
        var results = regex.exec(location.search);

        if (results === null) {
            return '';
        }

        return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    /**
     * Check the message to make sure it comes from an acceptable xdomain.
     * Defaults to '*' but can be overriden in config.
     *
     * @method _isSafeMessage
     * @inner
     *
     * @param {Event} e The message event.
     * @param {Object} settings Configuration.
     */
    var _isSafeMessage = function(e, settings) {
        if (settings.xdomain !== '*') {
            // If origin doesn't match our xdomain, return.
            if (!e.origin.match(new RegExp(settings.xdomain + '$'))) { return; }
        }

        // Ignore events that do not carry string data #151
        if (typeof e.data !== 'string') { return; }

        return true;
    };

    /**
     * Construct a message to send between frames.
     *
     * NB: We use string-building here because JSON message passing is
     * not supported in all browsers.
     *
     * @method _makeMessage
     * @inner
     *
     * @param {String} id The unique id of the message recipient.
     * @param {String} messageType The type of message to send.
     * @param {String} message The message to send.
     */
    var _makeMessage = function(id, messageType, message) {
        var bits = ['pym', id, messageType, message];

        return bits.join(MESSAGE_DELIMITER);
    };

    /**
     * Construct a regex to validate and parse messages.
     *
     * @method _makeMessageRegex
     * @inner
     *
     * @param {String} id The unique id of the message recipient.
     */
    var _makeMessageRegex = function(id) {
        var bits = ['pym', id, '(\\S+)', '(.*)'];

        return new RegExp('^' + bits.join(MESSAGE_DELIMITER) + '$');
    };

    /**
    * Underscore implementation of getNow
    *
    * @method _getNow
    * @inner
    *
    */
    var _getNow = Date.now || function() {
        return new Date().getTime();
    };

    /**
    * Underscore implementation of throttle
    *
    * @method _throttle
    * @inner
    *
    * @param {function} func Throttled function
    * @param {number} wait Throttle wait time
    * @param {object} options Throttle settings
    */

    var _throttle = function(func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) {options = {};}
        var later = function() {
            previous = options.leading === false ? 0 : _getNow();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) {context = args = null;}
        };
        return function() {
            var now = _getNow();
            if (!previous && options.leading === false) {previous = now;}
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) {context = args = null;}
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    /**
     * Clean autoInit Instances: those that point to contentless iframes
     * @method _cleanAutoInitInstances
     * @inner
     */
    var _cleanAutoInitInstances = function() {
        var length = lib.autoInitInstances.length;

        // Loop backwards to avoid index issues
        for (var idx = length - 1; idx >= 0; idx--) {
            var instance = lib.autoInitInstances[idx];
            // If instance has been removed or is contentless then remove it
            if (instance.el.getElementsByTagName('iframe').length &&
                instance.el.getElementsByTagName('iframe')[0].contentWindow) {
                continue;
            }
            else {
                // Remove the reference to the removed or orphan instance
                lib.autoInitInstances.splice(idx,1);
            }
        }
    };

    /**
     * Store auto initialized Pym instances for further reference
     * @name module:pym#autoInitInstances
     * @type Array
     * @default []
     */
    lib.autoInitInstances = [];

    /**
     * Initialize Pym for elements on page that have data-pym attributes.
     * Expose autoinit in case we need to call it from the outside
     * @instance
     * @method autoInit
     * @param {Boolean} doNotRaiseEvents flag to avoid sending custom events
     */
    lib.autoInit = function(doNotRaiseEvents) {
        var elements = document.querySelectorAll('[data-pym-src]:not([data-pym-auto-initialized])');
        var length = elements.length;

        // Clean stored instances in case needed
        _cleanAutoInitInstances();
        for (var idx = 0; idx < length; ++idx) {
            var element = elements[idx];
            /*
            * Mark automatically-initialized elements so they are not
            * re-initialized if the user includes pym.js more than once in the
            * same document.
            */
            element.setAttribute('data-pym-auto-initialized', '');

            // Ensure elements have an id
            if (element.id === '') {
                element.id = 'pym-' + idx + "-" + Math.random().toString(36).substr(2,5);
            }

            var src = element.getAttribute('data-pym-src');

            // List of data attributes to configure the component
            // structure: {'attribute name': 'type'}
            var settings = {'xdomain': 'string', 'title': 'string', 'name': 'string', 'id': 'string',
                            'sandbox': 'string', 'allowfullscreen': 'boolean',
                            'parenturlparam': 'string', 'parenturlvalue': 'string',
                            'optionalparams': 'boolean', 'trackscroll': 'boolean',
                            'scrollwait': 'number'};

            var config = {};

            for (var attribute in settings) {
                // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute#Notes
               if (element.getAttribute('data-pym-'+attribute) !== null) {
                  switch (settings[attribute]) {
                    case 'boolean':
                       config[attribute] = !(element.getAttribute('data-pym-'+attribute) === 'false'); // jshint ignore:line
                       break;
                    case 'string':
                       config[attribute] = element.getAttribute('data-pym-'+attribute);
                       break;
                    case 'number':
                        var n = Number(element.getAttribute('data-pym-'+attribute));
                        if (!isNaN(n)) {
                            config[attribute] = n;
                        }
                        break;
                    default:
                       console.err('unrecognized attribute type');
                  }
               }
            }

            // Store references to autoinitialized pym instances
            var parent = new lib.Parent(element.id, src, config);
            lib.autoInitInstances.push(parent);
        }

        // Fire customEvent
        if (!doNotRaiseEvents) {
            _raiseCustomEvent("pym-initialized");
        }
        // Return stored autoinitalized pym instances
        return lib.autoInitInstances;
    };

    /**
     * The Parent half of a response iframe.
     *
     * @memberof module:pym
     * @class Parent
     * @param {String} id The id of the div into which the iframe will be rendered. sets {@link module:pym.Parent~id}
     * @param {String} url The url of the iframe source. sets {@link module:pym.Parent~url}
     * @param {Object} [config] Configuration for the parent instance. sets {@link module:pym.Parent~settings}
     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
     * @param {string} [config.title] - if passed it will be assigned to the iframe title attribute
     * @param {string} [config.name] - if passed it will be assigned to the iframe name attribute
     * @param {string} [config.id] - if passed it will be assigned to the iframe id attribute
     * @param {boolean} [config.allowfullscreen] - if passed and different than false it will be assigned to the iframe allowfullscreen attribute
     * @param {string} [config.sandbox] - if passed it will be assigned to the iframe sandbox attribute (we do not validate the syntax so be careful!!)
     * @param {string} [config.parenturlparam] - if passed it will be override the default parentUrl query string parameter name passed to the iframe src
     * @param {string} [config.parenturlvalue] - if passed it will be override the default parentUrl query string parameter value passed to the iframe src
     * @param {string} [config.optionalparams] - if passed and different than false it will strip the querystring params parentUrl and parentTitle passed to the iframe src
     * @param {boolean} [config.trackscroll] - if passed it will activate scroll tracking on the parent
     * @param {number} [config.scrollwait] - if passed it will set the throttle wait in order to fire scroll messaging. Defaults to 100 ms.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe iFrame}
     */
    lib.Parent = function(id, url, config) {
        /**
         * The id of the container element
         *
         * @memberof module:pym.Parent
         * @member {string} id
         * @inner
         */
        this.id = id;
        /**
         * The url that will be set as the iframe's src
         *
         * @memberof module:pym.Parent
         * @member {String} url
         * @inner
         */
        this.url = url;

        /**
         * The container DOM object
         *
         * @memberof module:pym.Parent
         * @member {HTMLElement} el
         * @inner
         */
        this.el = document.getElementById(id);
        /**
         * The contained child iframe
         *
         * @memberof module:pym.Parent
         * @member {HTMLElement} iframe
         * @inner
         * @default null
         */
        this.iframe = null;
        /**
         * The parent instance settings, updated by the values passed in the config object
         *
         * @memberof module:pym.Parent
         * @member {Object} settings
         * @inner
         */
        this.settings = {
            xdomain: '*',
            optionalparams: true,
            parenturlparam: 'parentUrl',
            parenturlvalue: window.location.href,
            trackscroll: false,
            scrollwait: 100,
        };
        /**
         * RegularExpression to validate the received messages
         *
         * @memberof module:pym.Parent
         * @member {String} messageRegex
         * @inner
         */
        this.messageRegex = _makeMessageRegex(this.id);
        /**
         * Stores the registered messageHandlers for each messageType
         *
         * @memberof module:pym.Parent
         * @member {Object} messageHandlers
         * @inner
         */
        this.messageHandlers = {};

        // ensure a config object
        config = (config || {});

        /**
         * Construct the iframe.
         *
         * @memberof module:pym.Parent
         * @method _constructIframe
         * @inner
         */
        this._constructIframe = function() {
            // Calculate the width of this element.
            var width = this.el.offsetWidth.toString();

            // Create an iframe element attached to the document.
            this.iframe = document.createElement('iframe');

            // Save fragment id
            var hash = '';
            var hashIndex = this.url.indexOf('#');

            if (hashIndex > -1) {
                hash = this.url.substring(hashIndex, this.url.length);
                this.url = this.url.substring(0, hashIndex);
            }

            // If the URL contains querystring bits, use them.
            // Otherwise, just create a set of valid params.
            if (this.url.indexOf('?') < 0) {
                this.url += '?';
            } else {
                this.url += '&';
            }

            // Append the initial width as a querystring parameter
            // and optional params if configured to do so
            this.iframe.src = this.url + 'initialWidth=' + width +
                                         '&childId=' + this.id;

            if (this.settings.optionalparams) {
                this.iframe.src += '&parentTitle=' + encodeURIComponent(document.title);
                this.iframe.src += '&'+ this.settings.parenturlparam + '=' + encodeURIComponent(this.settings.parenturlvalue);
            }
            this.iframe.src +=hash;

            // Set some attributes to this proto-iframe.
            this.iframe.setAttribute('width', '100%');
            this.iframe.setAttribute('scrolling', 'no');
            this.iframe.setAttribute('marginheight', '0');
            this.iframe.setAttribute('frameborder', '0');

            if (this.settings.title) {
                this.iframe.setAttribute('title', this.settings.title);
            }

            if (this.settings.allowfullscreen !== undefined && this.settings.allowfullscreen !== false) {
                this.iframe.setAttribute('allowfullscreen','');
            }

            if (this.settings.sandbox !== undefined && typeof this.settings.sandbox === 'string') {
                this.iframe.setAttribute('sandbox', this.settings.sandbox);
            }

            if (this.settings.id) {
                if (!document.getElementById(this.settings.id)) {
                    this.iframe.setAttribute('id', this.settings.id);
                }
            }

            if (this.settings.name) {
                this.iframe.setAttribute('name', this.settings.name);
            }

            // Replace the child content if needed
            // (some CMSs might strip out empty elements)
            while(this.el.firstChild) { this.el.removeChild(this.el.firstChild); }
            // Append the iframe to our element.
            this.el.appendChild(this.iframe);

            // Add an event listener that will handle redrawing the child on resize.
            window.addEventListener('resize', this._onResize);

            // Add an event listener that will send the child the viewport.
            if (this.settings.trackscroll) {
                window.addEventListener('scroll', this._throttleOnScroll);
            }
        };

        /**
         * Send width on resize.
         *
         * @memberof module:pym.Parent
         * @method _onResize
         * @inner
         */
        this._onResize = function() {
            this.sendWidth();
            if (this.settings.trackscroll) {
                this.sendViewportAndIFramePosition();
            }
        }.bind(this);

        /**
         * Send viewport and iframe info on scroll.
         *
         * @memberof module:pym.Parent
         * @method _onScroll
         * @inner
         */
        this._onScroll = function() {
            this.sendViewportAndIFramePosition();
        }.bind(this);

        /**
         * Fire all event handlers for a given message type.
         *
         * @memberof module:pym.Parent
         * @method _fire
         * @inner
         *
         * @param {String} messageType The type of message.
         * @param {String} message The message data.
         */
        this._fire = function(messageType, message) {
            if (messageType in this.messageHandlers) {
                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
                   this.messageHandlers[messageType][i].call(this, message);
                }
            }
        };

        /**
         * Remove this parent from the page and unbind it's event handlers.
         *
         * @memberof module:pym.Parent
         * @method remove
         * @instance
         */
        this.remove = function() {
            window.removeEventListener('message', this._processMessage);
            window.removeEventListener('resize', this._onResize);

            this.el.removeChild(this.iframe);
            // _cleanAutoInitInstances in case this parent was autoInitialized
            _cleanAutoInitInstances();
        };

        /**
         * Process a new message from the child.
         *
         * @memberof module:pym.Parent
         * @method _processMessage
         * @inner
         *
         * @param {Event} e A message event.
         */
        this._processMessage = function(e) {
            // First, punt if this isn't from an acceptable xdomain.
            if (!_isSafeMessage(e, this.settings)) {
                return;
            }

            // Discard object messages, we only care about strings
            if (typeof e.data !== 'string') {
                return;
            }

            // Grab the message from the child and parse it.
            var match = e.data.match(this.messageRegex);

            // If there's no match or too many matches in the message, punt.
            if (!match || match.length !== 3) {
                return false;
            }

            var messageType = match[1];
            var message = match[2];

            this._fire(messageType, message);
        }.bind(this);

        /**
         * Resize iframe in response to new height message from child.
         *
         * @memberof module:pym.Parent
         * @method _onHeightMessage
         * @inner
         *
         * @param {String} message The new height.
         */
        this._onHeightMessage = function(message) {
            /*
             * Handle parent height message from child.
             */
            var height = parseInt(message);

            this.iframe.setAttribute('height', height + 'px');
        };

        /**
         * Navigate parent to a new url.
         *
         * @memberof module:pym.Parent
         * @method _onNavigateToMessage
         * @inner
         *
         * @param {String} message The url to navigate to.
         */
        this._onNavigateToMessage = function(message) {
            /*
             * Handle parent scroll message from child.
             */
            document.location.href = message;
        };

        /**
         * Scroll parent to a given child position.
         *
         * @memberof module:pym.Parent
         * @method _onScrollToChildPosMessage
         * @inner
         *
         * @param {String} message The offset inside the child page.
         */
        this._onScrollToChildPosMessage = function(message) {
            // Get the child container position using getBoundingClientRect + pageYOffset
            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            var iframePos = document.getElementById(this.id).getBoundingClientRect().top + window.pageYOffset;

            var totalOffset = iframePos + parseInt(message);
            window.scrollTo(0, totalOffset);
        };

        /**
         * Bind a callback to a given messageType from the child.
         *
         * Reserved message names are: "height", "scrollTo" and "navigateTo".
         *
         * @memberof module:pym.Parent
         * @method onMessage
         * @instance
         *
         * @param {String} messageType The type of message being listened for.
         * @param {module:pym.Parent~onMessageCallback} callback The callback to invoke when a message of the given type is received.
         */
        this.onMessage = function(messageType, callback) {
            if (!(messageType in this.messageHandlers)) {
                this.messageHandlers[messageType] = [];
            }

            this.messageHandlers[messageType].push(callback);
        };

        /**
         * @callback module:pym.Parent~onMessageCallback
         * @param {String} message The message data.
         */

        /**
         * Send a message to the the child.
         *
         * @memberof module:pym.Parent
         * @method sendMessage
         * @instance
         *
         * @param {String} messageType The type of message to send.
         * @param {String} message The message data to send.
         */
        this.sendMessage = function(messageType, message) {
            // When used alongside with pjax some references are lost
            if (this.el.getElementsByTagName('iframe').length) {
                if (this.el.getElementsByTagName('iframe')[0].contentWindow) {
                    this.el.getElementsByTagName('iframe')[0].contentWindow
                        .postMessage(_makeMessage(this.id, messageType, message), '*');
                }
                else {
                    // Contentless child detected remove listeners and iframe
                    this.remove();
                }
            }
        };

        /**
         * Transmit the current iframe width to the child.
         *
         * You shouldn't need to call this directly.
         *
         * @memberof module:pym.Parent
         * @method sendWidth
         * @instance
         */
        this.sendWidth = function() {
            var width = this.el.offsetWidth.toString();
            this.sendMessage('width', width);
        };

        /**
         * Transmit the current viewport and iframe position to the child.
         * Sends viewport width, viewport height
         * and iframe bounding rect top-left-bottom-right
         * all separated by spaces
         *
         * You shouldn't need to call this directly.
         *
         * @memberof module:pym.Parent
         * @method sendViewportAndIFramePosition
         * @instance
         */
        this.sendViewportAndIFramePosition = function() {
            var iframeRect = this.iframe.getBoundingClientRect();
            var vWidth   = window.innerWidth || document.documentElement.clientWidth;
            var vHeight  = window.innerHeight || document.documentElement.clientHeight;
            var payload = vWidth + ' ' + vHeight;
            payload += ' ' + iframeRect.top + ' ' + iframeRect.left;
            payload += ' ' + iframeRect.bottom + ' ' + iframeRect.right;
            this.sendMessage('viewport-iframe-position', payload);
        };

        // Add any overrides to settings coming from config.
        for (var key in config) {
            this.settings[key] = config[key];
        }

        /**
         * Throttled scroll function.
         *
         * @memberof module:pym.Parent
         * @method _throttleOnScroll
         * @inner
         */
        this._throttleOnScroll = _throttle(this._onScroll.bind(this), this.settings.scrollwait);

        // Bind required message handlers
        this.onMessage('height', this._onHeightMessage);
        this.onMessage('navigateTo', this._onNavigateToMessage);
        this.onMessage('scrollToChildPos', this._onScrollToChildPosMessage);
        this.onMessage('parentPositionInfo', this.sendViewportAndIFramePosition);

        // Add a listener for processing messages from the child.
        window.addEventListener('message', this._processMessage, false);

        // Construct the iframe in the container element.
        this._constructIframe();

        return this;
    };

    /**
     * The Child half of a responsive iframe.
     *
     * @memberof module:pym
     * @class Child
     * @param {Object} [config] Configuration for the child instance. sets {@link module:pym.Child~settings}
     * @param {function} [config.renderCallback=null] Callback invoked after receiving a resize event from the parent, sets {@link module:pym.Child#settings.renderCallback}
     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
     * @param {number} [config.polling=0] - polling frequency in milliseconds to send height to parent
     * @param {number} [config.id] - parent container id used when navigating the child iframe to a new page but we want to keep it responsive.
     * @param {string} [config.parenturlparam] - if passed it will be override the default parentUrl query string parameter name expected on the iframe src
     */
    lib.Child = function(config) {
        /**
         * The initial width of the parent page
         *
         * @memberof module:pym.Child
         * @member {string} parentWidth
         * @inner
         */
        this.parentWidth = null;
        /**
         * The id of the parent container
         *
         * @memberof module:pym.Child
         * @member {String} id
         * @inner
         */
        this.id = null;
        /**
         * The title of the parent page from document.title.
         *
         * @memberof module:pym.Child
         * @member {String} parentTitle
         * @inner
         */
        this.parentTitle = null;
        /**
         * The URL of the parent page from window.location.href.
         *
         * @memberof module:pym.Child
         * @member {String} parentUrl
         * @inner
         */
        this.parentUrl = null;
        /**
         * The settings for the child instance. Can be overriden by passing a config object to the child constructor
         * i.e.: var pymChild = new pym.Child({renderCallback: render, xdomain: "\\*\.npr\.org"})
         *
         * @memberof module:pym.Child.settings
         * @member {Object} settings - default settings for the child instance
         * @inner
         */
        this.settings = {
            renderCallback: null,
            xdomain: '*',
            polling: 0,
            parenturlparam: 'parentUrl'
        };

        /**
         * The timerId in order to be able to stop when polling is enabled
         *
         * @memberof module:pym.Child
         * @member {String} timerId
         * @inner
         */
        this.timerId = null;
        /**
         * RegularExpression to validate the received messages
         *
         * @memberof module:pym.Child
         * @member {String} messageRegex
         * @inner
         */
        this.messageRegex = null;
        /**
         * Stores the registered messageHandlers for each messageType
         *
         * @memberof module:pym.Child
         * @member {Object} messageHandlers
         * @inner
         */
        this.messageHandlers = {};

        // Ensure a config object
        config = (config || {});

        /**
         * Bind a callback to a given messageType from the child.
         *
         * Reserved message names are: "width".
         *
         * @memberof module:pym.Child
         * @method onMessage
         * @instance
         *
         * @param {String} messageType The type of message being listened for.
         * @param {module:pym.Child~onMessageCallback} callback The callback to invoke when a message of the given type is received.
         */
        this.onMessage = function(messageType, callback) {

            if (!(messageType in this.messageHandlers)) {
                this.messageHandlers[messageType] = [];
            }

            this.messageHandlers[messageType].push(callback);
        };

        /**
         * @callback module:pym.Child~onMessageCallback
         * @param {String} message The message data.
         */


        /**
         * Fire all event handlers for a given message type.
         *
         * @memberof module:pym.Child
         * @method _fire
         * @inner
         *
         * @param {String} messageType The type of message.
         * @param {String} message The message data.
         */
        this._fire = function(messageType, message) {
            /*
             * Fire all event handlers for a given message type.
             */
            if (messageType in this.messageHandlers) {
                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
                   this.messageHandlers[messageType][i].call(this, message);
                }
            }
        };

        /**
         * Process a new message from the parent.
         *
         * @memberof module:pym.Child
         * @method _processMessage
         * @inner
         *
         * @param {Event} e A message event.
         */
        this._processMessage = function(e) {
            /*
            * Process a new message from parent frame.
            */
            // First, punt if this isn't from an acceptable xdomain.
            if (!_isSafeMessage(e, this.settings)) {
                return;
            }

            // Discard object messages, we only care about strings
            if (typeof e.data !== 'string') {
                return;
            }

            // Get the message from the parent.
            var match = e.data.match(this.messageRegex);

            // If there's no match or it's a bad format, punt.
            if (!match || match.length !== 3) { return; }

            var messageType = match[1];
            var message = match[2];

            this._fire(messageType, message);
        }.bind(this);

        /**
         * Resize iframe in response to new width message from parent.
         *
         * @memberof module:pym.Child
         * @method _onWidthMessage
         * @inner
         *
         * @param {String} message The new width.
         */
        this._onWidthMessage = function(message) {
            /*
             * Handle width message from the child.
             */
            var width = parseInt(message);

            // Change the width if it's different.
            if (width !== this.parentWidth) {
                this.parentWidth = width;

                // Call the callback function if it exists.
                if (this.settings.renderCallback) {
                    this.settings.renderCallback(width);
                }

                // Send the height back to the parent.
                this.sendHeight();
            }
        };

        /**
         * Send a message to the the Parent.
         *
         * @memberof module:pym.Child
         * @method sendMessage
         * @instance
         *
         * @param {String} messageType The type of message to send.
         * @param {String} message The message data to send.
         */
        this.sendMessage = function(messageType, message) {
            /*
             * Send a message to the parent.
             */
            window.parent.postMessage(_makeMessage(this.id, messageType, message), '*');
        };

        /**
         * Transmit the current iframe height to the parent.
         *
         * Call this directly in cases where you manually alter the height of the iframe contents.
         *
         * @memberof module:pym.Child
         * @method sendHeight
         * @instance
         */
        this.sendHeight = function() {
            // Get the child's height.
            var height = document.getElementsByTagName('body')[0].offsetHeight.toString();

            // Send the height to the parent.
            this.sendMessage('height', height);

            return height;
        }.bind(this);

        /**
         * Ask parent to send the current viewport and iframe position information
         *
         * @memberof module:pym.Child
         * @method sendHeight
         * @instance
         */
        this.getParentPositionInfo = function() {
            // Send the height to the parent.
            this.sendMessage('parentPositionInfo');
        };

        /**
         * Scroll parent to a given element id.
         *
         * @memberof module:pym.Child
         * @method scrollParentTo
         * @instance
         *
         * @param {String} hash The id of the element to scroll to.
         */
        this.scrollParentTo = function(hash) {
            this.sendMessage('navigateTo', '#' + hash);
        };

        /**
         * Navigate parent to a given url.
         *
         * @memberof module:pym.Child
         * @method navigateParentTo
         * @instance
         *
         * @param {String} url The url to navigate to.
         */
        this.navigateParentTo = function(url) {
            this.sendMessage('navigateTo', url);
        };

        /**
         * Scroll parent to a given child element id.
         *
         * @memberof module:pym.Child
         * @method scrollParentToChildEl
         * @instance
         *
         * @param {String} id The id of the child element to scroll to.
         */
        this.scrollParentToChildEl = function(id) {
            // Get the child element position using getBoundingClientRect + pageYOffset
            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            var topPos = document.getElementById(id).getBoundingClientRect().top + window.pageYOffset;
            this.scrollParentToChildPos(topPos);
        };

        /**
         * Scroll parent to a particular child offset.
         *
         * @memberof module:pym.Child
         * @method scrollParentToChildPos
         * @instance
         *
         * @param {Number} pos The offset of the child element to scroll to.
         */
        this.scrollParentToChildPos = function(pos) {
            this.sendMessage('scrollToChildPos', pos.toString());
        };

        /**
         * Mark Whether the child is embedded or not
         * executes a callback in case it was passed to the config
         *
         * @memberof module:pym.Child
         * @method _markWhetherEmbedded
         * @inner
         *
         * @param {module:pym.Child~onMarkedEmbeddedStatus} The callback to execute after determining whether embedded or not.
         */
        var _markWhetherEmbedded = function(onMarkedEmbeddedStatus) {
          var htmlElement = document.getElementsByTagName('html')[0],
              newClassForHtml,
              originalHtmlClasses = htmlElement.className;
          try {
            if(window.self !== window.top) {
              newClassForHtml = "embedded";
            }else{
              newClassForHtml = "not-embedded";
            }
          }catch(e) {
            newClassForHtml = "embedded";
          }
          if(originalHtmlClasses.indexOf(newClassForHtml) < 0) {
            htmlElement.className = originalHtmlClasses ? originalHtmlClasses + ' ' + newClassForHtml : newClassForHtml;
            if(onMarkedEmbeddedStatus){
              onMarkedEmbeddedStatus(newClassForHtml);
            }
            _raiseCustomEvent("marked-embedded");
          }
        };

        /**
         * @callback module:pym.Child~onMarkedEmbeddedStatus
         * @param {String} classname "embedded" or "not-embedded".
         */

        /**
         * Unbind child event handlers and timers.
         *
         * @memberof module:pym.Child
         * @method remove
         * @instance
         */
        this.remove = function() {
            window.removeEventListener('message', this._processMessage);
            if (this.timerId) {
                clearInterval(this.timerId);
            }
        };

        // Initialize settings with overrides.
        for (var key in config) {
            this.settings[key] = config[key];
        }

        // Identify what ID the parent knows this child as.
        this.id = _getParameterByName('childId') || config.id;
        this.messageRegex = new RegExp('^pym' + MESSAGE_DELIMITER + this.id + MESSAGE_DELIMITER + '(\\S+)' + MESSAGE_DELIMITER + '(.*)$');

        // Get the initial width from a URL parameter.
        var width = parseInt(_getParameterByName('initialWidth'));

        // Get the url of the parent frame
        this.parentUrl = _getParameterByName(this.settings.parenturlparam);

        // Get the title of the parent frame
        this.parentTitle = _getParameterByName('parentTitle');

        // Bind the required message handlers
        this.onMessage('width', this._onWidthMessage);

        // Set up a listener to handle any incoming messages.
        window.addEventListener('message', this._processMessage, false);

        // If there's a callback function, call it.
        if (this.settings.renderCallback) {
            this.settings.renderCallback(width);
        }

        // Send the initial height to the parent.
        this.sendHeight();

        // If we're configured to poll, create a setInterval to handle that.
        if (this.settings.polling) {
            this.timerId = window.setInterval(this.sendHeight, this.settings.polling);
        }

        _markWhetherEmbedded(config.onMarkedEmbeddedStatus);

        return this;
    };

    // Initialize elements with pym data attributes
    // if we are not in server configuration
    if(typeof document !== "undefined") {
        lib.autoInit(true);
    }

    return lib;
});



/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var keysIn = __webpack_require__(115),
    rest = __webpack_require__(116);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : source[key];

    assignValue(object, key, newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return rest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * function Bar() {
 *   this.d = 4;
 * }
 *
 * Foo.prototype.c = 3;
 * Bar.prototype.e = 5;
 *
 * _.assignIn({ 'a': 1 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
 */
var assignIn = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keysIn(source), object);
    return;
  }
  for (var key in source) {
    assignValue(object, key, source[key]);
  }
});

module.exports = assignIn;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = start === undefined ? start : toInteger(start);
  return baseRest(func, start);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = rest;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _countdown = __webpack_require__(118);

var _countdown2 = _interopRequireDefault(_countdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _countdown2.default;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var countdown = __webpack_require__(119);

('use strict');

module.exports = Backbone.Model.extend({
    defaults: function() {
        return {
            name: 'generic timer',
            countdown_status: 0,
            future_time: null,
            timer: null,
            time_string: null,
            time_months: null,
            time_days: null,
            time_hours: null,
            time_minutes: null,
            time_seconds: null,
            blast_off: null,
            //Should we add these attributes to the Countdown model or add it to the CMS model?
            localTime: null,
            startTime: null,
            countdownStatus: null
        };
    },
    /**
     *
     */
    initialize: function(attributes, options) {
        this.cms = options.cms;

        //Set local time now as it is a dependency for building the future time
        this.set({
            localTime: new Date().getTime()
        });

        //Build remaining dependencies for countdown widget
        this.setData();

        this.listenTo(
            this,
            'change:blast_off',
            _.bind(this.stopInterval, this)
        );

        var cmsCountdown = this.cms.get('text').countdown_clock;

        var units = 0;
        var count = 0;

        if (this.get('countdown_status') <= 0) {
            this.focusChange();
        } else {
            if (parseInt(cmsCountdown.countdown_units.show_month))
                (units |= countdown.MONTHS), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_days))
                (units |= countdown.DAYS), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_hours))
                (units |= countdown.HOURS), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_minutes))
                (units |= countdown.MINUTES), (count += 1);
            if (parseInt(cmsCountdown.countdown_units.show_seconds))
                (units |= countdown.SECONDS), (count += 1);
        }

        this.initializer = countdown(
            this.get('future_time'),
            _.bind(this.timerInterval, this),
            units,
            count,
            0
        );

        //Changed so that it will check if countdown is already completed
        this.focusChange();
        //$(window).bind("focus", _.bind(this.focusChange, this));
    },
    /**
     *
     */
    setData: function() {
        var countdown = this.cms.get('text').countdown_clock;
        //create format for when countdown ends from CMS
        var date_and_time_str = '';
        if (isNaN(countdown.date_and_time.month_name)) {
            date_and_time_str =
                countdown.date_and_time.month_name +
                ' ' +
                countdown.date_and_time.day_number +
                ' ' +
                countdown.date_and_time.year_number +
                ' ' +
                countdown.date_and_time.hours_number +
                ':' +
                countdown.date_and_time.minutes_number +
                ':' +
                countdown.date_and_time.seconds_number +
                ' ' +
                countdown.date_and_time.AM_or_PM +
                ' ' +
                countdown.date_and_time.timezone;
        } else {
            date_and_time_str =
                countdown.date_and_time.year_number +
                '-' +
                countdown.date_and_time.month_name +
                '-' +
                countdown.date_and_time.day_number +
                ' ' +
                countdown.date_and_time.hours_number +
                ':' +
                countdown.date_and_time.minutes_number +
                ':' +
                countdown.date_and_time.seconds_number +
                ' ' +
                countdown.date_and_time.AM_or_PM +
                ' ' +
                countdown.date_and_time.timezone;
        }

        var startTime = new Date(date_and_time_str).getTime();

        this.set({
            future_time: this.getCountdownTime(startTime),
            countdown_status: startTime > this.cms.get('ts') ? 1 : 0,
            startTime: startTime,
            countdownStatus: startTime > this.cms.get('ts') ? 1 : 0
        });
        //if countdown is already expired
        if (this.get('countdownStatus') === 0) {
            this.set({
                time_months: 0,
                time_days: 0,
                time_hours: 0,
                time_minutes: 0,
                time_seconds: 0,
                time_string: 0,
                blast_off: true
            });
        }
    },
    /**
     *
     */
    timerInterval: function(ts) {
        const timer = ts;
        const timeMonths = timer.months ? timer.months : 0;
        const timeDays = timer.days ? timer.days : 0;
        const timeHours = timer.hours ? timer.hours : 0;
        const timeMinutes = timer.minutes ? timer.minutes : 0;
        const timeSeconds = timer.seconds ? timer.seconds : 0;
        const timeString =
            timeMonths + timeDays + timeHours + timeMinutes + timeSeconds;
        const blastOff =
            timeMonths === 0 &&
            timeDays === 0 &&
            timeHours === 0 &&
            timeMinutes === 0 &&
            timeSeconds === 0
                ? true
                : false;

        this.set({
            timer: timer,
            time_months: timeMonths,
            time_days: timeDays,
            time_hours: timeHours,
            time_minutes: timeMinutes,
            time_seconds: timeSeconds,
            time_string: timeString,
            blast_off: blastOff
        });
    },
    /**
     *
     */
    stopInterval: function(model, value) {
        if (value === true) {
            window.clearInterval(this.initializer);
            this.stopListening();
        }
    },
    /**
     *
     */
    focusChange: function() {
        if (this.getServerTime() > this.get('future_time')) {
            this.set({
                time_months: 0,
                time_days: 0,
                time_hours: 0,
                time_minutes: 0,
                time_seconds: 0,
                time_string: 0,
                blast_off: true
            });
        }
    },
    /**
     * sets our polling timer
     */
    getElapsedTime: function() {
        return new Date().getTime() - this.get('localTime');
    },
    /**
     * @returns unix timestamp in ms
     * @param time - unix timestamp which should always be greater than (in the future of) the server time
     */
    getCountdownTime: function(time) {
        // ms difference between the server time and the future sunrise/sunset time
        var difference = time - this.getServerTime();
        // use local time plus the difference
        return new Date(new Date().getTime() + difference).getTime();
    },
    /**
     *
     */
    getServerTime: function() {
        return this.cms.get('ts') + this.getElapsedTime();
    }
});


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/*global window */
/**
 * @license countdown.js v2.6.0 http://countdownjs.org
 * Copyright (c)2006-2014 Stephen M. McKamey.
 * Licensed under The MIT License.
 */
/*jshint bitwise:false */

/**
 * @public
 * @type {Object|null}
 */
var module;

/**
 * API entry
 * @public
 * @param {function(Object)|Date|number} start the starting date
 * @param {function(Object)|Date|number} end the ending date
 * @param {number} units the units to populate
 * @return {Object|number}
 */
var countdown = (

/**
 * @param {Object} module CommonJS Module
 */
function(module) {
	/*jshint smarttabs:true */

	'use strict';

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MILLISECONDS	= 0x001;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var SECONDS			= 0x002;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MINUTES			= 0x004;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var HOURS			= 0x008;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var DAYS			= 0x010;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var WEEKS			= 0x020;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MONTHS			= 0x040;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var YEARS			= 0x080;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var DECADES			= 0x100;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var CENTURIES		= 0x200;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MILLENNIA		= 0x400;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var DEFAULTS		= YEARS|MONTHS|DAYS|HOURS|MINUTES|SECONDS;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MILLISECONDS_PER_SECOND = 1000;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var SECONDS_PER_MINUTE = 60;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MINUTES_PER_HOUR = 60;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var HOURS_PER_DAY = 24;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MILLISECONDS_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var DAYS_PER_WEEK = 7;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var MONTHS_PER_YEAR = 12;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var YEARS_PER_DECADE = 10;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var DECADES_PER_CENTURY = 10;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var CENTURIES_PER_MILLENNIUM = 10;

	/**
	 * @private
	 * @param {number} x number
	 * @return {number}
	 */
	var ceil = Math.ceil;

	/**
	 * @private
	 * @param {number} x number
	 * @return {number}
	 */
	var floor = Math.floor;

	/**
	 * @private
	 * @param {Date} ref reference date
	 * @param {number} shift number of months to shift
	 * @return {number} number of days shifted
	 */
	function borrowMonths(ref, shift) {
		var prevTime = ref.getTime();

		// increment month by shift
		ref.setMonth( ref.getMonth() + shift );

		// this is the trickiest since months vary in length
		return Math.round( (ref.getTime() - prevTime) / MILLISECONDS_PER_DAY );
	}

	/**
	 * @private
	 * @param {Date} ref reference date
	 * @return {number} number of days
	 */
	function daysPerMonth(ref) {
		var a = ref.getTime();

		// increment month by 1
		var b = new Date(a);
		b.setMonth( ref.getMonth() + 1 );

		// this is the trickiest since months vary in length
		return Math.round( (b.getTime() - a) / MILLISECONDS_PER_DAY );
	}

	/**
	 * @private
	 * @param {Date} ref reference date
	 * @return {number} number of days
	 */
	function daysPerYear(ref) {
		var a = ref.getTime();

		// increment year by 1
		var b = new Date(a);
		b.setFullYear( ref.getFullYear() + 1 );

		// this is the trickiest since years (periodically) vary in length
		return Math.round( (b.getTime() - a) / MILLISECONDS_PER_DAY );
	}

	/**
	 * Applies the Timespan to the given date.
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @param {Date=} date
	 * @return {Date}
	 */
	function addToDate(ts, date) {
		date = (date instanceof Date) || ((date !== null) && isFinite(date)) ? new Date(+date) : new Date();
		if (!ts) {
			return date;
		}

		// if there is a value field, use it directly
		var value = +ts.value || 0;
		if (value) {
			date.setTime(date.getTime() + value);
			return date;
		}

		value = +ts.milliseconds || 0;
		if (value) {
			date.setMilliseconds(date.getMilliseconds() + value);
		}

		value = +ts.seconds || 0;
		if (value) {
			date.setSeconds(date.getSeconds() + value);
		}

		value = +ts.minutes || 0;
		if (value) {
			date.setMinutes(date.getMinutes() + value);
		}

		value = +ts.hours || 0;
		if (value) {
			date.setHours(date.getHours() + value);
		}

		value = +ts.weeks || 0;
		if (value) {
			value *= DAYS_PER_WEEK;
		}

		value += +ts.days || 0;
		if (value) {
			date.setDate(date.getDate() + value);
		}

		value = +ts.months || 0;
		if (value) {
			date.setMonth(date.getMonth() + value);
		}

		value = +ts.millennia || 0;
		if (value) {
			value *= CENTURIES_PER_MILLENNIUM;
		}

		value += +ts.centuries || 0;
		if (value) {
			value *= DECADES_PER_CENTURY;
		}

		value += +ts.decades || 0;
		if (value) {
			value *= YEARS_PER_DECADE;
		}

		value += +ts.years || 0;
		if (value) {
			date.setFullYear(date.getFullYear() + value);
		}

		return date;
	}

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_MILLISECONDS	= 0;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_SECONDS		= 1;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_MINUTES		= 2;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_HOURS			= 3;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_DAYS			= 4;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_WEEKS			= 5;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_MONTHS		= 6;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_YEARS			= 7;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_DECADES		= 8;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_CENTURIES		= 9;

	/**
	 * @private
	 * @const
	 * @type {number}
	 */
	var LABEL_MILLENNIA		= 10;

	/**
	 * @private
	 * @type {Array}
	 */
	var LABELS_SINGLUAR;

	/**
	 * @private
	 * @type {Array}
	 */
	var LABELS_PLURAL;

	/**
	 * @private
	 * @type {string}
	 */
	var LABEL_LAST;

	/**
	 * @private
	 * @type {string}
	 */
	var LABEL_DELIM;

	/**
	 * @private
	 * @type {string}
	 */
	var LABEL_NOW;

	/**
	 * Formats a number & unit as a string
	 * 
	 * @param {number} value
	 * @param {number} unit
	 * @return {string}
	 */
	var formatter;

	/**
	 * Formats a number as a string
	 * 
	 * @private
	 * @param {number} value
	 * @return {string}
	 */
	var formatNumber;

	/**
	 * @private
	 * @param {number} value
	 * @param {number} unit unit index into label list
	 * @return {string}
	 */
	function plurality(value, unit) {
		return formatNumber(value)+((value === 1) ? LABELS_SINGLUAR[unit] : LABELS_PLURAL[unit]);
	}

	/**
	 * Formats the entries with singular or plural labels
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @return {Array}
	 */
	var formatList;

	/**
	 * Timespan representation of a duration of time
	 * 
	 * @private
	 * @this {Timespan}
	 * @constructor
	 */
	function Timespan() {}

	/**
	 * Formats the Timespan as a sentence
	 * 
	 * @param {string=} emptyLabel the string to use when no values returned
	 * @return {string}
	 */
	Timespan.prototype.toString = function(emptyLabel) {
		var label = formatList(this);

		var count = label.length;
		if (!count) {
			return emptyLabel ? ''+emptyLabel : LABEL_NOW;
		}
		if (count === 1) {
			return label[0];
		}

		var last = LABEL_LAST+label.pop();
		return label.join(LABEL_DELIM)+last;
	};

	/**
	 * Formats the Timespan as a sentence in HTML
	 * 
	 * @param {string=} tag HTML tag name to wrap each value
	 * @param {string=} emptyLabel the string to use when no values returned
	 * @return {string}
	 */
	Timespan.prototype.toHTML = function(tag, emptyLabel) {
		tag = tag || 'span';
		var label = formatList(this);

		var count = label.length;
		if (!count) {
			emptyLabel = emptyLabel || LABEL_NOW;
			return emptyLabel ? '<'+tag+'>'+emptyLabel+'</'+tag+'>' : emptyLabel;
		}
		for (var i=0; i<count; i++) {
			// wrap each unit in tag
			label[i] = '<'+tag+'>'+label[i]+'</'+tag+'>';
		}
		if (count === 1) {
			return label[0];
		}

		var last = LABEL_LAST+label.pop();
		return label.join(LABEL_DELIM)+last;
	};

	/**
	 * Applies the Timespan to the given date
	 * 
	 * @param {Date=} date the date to which the timespan is added.
	 * @return {Date}
	 */
	Timespan.prototype.addTo = function(date) {
		return addToDate(this, date);
	};

	/**
	 * Formats the entries as English labels
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @return {Array}
	 */
	formatList = function(ts) {
		var list = [];

		var value = ts.millennia;
		if (value) {
			list.push(formatter(value, LABEL_MILLENNIA));
		}

		value = ts.centuries;
		if (value) {
			list.push(formatter(value, LABEL_CENTURIES));
		}

		value = ts.decades;
		if (value) {
			list.push(formatter(value, LABEL_DECADES));
		}

		value = ts.years;
		if (value) {
			list.push(formatter(value, LABEL_YEARS));
		}

		value = ts.months;
		if (value) {
			list.push(formatter(value, LABEL_MONTHS));
		}

		value = ts.weeks;
		if (value) {
			list.push(formatter(value, LABEL_WEEKS));
		}

		value = ts.days;
		if (value) {
			list.push(formatter(value, LABEL_DAYS));
		}

		value = ts.hours;
		if (value) {
			list.push(formatter(value, LABEL_HOURS));
		}

		value = ts.minutes;
		if (value) {
			list.push(formatter(value, LABEL_MINUTES));
		}

		value = ts.seconds;
		if (value) {
			list.push(formatter(value, LABEL_SECONDS));
		}

		value = ts.milliseconds;
		if (value) {
			list.push(formatter(value, LABEL_MILLISECONDS));
		}

		return list;
	};

	/**
	 * Borrow any underflow units, carry any overflow units
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @param {string} toUnit
	 */
	function rippleRounded(ts, toUnit) {
		switch (toUnit) {
			case 'seconds':
				if (ts.seconds !== SECONDS_PER_MINUTE || isNaN(ts.minutes)) {
					return;
				}
				// ripple seconds up to minutes
				ts.minutes++;
				ts.seconds = 0;

				/* falls through */
			case 'minutes':
				if (ts.minutes !== MINUTES_PER_HOUR || isNaN(ts.hours)) {
					return;
				}
				// ripple minutes up to hours
				ts.hours++;
				ts.minutes = 0;

				/* falls through */
			case 'hours':
				if (ts.hours !== HOURS_PER_DAY || isNaN(ts.days)) {
					return;
				}
				// ripple hours up to days
				ts.days++;
				ts.hours = 0;

				/* falls through */
			case 'days':
				if (ts.days !== DAYS_PER_WEEK || isNaN(ts.weeks)) {
					return;
				}
				// ripple days up to weeks
				ts.weeks++;
				ts.days = 0;

				/* falls through */
			case 'weeks':
				if (ts.weeks !== daysPerMonth(ts.refMonth)/DAYS_PER_WEEK || isNaN(ts.months)) {
					return;
				}
				// ripple weeks up to months
				ts.months++;
				ts.weeks = 0;

				/* falls through */
			case 'months':
				if (ts.months !== MONTHS_PER_YEAR || isNaN(ts.years)) {
					return;
				}
				// ripple months up to years
				ts.years++;
				ts.months = 0;

				/* falls through */
			case 'years':
				if (ts.years !== YEARS_PER_DECADE || isNaN(ts.decades)) {
					return;
				}
				// ripple years up to decades
				ts.decades++;
				ts.years = 0;

				/* falls through */
			case 'decades':
				if (ts.decades !== DECADES_PER_CENTURY || isNaN(ts.centuries)) {
					return;
				}
				// ripple decades up to centuries
				ts.centuries++;
				ts.decades = 0;

				/* falls through */
			case 'centuries':
				if (ts.centuries !== CENTURIES_PER_MILLENNIUM || isNaN(ts.millennia)) {
					return;
				}
				// ripple centuries up to millennia
				ts.millennia++;
				ts.centuries = 0;
				/* falls through */
			}
	}

	/**
	 * Ripple up partial units one place
	 * 
	 * @private
	 * @param {Timespan} ts timespan
	 * @param {number} frac accumulated fractional value
	 * @param {string} fromUnit source unit name
	 * @param {string} toUnit target unit name
	 * @param {number} conversion multiplier between units
	 * @param {number} digits max number of decimal digits to output
	 * @return {number} new fractional value
	 */
	function fraction(ts, frac, fromUnit, toUnit, conversion, digits) {
		if (ts[fromUnit] >= 0) {
			frac += ts[fromUnit];
			delete ts[fromUnit];
		}

		frac /= conversion;
		if (frac + 1 <= 1) {
			// drop if below machine epsilon
			return 0;
		}

		if (ts[toUnit] >= 0) {
			// ensure does not have more than specified number of digits
			ts[toUnit] = +(ts[toUnit] + frac).toFixed(digits);
			rippleRounded(ts, toUnit);
			return 0;
		}

		return frac;
	}

	/**
	 * Ripple up partial units to next existing
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @param {number} digits max number of decimal digits to output
	 */
	function fractional(ts, digits) {
		var frac = fraction(ts, 0, 'milliseconds', 'seconds', MILLISECONDS_PER_SECOND, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'seconds', 'minutes', SECONDS_PER_MINUTE, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'minutes', 'hours', MINUTES_PER_HOUR, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'hours', 'days', HOURS_PER_DAY, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'days', 'weeks', DAYS_PER_WEEK, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'weeks', 'months', daysPerMonth(ts.refMonth)/DAYS_PER_WEEK, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'months', 'years', daysPerYear(ts.refMonth)/daysPerMonth(ts.refMonth), digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'years', 'decades', YEARS_PER_DECADE, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'decades', 'centuries', DECADES_PER_CENTURY, digits);
		if (!frac) { return; }

		frac = fraction(ts, frac, 'centuries', 'millennia', CENTURIES_PER_MILLENNIUM, digits);

		// should never reach this with remaining fractional value
		if (frac) { throw new Error('Fractional unit overflow'); }
	}

	/**
	 * Borrow any underflow units, carry any overflow units
	 * 
	 * @private
	 * @param {Timespan} ts
	 */
	function ripple(ts) {
		var x;

		if (ts.milliseconds < 0) {
			// ripple seconds down to milliseconds
			x = ceil(-ts.milliseconds / MILLISECONDS_PER_SECOND);
			ts.seconds -= x;
			ts.milliseconds += x * MILLISECONDS_PER_SECOND;

		} else if (ts.milliseconds >= MILLISECONDS_PER_SECOND) {
			// ripple milliseconds up to seconds
			ts.seconds += floor(ts.milliseconds / MILLISECONDS_PER_SECOND);
			ts.milliseconds %= MILLISECONDS_PER_SECOND;
		}

		if (ts.seconds < 0) {
			// ripple minutes down to seconds
			x = ceil(-ts.seconds / SECONDS_PER_MINUTE);
			ts.minutes -= x;
			ts.seconds += x * SECONDS_PER_MINUTE;

		} else if (ts.seconds >= SECONDS_PER_MINUTE) {
			// ripple seconds up to minutes
			ts.minutes += floor(ts.seconds / SECONDS_PER_MINUTE);
			ts.seconds %= SECONDS_PER_MINUTE;
		}

		if (ts.minutes < 0) {
			// ripple hours down to minutes
			x = ceil(-ts.minutes / MINUTES_PER_HOUR);
			ts.hours -= x;
			ts.minutes += x * MINUTES_PER_HOUR;

		} else if (ts.minutes >= MINUTES_PER_HOUR) {
			// ripple minutes up to hours
			ts.hours += floor(ts.minutes / MINUTES_PER_HOUR);
			ts.minutes %= MINUTES_PER_HOUR;
		}

		if (ts.hours < 0) {
			// ripple days down to hours
			x = ceil(-ts.hours / HOURS_PER_DAY);
			ts.days -= x;
			ts.hours += x * HOURS_PER_DAY;

		} else if (ts.hours >= HOURS_PER_DAY) {
			// ripple hours up to days
			ts.days += floor(ts.hours / HOURS_PER_DAY);
			ts.hours %= HOURS_PER_DAY;
		}

		while (ts.days < 0) {
			// NOTE: never actually seen this loop more than once

			// ripple months down to days
			ts.months--;
			ts.days += borrowMonths(ts.refMonth, 1);
		}

		// weeks is always zero here

		if (ts.days >= DAYS_PER_WEEK) {
			// ripple days up to weeks
			ts.weeks += floor(ts.days / DAYS_PER_WEEK);
			ts.days %= DAYS_PER_WEEK;
		}

		if (ts.months < 0) {
			// ripple years down to months
			x = ceil(-ts.months / MONTHS_PER_YEAR);
			ts.years -= x;
			ts.months += x * MONTHS_PER_YEAR;

		} else if (ts.months >= MONTHS_PER_YEAR) {
			// ripple months up to years
			ts.years += floor(ts.months / MONTHS_PER_YEAR);
			ts.months %= MONTHS_PER_YEAR;
		}

		// years is always non-negative here
		// decades, centuries and millennia are always zero here

		if (ts.years >= YEARS_PER_DECADE) {
			// ripple years up to decades
			ts.decades += floor(ts.years / YEARS_PER_DECADE);
			ts.years %= YEARS_PER_DECADE;

			if (ts.decades >= DECADES_PER_CENTURY) {
				// ripple decades up to centuries
				ts.centuries += floor(ts.decades / DECADES_PER_CENTURY);
				ts.decades %= DECADES_PER_CENTURY;

				if (ts.centuries >= CENTURIES_PER_MILLENNIUM) {
					// ripple centuries up to millennia
					ts.millennia += floor(ts.centuries / CENTURIES_PER_MILLENNIUM);
					ts.centuries %= CENTURIES_PER_MILLENNIUM;
				}
			}
		}
	}

	/**
	 * Remove any units not requested
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @param {number} units the units to populate
	 * @param {number} max number of labels to output
	 * @param {number} digits max number of decimal digits to output
	 */
	function pruneUnits(ts, units, max, digits) {
		var count = 0;

		// Calc from largest unit to smallest to prevent underflow
		if (!(units & MILLENNIA) || (count >= max)) {
			// ripple millennia down to centuries
			ts.centuries += ts.millennia * CENTURIES_PER_MILLENNIUM;
			delete ts.millennia;

		} else if (ts.millennia) {
			count++;
		}

		if (!(units & CENTURIES) || (count >= max)) {
			// ripple centuries down to decades
			ts.decades += ts.centuries * DECADES_PER_CENTURY;
			delete ts.centuries;

		} else if (ts.centuries) {
			count++;
		}

		if (!(units & DECADES) || (count >= max)) {
			// ripple decades down to years
			ts.years += ts.decades * YEARS_PER_DECADE;
			delete ts.decades;

		} else if (ts.decades) {
			count++;
		}

		if (!(units & YEARS) || (count >= max)) {
			// ripple years down to months
			ts.months += ts.years * MONTHS_PER_YEAR;
			delete ts.years;

		} else if (ts.years) {
			count++;
		}

		if (!(units & MONTHS) || (count >= max)) {
			// ripple months down to days
			if (ts.months) {
				ts.days += borrowMonths(ts.refMonth, ts.months);
			}
			delete ts.months;

			if (ts.days >= DAYS_PER_WEEK) {
				// ripple day overflow back up to weeks
				ts.weeks += floor(ts.days / DAYS_PER_WEEK);
				ts.days %= DAYS_PER_WEEK;
			}

		} else if (ts.months) {
			count++;
		}

		if (!(units & WEEKS) || (count >= max)) {
			// ripple weeks down to days
			ts.days += ts.weeks * DAYS_PER_WEEK;
			delete ts.weeks;

		} else if (ts.weeks) {
			count++;
		}

		if (!(units & DAYS) || (count >= max)) {
			//ripple days down to hours
			ts.hours += ts.days * HOURS_PER_DAY;
			delete ts.days;

		} else if (ts.days) {
			count++;
		}

		if (!(units & HOURS) || (count >= max)) {
			// ripple hours down to minutes
			ts.minutes += ts.hours * MINUTES_PER_HOUR;
			delete ts.hours;

		} else if (ts.hours) {
			count++;
		}

		if (!(units & MINUTES) || (count >= max)) {
			// ripple minutes down to seconds
			ts.seconds += ts.minutes * SECONDS_PER_MINUTE;
			delete ts.minutes;

		} else if (ts.minutes) {
			count++;
		}

		if (!(units & SECONDS) || (count >= max)) {
			// ripple seconds down to milliseconds
			ts.milliseconds += ts.seconds * MILLISECONDS_PER_SECOND;
			delete ts.seconds;

		} else if (ts.seconds) {
			count++;
		}

		// nothing to ripple milliseconds down to
		// so ripple back up to smallest existing unit as a fractional value
		if (!(units & MILLISECONDS) || (count >= max)) {
			fractional(ts, digits);
		}
	}

	/**
	 * Populates the Timespan object
	 * 
	 * @private
	 * @param {Timespan} ts
	 * @param {?Date} start the starting date
	 * @param {?Date} end the ending date
	 * @param {number} units the units to populate
	 * @param {number} max number of labels to output
	 * @param {number} digits max number of decimal digits to output
	 */
	function populate(ts, start, end, units, max, digits) {
		var now = new Date();

		ts.start = start = start || now;
		ts.end = end = end || now;
		ts.units = units;

		ts.value = end.getTime() - start.getTime();
		if (ts.value < 0) {
			// swap if reversed
			var tmp = end;
			end = start;
			start = tmp;
		}

		// reference month for determining days in month
		ts.refMonth = new Date(start.getFullYear(), start.getMonth(), 15, 12, 0, 0);
		try {
			// reset to initial deltas
			ts.millennia = 0;
			ts.centuries = 0;
			ts.decades = 0;
			ts.years = end.getFullYear() - start.getFullYear();
			ts.months = end.getMonth() - start.getMonth();
			ts.weeks = 0;
			ts.days = end.getDate() - start.getDate();
			ts.hours = end.getHours() - start.getHours();
			ts.minutes = end.getMinutes() - start.getMinutes();
			ts.seconds = end.getSeconds() - start.getSeconds();
			ts.milliseconds = end.getMilliseconds() - start.getMilliseconds();

			ripple(ts);
			pruneUnits(ts, units, max, digits);

		} finally {
			delete ts.refMonth;
		}

		return ts;
	}

	/**
	 * Determine an appropriate refresh rate based upon units
	 * 
	 * @private
	 * @param {number} units the units to populate
	 * @return {number} milliseconds to delay
	 */
	function getDelay(units) {
		if (units & MILLISECONDS) {
			// refresh very quickly
			return MILLISECONDS_PER_SECOND / 30; //30Hz
		}

		if (units & SECONDS) {
			// refresh every second
			return MILLISECONDS_PER_SECOND; //1Hz
		}

		if (units & MINUTES) {
			// refresh every minute
			return MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE;
		}

		if (units & HOURS) {
			// refresh hourly
			return MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR;
		}
		
		if (units & DAYS) {
			// refresh daily
			return MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR * HOURS_PER_DAY;
		}

		// refresh the rest weekly
		return MILLISECONDS_PER_SECOND * SECONDS_PER_MINUTE * MINUTES_PER_HOUR * HOURS_PER_DAY * DAYS_PER_WEEK;
	}

	/**
	 * API entry point
	 * 
	 * @public
	 * @param {Date|number|Timespan|null|function(Timespan,number)} start the starting date
	 * @param {Date|number|Timespan|null|function(Timespan,number)} end the ending date
	 * @param {number=} units the units to populate
	 * @param {number=} max number of labels to output
	 * @param {number=} digits max number of decimal digits to output
	 * @return {Timespan|number}
	 */
	function countdown(start, end, units, max, digits) {
		var callback;

		// ensure some units or use defaults
		units = +units || DEFAULTS;
		// max must be positive
		max = (max > 0) ? max : NaN;
		// clamp digits to an integer between [0, 20]
		digits = (digits > 0) ? (digits < 20) ? Math.round(digits) : 20 : 0;

		// ensure start date
		var startTS = null;
		if ('function' === typeof start) {
			callback = start;
			start = null;

		} else if (!(start instanceof Date)) {
			if ((start !== null) && isFinite(start)) {
				start = new Date(+start);
			} else {
				if ('object' === typeof startTS) {
					startTS = /** @type{Timespan} */(start);
				}
				start = null;
			}
		}

		// ensure end date
		var endTS = null;
		if ('function' === typeof end) {
			callback = end;
			end = null;

		} else if (!(end instanceof Date)) {
			if ((end !== null) && isFinite(end)) {
				end = new Date(+end);
			} else {
				if ('object' === typeof end) {
					endTS = /** @type{Timespan} */(end);
				}
				end = null;
			}
		}

		// must wait to interpret timespans until after resolving dates
		if (startTS) {
			start = addToDate(startTS, end);
		}
		if (endTS) {
			end = addToDate(endTS, start);
		}

		if (!start && !end) {
			// used for unit testing
			return new Timespan();
		}

		if (!callback) {
			return populate(new Timespan(), /** @type{Date} */(start), /** @type{Date} */(end), /** @type{number} */(units), /** @type{number} */(max), /** @type{number} */(digits));
		}

		// base delay off units
		var delay = getDelay(units),
			timerId,
			fn = function() {
				callback(
					populate(new Timespan(), /** @type{Date} */(start), /** @type{Date} */(end), /** @type{number} */(units), /** @type{number} */(max), /** @type{number} */(digits)),
					timerId
				);
			};

		fn();
		return (timerId = setInterval(fn, delay));
	}

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.MILLISECONDS = MILLISECONDS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.SECONDS = SECONDS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.MINUTES = MINUTES;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.HOURS = HOURS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.DAYS = DAYS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.WEEKS = WEEKS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.MONTHS = MONTHS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.YEARS = YEARS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.DECADES = DECADES;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.CENTURIES = CENTURIES;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.MILLENNIA = MILLENNIA;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.DEFAULTS = DEFAULTS;

	/**
	 * @public
	 * @const
	 * @type {number}
	 */
	countdown.ALL = MILLENNIA|CENTURIES|DECADES|YEARS|MONTHS|WEEKS|DAYS|HOURS|MINUTES|SECONDS|MILLISECONDS;

	/**
	 * Customize the format settings.
	 * @public
	 * @param {Object} format settings object
	 */
	var setFormat = countdown.setFormat = function(format) {
		if (!format) { return; }

		if ('singular' in format || 'plural' in format) {
			var singular = format.singular || [];
			if (singular.split) {
				singular = singular.split('|');
			}
			var plural = format.plural || [];
			if (plural.split) {
				plural = plural.split('|');
			}

			for (var i=LABEL_MILLISECONDS; i<=LABEL_MILLENNIA; i++) {
				// override any specified units
				LABELS_SINGLUAR[i] = singular[i] || LABELS_SINGLUAR[i];
				LABELS_PLURAL[i] = plural[i] || LABELS_PLURAL[i];
			}
		}

		if ('string' === typeof format.last) {
			LABEL_LAST = format.last;
		}
		if ('string' === typeof format.delim) {
			LABEL_DELIM = format.delim;
		}
		if ('string' === typeof format.empty) {
			LABEL_NOW = format.empty;
		}
		if ('function' === typeof format.formatNumber) {
			formatNumber = format.formatNumber;
		}
		if ('function' === typeof format.formatter) {
			formatter = format.formatter;
		}
	};

	/**
	 * Revert to the default formatting.
	 * @public
	 */
	var resetFormat = countdown.resetFormat = function() {
		LABELS_SINGLUAR = ' millisecond| second| minute| hour| day| week| month| year| decade| century| millennium'.split('|');
		LABELS_PLURAL = ' milliseconds| seconds| minutes| hours| days| weeks| months| years| decades| centuries| millennia'.split('|');
		LABEL_LAST = ' and ';
		LABEL_DELIM = ', ';
		LABEL_NOW = '';
		formatNumber = function(value) { return value; };
		formatter = plurality;
	};

	/**
	 * Override the unit labels.
	 * @public
	 * @param {string|Array=} singular a pipe ('|') delimited list of singular unit name overrides
	 * @param {string|Array=} plural a pipe ('|') delimited list of plural unit name overrides
	 * @param {string=} last a delimiter before the last unit (default: ' and ')
	 * @param {string=} delim a delimiter to use between all other units (default: ', ')
	 * @param {string=} empty a label to use when all units are zero (default: '')
	 * @param {function(number):string=} formatNumber a function which formats numbers as a string
	 * @param {function(number,number):string=} formatter a function which formats a number/unit pair as a string
	 * @deprecated since version 2.6.0
	 */
	countdown.setLabels = function(singular, plural, last, delim, empty, formatNumber, formatter) {
		setFormat({
			singular: singular,
			plural: plural,
			last: last,
			delim: delim,
			empty: empty,
			formatNumber: formatNumber,
			formatter: formatter
		});
	};

	/**
	 * Revert to the default unit labels.
	 * @public
	 * @deprecated since version 2.6.0
	 */
	countdown.resetLabels = resetFormat;

	resetFormat();

	if (module && module.exports) {
		module.exports = countdown;

	} else if (typeof window.define === 'function' && typeof window.define.amd !== 'undefined') {
		window.define('countdown', [], function() {
			return countdown;
		});
	}

	return countdown;

})(module);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _voteOption = __webpack_require__(121);

var _voteOption2 = _interopRequireDefault(_voteOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _voteOption2.default;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(1);
var Model = __webpack_require__(122);

module.exports = Backbone.Collection.extend({
    model: Model,

    initialize: function(attrs, options, enable_eliminated) {
        // if show eliminated enabled sort based on eliminated and first name, otherwise firstname
        // need to create what happens if you do not want to display eliminated contestants
        this.options = options || {};

        if (!this.options.randomize) {
            this.comparator = function(model) {
                if (enable_eliminated) return [model.get('eliminated'), model.get(this.options.sorting_key)];
                else return model.get(this.options.sorting_key);
            };
        }
    },

    set: function(models, options) {
        if (this.options.randomize) {
            models = _.shuffle(models);
        }
        Backbone.Collection.prototype.set.call(this, models, options);
    },

    setSelected: function(id) {
        console.log('selected model id', id);

        this.each(function(model) {
            model.set({ selected: false }, { silent: true });
        });

        this.get(id).set({ selected: true });
        this.selectedElement = this.get(id);
    },

    getSelected: function() {
        return this.selectedElement || this.at(0);
    },

    next: function(option) {
        var model = this.at(this.indexOf(option) + 1);

        if (_.isUndefined(model)) {
            model = this.last();
        }

        return model;
    },

    prev: function(option) {
        var model = this.at(this.indexOf(option) - 1);

        if (_.isUndefined(model)) {
            model = this.first();
        }

        return model;
    },

    search: function(value) {
        var lastIndex = value.lastIndexOf(' ');
        var firstName = value.substr(0, lastIndex);
        var lastName = value.substr(lastIndex + 1);

        console.log('first name:', firstName, 'lastName:', lastName);
    },
    /**
     * clearVoteCount
     *
     * Set all models to zero
     */
    clearVoteCount: function(params) {
        params = params || {};
        _.each(this.models, function(model) {
            model.set(
                {
                    voteCount: 0,
                    selected: false
                },
                params
            );
        });
    }
});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);

module.exports = Backbone.Model.extend({

    defaults: {
        name: 'Unknown',
        firstname: 'Unknown',
        lastname: 'Unknown',
        count: 0,
        percent: 0,
        eliminated: null,
        image: '/img/contestants/avatar.png',
        number: null,
        selected: false,
        imgLoaded: false,
        secondaryinfo: ''
    },

    initialize: function() {
        this.on('change:selected', this.isSelected, this);
    },
    /**
   *
   */
    isSelected: function(model, value, options) {
        console.log('isSelected', model, value, options);
    }
});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cookie = __webpack_require__(9);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _cookie2.default;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/d4e1026c434005e2026b.main.js